import { DatePipe, DecimalPipe, TitleCasePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, HostListener, Input, OnInit, Renderer2, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import {
  DomSanitizer
} from "@angular/platform-browser";
import { ActivatedRoute, Router } from "@angular/router";
import * as saveAs from 'file-saver';
import { Observable, ReplaySubject } from 'rxjs';
import { LoaderService } from 'src/app/loader.service';
import Swal from 'sweetalert2';
import { environment as api } from '../../../environments/environment';
import { adjustWith2DecimalsForUI, BackdatedReasons, sumBy } from "../../common-functions";
import { CustomDatePipe } from '../../pipes/customdate.pipe';
import { PhoneFormatPipe as PhoneNoFormatPipe } from '../../pipes/phone-format.pipe';
// import { moment } from 'ngx-bootstrap/chronos/testing/chain';

import * as moment from "moment";
import { LoggerService } from 'src/app/services/logger.service';
import { invoiceFilter } from '../../common-functions';
import { HeaderComponent } from '../../layouts/header/header.component';
import { SidebarComponent } from '../../layouts/sidebar/sidebar.component';

@Component({
  selector: 'app-add-dependent',
  templateUrl: './add-dependent.component.html',
  styleUrls: ['./add-dependent.component.css'],
  providers: [DatePipe, TitleCasePipe, DecimalPipe, PhoneNoFormatPipe, CustomDatePipe],
  // encapsulation: ViewEncapsulation.None
})
export class AddDependentComponent implements OnInit {
  planobjdata1: any = {};
  planobjdataobj: any = {};
  addbenificaryData: any = []
  modifiedBlocksCoveredByCompany: any;
  modifiedBlocksPaidByCompany: any;
  mainarray: any = [];
  mainarrayValues: any = [];
  mainarrayFinal: any = [];
  public specialplans: any;
  public specialpackages: any;
  public formData: any;
  public allFormData: any = {};
  public packagesInBlocks: any;
  public basepackages: any;
  public customerSelectedPlans: any;
  public CORP_PAYROLL_NOT_MANDATORY_PACKAGES: any = [2, 8, 9];
  public CORP_PAYROLL_NOT_MANDATORY_PLANLEVELS: any = [19, 20, 21, 23, 25, 26];
  public companypaidproductid: any = [];
  public disabledcompanypaidproductid: any = [];
  public removedisabledcompanypaidproductid: any = [];
  public adddisabledcompanypaidproductid: any = [];
  public isDisabledplan: boolean = false;
  isExecutiveCP: boolean = false;
  employercheck: any = false;


  public coveredEmployeeShare: any = 0;
  public paidEmployeeShare: any = 0;
  public totalEmployeeShare: any = 0;
  public cartDisplayAmount: any = 0;
  public allPlansAmountTotal: any = 0;
  public allPlansTotal: any = 0;
  public allPlansTotaltax: any = 0;
  public allCPPlansAmountTotal: any = 0;
  public allCCPlansAmountTotal: any = 0;
  public allEPPlansAmountTotal: any = 0;
  public allCPTaxTotal: any = 0;
  public allCCTaxTotal: any = 0;
  public allEPTaxTotal: any = 0;
  public companyPaidTotal: any = 0;
  public companyCoveredTotal: any = 0;
  public paidEmployeedTotal: any = 0;
  public companyCoveredCompanyShareTotal: any = 0;
  public companyCoveredCompanySharePlanAmountTotal: any = 0;
  public companyCoveredCompanyShareTaxTotal: any = 0;
  public companyCoveredEmployeeShareTotal: any = 0;
  public companyCoveredEmployeeSharePlanAmountTotal: any = 0;
  public companyCoveredEmployeeShareTaxTotal: any = 0;
  public effectiveCompanyTotalContibution: any = 0;
  public effectiveEmployeeTotalContibution: any = 0;
  public effectiveCompanyPlansAmountTotal: any = 0;
  public effectiveCompanyTaxTotal: any = 0;
  public alloptinplans: any = [];
  public showPaymenthMethod: boolean = false;
  public showPaymenthMethod1: boolean = true;
  // public bankpay: boolean = false;
  public creditcardform: boolean = false;
  public bankpaymentmethod: any;
  public directpayCCplansarr: any = [];
  public payrollCCplansarr: any = [];
  public employeeDealingPlansarr: any = [];
  public backdatedReasonsArr: any = [];


  public companySelectedPlans: any = [];
  public companyCoveredPlans: any = [];
  public EmployeeSelectedPlans: any = [];
  public allSelectedPlans: any = [];
  public companyDealingPlans: any = [];

  payrollCCPlantaxTotal: any;
  empDirectpayPlanamountTotal: any;
  empDirectpayPlantaxTotal: any;
  payrollCCPlansAmountTotal: any;
  payrollCCPlangrandTotal: any;
  empDirectpayPlangrandTotal: any;
  DirectCCpayPlanamountTotal: any;
  DirectCCpayPlantaxTotal: any;
  DirectCCpayPlangrandTotal: any;
  companydealingplansTotal: any;
  companydealingplanstaxTotal: any;
  companydealingplansgrandTotal: any;
  deltaCompanyTax: any;
  spouseDob: Date = new Date();
  spouseDob_: any;
  beneficiaries: any = [];
  beneficiaries1: any = [];
  beneficiariesConst: any = [];
  beneficiary: any = {};
  hoverStates: {
    [index: number]: boolean
  } = {};
  currencySymbol: string = "$";
  currentBeneficiary: any = { customerType: '', type: '' };
  benficiaryIsMemberDetails: any = {};
  benficiaryIsSpouseDetails: any = {};
  beneficiaryReload: number = 0;


  addPlanForm: FormGroup = new FormGroup({

    planEnrollmentDate: new FormControl(''),

  });
  cancelPlanForm: FormGroup = new FormGroup({

    terminationDate: new FormControl(''),

  });
  provianceList: any;
  isBackdated: any = false;
  planChanges: any = false;
  addressform: FormGroup = new FormGroup({
    firstName: new FormControl(''),
    lastName: new FormControl(''),
    line1: new FormControl(''),
    line2: new FormControl(''),
    city: new FormControl(''),
    country: new FormControl(''),
    province: new FormControl(''),
    postalCode: new FormControl(''),
    primaryPhone: new FormControl(''),
    secondaryPhone: new FormControl(''),
    email: new FormControl(''),
    dob: new FormControl(''),
    gender: new FormControl(''),
  });

  phoneform: FormGroup = new FormGroup({
    primaryPhone: new FormControl(''),
    secondaryPhone: new FormControl(''),
  });


  dependentTypeForm: FormGroup = new FormGroup({
    dependentType: new FormControl(''),
    marriageType: new FormControl(''),
    marriageDate: new FormControl(''),
    childrenCountData: new FormControl('0'),
    effectiveDate: new FormControl('')
  });
  dependentTypeForm1: FormGroup = new FormGroup({
    effectiveDate: new FormControl('')
  });

  showFirst:any = true;
  showSecond:any = false;
  spouseform: FormGroup = new FormGroup({
    dependentType: new FormControl(null, Validators.required),
    fullName: new FormControl('', [Validators.required, Validators.minLength(2),  this.fullNameValidator]),
    dob: new FormControl('', Validators.required),
    email: new FormControl('', [Validators.required, Validators.email]),
    coveredByAnotherPlan: new FormControl('', Validators.required),
    insurer: new FormControl(''), // conditional validation may apply here
    dateOfMarriage: new FormControl('', Validators.required),
    maritalStatus: new FormControl('', Validators.required),
    reasonForLate: new FormControl('', Validators.required)
  });

  cobform: FormGroup = new FormGroup({
    insurer: new FormControl('', Validators.required),
    cobCoverage: new FormControl('', Validators.required),
  });

  maritalStatusform: FormGroup = new FormGroup({
    maritalStatus: new FormControl('', Validators.required),
    reason: new FormControl('')
  });

  underWritingMessage1: any;
  underWritingMessage2: any;
  isExcludeSpouse: boolean = false;
  isExcludeChild: boolean = false;
  isExcludeChildAndSpouse: boolean = false;
  isExcludeAll: boolean = false;
  cobcoverage: any;
  needToUpdate: any;
  isNeedToUpdate: boolean = false;
  cobeventType: any;
  cobevent: any;
  childEffectiveDate: any;
  finalEffectiveDate: any = null;
  customerQueues: any;
  isSpouseInUnderwriting: any = false;
  underwritingHeading: any;
  voluntryplansCheck: any;
  upgradeplansCheck: any;
  planssummarymainLife: any;
  showCorpPlansTable: any = false;
  isDirectUpdate: any = false;
  upcomingamountWithoutTax: any;
  currentamountWithoutTax: any;
  upcomingamountTax: any;
  currentamountTax: any;
  proceedDeleteButtonDisabled: any;
  backdatedDependentsChild: any = [];
  backdatedDependentsSpouse: any = [];
  normalDependentDeletion: any = false;
  isSpecialCondition: any = false;
  maxEnrollmentDate: any;
  specialConditionMessage: any;
  childrenApprovalNeed: any = [];
  customerOldPlans: any = [];
  showSpouseDropDownForDelete: any = false;
  isDependentSelected: any = false;
  secondTarget: any;
  canShowPlans: any = false;

  fullNameValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value?.trim();
    if (!value) return { required: true };
  
    const words = value.split(/\s+/);
    if (words.length < 2) {
      return { fullNameInvalid: true }; // Must contain at least two words
    }
  
    return null;
  }

  updatespouseform: FormGroup = new FormGroup({
    firstName: new FormControl(''),
    lastName: new FormControl(''),
    dob: new FormControl(this.spouseDob.toISOString().split("T")[0]),
    email: new FormControl(''),
    coveredByAnotherPlan: new FormControl(''),
    healthPlan: new FormControl(''),
    insurer: new FormControl(''),
    martialStatus: new FormControl(''),
    effectiveDate: new FormControl(''),
    gender: new FormControl(''),
    status: new FormControl('')
  });

  deletespouseform: FormGroup = new FormGroup({
    firstName: new FormControl(''),
    lastName: new FormControl(''),
    dob: new FormControl(this.spouseDob.toISOString().split("T")[0]),
    email: new FormControl(''),
    coveredByAnotherPlan: new FormControl(''),
    healthPlan: new FormControl(''),
    insurer: new FormControl(''),
    martialStatus: new FormControl(''),
    effectiveDate: new FormControl(''),
    gender: new FormControl(''),
    status: new FormControl(''),
    reason: new FormControl('')
  });

  deleteForm: FormGroup = new FormGroup({
    deletionReason: new FormControl('', Validators.required),
    otherReason: new FormControl(''),
    selectedDepId: new FormControl('')
  });

  availableFirstNames: any = []; // example names

  deletedependentform: FormGroup = new FormGroup({
    firstName: new FormControl(''),
    lastName: new FormControl(''),
    dob: new FormControl(''),
    gender: new FormControl(''),
    age: new FormControl(''),
    phoneNum: new FormControl(''),
    coveredByAnotherPlan: new FormControl(''),
    carrierName: new FormControl(''),
    specialNeeds: new FormControl(''),
    postSecondaryStudent: new FormControl(''),
    graduationDate: new FormControl(''),
    // martialStatus: new FormControl(''),
    effectiveDate: new FormControl(''),
  });

  dependentform: FormGroup = new FormGroup({
    fullName: new FormControl('', [Validators.required, Validators.minLength(2),  this.fullNameValidator]),
    dob: new FormControl(''),
    age: new FormControl(''),
    phoneNum: new FormControl(''),
    coveredByAnotherPlan: new FormControl(''),
    carrierName: new FormControl(''),
    specialNeeds: new FormControl(''),
    postSecondaryStudent: new FormControl(''),
    graduationDate: new FormControl(''),
    reasonForLate: new FormControl(''),
  });

  pureDependentform: FormGroup = new FormGroup({
    firstName: new FormControl(''),
    lastName: new FormControl(''),
    dob: new FormControl(''),
    gender: new FormControl(''),
    age: new FormControl(''),
    phoneNum: new FormControl(''),
    coveredByAnotherPlan: new FormControl(''),
    carrierName: new FormControl(''),
    specialNeeds: new FormControl(''),
    postSecondaryStudent: new FormControl(''),
    graduationDate: new FormControl(''),
    // martialStatus: new FormControl(''),
    // effectiveDate: new FormControl(''),
  });

  paymentform: FormGroup = new FormGroup({
    cutomerId: new FormControl(''),
    // Id: new FormControl(''),
    PublicApiKey: new FormControl(''),
    SuccessUri: new FormControl(''),
    FailUri: new FormControl(''),
    FirstName: new FormControl(''),
    LastName: new FormControl(''),
    email: new FormControl(''),
    CardNumber: new FormControl(''),
    ExpirationMonth: new FormControl(''),
    ExpirationYear: new FormControl(''),
    Cvv: new FormControl(''),
    nameonthecard: new FormControl(''),
    aptcheck: new FormControl(''),
    streetaddress: new FormControl(''),
    streetaddressline2: new FormControl(''),
    city: new FormControl(''),
    stateId: new FormControl(''),
    postalcode: new FormControl(''),
    recaptchaReactive: new FormControl(''),
  });

  ccform: FormGroup = new FormGroup({
    cutomerId: new FormControl(''),
    Id: new FormControl(''),
    PublicApiKey: new FormControl(''),
    SuccessUri: new FormControl(''),
    FailUri: new FormControl(''),
    FirstName: new FormControl(''),
    LastName: new FormControl(''),
    email: new FormControl(''),
    CardNumber: new FormControl(''),
    ExpirationMonth: new FormControl(''),
    ExpirationYear: new FormControl(''),
    Cvv: new FormControl(''),
    nameonthecard: new FormControl(''),
    aptcheck: new FormControl(''),
    streetaddress: new FormControl(''),
    streetaddressline2: new FormControl(''),
    city: new FormControl(''),
    stateId: new FormControl(''),
    postalcode: new FormControl(''),
    recaptchaReactive: new FormControl(''),
  });

  padform: FormGroup = new FormGroup({
    bankcode: new FormControl(''),
    transitNumber: new FormControl(''),
    accountNo: new FormControl(''),
    bankdetails: new FormControl(''),
    file: new FormControl(''),
  });

  paymentMethodForm: FormGroup = new FormGroup({
    bankCode: new FormControl(''),
    branchCode: new FormControl(''),
    accountNumber: new FormControl(''),
    files: new FormControl(''),
    paymentmethod: new FormControl(''),
  });

  valisignform: FormGroup = new FormGroup({
    code: new FormControl(''),
  });

  invoicesList: any[] = [];
  hicList: any[] = [];
  @Input() customerId: any;
  customerData: any;
  childrenInfo: any[] = [];
  childrenId: any;
  paymentMethod: any;
  // UpdateAddressComponent = false;
  // UpdateSpousePlanComponent = false;
  spouseInsurer: any;
  roe: any;
  viewRoe: boolean = true;
  formConfiguration: any;
  beneficiaryValidations: any = [];
  selectedTab: any = 'tab1';
  healthCard: any = false;
  src: any;
  spouseCoverage: any;
  childCoverage: any;
  specialNeeds: any;
  postSecondaryStudent: any;
  graduationDate = true;
  coverage: any = 'open';
  isDependentPlanChange: any = true;
  dependentCoverage = 'close';
  bookletList: any[] = [];
  bookletList1: any[] = [];
  isDeleteDisabled: any = true;
  // declare var $: any;
  // display:any = 'none';
  displayStyle = 'none';
  displayBooklet = 'none';
  roeUrl: any;
  secondaryPhone: any;
  invalidpostalcodeprivince: boolean = false;
  configprovinceres: any;
  openUpdatePaymentForm: any;
  provincialZipcodes: any;
  provincelistid: any;
  state_id: any;
  statename: any;
  postalvalue: any;
  resetButton = false;
  resetbutton = false;
  uploadCheque = false;
  bankInfo: any;
  bank: any;
  bankAddress: any[] = [];
  displayTimer: any;
  showTimer: any;
  startTimer: any;
  customerid: any;
  accessToken: any;
  invoiceResponse: any;
  creditCardNo: any;
  expire: any;
  bookletLink: any;
  booklet_link: any;
  support_link: any;
  health_card: any;
  hidebooklet: any = false;
  upcomingInvoice: any;
  spouseId: any;
  fusebillId: any;
  advisor: any;
  corporateDetails: any;
  paymentVoidCheque: any;
  imagedisplay: any;
  address: any;
  fileExtension: any;
  signatureImg: any;
  encBank: any;
  showIAFG: any;
  iafgSubscriptionPendingNotification: any;
  iafgSubscriptionConfirmation: any;
  medicalQuestionaireStatus: any;
  pendingMedicalQuestionaire: any;
  pendingMedicalQuestionaireCoverage: any;
  iafg: any;
  signaturePadOptions: Object = {
    'minWidth': 2,
    'canvasWidth': 700,
    'canvasHeight': 300
  };
  deleteBenfIds: any = [];
  deleteBenfIds1: any = [];
  spouseData: any;
  spouseUpdate: any;
  spouseStatus: any;
  spouseInfo: any;
  dependentData: any;
  dependentUpdate: any;
  dependentStatus: any;
  currentDeleteMember: any = "spouse";
  // selectedBase64: string | null = null;
  selectedBase64: any;
  expireMonth: any;
  expireYear: any;
  invalidExpiration = false;
  showImage = false;
  bankDetails = false;
  bankinfo = false;
  cheque = false;
  additionalDetails: any;
  pad: any;
  iafgplansCheck: any = [];
  signedPad: any;
  PADdetails: any;
  bankCode: any;
  transitNumber: any;
  accountNumber: any;
  banknameres: any;
  items: any = 1;
  cardNumber: any;
  currentIndex = 1;
  link: any;
  showconfirm: any = false;
  selectedLanguage: any;


  // @ViewChild(SignaturePad)
  // signaturePad!: SignaturePad;
  @ViewChild('closePhonemodal') closePhonemodal: any;
  @ViewChild('closeAddressmodal') closeAddressmodal: any;
  @ViewChild('closeSpousemodal') closeSpousemodal: any;
  @ViewChild('closeDependentmodal') closeDependentmodal: any;
  @ViewChild('closePaymentmodal') closePaymentmodal: any;
  @ViewChild('openRoe') openRoe: any;
  @ViewChild('videoPopup') openPopup: any;
  @ViewChild('iframePopup') openiframe: any;
  @ViewChild('equitablePopup') openequitable: any;
  @ViewChild('supportPopup') opensupport: any;
  @ViewChild('closePaymenttoPAD') closePaymenttoPAD: any;
  filename: any;
  padfilename: any;
  ext: any;
  mimetype: any;
  previewbutton: boolean = false;
  updatepreviewbutton: boolean = false;
  changetopad: boolean = false;
  invoicedraftData: any;
  paymentUri: any;
  paymentsuccessuri: any;
  publicapikey: any;
  paymentform2: any;
  recaptchaResponse: any;
  fusbillinfocaptchavalue: any;
  fullName: any;
  voidCheque1: any;
  voidCheque2: any;
  bankinformation: any;
  paymentMethodId: any;
  padAgreement: any;
  existVoid: any;
  review: any;
  fuseBillKey: any;
  voidCheckImage: any;
  voidCheckFileType: any;
  ccDetails: any;
  stateId: any;
  countryId: any;
  customerID: any;
  card: any;
  spouse: any;
  index: any = 1;
  lang: any = {};
  lang1: any = {};
  gender: any;
  dependentBackgroundColor: any[] = [];
  plans: any;
  benefits: any;
  unlistener: any;
  videoLink: any;
  videoTitle: any;
  videoPopup: any = 'none';
  iframeLink: any;
  iframeTitle: any;
  customerInvoices: any[] = [];
  registrationDate: any;
  iafgDays: any;
  enactMode: any = "add";

  currentIndexOfSwipperDependents: any = 1;

  currentIndexOfSwipperDownload: any = 1;

  currentIndexOfSwipperPlan: any = 1;

  currentIndexOfSwipperBenifits: any = 1;
  @ViewChild('videoPlayer') videoplayer: any;

  public startedPlay: boolean = false;

  public show: boolean = false;
  logo: any;
  editSpouse: boolean = true;
  editChild: boolean = false;
  logoimage: any;
  headerName: any;
  voidCheckPdf: any;
  url: any;
  minDate: any;
  maxDate: any;
  minDatechild: any;
  minDateHire: any;
  maxDatechild: any;
  memberportalgreensShildCheck: any;
  memberportalEquitabelCheck: any;
  secondaryphonecheck: boolean = false;
  failedsignature: any;
  showinvoiceMessage: any;
  isCorporateAccount: any = false;
  invoiceslink: any;
  getCustomerDraftDetails: any;
  getCustomerDraftDate: any = "";
  showViewPlansLoading: boolean = true;
  loading: boolean = true;
  showROES: any[] = [];
  waddelCustomer: any;
  showupdatesignatue: boolean = true;
  memberDOB: any;
  cardType: string = '';
  public invalidcreditcard: boolean = false;
  invalidcreditcarddetails: boolean = false;
  customerFinalInvoices: any[] = [];
  customerFinalInvoicesIGBMS: any[] = [];
  allCustomerFinalInvoices: any = [];
  allCustomerFinalInvoicesIGBMS: any = [];
  getCustomerDraftDate1: any = "";
  filterDateSelection: any = "";
  filteredInvoices: any = [];
  filterInvoice: any = "All";
  maxDateForPicker: Date = new Date();
  // @ViewChild('content') content: any;
  @Input() formConfig!: any;
  @Input() customerDataInput: any;
  currentYear: any;
  @ViewChild(HeaderComponent) header!: HeaderComponent;
  @ViewChild(SidebarComponent) sidebar!: SidebarComponent;

  criticalInsurance: any = [{
    title: 'Subscription Details',
    logo: 'img_link',
    data: '30 days'
  },
  {
    title: 'Questions Details',
    logo: 'img_link',
    data: 'questions data'
  }
  ]
  normalSpouseRegistration: any = true;
  noReason: any = ''
  normalDependentRegistration: any = true;
  dependentType: any = '';
  isMarried: any;
  isCommonLaw: any;
  showDependent: any;
  dummyDependentData: any;
  marriageType: any;
  isInsuranceCheck: boolean = false;
  childCount: any = 0;
  showChildForm: boolean = false;
  childrenDetails: any = [];
  childrenDetailsForNormalReg:any = [];
  editChildUpdate: boolean = false;
  childIndex: any = 0;
  mode: any;
  dummyPlanAndPriceChangeData: any;
  validateCheck: any = true;
  showValidatePlans: boolean = false;
  combinedPlanAndPriceChangeData: any;
  customerRegisteredServices: any = [];
  todayDate: any;
  validatePlansData: any;
  displayPackage: any;
  role: any = '';
  plansError: boolean = false;
  cartcheckvalue: any;
  plansObj: any;
  addPlansConfigData: any;
  warningsData: any;
  addPlanEnrollmentDate: any;
  unselected: any = [];
  selectedPlans_: any = [];
  obj:any = {};
  obj1:any=[];
  downgradePlans: any = [];
  unSelectedPlans_: any = [];
  newlySelectedPlans: any = [];
  planobjdata!: { packageId: any; packageName: any; planproductname: any; groupid: any; groupName: any; id: any; name: any; planLevel: any; planLevelParent: any; fusebillPlanID: any; planFrequencyID: any; isBundle: any; coverage: any; planCoverage: any; bundledProducts: any[]; products: any[]; };
  planssummaryopt: any;
  planAmount: any;
  plansskumain: any = [];
  planssummarymain: any;
  plandetailsobjvalue: any;
  optionstitle: any;
  showoptions: any;
  showPlanDetails: any = false;
  showAfterPlanDetails:any = false;
  showSpouseInfo: any = false;
  maritalStatus: any = "";
  reasonForLate: any = "";
  handlePlanUpgrade: any;
  priceChangeText: any;
  coverageChangeText: any;
  provisioningSites: any;
  coverageChange: any;
  coverageChange2: any;
  hasSpouse: any = false;
  hasChildren: any = false;
  planEnrollmentDates: any;
  showROAS: any[] = [];
  addDependentWithSpouse: boolean = false;
  coveredByAnotherPlan: any;
  selectedDepId:any;
  addToPolicy: any;
  dependentChildCoverage: string = 'undefined';
  plansSummaryObj: any = [];
  firstColumn = ['Plan Name', 'Coverage', 'Price', 'Tax']
  signaturecheckvalue1cc: any;
  public signaturemessagecc: boolean = false;
  public signaturecheckvaluecc: boolean = false;
  public signaturecheckcc: boolean = true;
  spouseCovered: any = false;
  childCovered: any = false;
  totalCount: number = 0;
  totalSummaryPrice: any = 0;
  oldExistingPlans: any = [];
  selectedTrues: any = [];
  isSpouseExists: any = false;
  isUpgradeOrDowngrade: any = '';
  productobj: any = {};
  selectedDependentDetails: any = {};
  customerPlans: any;
  upgradeorDowngradeplans: any = []
  upgradeorDowngradeplansSelected: any = []
  isCorpCustomer: boolean = false;
  Displayproducts: any;

  applicantSpousename: any;
  spouseName:any;
  applicantfirstname: any;
  applicantChildrenname: any;
  lecHistory: any = [];
  marriedDate: any;
  padView: any;
  spouseMarriedDate: any;
  genders: any;
  showDependentForm: any=false;
  firstMessage: any = '';
  secondMessage: any = '';
  currentamount:any = 0;
  upcomingamount:any = 0;
  backdatedamount:any = 0;
   currentamountUI:any = 0;
  upcomingamountUI:any = 0;
  backdatedamountUI:any = 0;
  firstConfirmMessage: any;
  secondConfirmMessage: any;
  thirdConfirmMessage: any;
  effectedPackages: any = [];
  effectedPackageNames:any = [];
  existingSpouse: any;
  existingChildren: any;
  isSpouseExistsBefore: boolean = false;
  isChildExistsBefore: boolean = false;
  showAddToPolicyError: boolean = false;
  isGradError: boolean = false;
  corpMessage: any;
  payrollDeduction: any = false;
  isSpouseSelected: any = {};
  isChildSelected:any = {};

  constructor(
    private renderer: Renderer2,
    private http: HttpClient,
    private formBuilder: FormBuilder,
    public elementRef: ElementRef,
    private _decimalPipe: DecimalPipe,
    private datePipe: DatePipe,
    private titleCase: TitleCasePipe,
    private phoneNoFormat: PhoneNoFormatPipe,
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private renderer2: Renderer2,
    private router: Router,
    public _LoaderService: LoaderService,
    private _LoggerService: LoggerService,
    private _CustomDatePipe: CustomDatePipe
  ) {

  }
  @ViewChild('sigPad') sigPad;
  sigPadElement: any;
  context: any;
  isDrawing = false;
  disabledelement: any;
  ngOnInit() {
    this.getLanguageTokens();

    this.showDependent = false;

    this.planEnrollmentDates = [
      moment().subtract(1, 'months').startOf('month').format('MMM-DD-YYYY'), // Previous month
      moment().startOf('month').format('MMM-DD-YYYY'),
      moment().add(1, 'months').startOf('month').format('MMM-DD-YYYY'),
      moment().add(2, 'months').startOf('month').format('MMM-DD-YYYY')
    ]
    this.currentYear = Number(new Date().getFullYear());

    setTimeout(() => {
      this.sigPadElement = this.sigPad?.nativeElement;
      this.context = this.sigPadElement?.getContext('2d');
      if(this.context){
        this.context.strokeStyle = 'black';
      }
    }, 10000);
    this.minDate = moment().subtract(100, "years").calendar();
    this.maxDate = moment().subtract(16, "years").calendar();

    this.minDate = new Date(this.minDate);

    this.maxDate = new Date(this.maxDate);

    this.minDateHire = moment().subtract(60, "years").calendar();

    // this.minDatechild = new Date(this.minDateHire);

    this.minDatechild = new Date();
    const today = new Date();
    this.minDatechild.setFullYear(today.getFullYear()-21);
    this.minDatechild.setMonth(0); // January
    this.minDatechild.setDate(1); // 1st
    this.maxDatechild = new Date();
    this.getFormConfiguration('en');
    this.dependentBackgroundColor = ["#E6D1FF",
      "#FFE2FB",
      "#E2F1FF",
      "#E6D1FF",]
    this.customerid = sessionStorage.getItem('customerId');
    this.accessToken = sessionStorage.getItem('accessToken');


    // this.getDraftInvoice();
    this.route.queryParams.subscribe(params => {
      //this._LoggerService.log(params);
    })
    this.logoimage = sessionStorage.getItem("logo")
    this.unlistener = this.renderer2.listen("document", "click", event => {
      //this._LoggerService.log(event)
      let element = event.target
      var attribute = element.getAttribute("href");
      var heading = element.innerText;
      // this.videoPopup = 'block';
      if (event.target.className == 'video') {
        event.preventDefault();
        this.videoLink = attribute;
        this.videoTitle = heading;
        //this._LoggerService.log(this.videoLink)
        //this._LoggerService.log(this.videoTitle)
        var video = document.getElementsByTagName('video')[0];
        //this._LoggerService.log(video)

        this.openVideoPopup();
        video.load();
        video.play();
      }
      if (event.target.className == 'shortlink') {
        this.openSupportPopup();
        this.support_link = this.sanitizer.bypassSecurityTrustResourceUrl(attribute);
        event.preventDefault();
      }
      if (event.target.className == 'booklet') {
        this.openequitablePopup();
        event.preventDefault();
        this.booklet_link = element.getAttribute("href");
      }
      if (event.target.className == 'healthcard') {
        this.downloadCard();
        event.preventDefault();
        this.health_card = element.getAttribute("href");
      }
      if (event.target.classList.contains('closevideo')) {
        var video = document.getElementsByTagName('video')[0];
        video.pause();
      }
      if (event.target.className == 'closevideo') {
        var video = document.getElementsByTagName('video')[0];
        video.pause();
      }
      if (event.target.className == 'drugsmart') {
        event.preventDefault();
        window.open("https://drugsmart-pharmacy.myshopify.com/account/register",
          "Register Direct2U pharma", "menubar=1,toolbar=yes,resizable=0,width=800,height=465,left=220,top=170");
      }
      if (event.target.className == 'bedrugsmart') {
        event.preventDefault();
        window.open("https://bedrugsmart.ca/pages/direct2u",
          "Direct2U pharma", "menubar=1,toolbar=yes,resizable=0,width=800,height=465,left=220,top=170");
      }
      if (event.target.classList.contains('site')) {
        //this._LoggerService.log('attribute',attribute)
        //this._LoggerService.log(typeof attribute)
        //this._LoggerService.log(attribute == 'unsafe: https://www.myfriendlylawyer.com/subscriptions')
        //this._LoggerService.log(attribute == 'https://www.myfriendlylawyer.com/subscriptions')
        if (attribute == 'unsafe: https://www.myfriendlylawyer.com/subscriptions') {
          attribute = 'https://www.myfriendlylawyer.com/subscriptions';
        }
        //this._LoggerService.log('afterattribute',attribute)
        this.iframeLink = this.sanitizer.bypassSecurityTrustResourceUrl(attribute)
        this.iframeTitle = heading;
        //this._LoggerService.log(this.iframeLink.changingThisBreaksApplicationSecurity)
        if (this.iframeLink.changingThisBreaksApplicationSecurity != 'https://secure.kiihealth.ca/register?eac=BNFZ1222&locale=en' && this.iframeLink.changingThisBreaksApplicationSecurity != 'https://groupbenefitz.lifespeak.com' && this.iframeLink.changingThisBreaksApplicationSecurity != 'http://my.norton.com/' && this.iframeLink.changingThisBreaksApplicationSecurity != 'https://clients.cowangroup.ca/') {
          //this._LoggerService.log(this.iframeLink.changingThisBreaksApplicationSecurity != 'https://secure.kiihealth.ca/register?eac=BNFZ1222&locale=en')
          this.openiframePopup();
        }
        if (this.iframeLink.changingThisBreaksApplicationSecurity == 'https://secure.kiihealth.ca/register?eac=BNFZ1222&locale=en') {
          window.open("https://secure.kiihealth.ca/register?eac=BNFZ1222&locale=en", "CloudMDKii", "menubar=1,toolbar=yes,resizable=0,width=800,height=465,left=220,top=170");
        }
        if (this.iframeLink.changingThisBreaksApplicationSecurity == 'https://groupbenefitz.lifespeak.com') {
          window.open("https://groupbenefitz.lifespeak.com", "LifeSpeak", "menubar=1,toolbar=yes,resizable=0,width=800,height=465,left=220,top=170");
        }
        if (this.iframeLink.changingThisBreaksApplicationSecurity == 'http://my.norton.com/') {
          window.open("http://my.norton.com/", "Norton", "menubar=1,toolbar=yes,resizable=0,width=800,height=465,left=220,top=170");
        }

        if (this.iframeLink.changingThisBreaksApplicationSecurity == 'https://clients.cowangroup.ca/') {
          window.open("https://clients.cowangroup.ca/", "Cowin", "menubar=1,toolbar=yes,resizable=0,width=800,height=465,left=220,top=170");
        }
        event.preventDefault();
      }
      // alert(attribute);

      // alert(heading);
      // document.getElementsByClassName("vid-title")[0].innerText=heading;
      // document.getElementsByTagName("source")[0].src=attribute;



      // var video = document.getElementsByTagName('video')[0];



      // video.load();
      // video.play();
    });

    this.fusbillinfocaptchavalue = '6LfVtGwUAAAAALHn9Ycaig9801f6lrPmouzuKF11';
    // this.fusbillinfocaptchavalue = '6Lfj88QgAAAAAAJ8bY1NW0Bgmm9V8PV2onC4RCNx';
    this.url = window.origin + "/";
    this.paymentUri = this.url + "home";

    this.paymentsuccessuri = this.url + "home";



    this.customerid = sessionStorage.getItem("customerId");


    this.phoneform = this.formBuilder.group({
      primaryPhone: ['', [Validators.required, Validators.minLength(16), Validators.maxLength(16)]],
      secondaryPhone: ['', [Validators.minLength(16), Validators.maxLength(16)]],
    });

    this.dependentTypeForm = this.formBuilder.group({
      dependentType: ['', [Validators.required]],
      marriageType: ['', [Validators.required]],
      marriageDate: ['', [Validators.required]],
      childrenCountData: [{ value: 0, disabled: true }],
      effectiveDate: ['', [Validators.required]]
    })
    this.dependentTypeForm1 = this.formBuilder.group({
      effectiveDate: ['', [Validators.required]]
    })



    // this.dependentTypeForm.get('childrenCountData')?.setValue(0, {emitEvent: false})
    // { validators: [phoneNumbersMustBeDifferent]}
    this.addressform = this.formBuilder.group({
      firstName: ['', [Validators.required]],
      lastName: ['', [Validators.required]],
      line1: ['', [Validators.required]],
      line2: [''],
      city: ['', [Validators.required]],
      country: ['', [Validators.required]],
      province: ['', [Validators.required]],
      dob: ['', [Validators.required]],
      gender: ['', [Validators.required]],
      postalCode: ['', [Validators.required, postalcodeValidator]],
      primaryPhone: ['', [Validators.required, Validators.minLength(16), Validators.maxLength(16)]],
      secondaryPhone: ['', [Validators.minLength(16), Validators.maxLength(16)]],
      email: [
        '',
        [
          Validators.required,
          // Validators.pattern(this.commonPatternsService.emailPattern),
          Validators.pattern(
            '^(?!\\s)[_A-Za-z0-9._%+-]+(\\.[_A-Za-z0-9._%+-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$'
          ),
          //pattern(/^(?!\\s)*[\sA-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[a-z]{2,3}(?!\\s)*$/i),
          //          pattern('^(?!\\s)[_A-Za-z0-9-]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$')])],
        ],
      ],
    });
    // secondaryPhone: ['',[Validators.minLength(16), Validators.maxLength(16),phoneNumbersMustBeDifferent]],
    // secondaryPhone: ['', notSameAsPrimaryValidator('primaryPhone')]



    this.spouseform = this.formBuilder.group({
      fullName: ['', [Validators.required, Validators.minLength(2), this.fullNameValidator]],
      dependentType: ['', [Validators.required, Validators.minLength(1)]],
      dob: ['', [Validators.required, this.ageValidator(18)]],
      email: ['', [Validators.pattern('^[_A-Za-z0-9-]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$')]],
      coveredByAnotherPlan: ['', [Validators.required]],
      insurer: [''],
      dateOfMarriage: ['', [Validators.required]],
      maritalStatus: [''],
      reasonForLate: ['']
    });



   this.spouseform.get('coveredByAnotherPlan')?.valueChanges.subscribe(value => {
    const insurerControl = this.spouseform.get('insurer');

    if (value === true || value === 'true') {
      insurerControl?.setValidators([Validators.required]);
    } else {
      insurerControl?.clearValidators();
    }

    insurerControl?.updateValueAndValidity();
  });

   this.maritalStatusform.get('maritalStatus')?.valueChanges.subscribe(value => {
    const reason = this.maritalStatusform.get('reason');

    if (value === 'other') {
      reason?.setValidators([Validators.required]);
    } else {
      reason?.clearValidators();
    }

    reason?.updateValueAndValidity();
  });

    this.cobform = this.formBuilder.group({
      insurer: ['', [Validators.required]],
      cobCoverage: ['', [Validators.required]],
    });
    
    this.maritalStatusform = this.formBuilder.group({
      maritalStatus: ['', [Validators.required]],
      reason: ['']
    });


    this.updatespouseform = this.formBuilder.group({
      firstName: ['', [Validators.required, Validators.minLength(1)]],
      lastName: ['', [Validators.required, Validators.minLength(1)]],
      dob: ['', [Validators.required, this.ageValidator(18)]],
      email: ['', [Validators.pattern('^[_A-Za-z0-9-]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$')]],
      coveredByAnotherPlan: ['', [Validators.required]],
      healthPlan: ['', [Validators.required]],
      insurer: ['', [Validators.required]],
      martialStatus: ['', [Validators.required]],
      effectiveDate: ['', [Validators.required]],
      gender: ['', [Validators.required]],
      status: [''],
    });


    this.deletespouseform = this.formBuilder.group({
      firstName: [{ value: '', disabled: true }],
      lastName: [{ value: '', disabled: true }],
      dob: [{ value: '', disabled: true }],
      email: [{ value: '', disabled: true }],
      coveredByAnotherPlan: [{ value: '', disabled: true }],
      healthPlan: [{ value: '', disabled: true }],
      insurer: [{ value: '', disabled: true }],
      martialStatus: [{ value: '', disabled: true }],
      effectiveDate: [{ value: '', disabled: true }],
      gender: [{ value: '', disabled: true }],
      status: [{ value: '', disabled: true }],
      reason: [{ value: '' }]
    });

    this.deleteForm = this.formBuilder.group({
      deletionReason: ['', Validators.required],
      otherReason: [''],
      selectedDepId: [''],
    });

    const deletionReasonControl = this.deleteForm.get('deletionReason');
    if (deletionReasonControl) {
      deletionReasonControl.valueChanges.subscribe(value => {
        const otherReasonControl = this.deleteForm.get('otherReason');
        if (otherReasonControl) {
          if (value === 'other') {
            otherReasonControl.setValidators(Validators.required);
          } else {
            otherReasonControl.clearValidators();
          }
          otherReasonControl.updateValueAndValidity();
        }
      });
    }

    this.deletedependentform = this.formBuilder.group({
      firstName: [{ disabled: true }],
      lastName: [{ disabled: true }],
      dob: [{ disabled: true }],
      email: [{ disabled: true }],
      coveredByAnotherPlan: [{ disabled: true }],
      carrierName: [{ disabled: true }],
      postSecondaryStudent: [{ disabled: true }],
      // martialStatus: [{disabled: true}],
      effectiveDate: [{ disabled: true }],
      gender: [{ disabled: true }],
      // status: [{disabled: true}],
      age: [{ disabled: true }],
      phoneNum: [{ disabled: true }],
      graduationDate: [{ disabled: true }],
    });


    // this.todayDate = moment(new Date()).format('MM-DD-YYYY')
    // this.spouseform.get('effectiveDate')?.setValue(this.todayDate, {emitEvent: false})

    if (this.dependentType === 'child' && this.showChildForm) {
      this.pureDependentform = this.formBuilder.group({
        firstName: ['', [Validators.required, Validators.minLength(1)]],
        lastName: ['', [Validators.required, Validators.minLength(1)]],
        gender: ['', [Validators.required]],
        // dob: ['', [Validators.required]],
        dob: ['', Validators.compose([Validators.required, childrenminimumAgeValidator,this.validateDateforGraduationandBirth])],
        age: [''],
        phoneNum: [''],
        coveredByAnotherPlan: ['', [Validators.required]],
        graduationDate: [''],
        carrierName: ['', [Validators.required]],
        specialNeeds: [''],
        postSecondaryStudent: [''],
        // martialStatus: ['', [Validators.required]],
        effectiveDate: ['', [Validators.required]],
      });
    }
    this.dependentform = this.formBuilder.group({
      fullName: ['', [Validators.required, Validators.minLength(2), this.fullNameValidator]],
      dob: ['', [Validators.required]],
      age: [''],
      phoneNum: [''],
      coveredByAnotherPlan: ['', [Validators.required]],
      graduationDate: [''],
      carrierName: ['', [Validators.required]],
      specialNeeds: [''],
      postSecondaryStudent: [''],
      reasonForLate: ['']
    });

    // Subscribe to value changes of effectiveDate
    this.dependentTypeForm1.get('effectiveDate')?.valueChanges.subscribe((newDate) => {
      console.log(newDate);
      if (newDate) {
        this.handleContinue('remove');
      }
    });


    this.paymentform = this.formBuilder.group({
      cutomerId: [""],
      // Id: [""],
      PublicApiKey: [""],
      SuccessUri: [""],
      FailUri: [""],
      FirstName: ["", [Validators.required]],
      LastName: ["", [Validators.required]],
      email: ["", Validators.compose([Validators.required, Validators.pattern('^(?!\\s)[_A-Za-z0-9-]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$')])],
      CardNumber: ["", [Validators.required]],
      ExpirationMonth: ["", Validators.required],
      ExpirationYear: ["", Validators.required],
      Cvv: ["", Validators.compose([Validators.required, Validators.minLength(3), Validators.maxLength(4)])],
      recaptchaReactive: ["", Validators.required],
    })

    this.ccform = this.formBuilder.group({
      cutomerId: [""],
      Id: [""],
      PublicApiKey: [""],
      SuccessUri: [""],
      FailUri: [""],
      FirstName: ["", [Validators.required]],
      LastName: ["", [Validators.required]],
      email: [""],
      CardNumber: ["", [Validators.required]],
      ExpirationMonth: ["", Validators.required],
      ExpirationYear: ["", Validators.required],
      Cvv: ["", Validators.compose([Validators.required, Validators.minLength(3), Validators.maxLength(4)])],
      nameonthecard: [""],
      aptcheck: [""],
      streetaddress: [""],
      streetaddressline2: [""],
      city: [""],
      countryId: [""],
      stateId: [""],
      postalcode: [""],
      recaptchaReactive: ["", Validators.required],
    });

    this.padform = this.formBuilder.group({
      bankcode: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(3)]],
      transitNumber: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(5)]],
      accountNo: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(12)]],
      bankdetails: [''],
      file: [''],
    })

    this.paymentMethodForm = this.formBuilder.group({
      bankCode: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(3)]],
      branchCode: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(5)]],
      accountNumber: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(12)]],
      files: [''],
      paymentmethod: [''],
    })

    this.valisignform = this.formBuilder.group({
      code: ['', [Validators.required, Validators.minLength(6)]],
    })

    this.route.queryParams.subscribe((params) => {
      if (params["success"]) {
        if (params["success"] == "False") {

          setTimeout(() => {
          }, 10);
          // Swal.fire({
          //   allowOutsideClick: false,
          //   title: this.lang?.An_error_occurred_while_processing_the_transaction_possible_failure_reasons_are,
          //   text: this.lang?.The_payment_information_could_not_be_verified,
          //   icon: "warning",
          //   width: "50%",
          //   showCancelButton: false,
          //   confirmButtonText: "Ok",
          //   cancelButtonText: "No",
          // }).then((result) => {
          //   if (result.value) {
          //     this.router.navigate(["home"]);
          //   } else {
          //   }
          // });
          Swal.fire({
            allowOutsideClick: false,
            title: this.lang?.An_error_occurred_while_processing_the_transaction_possible_failure_reasons_are || 'An error occurred while processing the transaction. possible failure reasons are',
            text: this.lang?.The_payment_information_could_not_be_verified || "The payment information could not be verified",
            confirmButtonText: "Ok",
          }).then((result) => {
            if (result.value) {
              this.router.navigate(["home"]);
            }
          });
        }
        else {
          let oldCardDetails = JSON.parse(localStorage.getItem("oldCardDetails") ?? "{}")
          let newCardDetails = JSON.parse(localStorage.getItem("newCardDetails") ?? "{}")

          let cardDetails = {
            old: oldCardDetails,
            new: newCardDetails
          }
          let Endpoint = '/' + this.customerid + '/paymentType/CREDIT_CARD/change';
          this.http.post(api.url + Endpoint, { "paymentId": parseInt(params["paymentMethodId"]), "cardDetails": cardDetails }, {
            headers: {
              Authorization: 'Bearer ' + this.accessToken,
            }
          }).subscribe((response: any) => {
            this.router.navigate(["home"]);
            localStorage.removeItem("oldCardDetails")
            localStorage.removeItem("newCardDetails")
            if (response.status == 200) {
              if (response.message == "Payment method updated successfully. Any changes related to plans and member-cards if applicable, will be reflected soon.") {
                setTimeout(() => {
                  window.location.reload()
                }, 40000);
                let existingCreditCards = JSON.parse(sessionStorage.getItem('existingCreditCards') || '')
                if (existingCreditCards && existingCreditCards?.length > 0) {
                  for (let i = 0; i < existingCreditCards.length; i++) {
                    this.http.delete(api.url + `/payment/cc/${existingCreditCards[i]?.id}/remove`, {
                      headers: {
                        Authorization: 'Bearer ' + this.accessToken,
                        'Content-Type': 'application/json',
                      }
                    })
                      .subscribe((response: any) => {
                        if (response.status != 200) {
                          Swal.fire({ title: 'Error', text: 'Error deleting old credit card' + existingCreditCards[i]?.maskedCardNumber })
                        }
                      })
                  }
                  sessionStorage.removeItem('existingCreditCards')
                }
              }
              Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })
            }
            else {
              Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })
            }
          }, (error) => {
            Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
          });


        }
      }
    });


    this.adjudicationQueues()

  }


  
  validateDateforGraduation = (control: AbstractControl): { [key: string]: any } | null => {
    if (this.dependentform) {
      let dobControl = this.dependentform.get('dob');
      //this.consoleMessage({ dobControl })
      // if (!dobControl.value) {
      //   return { dateOfBirth: true };
      // }
      if (dobControl) {
        let dob = new Date(dobControl.value);
        if (new Date(control.value) < dob) {
          return { validGraduationDate: true };
        }
      }
    }
    return null;
  };
  validateDateforGraduationandBirth = (control: AbstractControl): { [key: string]: any } | null => {
    if (this.dependentform) {
      let gradeControl = this.dependentform.get('graduationDate');
      //this.consoleMessage({ dobControl })
      // if (!dobControl.value) {
      //   return { dateOfBirth: true };
      // }
      if (gradeControl) {
        let grade = new Date(gradeControl.value);
        if (new Date(control.value) > grade) {
          return { validGraduationDateBirth: true };
        }
      }
    }
    return null;
  };

  public adjudicationQueues() {
    if(!this.customerid){
      return;
    }
    let endPoint = '/get-adjudication-queues/' + this.customerid
    // let endPoint = '/'+3493+'/achDetails'
    this.http.get(api.apiUrl +'/api/ap' + endPoint, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      if (response.status == 200 || response.statusCode == 200) {
        this.customerQueues = response.data.queues ?? []
        for(const queue of this.customerQueues) {
          if(queue.status == 'Review' && queue.process.includes("Spouse")){
            this.isSpouseInUnderwriting = true;
          }
        }
      }
      else {
        Swal.fire({allowOutsideClick: false,title: this.lang?.Info, text:response.message})
      }
    }, (error) => {
      Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error?.error?.error?.message })
    })
  }


  public handleActionMode(value: any) {
    this.needToUpdate = ''
    this.cobevent = ''
    this.showCorpPlansTable = false;
    this.cobeventType = ''
    this.enactMode = value;
    this.isExcludeSpouse = false;
    this.isExcludeAll = false;
    this.isExcludeChild = false;
    this.isExcludeChildAndSpouse = false;
    this.finalEffectiveDate = null;
    this.clearAllMessages();
    this.dependentType = ''
    this.maritalStatus = ''
    this.needToUpdate = false;
    this.firstConfirmMessage = ''
    this.secondConfirmMessage = ''
    this.corpMessage = ''
    this.firstMessage = ''
    this.thirdConfirmMessage = ''
    this.underWritingMessage1 = ''
    this.underWritingMessage2 = ''
    this.deleteForm.reset()
    this.spouseform.reset()
    this.childrenDetails = []
    this.childrenDetailsForNormalReg = []
    this.addToPolicy = ''
    this.secondMessage = ''
    this.dependentform.reset()
    this.cobform.reset()
  }

  public handleMaritalStatus(value: any) {
    this.maritalStatus = value;
  }


  public splitPackages(){
    const currentCoverage = this.coverageChange2;
    let splitPackages:any = [];
    switch(currentCoverage) {
      case "STF":
        splitPackages.push('STC')
        splitPackages.push('CTF')
        break;
      case "FTS":
        splitPackages.push('FTC')
        splitPackages.push('CTS')
        break;
      default:
        break;
    }
    return splitPackages;
  }



  public ageValidator(minAge: number): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const dob = control.value;
      if (!dob) {
        return null; // No DOB provided
      }

      const today = new Date();
      const birthDate = new Date(dob);
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();

      if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }

      return age < minAge ? { 'ageError': true } : null; // Return an error if under 18
    };
  }

  public handleContinue(response:any) {
    this.showPlanDetails = true;
    this.showAfterPlanDetails = false;
    console.log(this.dependentType, "slug889")
    this.dependentType = this.dependentType ?? 'spouse'
    console.log(this.dependentTypeForm.get('effectiveDate')?.value)
    console.log(this.dependentform.get('effectiveDate')?.value)
    let effectiveDate: any;

    console.log('this.dependentCoverage990', this.childrenDetails)
    let childCovered = 'none';
    let childCoveredCount = 0;
    if (this.childrenDetails && this.childrenDetails.length > 0) {
      for (const cd of this.childrenDetails) {
        if (cd.coveredByAnotherPlan == true) {
          childCoveredCount++;
        }
      }

      if (this.childrenDetails.length == childCoveredCount) {
        childCovered = 'full'
      } else {
        childCovered = 'partial'
      }


      if (childCoveredCount == 0) {
        childCovered = 'none'
      }
    }
    // commented
    // return;

    sessionStorage.removeItem("plansummarymain")
    sessionStorage.removeItem("plansskumain");
    sessionStorage.removeItem("plansummaryopt");
    sessionStorage.removeItem("plansummary");
    sessionStorage.removeItem("selectedPlans");
    sessionStorage.removeItem("totalAmount");
    sessionStorage.removeItem("totalAmountUI");
    console.log(this.isCorporateAccount, 'isCorporateAccount')

    if (response.status == 200 && !this.isCorporateAccount) {
      console.log(response?.data, 'asda')
      this.coverageChange = response?.data?.coverageChange;
      let prs = response?.data?.gsOrEqMemberStatus ?? {}
      let prsStatus: any = []
      const prsKeys = Object.keys(prs);
      if (prsKeys.length > 0) {
        for (const prk of prsKeys) {
          if (prs[prk] == true) {
            if (prk == 'greenShildCustomer') {
              prsStatus.push('GreenShield')
            }
            if (prk == 'hcdSecuremePlans') {
              prsStatus.push('HCD Secureme')
            }
            if (prk == 'equitableCustomer') {
              prsStatus.push('Equitable')
            }
            if (prk == 'phrCustomer') {
              prsStatus.push('PHR')
            }
            if (prk == 'waddelCustomer') {
              prsStatus.push('Waddel')
            }
          }
        }
      }
      this.provisioningSites = prsStatus.toString() ?? ""


      console.log("calledoooo")
      let data__ = response?.data?.packages
      this.customerPlans = response?.data?.customerPlans;

      console.log(this.customerPlans, "custplans889")
      setTimeout(() => {

        const coverageMap: { [key: string]: string } = {
          STC: 'COUPLE',
          STF: 'FAMILY',
          CTF: 'FAMILY',
          CTS: 'SINGLE',
          FTS: 'SINGLE',
          FTC: 'COUPLE',
          F: 'FAMILY'
        };

        console.log(this.showAfterPlanDetails)
        console.log(this.secondTarget)

        let targetCoverage = this.showAfterPlanDetails ? this.secondTarget : coverageMap[this.coverageChange];
        this.customerPlans.forEach(element => {
          const dom: HTMLElement = this.elementRef.nativeElement;

         
            console.log(element, "jiihhsh")
            if (element.isBundle) {


              let coverages = ['SINGLE', 'COUPLE', 'FAMILY'];
              let clicked = false;
              
               
              if ($("#plancheck" + element.planId + ".coverage" + targetCoverage.toUpperCase()).length == 0) {
                for (const cov of coverages) {
                  const selector = "#plancheck" + element.planId + ".coverage" + cov.toUpperCase();
                  if ($(selector).length > 0 && !clicked) {
                    $(selector).click();
                    $(selector).prop("disabled", true);
                    clicked = true;
                  }
                }
              } else {
                const selector = "#plancheck" + element.planId + ".coverage" + targetCoverage.toUpperCase();
                $(selector).click();
                $(selector).prop("disabled", true);
              }


            }
            else { 
              console.log(targetCoverage, "after else")
              if (targetCoverage && targetCoverage != '-') {
                // const plan: any = dom.querySelector("#plancheck" + element.planSelectionId2 + ".coverage" + element.coverage1.toUpperCase());

                // $("#plancheck" + element.planSelectionId2 + ".coverage"+element.coverage).click()
                console.log("#plancheck" + element.planId + ".coverage" + targetCoverage.toUpperCase())
                $("#plancheck" + element.planSelectionId2).click()
                $("#plancheck" + element.planId + ".coverage" + targetCoverage.toUpperCase()).prop("disabled", true);
              }
              else {
                console.log($("#plancheck" + element.planSelectionId2))
                $("#plancheck" + element.planSelectionId2).click()
                $("#plancheck" + element.planSelectionId2).prop("disabled", true);

              }
            }
          


        });
      }, 1000);

      this.selectedPlans_ = [];
      this.oldExistingPlans = []
      this.selectedTrues = []
      this.unSelectedPlans_ = []
      this.totalSummaryPrice = 0;

      for (let package_ of data__) {
        console.log(package_, 'asdaas2');

        let groupKeys_ = Object.keys(package_.groups);
        for (let i = 0; i < groupKeys_.length; i++) {
          let groups = groupKeys_[i];

          for (let j = 0; j < package_.groups[groups].length; j++) {
            let group = package_.groups[groups][j];

            for (let k = 0; k < group.plans.length; k++) {
              let plan = group.plans[k];
              let pan = plan.productAddonssNames;
              console.log(plan.isBundle, "bundled")

              for (let product of pan) {
                if (plan.productAddonss[product]) {
                  const paon = plan.productAddonss[product];

                  const selectedAddons = paon.filter((item: any) => item.selected);



                  if (selectedAddons && selectedAddons.length > 0) {
                    const unSelectedAddon = paon.find((item: any) => !item.selected);

                    console.log(unSelectedAddon)
                    if (!!unSelectedAddon && plan.selected) {
                      this.upgradeorDowngradeplans.push({
                        'name': unSelectedAddon?.name,
                        'addon': unSelectedAddon,
                        'isBundle': plan.isBundle
                      })
                    }
                    if (!unSelectedAddon && plan.selected) {
                      for (const selectedAddon of selectedAddons) {
                        const customerPlan = this.customerPlans.find((item: any) => (item.planId == selectedAddon.planId && (item.terminationDate == null || item.terminationDate == "")))
                        console.log(customerPlan, selectedAddon)
                        if (customerPlan.coverage1.toUpperCase() == selectedAddon.planCoverage) {
                          this.upgradeorDowngradeplans.push({
                            'name': selectedAddon?.name,
                            'addon': selectedAddon,
                            'isBundle': plan.isBundle
                          })
                        }
                      }
                    }
                    if (plan.selected) {
                      //check for the termination date
                      for (const selectedAddon of selectedAddons) {
                        this.upgradeorDowngradeplansSelected.push({
                          'name': selectedAddon?.name,
                          'addon': selectedAddon,
                          'isBundle': plan.isBundle
                        })

                      }
                    }
                  }
                  // Loop over the addonss for the plan
                  for (const paon_ of paon) {
                    console.log(paon_, '12345');

                    if (paon_.selected === true) {
                      // We can call the onCheckboxChange



                      this.selectedTrues.push({
                        id: paon_.id,
                        productId: paon_.productId,
                        planId: paon_.planId
                      });

                      paon_['checked'] = true;  // Mark the plan as checked
                      this.totalSummaryPrice += paon_.calculatedTax.total;
                      this.selectedPlans_.push(paon_);
                      this.oldExistingPlans.push(paon_);
                    } else {
                      this.unSelectedPlans_.push(paon_);
                    }
                  }
                }
              }
            }
          }
        }






        console.log(this.selectedPlans_, 'asd2342');
        console.log(this.unSelectedPlans_, 'asd23421');
        this.getPlanSummaryObject();
      }


      console.log('selectedTrues', this.selectedTrues)


      this.specialpackages = data__ ?? []


      //get the selected coverages



      // this.getCustomerData();
      // this.closeDependentmodal.nativeElement.click();
      // Swal.fire({allowOutsideClick: false, title: this.lang?.Info, text: response.message });
    }

    if (response.status == 200 && this.isCorporateAccount) {
      this.coverageChange = response?.data?.coverageChange;
      sessionStorage.setItem(
        "customerTierId",
        response.data.customer.customerTierId
      );
      sessionStorage.setItem("employeeshare", "0");
      this.mainarray = [];
      this.mainarrayValues = [];
      this.mainarrayFinal = [];
      this.modifiedBlocksPaidByCompany = '',
        this.modifiedBlocksCoveredByCompany = '',

        sessionStorage.setItem("planDetailsArrayBlock", "[]");
      this.effectiveEmployeeTotalContibution = 0;
      sessionStorage.setItem("totalAmount", "0");
      sessionStorage.setItem("totalAmountUI", "0");

      sessionStorage.setItem("allSelectedPlans", "[]");

      sessionStorage.setItem("plansummary", "[]");
      sessionStorage.setItem("selectedPlans", "{}");
      sessionStorage.setItem("selectedPlansLife", "{}");
      sessionStorage.setItem("plansummarymain", "[]");
      sessionStorage.setItem("plansummaryopt", "[]");
      sessionStorage.removeItem("Spousesignature")

      this.addbenificaryData = []
      // sessionStorage.setItem(
      //   "corporateStateId",
      //   response.data.workingProvince.id
      // );
      // sessionStorage.setItem(
      //   "corporateStateName",
      //   response.data.workingProvince.name
      // );
      // sessionStorage.setItem(
      //   "companyStateId",
      //   response.data.corporateProvince.id
      // );


      this.allFormData = {}
      this.formData = {}
      sessionStorage.setItem('plansummaryLife', '[]');
      sessionStorage.setItem('planssummarymainLife', '[]');







      setTimeout(() => {



        
      setTimeout(() => {

        const coverageMap: { [key: string]: string } = {
          STC: 'COUPLE',
          STF: 'FAMILY',
          CTF: 'FAMILY',
          CTS: 'SINGLE',
          FTS: 'SINGLE',
          FTC: 'COUPLE',
          F: 'FAMILY'
        };

        let targetCoverage = coverageMap[this.coverageChange];
        // let targetCoverage = this.showAfterPlanDetails ? this.secondTarget : coverageMap[this.coverageChange];


        // this.customerSelectedPlansValues(this.customerSelectedPlans)


        this.customerSelectedPlans.forEach(element => {
          const dom: HTMLElement = this.elementRef.nativeElement;

         
            console.log(element, "jiihhsh")
            if (element.isBundle) {


              let coverages = ['SINGLE', 'COUPLE', 'FAMILY'];
              let clicked = false;
              console.log(targetCoverage, "targetCoverage9998")
              console.log($("#plancheck" + element.planId + ".coverage" + targetCoverage.toUpperCase()))
              console.log($("#plancheck" + element.planId + ".coverage" + targetCoverage.toUpperCase()).length)
              if ($("#plancheck" + element.planId + ".coverage" + targetCoverage.toUpperCase()).length == 0) {
                for (const cov of coverages) {
                  const selector = "#plancheck" + element.planId + ".coverage" + cov.toUpperCase();
                  if ($(selector).length > 0 && !clicked) {
                    $(selector).click();
                    $(selector).prop("disabled", true);
                    clicked = true;
                  }
                }
              } else {
                const selector = "#plancheck" + element.planId + ".coverage" + targetCoverage.toUpperCase();
                    console.log($(selector))
                $(selector).click();
                $(selector).prop("disabled", true);
              }


            }
            else { 
              console.log(targetCoverage, "after else")
              if (targetCoverage && targetCoverage != '-') {
                // const plan: any = dom.querySelector("#plancheck" + element.planSelectionId2 + ".coverage" + element.coverage1.toUpperCase());

                // $("#plancheck" + element.planSelectionId2 + ".coverage"+element.coverage).click()
                console.log("#plancheck" + element.planId + ".coverage" + targetCoverage.toUpperCase())
                $("#plancheck" + element.planSelectionId2).click()
                $("#plancheck" + element.planId + ".coverage" + targetCoverage.toUpperCase()).prop("disabled", true);
              }
              else {
                console.log($("#plancheck" + element.planSelectionId2))
                $("#plancheck" + element.planSelectionId2).click()
                $("#plancheck" + element.planSelectionId2).prop("disabled", true);

              }
            }
          


        });


        
        



      }, 6000);


        this.autoSelectCompanyPaidPlans();



        sessionStorage.setItem(
          "enrollmentdate",
          response.data.planEnrollmentDate
        );

      }, 1000);

      ///here
      sessionStorage.removeItem("paymentfail");
      this.companypaidproductid = [];
      this.disabledcompanypaidproductid = [];
      this.removedisabledcompanypaidproductid = [];
      this.adddisabledcompanypaidproductid = [];
      // this.applicantfirstname = this.capitalize(value.givenname);
      // this.planssummary = JSON.parse(
      //   sessionStorage.getItem("plansummary")
      // );



      console.log(response)
      this.specialpackages = [];
      this.packagesInBlocks = response.data.blocks;
      this.basepackages = response.data.packages;
      this.customerSelectedPlans = response.data.customerPlans



      let companyplans = this.convertpackagesToPlans2(
        this.packagesInBlocks
      )[1];
      let baseplans = this.convertpackagesToPlans2(this.basepackages)[1];
      this.calculateBasePlanDeltasforCCplans(
        this.packagesInBlocks.coveredByCompany,
        baseplans,
        companyplans
      );
      this.calculateBasePlanCPplans(
        this.packagesInBlocks.paidByCompany,
        baseplans,
        companyplans
      );

      // //console.log(this.packagesInBlocks.paidByCompany)
      // //console.log(this.modifiedBlocksPaidByCompany)
      this.mainarrayValues = this.cobminedcommonfunction(
        // this.packagesInBlocks.paidByCompany,
        this.modifiedBlocksPaidByCompany,
        this.modifiedBlocksCoveredByCompany,
        this.packagesInBlocks.paidByEmployee
      );

      let allPackages: any = [];
      for (let key in this.mainarrayValues) {
        //this.consoleMessage(key)
        allPackages.push(this.mainarrayValues[key]);
      }

      console.log(allPackages)
      // this.mainarray = allPackages;





      let filteredMainArray = allPackages
        .map((element: any) => {
          // Map the groups
          let filteredGroups = element.groups.map((group: any) => {
            // Map the plans
            let filteredPlans = group.plans.map((plan: any) => {
              // Filter the productAddonss


              let filteredProductAddonss = Object.keys(plan.productAddonss).reduce(
                (acc: any, key) => {

                  // Filter the products where display is true
                  // let filteredProducts = plan.productAddonss[key].filter((product: any) =>
                  //   product.hasOwnProperty('display') && product.display
                  // );
                  // let filteredProducts = plan.productAddonss[key].map((product: any) => {
                  //   // Check if the 'display' key exists and is true
                  //   if (product.hasOwnProperty('display') && product.display) {
                  //     return product; // Keep the object as-is if display is true
                  //   }
                  //   const newProduct = {};
                  //   // console.log("Product replaced with empty object:", product, "New product:", newProduct);
                  //   return newProduct;
                  // });
                  const containsOnlyEmptyObjects = plan.productAddonss[key].every(
                    (product: any) => Object.keys(product).length === 0
                  );

                  if (containsOnlyEmptyObjects) {
                    console.log("filteredProducts contains only empty objects.");
                  } else {
                    acc[key] = plan.productAddonss[key];
                    console.log("filteredProducts contains non-empty objects.");
                  }
                  // if (filteredProducts.length > 0) {
                  //   acc[key] = filteredProducts;
                  // }
                  return acc;
                },
                {}
              );
              return {
                ...plan,
                productAddonss: filteredProductAddonss,
              };
            }).filter((plan: any) => Object.keys(plan.productAddonss).length > 0); // Remove plans without any matching productAddons

            return {
              ...group,
              plans: filteredPlans,
            };
          }).filter((group: any) => group.plans.length > 0); // Remove groups without any matching plans

          return {
            ...element,
            groups: filteredGroups,
          };
        })
        .filter((element: any) => element.groups.length > 0); // Remove elements without any matching groups


      console.log(filteredMainArray)

      this.mainarrayFinal = filteredMainArray

      console.log(this.mainarrayFinal)

      // this code needs to comment for single single in
      this.mainarrayFinal.forEach((element: any) => {
        element.groups.forEach((group: any) => {
          group.plans.forEach((plan: any) => {
            if (plan.productAddonss) {
              Object.keys(plan.productAddonss).forEach((key) => {
                // plan.productAddonss[key].forEach((product) => {
                const keys = ['planCoverage'];
                const filteredData = plan.productAddonss[key].filter((value: any, index: any, self: any) =>
                  self.findIndex((v: { [x: string]: any; }) => keys.every(k => v[k] === value[k])) === index
                );
                plan.productAddonss[key] = filteredData
                // });
              });
            }
          });

        });
      });

      this.mainarrayFinal.forEach((element: any) => {
        element.groups.forEach((group: any) => {
          if (group.categorization.paidByCompany == 1) {
            group.plans.forEach((plan: any) => {
              let pl = { ...plan, ...group.categorization }
              Object.keys(plan.productAddonss).forEach((key) => {
                let productLength = plan.productAddonss[key]?.display
                let displayingProductlengths = plan.productAddonss[key].filter((e: any) => { return e.dispaly == true })?.length
                // this.Displayproducts[key] = { 'productLength': productLength, 'displayingProductLength': displayingProductlengths }

                plan.productAddonss[key].forEach((product: any) => {

                  if (pl.isBundle) {
                    this.companypaidproductid.push(pl);
                  }
                  else {
                    this.companypaidproductid.push(product.planlevel);
                  }


                  const dom: HTMLElement = this.elementRef.nativeElement;

                  const plan: any = dom.querySelector("#plancheck" + product.id);

                  if (plan) {
                    plan.checked = false;
                  }
                  // $("#plancheck" + product.id).prop("checked", false);
                });
              });
            });
          }

          setTimeout(() => {
            if (group.categorization.coveredByCompany == 1) {
              group.plans.forEach((plan: any) => {
                Object.keys(plan.productAddonss).forEach((key) => {
                  plan.productAddonss[key].forEach((product: any) => {
                    // $("#plancheck" + product.id).prop("checked", false);
                    const dom: HTMLElement = this.elementRef.nativeElement;

                    const plan: any = dom.querySelector("#plancheck" + product.id);

                    if (plan) {
                      plan.checked = false;
                    }
                  });
                });
              });
            }
            if (group.categorization.paidByEmployee == 1) {
              group.plans.forEach((plan: any) => {

                if (plan.productAddonss) {
                  Object.keys(plan.productAddonss).forEach((key) => {
                    plan.productAddonss[key].forEach((product: any) => {
                      // $("#plancheck" + product.id).prop("checked", false);
                      const dom: HTMLElement = this.elementRef.nativeElement;

                      const plan: any = dom.querySelector("#plancheck" + product.id);

                      if (plan) {
                        plan.checked = false;
                      }
                    });
                  });
                }
              });
            }
          }, 1000);




        });
      });

      console.log(this.mainarrayFinal)
      this.mainarrayFinal.forEach((element: any) => {
        let coveragerray: any = []
        element.groups.forEach((group: any) => {

          group.plans.forEach((plan: any) => {
            let pl = { ...plan, ...group.categorization }
            Object.keys(plan.productAddonss).forEach((key) => {

              plan.productAddonss[key].forEach((product: any) => {
                coveragerray.push(product.planCoverage)

                if (pl.isBundle) {

                  setTimeout(() => {
                    const dom: HTMLElement = this.elementRef.nativeElement;
                    const plan = dom.querySelectorAll(".plan-description-span.single" + ".plancheck" + pl.id);
                    const plan2 = dom.querySelectorAll(".plan-description-span.couple" + ".plancheck" + pl.id);
                    const plan3 = dom.querySelectorAll(".plan-description-span.family" + ".plancheck" + pl.id);
                    // //console.log(plan)


                    if (
                      coveragerray.includes("SINGLE") &&
                      coveragerray.includes("COUPLE") &&
                      coveragerray.includes("FAMILY")
                    ) {
                      if (plan) {
                        plan.forEach((elem: any) => {
                          (elem as HTMLElement).style.display = 'block';
                        });
                      }
                      if (plan2) {
                        plan2.forEach((elem: any) => {
                          (elem as HTMLElement).style.display = 'block';
                        });
                      }
                      if (plan3) {
                        plan3.forEach((elem: any) => {
                          (elem as HTMLElement).style.display = 'block';
                        });
                      }
                    }
                    else if (
                      coveragerray.includes("SINGLE") &&
                      coveragerray.includes("COUPLE")
                    ) {
                      if (plan) {
                        plan.forEach((elem: any) => {
                          (elem as HTMLElement).style.display = 'block';
                        });
                      }
                      if (plan2) {
                        plan2.forEach((elem: any) => {
                          (elem as HTMLElement).style.display = 'block';
                        });
                      }
                      if (plan3) {
                        plan3.forEach((elem: any) => {
                          (elem as HTMLElement).style.display = 'none';
                        });
                      }
                    }
                    else if (
                      coveragerray.includes("SINGLE") &&
                      coveragerray.includes("FAMILY")
                    ) {
                      if (plan) {
                        plan.forEach((elem: any) => {
                          (elem as HTMLElement).style.display = 'block';
                        });
                      }
                      if (plan2) {
                        plan2.forEach((elem: any) => {
                          (elem as HTMLElement).style.display = 'none';
                        });
                      }
                      if (plan3) {
                        plan3.forEach((elem: any) => {
                          (elem as HTMLElement).style.display = 'block';
                        });
                      }
                    }
                    else if (
                      coveragerray.includes("COUPLE") &&
                      coveragerray.includes("FAMILY")
                    ) {
                      if (plan) {
                        plan.forEach((elem: any) => {
                          (elem as HTMLElement).style.display = 'none';
                        });
                      }
                      if (plan2) {
                        plan2.forEach((elem: any) => {
                          (elem as HTMLElement).style.display = 'block';
                        });
                      }
                      if (plan3) {
                        plan3.forEach((elem: any) => {
                          (elem as HTMLElement).style.display = 'block';
                        });
                      }
                    }
                    else if (product.planCoverage === "SINGLE") {
                      if (plan) {
                        plan.forEach((elem: any) => {
                          (elem as HTMLElement).style.display = 'block';
                        });
                      }
                      if (plan2) {
                        plan2.forEach((elem: any) => {
                          (elem as HTMLElement).style.display = 'none';
                        });
                      }
                      if (plan3) {
                        plan3.forEach((elem: any) => {
                          (elem as HTMLElement).style.display = 'none';
                        });
                      }
                    }
                    else if (product.planCoverage === "COUPLE") {
                      if (plan) {
                        plan.forEach((elem: any) => {
                          (elem as HTMLElement).style.display = 'none';
                        });
                      }
                      if (plan2) {
                        plan2.forEach((elem: any) => {
                          (elem as HTMLElement).style.display = 'block';
                        });
                      }
                      if (plan3) {
                        plan3.forEach((elem: any) => {
                          (elem as HTMLElement).style.display = 'none';
                        });
                      }
                    }
                    else if (product.planCoverage === "FAMILY") {
                      if (plan) {
                        plan.forEach((elem: any) => {
                          (elem as HTMLElement).style.display = 'none';
                        });
                      }
                      if (plan2) {
                        plan2.forEach((elem: any) => {
                          (elem as HTMLElement).style.display = 'none';
                        });
                      }
                      if (plan3) {
                        plan3.forEach((elem: any) => {
                          (elem as HTMLElement).style.display = 'block';
                        });
                      }
                    } else {
                      // Default case - hide all plans if coverage doesn't match expected
                    }



                  }, 1000);

                }
                else {
                  // this.companypaidproductid.push(product.planlevel);
                }


                // $("#plancheck" + product.id).prop("checked", false);
              });
            });
          });







        });
      });

      this.planAmount = ''

      sessionStorage.setItem("stateid", response.data.province.id);


      sessionStorage.setItem(
        "planDetailsArray",
        JSON.stringify(this.specialpackages)
      );
      sessionStorage.setItem(
        "planDetailsArrayBlock",
        JSON.stringify(this.mainarrayFinal)
      );
      console.log("called88888")
      


    }
    else {
      // Swal.fire({allowOutsideClick: false,title: this.lang?.Info, text:response.message})
    }
    
    if (this.specialpackages && this.specialpackages.length > 0) {
      let filteredPackages_: any = [];
      console.log("called")
      //filter the repeated packages for medcan care
      for (let package_ of this.specialpackages) {
        console.log(package_, 'asdaas2')
        let groupKeys_ = Object.keys(package_.groups);
        for (let groups of groupKeys_) {
          for (let group of package_.groups[groups]) {
            for (let plan of group.plans) {
              let pan = plan.productAddonssNames
              for (let product of plan.productAddonssNames) {
                if (plan.productAddonss[product]) {
                  const paon = plan.productAddonss[product]
                  for (const paon_ of paon) {
                    if (paon_.selected == true) {
                      this.selectedPlans_.push(paon_);
                    }
                  }
                }
              }

            }
          }
        }
        console.log(this.selectedPlans_, 'asd2342')
        if (package_.id == 5) {
          let groupKeys_ = Object.keys(package_.groups);
          for (let groups of groupKeys_) {
            for (let group of package_.groups[groups]) {
              for (let plan of group.plans) {
                let pan = plan.productAddonssNames
                for (let product of plan.productAddonssNames) {

                  // plan.productAddonss[product][0]?.planlevel.id, plan.productAddonss[product][0].product_id
                  if (filteredPackages_[product]) {
                    if (filteredPackages_[product]['planProductIds']?.includes(plan.productAddonss[product][0]?.planlevel.id) && filteredPackages_[product]['planProductIds'].includes(plan.productAddonss[product][0].product_id)) {
                      let index = pan.indexOf(product);
                      if (index !== -1) {
                        pan.splice(index, 1);
                      }
                    }
                  } else {
                    filteredPackages_[product] = { 'planProductIds': [] }
                    filteredPackages_[product]['planProductIds'] = [plan.productAddonss[product][0]?.planlevel.id, plan.productAddonss[product][0].product_id]
                  }

                  console.log(plan.productAddonss, product);

                }

                plan.productAddonssNames = pan;
              }
            }
          }
        }
      }

      // console.log(this.specialpackages)
    }

    
  }


  public handleContinue_v2(slug: any = '') {

    let effectiveDate: any;

    let endPoint: any
    if (slug == 'remove') {
      // Create a Date object from the newDate (assuming it's in ISO format)
      // const date = new Date(this.dependentTypeForm1.get('effectiveDate')?.value)??'';

      // if (date.getFullYear() < 2000) {
      //   console.error('The date cannot be before the year 2000');
      //   return;  // Prevent proceeding if the date is before 2000
      // }

      // // Format the date as 'Jan-15-2024'
      // const formattedDate = date.toLocaleString('en-US', {
      //   year: 'numeric',
      //   month: 'short',
      //   day: '2-digit',
      // }).replace(/ /g, '-').replace(',','').replace(' ','');

      // console.log(formattedDate);
      // effectiveDate = formattedDate

      effectiveDate = this.dependentTypeForm1.get('effectiveDate')?.value

      if (this.isCorpCustomer) {
        endPoint = `/v2/${this.customerid}/customerPlans/${this.dependentType ?? 'spouse'}/${slug}`
      } else {
        endPoint = `/${this.customerid}/customerPlans/${this.dependentType ?? 'spouse'}/${slug}`
      }
    } else {
      endPoint = `/customer/${this.customerid}/customerPlans/${this.dependentType == 'child' ? 'dependent' : this.dependentType}/add`
      if (this.isCorpCustomer) {
        endPoint = `/v2/${endPoint}`
      }
    }


    $('#showPlanSummaryBrief').show()
    if (false) {
      let childCovered = 'none';
      let childCoveredCount = 0;
      if (this.childrenDetails && this.childrenDetails.length > 0) {
        for (const cd of this.childrenDetails) {
          if (cd.coveredByAnotherPlan == true) {
            childCoveredCount++;
          }
        }

        if (this.childrenDetails.length == childCoveredCount) {
          childCovered = 'full'
        } else {
          childCovered = 'partial'
        }


        if (childCoveredCount == 0) {
          childCovered = 'none'
        }
      }

      let payload = {
        "enrollmentDate": this.spouseMarriedDate,
        spouseCovered: this.coveredByAnotherPlan == 'open' ? true : false,
        removeRoleBasedPlans: false,
        childCovered: childCovered,
        totalCount: this.childrenDetails.length
      }
      console.log({ payload, endPoint })
      // commented
      // return;

      sessionStorage.removeItem("plansummarymain")
      sessionStorage.removeItem("plansskumain");
      sessionStorage.removeItem("plansummaryopt");
      sessionStorage.removeItem("plansummary");
      sessionStorage.removeItem("selectedPlans");
      sessionStorage.removeItem("totalAmount");
      sessionStorage.removeItem("totalAmountUI");
      this.http.post(api.url + endPoint, payload, {
        headers: {
          Authorization: 'Bearer ' + this.accessToken,
          'Content-Type': 'application/json',
        }
      }).subscribe((response: any) => {
        if (response.status == 200 && !this.isCorpCustomer) {
          console.log(response?.data, 'asda')
          this.coverageChange = response?.data?.coverageChange;
          let prs = response?.data?.gsOrEqMemberStatus ?? {}
          let prsStatus: any = []
          const prsKeys = Object.keys(prs);
          if (prsKeys.length > 0) {
            for (const prk of prsKeys) {
              if (prs[prk] == true) {
                if (prk == 'greenShildCustomer') {
                  prsStatus.push('GreenShield')
                }
                if (prk == 'hcdSecuremePlans') {
                  prsStatus.push('HCD Secureme')
                }
                if (prk == 'equitableCustomer') {
                  prsStatus.push('Equitable')
                }
                if (prk == 'phrCustomer') {
                  prsStatus.push('PHR')
                }
                if (prk == 'waddelCustomer') {
                  prsStatus.push('Waddel')
                }
              }
            }
          }
          this.provisioningSites = prsStatus.toString() ?? ""


          console.log("calledoooo")
          let data__ = response?.data?.packages
          this.customerPlans = response?.data?.customerPlans;

          console.log(this.customerPlans, "custplans889")
          setTimeout(() => {
            this.customerPlans.forEach(element => {
              const dom: HTMLElement = this.elementRef.nativeElement;

              if (slug == 'remove') {
                console.log(element)
                if (element.isBundle) {
                  // if(element.name.includes('Life Insurance' || 'Critical')){

                  // }else{

                  // }

                  let coverages = ['SINGLE', 'COUPLE', 'FAMILY'];
                  let clicked = false;
                  if ($("#plancheck2" + element.planId + ".coverage" + element.coverage1.toUpperCase()).length == 0) {
                    for (const cov of coverages) {
                      console.log($("#plancheck2" + element.planId + ".coverage" + cov.toUpperCase()))
                      if ($("#plancheck2" + element.planId + ".coverage" + cov.toUpperCase()).length > 0 && !clicked) {
                        $("#plancheck2" + element.planId + ".coverage" + cov.toUpperCase()).click()
                        $("#plancheck2" + element.planId + ".coverage" + cov.toUpperCase()).prop("disabled", true);
                        clicked = true;
                      }
                    }
                  } else {
                    $("#plancheck2" + element.planId + ".coverage" + element.coverage1.toUpperCase()).click()
                    $("#plancheck2" + element.planId + ".coverage" + element.coverage1.toUpperCase()).prop("disabled", true);
                  }
                }
                else {
                  if (element.coverage) {
                    const plan: any = dom.querySelector("#plancheck2" + element.planSelectionId2 + ".coverage" + element.coverage1.toUpperCase());

                    // $("#plancheck" + element.planSelectionId2 + ".coverage"+element.coverage).click()
                    console.log($("#plancheck2" + element.planSelectionId2))
                    $("#plancheck2" + element.planSelectionId2).click()
                    $("#plancheck2" + element.planSelectionId2).prop("disabled", true);
                  }
                  else {
                    console.log($("#plancheck2" + element.planSelectionId2))
                    $("#plancheck2" + element.planSelectionId2).click()
                    $("#plancheck2" + element.planSelectionId2).prop("disabled", true);

                  }
                }
              } else {
                console.log(element, "jiihhsh")
                if (element.isBundle) {
                  // if(element.name.includes('Life Insurance' || 'Critical')){

                  // }else{

                  // }


                  let coverages = ['SINGLE', 'COUPLE', 'FAMILY'];
                  let clicked = false;
                  if ($("#plancheck" + element.planId + ".coverage" + element.coverage1.toUpperCase()).length == 0) {
                    for (const cov of coverages) {
                      console.log($("#plancheck" + element.planId + ".coverage" + cov.toUpperCase()))
                      if ($("#plancheck" + element.planId + ".coverage" + cov.toUpperCase()).length > 0 && !clicked) {
                        $("#plancheck" + element.planId + ".coverage" + cov.toUpperCase()).click()
                        $("#plancheck" + element.planId + ".coverage" + cov.toUpperCase()).prop("disabled", true);
                        clicked = true;
                      }
                    }
                  } else {
                    $("#plancheck" + element.planId + ".coverage" + element.coverage1.toUpperCase()).click()
                    $("#plancheck" + element.planId + ".coverage" + element.coverage1.toUpperCase()).prop("disabled", true);
                  }


                }
                else {
                  console.log(element?.coverage1, "after else")
                  if (element?.coverage1 && element?.coverage1 != '-') {
                    // const plan: any = dom.querySelector("#plancheck" + element.planSelectionId2 + ".coverage" + element.coverage1.toUpperCase());

                    // $("#plancheck" + element.planSelectionId2 + ".coverage"+element.coverage).click()
                    console.log("#plancheck" + element.planId + ".coverage" + element.coverage1.toUpperCase())
                    $("#plancheck" + element.planSelectionId2).click()
                    $("#plancheck" + element.planId + ".coverage" + element.coverage1.toUpperCase()).prop("disabled", true);
                  }
                  else {
                    console.log($("#plancheck" + element.planSelectionId2))
                    $("#plancheck" + element.planSelectionId2).click()
                    $("#plancheck" + element.planSelectionId2).prop("disabled", true);

                  }
                }
              }


            });
          }, 1000);

          this.selectedPlans_ = [];
          this.oldExistingPlans = []
          this.selectedTrues = []
          this.unSelectedPlans_ = []
          this.totalSummaryPrice = 0;


          for (let package_ of data__) {
            console.log(package_, 'asdaas2');

            let groupKeys_ = Object.keys(package_.groups);
            for (let i = 0; i < groupKeys_.length; i++) {
              let groups = groupKeys_[i];

              for (let j = 0; j < package_.groups[groups].length; j++) {
                let group = package_.groups[groups][j];

                for (let k = 0; k < group.plans.length; k++) {
                  let plan = group.plans[k];
                  let pan = plan.productAddonssNames;
                  console.log(plan.isBundle, "bundled")

                  for (let product of pan) {
                    if (plan.productAddonss[product]) {
                      const paon = plan.productAddonss[product];

                      const selectedAddons = paon.filter((item: any) => item.selected);



                      if (selectedAddons && selectedAddons.length > 0) {
                        const unSelectedAddon = paon.find((item: any) => !item.selected);

                        console.log(unSelectedAddon)
                        if (!!unSelectedAddon && plan.selected) {
                          this.upgradeorDowngradeplans.push({
                            'name': unSelectedAddon?.name,
                            'addon': unSelectedAddon,
                            'isBundle': plan.isBundle
                          })
                        }
                        if (!unSelectedAddon && plan.selected) {
                          for (const selectedAddon of selectedAddons) {
                            const customerPlan = this.customerPlans.find((item: any) => (item.planId == selectedAddon.planId && (item.terminationDate == null || item.terminationDate == "")))
                            console.log(customerPlan, selectedAddon)
                            if (customerPlan.coverage1.toUpperCase() == selectedAddon.planCoverage) {
                              this.upgradeorDowngradeplans.push({
                                'name': selectedAddon?.name,
                                'addon': selectedAddon,
                                'isBundle': plan.isBundle
                              })
                            }
                          }
                        }
                        if (plan.selected) {
                          //check for the termination date
                          for (const selectedAddon of selectedAddons) {
                            this.upgradeorDowngradeplansSelected.push({
                              'name': selectedAddon?.name,
                              'addon': selectedAddon,
                              'isBundle': plan.isBundle
                            })

                          }
                        }
                      }
                      // Loop over the addonss for the plan
                      for (const paon_ of paon) {
                        console.log(paon_, '12345');

                        if (paon_.selected === true) {
                          // We can call the onCheckboxChange



                          this.selectedTrues.push({
                            id: paon_.id,
                            productId: paon_.productId,
                            planId: paon_.planId
                          });

                          paon_['checked'] = true;  // Mark the plan as checked
                          this.totalSummaryPrice += paon_.calculatedTax.total;
                          this.selectedPlans_.push(paon_);
                          this.oldExistingPlans.push(paon_);
                        } else {
                          this.unSelectedPlans_.push(paon_);
                        }
                      }
                    }
                  }
                }
              }
            }






            console.log(this.selectedPlans_, 'asd2342');
            console.log(this.unSelectedPlans_, 'asd23421');

            // Trigger clicks for selected plans after a slight delay
            // setTimeout(() => {
            //   this.selectedTrues.forEach(element => {
            //     const dom = "#plancheck" + element.id;
            //     console.log("selectedPlan123", dom);
            //     $(dom).click();
            //   });


            //   // sudeep2

            // }, 1000);

            // Call method to get the summary of the selected plans
            this.getPlanSummaryObject();
          }

          // let table = '<table style="width: 100%; margin-bottom: 10px; border-collapse: collapse;">';

          // upgradeorDowngradeplans.forEach(plan => {
          //   table += `
          //     <tr>
          //       <td style="padding: 8px; border: 1px solid #ddd; text-align: left;">
          //         <span>${plan.name} - ${plan.addon.planCoverageUI}</span>
          //       </td>
          //       <td style="padding: 8px; border: 1px solid #ddd; text-align: left;">
          //         <label>
          //           <input type="radio" name="plan_${plan.name}" value="yes" /> Yes
          //         </label>
          //         &nbsp;&nbsp;
          //         <label>
          //           <input type="radio" name="plan_${plan.name}" value="no" /> No
          //         </label>
          //       </td>
          //     </tr>
          //   `;
          // });
          // table += '</table>';
          // Swal.fire({
          //   title: 'Do you wish to change your coverage?',
          //   html: table,  // Display all the plans in the popup
          //   showCancelButton: true,
          //   confirmButtonText: 'Confirm',
          //   cancelButtonText: 'Cancel',
          //   preConfirm: () => {
          //     const selectedPlans = upgradeorDowngradeplans.map(plan => {
          //       const selectedOption = document.querySelector(`input[name="plan_${plan.name}"]:checked`) as HTMLInputElement;
          //       return {
          //         planName: plan.name,
          //         addOn: plan.addon,
          //         action: selectedOption ? selectedOption.value : null,
          //         isBundle: plan.isBundle
          //       };
          //     });

          //     // Handle the selected plans and actions (Upgrade/Downgrade)
          //     selectedPlans.forEach((plan) => {
          //       console.log(plan, "....plan...")
          //       if (plan.action === 'yes') {
          //         // we gonna click that element
          //         let element:any = plan.addOn
          //         if (plan.isBundle) {
          //           // if(element.name.includes('Life Insurance' || 'Critical')){

          //           // }else{

          //           // }
          //           $("#plancheck" + element.planId + ".coverage" + element.planCoverage.toUpperCase()).click()
          //           console.log($("#plancheck" + element.planId + ".coverage" + element.planCoverage.toUpperCase()), "called3322")

          //         }
          //         else {
          //           console.log(element, "elem677")
          //           if (element?.planCoverage && element?.planCoverage != '-') {
          //             // $("#plancheck" + element.planSelectionId2 + ".coverage"+element.coverage).click()
          //             console.log("#plancheck" +  element.planlevel.id + ".coverage" + element.planCoverage.toUpperCase())
          //            $("#plancheck" +  element.planlevel.id + ".coverage" + element.planCoverage.toUpperCase()).click()
          //           }
          //           else {
          //             console.log($("#plancheck" +  element.planlevel.id))
          //             $("#plancheck" +  element.planlevel.id).click()

          //           }
          //         }
          //         console.log(`Upgrading ${plan.planName}`);
          //       } else if (plan.action === 'no') {
          //         console.log(`Downgrading ${plan.planName}`);
          //       }
          //     });
          //   }
          // });

          console.log('selectedTrues', this.selectedTrues)

          // setTimeout(() => {
          //   this.selectedTrues.forEach(element => {
          //     const dom = "#plancheck" + element.id
          //     console.log("selectedPlan123", dom)
          //     $(dom).click()
          //   });
          // }, 1000);


          // for (let package_ of data__) {
          //   console.log(package_, 'asdaas2');

          //   let groupKeys_ = Object.keys(package_.groups);

          //   for (let groups of groupKeys_) {
          //     for (let group of package_.groups[groups]) {
          //       for (let plan of group.plans) {
          //         let pan = plan.productAddonssNames;

          //         for (let product of pan) {
          //           if (plan.productAddonss[product]) {
          //             let unSelectedCount = 0;
          //             const paon = plan.productAddonss[product];

          //             for (const paon_ of paon) {
          //               console.log(paon_, '12345');

          //               if (paon_.selected === true) {
          //                 paon_['checked'] = true;
          //                 this.totalSummaryPrice += paon_.calculatedTax.total;
          //                 this.selectedPlans_.push(paon_);
          //                 console.log(this.selectedPlans_, '123456');
          //                 this.oldExistingPlans.push(paon_);
          //               } else {
          //                 unSelectedCount += 1;
          //                 this.unSelectedPlans_.push(paon_);

          //                 // If all items in the group are unselected, select the first one
          //                 // if (unSelectedCount === paon.length) {
          //                 //   // paon_['checked'] = true;
          //                 //   paon_['selected'] = true;
          //                 //   this.totalSummaryPrice += paon_.calculatedTax.total;
          //                 //   this.selectedPlans_.push(paon_);
          //                 //   this.oldExistingPlans.push(paon_);
          //                 // } else {
          //                 //   this.unSelectedPlans_.push(paon_);
          //                 // }
          //               }
          //             }
          //           }
          //         }
          //       }
          //     }
          //   }

          //   console.log(this.selectedPlans_, 'asd2342');
          //   console.log(this.unSelectedPlans_, 'asd23421');

          //   // Click checkboxes after the data is updated
          //   // setTimeout(() => {
          //   //   this.selectedPlans_.forEach(element => {
          //   //     const dom = "#plancheck" + element.id;
          //   //     console.log("selectedPlan", dom);
          //   //     $(dom).click();
          //   //   });
          //   // }, 1000);

          //   this.getPlanSummaryObject();
          // }


          this.specialpackages = data__ ?? []


          //get the selected coverages




          // this.closeDependentmodal.nativeElement.click();
          // Swal.fire({allowOutsideClick: false, title: this.lang?.Info, text: response.message });
        }

        if (response.status == 200 && this.isCorpCustomer) {

          sessionStorage.setItem(
            "customerTierId",
            response.data.customer.customerTierId
          );
          sessionStorage.setItem("employeeshare", "0");
          this.mainarray = [];
          this.mainarrayValues = [];
          this.mainarrayFinal = [];
          this.modifiedBlocksPaidByCompany = '',
            this.modifiedBlocksCoveredByCompany = '',

            sessionStorage.setItem("planDetailsArrayBlock", "[]");
          this.effectiveEmployeeTotalContibution = 0;
          sessionStorage.setItem("totalAmount", "0");
          sessionStorage.setItem("totalAmountUI", "0");

          sessionStorage.setItem("allSelectedPlans", "[]");

          sessionStorage.setItem("plansummary", "[]");
          sessionStorage.setItem("selectedPlans", "{}");
          sessionStorage.setItem("selectedPlansLife", "{}");
          sessionStorage.setItem("plansummarymain", "[]");
          sessionStorage.setItem("plansummaryopt", "[]");
          sessionStorage.removeItem("Spousesignature")

          this.addbenificaryData = []
          // sessionStorage.setItem(
          //   "corporateStateId",
          //   response.data.workingProvince.id
          // );
          // sessionStorage.setItem(
          //   "corporateStateName",
          //   response.data.workingProvince.name
          // );
          // sessionStorage.setItem(
          //   "companyStateId",
          //   response.data.corporateProvince.id
          // );


          this.allFormData = {}
          this.formData = {}
          sessionStorage.setItem('plansummaryLife', '[]');
          sessionStorage.setItem('planssummarymainLife', '[]');


          setTimeout(() => {
            // this.autoSelectCompanyPaidPlans();



            // sessionStorage.setItem(
            //   "enrollmentdate",
            //   response.data.planEnrollmentDate
            // );

          }, 2000);

          ///here
          sessionStorage.removeItem("paymentfail");
          this.companypaidproductid = [];
          this.disabledcompanypaidproductid = [];
          this.removedisabledcompanypaidproductid = [];
          this.adddisabledcompanypaidproductid = [];
          // this.applicantfirstname = this.capitalize(value.givenname);
          // this.planssummary = JSON.parse(
          //   sessionStorage.getItem("plansummary")
          // );




          console.log(response)
          this.specialpackages = [];
          this.packagesInBlocks = response.data.blocks;
          this.basepackages = response.data.packages;
          this.customerSelectedPlans = response.data.customerPlans

          setTimeout(() => {
            this.customerSelectedPlansValues(this.customerSelectedPlans)

          }, 2000);
          let companyplans = this.convertpackagesToPlans2(
            this.packagesInBlocks
          )[1];
          let baseplans = this.convertpackagesToPlans2(this.basepackages)[1];
          this.calculateBasePlanDeltasforCCplans(
            this.packagesInBlocks.coveredByCompany,
            baseplans,
            companyplans
          );
          this.calculateBasePlanCPplans(
            this.packagesInBlocks.paidByCompany,
            baseplans,
            companyplans
          );

          // //console.log(this.packagesInBlocks.paidByCompany)
          // //console.log(this.modifiedBlocksPaidByCompany)
          this.mainarrayValues = this.cobminedcommonfunction(
            // this.packagesInBlocks.paidByCompany,
            this.modifiedBlocksPaidByCompany,
            this.modifiedBlocksCoveredByCompany,
            this.packagesInBlocks.paidByEmployee
          );

          let allPackages: any = [];
          for (let key in this.mainarrayValues) {
            //this.consoleMessage(key)
            allPackages.push(this.mainarrayValues[key]);
          }

          console.log(allPackages)
          // this.mainarray = allPackages;





          let filteredMainArray = allPackages
            .map((element: any) => {
              // Map the groups
              let filteredGroups = element.groups.map((group: any) => {
                // Map the plans
                let filteredPlans = group.plans.map((plan: any) => {
                  // Filter the productAddonss


                  let filteredProductAddonss = Object.keys(plan.productAddonss).reduce(
                    (acc: any, key) => {

                      // Filter the products where display is true
                      let filteredProducts = plan.productAddonss[key].filter((product: any) =>
                        product.hasOwnProperty('display') && product.display
                      );
                      // let filteredProducts = plan.productAddonss[key].map((product: any) => {
                      //   // Check if the 'display' key exists and is true
                      //   if (product.hasOwnProperty('display') && product.display) {
                      //     return product; // Keep the object as-is if display is true
                      //   }
                      //   const newProduct = {};
                      //   // console.log("Product replaced with empty object:", product, "New product:", newProduct);
                      //   return newProduct;
                      // });
                      const containsOnlyEmptyObjects = filteredProducts.every(
                        (product: any) => Object.keys(product).length === 0
                      );

                      if (containsOnlyEmptyObjects) {
                        console.log("filteredProducts contains only empty objects.");
                      } else {
                        acc[key] = filteredProducts;
                        console.log("filteredProducts contains non-empty objects.");
                      }
                      // if (filteredProducts.length > 0) {
                      //   acc[key] = filteredProducts;
                      // }
                      return acc;
                    },
                    {}
                  );
                  return {
                    ...plan,
                    productAddonss: filteredProductAddonss,
                  };
                }).filter((plan: any) => Object.keys(plan.productAddonss).length > 0); // Remove plans without any matching productAddons

                return {
                  ...group,
                  plans: filteredPlans,
                };
              }).filter((group: any) => group.plans.length > 0); // Remove groups without any matching plans

              return {
                ...element,
                groups: filteredGroups,
              };
            })
            .filter((element: any) => element.groups.length > 0); // Remove elements without any matching groups


          console.log(filteredMainArray)

          this.mainarrayFinal = filteredMainArray

          console.log(this.mainarrayFinal)

          // this code needs to comment for single single in
          this.mainarrayFinal.forEach((element: any) => {
            element.groups.forEach((group: any) => {
              group.plans.forEach((plan: any) => {
                if (plan.productAddonss) {
                  Object.keys(plan.productAddonss).forEach((key) => {
                    // plan.productAddonss[key].forEach((product) => {
                    const keys = ['planCoverage'];
                    const filteredData = plan.productAddonss[key].filter((value: any, index: any, self: any) =>
                      self.findIndex((v: { [x: string]: any; }) => keys.every(k => v[k] === value[k])) === index
                    );
                    plan.productAddonss[key] = filteredData
                    // });
                  });
                }
              });

            });
          });

          this.mainarrayFinal.forEach((element: any) => {
            element.groups.forEach((group: any) => {
              if (group.categorization.paidByCompany == 1) {
                group.plans.forEach((plan: any) => {
                  let pl = { ...plan, ...group.categorization }
                  Object.keys(plan.productAddonss).forEach((key) => {
                    let productLength = plan.productAddonss[key]?.display
                    let displayingProductlengths = plan.productAddonss[key].filter((e: any) => { return e.dispaly == true })?.length
                    // this.Displayproducts[key] = { 'productLength': productLength, 'displayingProductLength': displayingProductlengths }

                    plan.productAddonss[key].forEach((product: any) => {

                      if (pl.isBundle) {
                        this.companypaidproductid.push(pl);
                      }
                      else {
                        this.companypaidproductid.push(product.planlevel);
                      }


                      const dom: HTMLElement = this.elementRef.nativeElement;

                      const plan: any = dom.querySelector("#plancheck" + product.id);

                      if (plan) {
                        plan.checked = false;
                      }
                      // $("#plancheck" + product.id).prop("checked", false);
                    });
                  });
                });
              }

              setTimeout(() => {
                if (group.categorization.coveredByCompany == 1) {
                  group.plans.forEach((plan: any) => {
                    Object.keys(plan.productAddonss).forEach((key) => {
                      plan.productAddonss[key].forEach((product: any) => {
                        // $("#plancheck" + product.id).prop("checked", false);
                        const dom: HTMLElement = this.elementRef.nativeElement;

                        const plan: any = dom.querySelector("#plancheck" + product.id);

                        if (plan) {
                          plan.checked = false;
                        }
                      });
                    });
                  });
                }
                if (group.categorization.paidByEmployee == 1) {
                  group.plans.forEach((plan: any) => {

                    if (plan.productAddonss) {
                      Object.keys(plan.productAddonss).forEach((key) => {
                        plan.productAddonss[key].forEach((product: any) => {
                          // $("#plancheck" + product.id).prop("checked", false);
                          const dom: HTMLElement = this.elementRef.nativeElement;

                          const plan: any = dom.querySelector("#plancheck" + product.id);

                          if (plan) {
                            plan.checked = false;
                          }
                        });
                      });
                    }
                  });
                }
              }, 1000);




            });
          });


          this.mainarrayFinal.forEach((element: any) => {
            let coveragerray: any = []
            element.groups.forEach((group: any) => {

              group.plans.forEach((plan: any) => {
                let pl = { ...plan, ...group.categorization }
                Object.keys(plan.productAddonss).forEach((key) => {

                  plan.productAddonss[key].forEach((product: any) => {
                    coveragerray.push(product.planCoverage)

                    if (pl.isBundle) {

                      setTimeout(() => {
                        const dom: HTMLElement = this.elementRef.nativeElement;
                        const plan = dom.querySelectorAll(".plan-description-span.single" + ".plancheck" + pl.id);
                        const plan2 = dom.querySelectorAll(".plan-description-span.couple" + ".plancheck" + pl.id);
                        const plan3 = dom.querySelectorAll(".plan-description-span.family" + ".plancheck" + pl.id);
                        // //console.log(plan)


                        if (
                          coveragerray.includes("SINGLE") &&
                          coveragerray.includes("COUPLE") &&
                          coveragerray.includes("FAMILY")
                        ) {
                          if (plan) {
                            plan.forEach((elem: any) => {
                              (elem as HTMLElement).style.display = 'block';
                            });
                          }
                          if (plan2) {
                            plan2.forEach((elem: any) => {
                              (elem as HTMLElement).style.display = 'block';
                            });
                          }
                          if (plan3) {
                            plan3.forEach((elem: any) => {
                              (elem as HTMLElement).style.display = 'block';
                            });
                          }
                        }
                        else if (
                          coveragerray.includes("SINGLE") &&
                          coveragerray.includes("COUPLE")
                        ) {
                          if (plan) {
                            plan.forEach((elem: any) => {
                              (elem as HTMLElement).style.display = 'block';
                            });
                          }
                          if (plan2) {
                            plan2.forEach((elem: any) => {
                              (elem as HTMLElement).style.display = 'block';
                            });
                          }
                          if (plan3) {
                            plan3.forEach((elem: any) => {
                              (elem as HTMLElement).style.display = 'none';
                            });
                          }
                        }
                        else if (
                          coveragerray.includes("SINGLE") &&
                          coveragerray.includes("FAMILY")
                        ) {
                          if (plan) {
                            plan.forEach((elem: any) => {
                              (elem as HTMLElement).style.display = 'block';
                            });
                          }
                          if (plan2) {
                            plan2.forEach((elem: any) => {
                              (elem as HTMLElement).style.display = 'none';
                            });
                          }
                          if (plan3) {
                            plan3.forEach((elem: any) => {
                              (elem as HTMLElement).style.display = 'block';
                            });
                          }
                        }
                        else if (
                          coveragerray.includes("COUPLE") &&
                          coveragerray.includes("FAMILY")
                        ) {
                          if (plan) {
                            plan.forEach((elem: any) => {
                              (elem as HTMLElement).style.display = 'none';
                            });
                          }
                          if (plan2) {
                            plan2.forEach((elem: any) => {
                              (elem as HTMLElement).style.display = 'block';
                            });
                          }
                          if (plan3) {
                            plan3.forEach((elem: any) => {
                              (elem as HTMLElement).style.display = 'block';
                            });
                          }
                        }
                        else if (product.planCoverage === "SINGLE") {
                          if (plan) {
                            plan.forEach((elem: any) => {
                              (elem as HTMLElement).style.display = 'block';
                            });
                          }
                          if (plan2) {
                            plan2.forEach((elem: any) => {
                              (elem as HTMLElement).style.display = 'none';
                            });
                          }
                          if (plan3) {
                            plan3.forEach((elem: any) => {
                              (elem as HTMLElement).style.display = 'none';
                            });
                          }
                        }
                        else if (product.planCoverage === "COUPLE") {
                          if (plan) {
                            plan.forEach((elem: any) => {
                              (elem as HTMLElement).style.display = 'none';
                            });
                          }
                          if (plan2) {
                            plan2.forEach((elem: any) => {
                              (elem as HTMLElement).style.display = 'block';
                            });
                          }
                          if (plan3) {
                            plan3.forEach((elem: any) => {
                              (elem as HTMLElement).style.display = 'none';
                            });
                          }
                        }
                        else if (product.planCoverage === "FAMILY") {
                          if (plan) {
                            plan.forEach((elem: any) => {
                              (elem as HTMLElement).style.display = 'none';
                            });
                          }
                          if (plan2) {
                            plan2.forEach((elem: any) => {
                              (elem as HTMLElement).style.display = 'none';
                            });
                          }
                          if (plan3) {
                            plan3.forEach((elem: any) => {
                              (elem as HTMLElement).style.display = 'block';
                            });
                          }
                        } else {
                          // Default case - hide all plans if coverage doesn't match expected
                        }



                      }, 1000);

                    }
                    else {
                      // this.companypaidproductid.push(product.planlevel);
                    }


                    // $("#plancheck" + product.id).prop("checked", false);
                  });
                });
              });







            });
          });
          // setTimeout(() => {
          //   console.log(this.mainarray)
          // }, 2000);

          this.planAmount = ''

          sessionStorage.setItem("stateid", response.data.province.id);


          sessionStorage.setItem(
            "planDetailsArray",
            JSON.stringify(this.specialpackages)
          );
          sessionStorage.setItem(
            "planDetailsArrayBlock",
            JSON.stringify(this.mainarrayFinal)
          );
        }
        // if(response.status==200 && this.isCorpCustomer) {
        //   console.log(response?.data,'asda')

        //   setTimeout(() => {
        //     this.autoSelectCompanyPaidPlans();



        //     sessionStorage.setItem(
        //       "enrollmentdate",
        //       response.data.planEnrollmentDate
        //     );

        //   }, 2000);


        //   sessionStorage.removeItem("paymentfail");
        //       this.companypaidproductid = [];
        //       this.disabledcompanypaidproductid = [];
        //       this.removedisabledcompanypaidproductid = [];
        //       this.adddisabledcompanypaidproductid = [];
        //       // this.applicantfirstname = this.capitalize(value.givenname);
        //       // this.planssummary = JSON.parse(
        //       //   sessionStorage.getItem("plansummary")
        //       // );


        //       this.applicantSpousename = value.spousefirstname || "";
        //       this.applicantfirstname = inputData.firstName;

        //       // //console.log(this.applicantfirstname)

        //       childrenarray.forEach((element: any) => {
        //         childarry.push(element.first_name);
        //       });
        //       this.applicantChildrenname = childarry || "";

        //       if (
        //         value.having_spouse == "true" &&
        //         value.having_dependent_children == "true"
        //       ) {
        //         this.completeapplicantinfo =
        //           this.lang.Based_on_the_information_provided_you_your_spouse
        //           +
        //           " " + this.applicantSpousename +
        //           " " +
        //           this.lang.and_your_dependent_s +
        //           " " +
        //           this.applicantChildrenname +
        //           " " +
        //           this.lang.are_eligible_to_apply_for_the_following_plans;
        //       } else if (value.having_spouse == "true") {
        //         this.completeapplicantinfo =
        //           this.lang.Based_on_the_information_provided_you_your_spouse +
        //           " " +
        //           this.applicantSpousename +
        //           " " +
        //           this.lang.are_eligible_to_apply_for_the_following_plans;
        //       } else if (value.having_dependent_children == "true") {
        //         this.completeapplicantinfo =
        //           this.lang.Based_on_the_information_provided_you_and_your_dependent_s +
        //           " " +
        //           this.applicantChildrenname +
        //           " " +
        //           this.lang.are_eligible_to_apply_for_the_following_plans;
        //       } else {
        //         this.completeapplicantinfo = this.lang.Based_on_the_information_provided_you_are_eligible_to_apply_for_the_following_plans;
        //       }
        //       sessionStorage.setItem(
        //         "completeapplicantinfo",
        //         this.completeapplicantinfo
        //       );


        //       this.specialpackages = [];
        //       this.packagesInBlocks = result.data.blocks;
        //       this.basepackages = result.data.packages;
        //       let companyplans = this.convertpackagesToPlans2(
        //         this.packagesInBlocks
        //       )[1];
        //       let baseplans = this.convertpackagesToPlans2(this.basepackages)[1];
        //       this.calculateBasePlanDeltasforCCplans(
        //         this.packagesInBlocks.coveredByCompany,
        //         baseplans,
        //         companyplans
        //       );
        //       this.calculateBasePlanCPplans(
        //         this.packagesInBlocks.paidByCompany,
        //         baseplans,
        //         companyplans
        //       );

        //       // //console.log(this.packagesInBlocks.paidByCompany)
        //       // //console.log(this.modifiedBlocksPaidByCompany)
        //       this.mainarrayValues = this.cobminedcommonfunction(
        //         // this.packagesInBlocks.paidByCompany,
        //         this.modifiedBlocksPaidByCompany,
        //         this.modifiedBlocksCoveredByCompany,
        //         this.packagesInBlocks.paidByEmployee
        //       );

        //       let allPackages = [];
        //       for (let key in this.mainarrayValues) {
        //         //this.consoleMessage(key)
        //         allPackages.push(this.mainarrayValues[key]);
        //       }
        //       // this.mainarray = allPackages;





        //       let filteredMainArray = allPackages
        //         .map((element: any) => {
        //           // Map the groups
        //           let filteredGroups = element.groups.map((group: any) => {
        //             // Map the plans
        //             let filteredPlans = group.plans.map((plan: any) => {
        //               // Filter the productAddonss


        //               let filteredProductAddonss = Object.keys(plan.productAddonss).reduce(
        //                 (acc: any, key) => {

        //                   // Filter the products where display is true
        //                   let filteredProducts = plan.productAddonss[key].filter((product: any) =>
        //                     product.hasOwnProperty('display') && product.display
        //                   );
        //                   // let filteredProducts = plan.productAddonss[key].map((product: any) => {
        //                   //   // Check if the 'display' key exists and is true
        //                   //   if (product.hasOwnProperty('display') && product.display) {
        //                   //     return product; // Keep the object as-is if display is true
        //                   //   }
        //                   //   const newProduct = {};
        //                   //   // console.log("Product replaced with empty object:", product, "New product:", newProduct);
        //                   //   return newProduct;
        //                   // });
        //                   const containsOnlyEmptyObjects = filteredProducts.every(
        //                     (product: any) => Object.keys(product).length === 0
        //                   );

        //                   if (containsOnlyEmptyObjects) {
        //                     console.log("filteredProducts contains only empty objects.");
        //                   } else {
        //                     acc[key] = filteredProducts;
        //                     console.log("filteredProducts contains non-empty objects.");
        //                   }
        //                   // if (filteredProducts.length > 0) {
        //                   //   acc[key] = filteredProducts;
        //                   // }
        //                   return acc;
        //                 },
        //                 {}
        //               );
        //               return {
        //                 ...plan,
        //                 productAddonss: filteredProductAddonss,
        //               };
        //             }).filter((plan: any) => Object.keys(plan.productAddonss).length > 0); // Remove plans without any matching productAddons

        //             return {
        //               ...group,
        //               plans: filteredPlans,
        //             };
        //           }).filter((group: any) => group.plans.length > 0); // Remove groups without any matching plans

        //           return {
        //             ...element,
        //             groups: filteredGroups,
        //           };
        //         })
        //         .filter((element: any) => element.groups.length > 0); // Remove elements without any matching groups


        //       console.log(filteredMainArray)

        //       this.mainarrayFinal = filteredMainArray

        //       console.log(this.mainarrayFinal)

        //       // this code needs to comment for single single in
        //       this.mainarrayFinal.forEach((element: any) => {
        //         element.groups.forEach((group: any) => {
        //           group.plans.forEach((plan: any) => {
        //             if (plan.productAddonss) {
        //               Object.keys(plan.productAddonss).forEach((key) => {
        //                 // plan.productAddonss[key].forEach((product) => {
        //                 const keys = ['planCoverage'];
        //                 const filteredData = plan.productAddonss[key].filter((value: any, index: any, self: any) =>
        //                   self.findIndex((v: { [x: string]: any; }) => keys.every(k => v[k] === value[k])) === index
        //                 );
        //                 plan.productAddonss[key] = filteredData
        //                 // });
        //               });
        //             }
        //           });

        //         });
        //       });

        //       this.mainarrayFinal.forEach((element: any) => {
        //         element.groups.forEach((group: any) => {
        //           if (group.categorization.paidByCompany == 1) {
        //             group.plans.forEach((plan: any) => {
        //               let pl = { ...plan, ...group.categorization }
        //               Object.keys(plan.productAddonss).forEach((key) => {
        //                 let productLength = plan.productAddonss[key]?.display
        //                 let displayingProductlengths = plan.productAddonss[key].filter((e: any) => { return e.dispaly == true })?.length
        //                 this.Displayproducts[key] = { 'productLength': productLength, 'displayingProductLength': displayingProductlengths }

        //                 plan.productAddonss[key].forEach((product: any) => {

        //                   if (pl.isBundle) {
        //                     this.companypaidproductid.push(pl);
        //                   }
        //                   else {
        //                     this.companypaidproductid.push(product.planlevel);
        //                   }


        //                   const dom: HTMLElement = this.elementRef.nativeElement;

        //                   const plan: any = dom.querySelector("#plancheck" + product.id);

        //                   if (plan) {
        //                     plan.checked = false;
        //                   }
        //                   // $("#plancheck" + product.id).prop("checked", false);
        //                 });
        //               });
        //             });
        //           }

        //           setTimeout(() => {
        //             if (group.categorization.coveredByCompany == 1) {
        //               group.plans.forEach((plan: any) => {
        //                 Object.keys(plan.productAddonss).forEach((key) => {
        //                   plan.productAddonss[key].forEach((product: any) => {
        //                     // $("#plancheck" + product.id).prop("checked", false);
        //                     const dom: HTMLElement = this.elementRef.nativeElement;

        //                     const plan: any = dom.querySelector("#plancheck" + product.id);

        //                     if (plan) {
        //                       plan.checked = false;
        //                     }
        //                   });
        //                 });
        //               });
        //             }
        //             if (group.categorization.paidByEmployee == 1) {
        //               group.plans.forEach((plan: any) => {

        //                 if (plan.productAddonss) {
        //                   Object.keys(plan.productAddonss).forEach((key) => {
        //                     plan.productAddonss[key].forEach((product: any) => {
        //                       // $("#plancheck" + product.id).prop("checked", false);
        //                       const dom: HTMLElement = this.elementRef.nativeElement;

        //                       const plan: any = dom.querySelector("#plancheck" + product.id);

        //                       if (plan) {
        //                         plan.checked = false;
        //                       }
        //                     });
        //                   });
        //                 }
        //               });
        //             }
        //           }, 1000);
        //         });
        //       });




        //   this.coverageChange = response?.data?.coverageChange;
        //   let prs = response?.data?.gsOrEqMemberStatus ?? {}
        //   let prsStatus:any = []
        //   const prsKeys = Object.keys(prs);
        //   if(prsKeys.length > 0){
        //     for(const prk of prsKeys){
        //       if(prs[prk] == true){
        //         if(prk == 'greenShildCustomer'){
        //           prsStatus.push('GreenShield')
        //         }
        //         if(prk == 'hcdSecuremePlans'){
        //           prsStatus.push('HCD Secureme')
        //         }
        //         if(prk == 'equitableCustomer'){
        //           prsStatus.push('Equitable')
        //         }
        //         if(prk == 'phrCustomer'){
        //           prsStatus.push('PHR')
        //         }
        //         if(prk == 'waddelCustomer'){
        //           prsStatus.push('Waddel')
        //         }
        //       }
        //     }
        //   }
        //   this.provisioningSites = prsStatus.toString() ?? ""


        //   console.log("calledoooo")
        //   let data__ = response?.data?.packages
        //   this.customerPlans = response?.data?.customerPlans;

        //   console.log( this.customerPlans, "custplans889")
        //   setTimeout(() => {
        //     this.customerPlans.forEach(element => {
        //       const dom: HTMLElement = this.elementRef.nativeElement;

        //       if(slug == 'remove'){
        //         if (element.isBundle) {
        //           // if(element.name.includes('Life Insurance' || 'Critical')){

        //           // }else{

        //           // }
        //           $("#plancheck2" + element.planId + ".coverage" + element.coverage1.toUpperCase()).click()
        //           $("#plancheck2" +element.planId + ".coverage" + element.coverage1.toUpperCase()).prop("disabled", true);

        //         }
        //         else {
        //           if (element.coverage) {
        //             const plan: any = dom.querySelector("#plancheck2" + element.planSelectionId2 + ".coverage" + element.coverage1.toUpperCase());

        //             // $("#plancheck" + element.planSelectionId2 + ".coverage"+element.coverage).click()
        //             console.log($("#plancheck2" + element.planSelectionId2))
        //             $("#plancheck2" + element.planSelectionId2).click()
        //             $("#plancheck2" + element.planSelectionId2).prop("disabled", true);
        //           }
        //           else {
        //             console.log($("#plancheck2" + element.planSelectionId2))
        //             $("#plancheck2" + element.planSelectionId2).click()
        //             $("#plancheck2" + element.planSelectionId2).prop("disabled", true);

        //           }
        //         }
        //       }else{
        //         console.log(element, "jiihhsh")
        //         if (element.isBundle) {
        //           // if(element.name.includes('Life Insurance' || 'Critical')){

        //           // }else{

        //           // }
        //           $("#plancheck" + element.planId + ".coverage" + element.coverage1.toUpperCase()).click()
        //           $("#plancheck" +  element.planId + ".coverage" + element.coverage1.toUpperCase()).prop("disabled", true);
        //           console.log($("#plancheck" + element.planId + ".coverage" + element.coverage1.toUpperCase()), "called3322")

        //         }
        //         else {
        //           console.log(element?.coverage1, "after else")
        //           if (element?.coverage1 && element?.coverage1 != '-') {
        //             // const plan: any = dom.querySelector("#plancheck" + element.planSelectionId2 + ".coverage" + element.coverage1.toUpperCase());

        //             // $("#plancheck" + element.planSelectionId2 + ".coverage"+element.coverage).click()
        //             console.log("#plancheck" + element.planId + ".coverage" + element.coverage1.toUpperCase())
        //             $("#plancheck" + element.planSelectionId2).click()
        //             $("#plancheck" + element.planId + ".coverage" + element.coverage1.toUpperCase()).prop("disabled", true);
        //           }
        //           else {
        //             console.log($("#plancheck" + element.planSelectionId2))
        //             $("#plancheck" + element.planSelectionId2).click()
        //             $("#plancheck" + element.planSelectionId2).prop("disabled", true);

        //           }
        //         }
        //       }


        //     });
        //   }, 1000);

        //   this.selectedPlans_ = [];
        //   this.oldExistingPlans = []
        //   this.selectedTrues=[]
        //   this.unSelectedPlans_ = []
        //   this.totalSummaryPrice = 0;


        //   for (let package_ of data__) {
        //     console.log(package_, 'asdaas2');

        //     let groupKeys_ = Object.keys(package_.groups);
        //     for (let i = 0; i < groupKeys_.length; i++) {
        //       let groups = groupKeys_[i];

        //       for (let j = 0; j < package_.groups[groups].length; j++) {
        //         let group = package_.groups[groups][j];

        //         for (let k = 0; k < group.plans.length; k++) {
        //           let plan = group.plans[k];
        //           let pan = plan.productAddonssNames;
        //           console.log(plan.isBundle, "bundled")

        //           for (let product of pan) {
        //             if (plan.productAddonss[product]) {
        //               const paon = plan.productAddonss[product];

        //               const selectedAddon = paon.filter((item:any) => item.selected);



        //               if(selectedAddon && selectedAddon.length > 0){
        //                 const unSelectedAddon = paon.find((item:any) => !item.selected);
        //                 const selectedAddon = paon.find((item:any) => item.selected);

        //                 console.log(unSelectedAddon)
        //                   if(!!unSelectedAddon && plan.selected){
        //                     this.upgradeorDowngradeplans.push({
        //                       'name': unSelectedAddon?.name,
        //                       'addon': unSelectedAddon,
        //                       'isBundle': plan.isBundle
        //                     })
        //                   }
        //                   if(selectedAddon && plan.selected){
        //                     this.upgradeorDowngradeplansSelected.push({
        //                       'name': selectedAddon?.name,
        //                       'addon': selectedAddon,
        //                       'isBundle': plan.isBundle
        //                     })
        //                   }
        //               }
        //               // Loop over the addonss for the plan
        //               for (const paon_ of paon) {
        //                 console.log(paon_, '12345');

        //                 if (paon_.selected === true) {
        //                   // We can call the onCheckboxChange



        //                   this.selectedTrues.push({
        //                     id: paon_.id,
        //                     productId: paon_.productId,
        //                     planId: paon_.planId
        //                   });

        //                   paon_['checked'] = true;  // Mark the plan as checked
        //                   this.totalSummaryPrice += paon_.calculatedTax.total;
        //                   this.selectedPlans_.push(paon_);
        //                   this.oldExistingPlans.push(paon_);
        //                 } else {
        //                   this.unSelectedPlans_.push(paon_);
        //                 }
        //               }
        //             }
        //           }
        //         }
        //       }
        //     }






        //     console.log(this.selectedPlans_, 'asd2342');
        //     console.log(this.unSelectedPlans_, 'asd23421');

        //     // Trigger clicks for selected plans after a slight delay
        //     // setTimeout(() => {
        //     //   this.selectedTrues.forEach(element => {
        //     //     const dom = "#plancheck" + element.id;
        //     //     console.log("selectedPlan123", dom);
        //     //     $(dom).click();
        //     //   });


        //     //   // sudeep2

        //     // }, 1000);

        //     // Call method to get the summary of the selected plans
        //     this.getPlanSummaryObject();
        //   }

        //   // let table = '<table style="width: 100%; margin-bottom: 10px; border-collapse: collapse;">';

        //   // upgradeorDowngradeplans.forEach(plan => {
        //   //   table += `
        //   //     <tr>
        //   //       <td style="padding: 8px; border: 1px solid #ddd; text-align: left;">
        //   //         <span>${plan.name} - ${plan.addon.planCoverageUI}</span>
        //   //       </td>
        //   //       <td style="padding: 8px; border: 1px solid #ddd; text-align: left;">
        //   //         <label>
        //   //           <input type="radio" name="plan_${plan.name}" value="yes" /> Yes
        //   //         </label>
        //   //         &nbsp;&nbsp;
        //   //         <label>
        //   //           <input type="radio" name="plan_${plan.name}" value="no" /> No
        //   //         </label>
        //   //       </td>
        //   //     </tr>
        //   //   `;
        //   // });
        //   // table += '</table>';
        //   // Swal.fire({
        //   //   title: 'Do you wish to change your coverage?',
        //   //   html: table,  // Display all the plans in the popup
        //   //   showCancelButton: true,
        //   //   confirmButtonText: 'Confirm',
        //   //   cancelButtonText: 'Cancel',
        //   //   preConfirm: () => {
        //   //     const selectedPlans = upgradeorDowngradeplans.map(plan => {
        //   //       const selectedOption = document.querySelector(`input[name="plan_${plan.name}"]:checked`) as HTMLInputElement;
        //   //       return {
        //   //         planName: plan.name,
        //   //         addOn: plan.addon,
        //   //         action: selectedOption ? selectedOption.value : null,
        //   //         isBundle: plan.isBundle
        //   //       };
        //   //     });

        //   //     // Handle the selected plans and actions (Upgrade/Downgrade)
        //   //     selectedPlans.forEach((plan) => {
        //   //       console.log(plan, "....plan...")
        //   //       if (plan.action === 'yes') {
        //   //         // we gonna click that element
        //   //         let element:any = plan.addOn
        //   //         if (plan.isBundle) {
        //   //           // if(element.name.includes('Life Insurance' || 'Critical')){

        //   //           // }else{

        //   //           // }
        //   //           $("#plancheck" + element.planId + ".coverage" + element.planCoverage.toUpperCase()).click()
        //   //           console.log($("#plancheck" + element.planId + ".coverage" + element.planCoverage.toUpperCase()), "called3322")

        //   //         }
        //   //         else {
        //   //           console.log(element, "elem677")
        //   //           if (element?.planCoverage && element?.planCoverage != '-') {
        //   //             // $("#plancheck" + element.planSelectionId2 + ".coverage"+element.coverage).click()
        //   //             console.log("#plancheck" +  element.planlevel.id + ".coverage" + element.planCoverage.toUpperCase())
        //   //            $("#plancheck" +  element.planlevel.id + ".coverage" + element.planCoverage.toUpperCase()).click()
        //   //           }
        //   //           else {
        //   //             console.log($("#plancheck" +  element.planlevel.id))
        //   //             $("#plancheck" +  element.planlevel.id).click()

        //   //           }
        //   //         }
        //   //         console.log(`Upgrading ${plan.planName}`);
        //   //       } else if (plan.action === 'no') {
        //   //         console.log(`Downgrading ${plan.planName}`);
        //   //       }
        //   //     });
        //   //   }
        //   // });

        //     console.log('selectedTrues',this.selectedTrues)

        //     // setTimeout(() => {
        //     //   this.selectedTrues.forEach(element => {
        //     //     const dom = "#plancheck" + element.id
        //     //     console.log("selectedPlan123", dom)
        //     //     $(dom).click()
        //     //   });
        //     // }, 1000);


        //   // for (let package_ of data__) {
        //   //   console.log(package_, 'asdaas2');

        //   //   let groupKeys_ = Object.keys(package_.groups);

        //   //   for (let groups of groupKeys_) {
        //   //     for (let group of package_.groups[groups]) {
        //   //       for (let plan of group.plans) {
        //   //         let pan = plan.productAddonssNames;

        //   //         for (let product of pan) {
        //   //           if (plan.productAddonss[product]) {
        //   //             let unSelectedCount = 0;
        //   //             const paon = plan.productAddonss[product];

        //   //             for (const paon_ of paon) {
        //   //               console.log(paon_, '12345');

        //   //               if (paon_.selected === true) {
        //   //                 paon_['checked'] = true;
        //   //                 this.totalSummaryPrice += paon_.calculatedTax.total;
        //   //                 this.selectedPlans_.push(paon_);
        //   //                 console.log(this.selectedPlans_, '123456');
        //   //                 this.oldExistingPlans.push(paon_);
        //   //               } else {
        //   //                 unSelectedCount += 1;
        //   //                 this.unSelectedPlans_.push(paon_);

        //   //                 // If all items in the group are unselected, select the first one
        //   //                 // if (unSelectedCount === paon.length) {
        //   //                 //   // paon_['checked'] = true;
        //   //                 //   paon_['selected'] = true;
        //   //                 //   this.totalSummaryPrice += paon_.calculatedTax.total;
        //   //                 //   this.selectedPlans_.push(paon_);
        //   //                 //   this.oldExistingPlans.push(paon_);
        //   //                 // } else {
        //   //                 //   this.unSelectedPlans_.push(paon_);
        //   //                 // }
        //   //               }
        //   //             }
        //   //           }
        //   //         }
        //   //       }
        //   //     }
        //   //   }

        //   //   console.log(this.selectedPlans_, 'asd2342');
        //   //   console.log(this.unSelectedPlans_, 'asd23421');

        //   //   // Click checkboxes after the data is updated
        //   //   // setTimeout(() => {
        //   //   //   this.selectedPlans_.forEach(element => {
        //   //   //     const dom = "#plancheck" + element.id;
        //   //   //     console.log("selectedPlan", dom);
        //   //   //     $(dom).click();
        //   //   //   });
        //   //   // }, 1000);

        //   //   this.getPlanSummaryObject();
        //   // }


        //   this.specialpackages = data__ ?? []


        //   //get the selected coverages



        //  
        //   // this.closeDependentmodal.nativeElement.click();
        //   // Swal.fire({allowOutsideClick: false, title: this.lang?.Info, text: response.message });
        // }
        else {
          // Swal.fire({allowOutsideClick: false,title: this.lang?.Info, text:response.message})
        }
      }, (error) => {
        // Swal.fire({allowOutsideClick: false,title: this.lang?.Info, text: error.error.error.message})
      });
      if (this.specialpackages && this.specialpackages.length > 0) {
        let filteredPackages_: any = [];
        console.log("called")
        //filter the repeated packages for medcan care
        for (let package_ of this.specialpackages) {
          console.log(package_, 'asdaas2')
          let groupKeys_ = Object.keys(package_.groups);
          for (let groups of groupKeys_) {
            for (let group of package_.groups[groups]) {
              for (let plan of group.plans) {
                let pan = plan.productAddonssNames
                for (let product of plan.productAddonssNames) {
                  if (plan.productAddonss[product]) {
                    const paon = plan.productAddonss[product]
                    for (const paon_ of paon) {
                      if (paon_.selected == true) {
                        this.selectedPlans_.push(paon_);
                      }
                    }
                  }
                }

              }
            }
          }
          console.log(this.selectedPlans_, 'asd2342')
          if (package_.id == 5) {
            let groupKeys_ = Object.keys(package_.groups);
            for (let groups of groupKeys_) {
              for (let group of package_.groups[groups]) {
                for (let plan of group.plans) {
                  let pan = plan.productAddonssNames
                  for (let product of plan.productAddonssNames) {

                    // plan.productAddonss[product][0]?.planlevel.id, plan.productAddonss[product][0].product_id
                    if (filteredPackages_[product]) {
                      if (filteredPackages_[product]['planProductIds']?.includes(plan.productAddonss[product][0]?.planlevel.id) && filteredPackages_[product]['planProductIds'].includes(plan.productAddonss[product][0].product_id)) {
                        let index = pan.indexOf(product);
                        if (index !== -1) {
                          pan.splice(index, 1);
                        }
                      }
                    } else {
                      filteredPackages_[product] = { 'planProductIds': [] }
                      filteredPackages_[product]['planProductIds'] = [plan.productAddonss[product][0]?.planlevel.id, plan.productAddonss[product][0].product_id]
                    }

                    console.log(plan.productAddonss, product);

                  }

                  plan.productAddonssNames = pan;
                }
              }
            }
          }
        }

        // console.log(this.specialpackages)
      }
    }
  }

  public handleGetReason(isBackdated: any, isSpouse: any, isChildren: any, childrenDetails: any, spouseDetails: any) {
    console.log(this.normalSpouseRegistration)
    let reasons: any = []
    if (isBackdated && this.planChanges) {
      if (isSpouse) {
        reasons.push(BackdatedReasons.spouse.ADD_SPOUSE_EFFECTIVE_BACKDATED)
      }
      if (isChildren) {
        reasons.push(BackdatedReasons.children.ADD_CHILDREN_EFFECTIVE_BACKDATED)
      }
    }
    if (isChildren && childrenDetails.length > 0 && this.planChanges) {
      for (const child of childrenDetails) {
        // childObj['dob'] = child?.dob ?? "";
        // childObj['coveredByAnotherPlan'] = child?.coveredByAnotherPlan ?? true;
        // childObj['specialNeeds'] = child?.specialNeeds ?? false;
        // childObj['postSecondaryStudent'] = child?.postSecondaryStudent ?? false;
        if (child?.specialNeeds && this.planChanges) {
          reasons.push(BackdatedReasons.children.CHILDREN_WITH_DISABLITY)
        }
        if (!child?.coveredByAnotherPlan) {
          // check if the age is above 18
          const birthDate = moment(child.dob);
          const currentDate = moment();

          const age = currentDate.diff(birthDate, 'years');

          if (age >= 18) {
            if (!child?.postSecondaryStudent) {
              reasons.push(BackdatedReasons.children.CHILDREN_ABOVE_18_NO_STUDENT_NOT_COVERED)
            } else {
              reasons.push(BackdatedReasons.children.CHILDREN_ABOVE_18_STUDENT_NOT_COVERED)
            }
          }

        }
      }
    }
    if (isSpouse && Object.keys(spouseDetails).length > 0 && this.planChanges) {
      if (!this.normalSpouseRegistration) {
        // check if the spouse is not normal
        if (this.marriageType == 'married') {
          reasons.push(BackdatedReasons.spouse.MARRIED_30_BEFORE_NOT_COVERED)
        }
        else {
          reasons.push(BackdatedReasons.spouse.COMMONLAW_365_BEFORE_NOT_COVERED)
        }
      }
    }
    return reasons.length > 0 ? reasons.join(',') : "";
  }


  // public autoSelectCompanyPaidPlans() {

  //   // console.log(this.companypaidproductid)
  //   this.companypaidproductid = this.companypaidproductid.filter(
  //     (item: any) => item !== undefined && item !== null
  //   );

  //   var result = this.companypaidproductid.reduce((unique: any, o: any) => {
  //     if (!unique.some((obj: { name: any; }) => obj.name === o.name)) {
  //       unique.push(o);
  //     }
  //     return unique;
  //   }, []);
  //   console.log(result);

  //   // this.companypaidproductid.forEach((element, index) => {

  //   result.forEach((element: any, index: any) => {


  //     setTimeout(() => {
  //       const dom: HTMLElement = this.elementRef.nativeElement;
  //       // const plan: any = dom.querySelector("#plancheck" + element.id);
  //       // this.renderer.selectRootElement("#plancheck" + element.id).click()



  //       if (element.isBundle) {
  //         let productKeyArray: any = Object.keys(element.productAddonss)
  //         for (let productkey of productKeyArray) {
  //           //console.log(productkey)
  //           //console.log(element.productAddonss)
  //           //console.log(productKeyArray)
  //           for (let i = 0; i < element.productAddonss[productkey].length; i++) {
  //             //console.log(element.productAddonss[productkey][i])
  //             let coverage = element.companyPaidCoverage?.replace("SELECTIVE_", "")
  //             console.log(coverage)
  //             if (coverage && coverage != "DIRECT") {
  //               try {
  //                 const elementSelector = "#plancheck" +
  //                   element.productAddonss[productkey][i].planId +
  //                   ".coverage" +
  //                   coverage;

  //                 const targetElement = this.renderer.selectRootElement(elementSelector, true);
  //                 console.log(targetElement)
  //                 // Use the second argument 'true' to avoid throwing an error if the element is not found
  //                 if (targetElement.disabled) {
  //                   targetElement.disabled = false
  //                   targetElement.click();
  //                   break;
  //                 }
  //                 else {
  //                   targetElement.click();
  //                   break;
  //                 }




  //               } catch (error) {
  //                 console.warn('Element not found. Moving to the next element:', error);
  //                 // Handle the case when the element is not found
  //                 // You can skip the iteration or log the error as needed
  //               }
  //               // this.renderer.selectRootElement("#plancheck" + element.productAddonss[productkey][i].planId + ".coverage" + coverage).click()

  //             }
  //             else {

  //               try {
  //                 const elementSelector = "#plancheck" +
  //                   element.productAddonss[productkey][i].planId +
  //                   ".coverage" +
  //                   element.productAddonss[productkey][i].planCoverage;

  //                 const targetElement = this.renderer.selectRootElement(elementSelector, true);
  //                 // Use the second argument 'true' to avoid throwing an error if the element is not found
  //                 console.log(targetElement)
  //                 if (targetElement.disabled) {
  //                   targetElement.disabled = false
  //                   targetElement.click();
  //                 }
  //                 else {
  //                   targetElement.click();
  //                 }

  //               } catch (error) {
  //                 console.warn('Element not found. Moving to the next element:', error);
  //                 // Handle the case when the element is not found
  //                 // You can skip the iteration or log the error as needed
  //               }
  //               // this.renderer.selectRootElement("#plancheck" + element.productAddonss[productkey][i].planId + ".coverage" + element.productAddonss[productkey][i].planCoverage).click()

  //             }

  //           }

  //         }

  //         // Object.keys(element.productAddonss).forEach((key) => {
  //         //   element.productAddonss[key].forEach((product: any) => {
  //         //    //console.log(product)
  //         //    let coverage = element.companyPaidCoverage?.replace("SELECTIVE_","")
  //         //    //console.log(coverage)
  //         //   //  //console.log(this.renderer.selectRootElement("#plancheck" + product.planId + ".coverage" + coverage?coverage:product.planCoverage))
  //         //   //   // //console.log(this.renderer.selectRootElement("#plancheck" + product.planId + ".coverage" + covergae))
  //         //     // this.renderer.selectRootElement("#plancheck" + product.planId + ".coverage" + coverage?coverage:product.planCoverage).click()

  //         //     if(coverage!="DIRECT"){
  //         //       this.renderer.selectRootElement("#plancheck" + product.planId + ".coverage" + coverage).click()

  //         //     }
  //         //     else{
  //         //       this.renderer.selectRootElement("#plancheck" + product.planId + ".coverage" + product.planCoverage).click()
  //         //     }

  //         //   })
  //         // })

  //       }
  //       else {
  //         this.renderer.selectRootElement("#plancheck" + element.id).click()
  //       }



  //     }, 100);

  //   });


  //   setTimeout(() => {
  //     let selectplans =
  //       JSON.parse(sessionStorage.getItem("plansummarymain") || '[]') || "";

  //     //this.consoleMessage(selectplans)

  //     //console.log(selectplans)
  //     selectplans.forEach((element: any) => {
  //       if (element.paidByCompany == 1) {
  //         element.products.forEach((product: any, index: any) => {
  //           const dom: HTMLElement = this.elementRef.nativeElement;
  //           const plan: any = dom.querySelector("#plancheck" + product.id);

  //           if (plan) {
  //             plan.disabled = true;
  //           }
  //         })

  //       }
  //     });
  //   }, 2000);
  //   // this.mainarrayFinal.forEach((element: any) => {
  //   //   element.groups.forEach((group: any) => {
  //   //     group.plans.forEach((plan: any) => {
  //   //       if (plan.productAddonss) {
  //   //         Object.keys(plan.productAddonss).forEach((key) => {
  //   //           // plan.productAddonss[key].forEach((product) => {
  //   //           const keys = ['planCoverage'];
  //   //           const filteredData = plan.productAddonss[key].filter((value: any, index: any, self: any) =>
  //   //             self.findIndex((v: { [x: string]: any; }) => keys.every(k => v[k] === value[k])) === index
  //   //           );
  //   //           plan.productAddonss[key] = filteredData
  //   //           // });
  //   //         });
  //   //       }
  //   //     });

  //   //   });
  //   // });
  //   //this.consoleMessage(this.mainarray)

  //   this.mainarrayFinal.forEach((element: { groups: any[]; }) => {
  //     element.groups.forEach((group: { categorization: { paidByCompany: number; }; plans: any[]; }) => {
  //       // //this.consoleMessage(element.groups)
  //       if (element.groups.length == 1) {
  //         // //this.consoleMessage(group)
  //         if (group.categorization.paidByCompany == 1) {
  //           group.plans.forEach((plan: { productAddonss: { [x: string]: any[]; }; }) => {
  //             Object.keys(plan.productAddonss).forEach((key) => {
  //               plan.productAddonss[key].forEach((product: { id: any; }) => {
  //                 this.disabledcompanypaidproductid.push({ id: product.id });
  //                 const dom: HTMLElement = this.elementRef.nativeElement;

  //                 const plan: any = dom.querySelector("#plancheck" + product.id);

  //                 if (plan) {
  //                   plan.checked = false;
  //                 }
  //                 // $("#plancheck" + product.id).prop("checked", false);
  //               });
  //             });
  //           });
  //         }
  //       }
  //     });
  //   });


  //   this.disabledcompanypaidproductid.forEach((element: { id: string; }, index: any) => {
  //     setTimeout(() => {
  //       const dom: HTMLElement = this.elementRef.nativeElement;
  //       const plan: any = dom.querySelector("#plancheck" + element.id);

  //       // plan.disabled=true
  //     }, 100);
  //   });
  //   // if (packagesInBlocks && packagesInBlocks.paidByCompany) {
  //   //   for (const cpPackage of packagesInBlocks.paidByCompany) {
  //   //     for (const cpGroup of cpPackage.groupsCP) {
  //   //       for (const cpPlan of cpGroup.plans) {

  //   //         for(const product1 in cpPlan.productAddonss){
  //   //           //this.consoleMessage(product1)
  //   //           //this.consoleMessage(cpPlan.productAddonss[product1])
  //   //           $("#plancheck"+cpPlan.productAddonss[product1][0].id).click();

  //   //         }

  //   //       }
  //   //     }
  //   //   }
  //   // }
  //   // this.toastrService.success("Company paid plans are all selected", "");

  // }

  public customerSelectedPlansValues(selectedPlans) {

    let data: any = selectedPlans;
    let obj = {};

    if (data) {

      data.forEach((element: any, index: any) => {
        obj = {
          planid: element.id,
        };

        setTimeout(() => {

          const dom: HTMLElement = this.elementRef.nativeElement;


          if (element.options && element.options.length > 0) {

            if (element.isBundle) {
              // const planCheck = this.renderer.selectRootElement("#plancheck" + element.id, true);


              // this.renderer.setProperty(planCheck, 'checked', true);
              const plan: any = dom.querySelector("#plancheck" + element.planSelectionId2 + ".coverage" + element.coverage1.toUpperCase());
              // this.renderer.setProperty(plan, 'checked', true);
              if (plan) {
                plan.click(); // Simulate a user click
              }


            } else {
              // const planCheck = this.renderer.selectRootElement("#plancheck" + products.planLevel, true);


              // this.renderer.setProperty(planCheck, 'checked', true);
              if (element.coverage1) {
                const plan: any = dom.querySelector("#plancheck" + element.planSelectionId2 + ".coverage" + element.coverage1.toUpperCase());


                // this.renderer.setProperty(plan, 'checked', true);
                if (plan) {
                  plan.click(); // Simulate a user click
                }
              }
              else {
                const planCheck = this.renderer.selectRootElement("#plancheck" + element.planSelectionId2, true);
                // this.renderer.setProperty(planCheck, 'checked', true);
                if (planCheck) {
                  planCheck.click(); // Simulate a user click
                }

              }



            }

          }

          else {

            if (element.isBundle) {
              const plan: any = dom.querySelector("#plancheck" + element.planSelectionId2 + ".coverage" + element.coverage1.toUpperCase());

              let CoverageSelection;
              // this.renderer.setProperty(plan, 'checked', true);
              if (plan) {
                plan.click(); // Simulate a user click
              }


              // const planCheck = this.renderer.selectRootElement("#plancheck" + element.id, true);

              // // //console.log(planCheck)
              // this.renderer.setProperty(planCheck, 'checked', true);









            }
            else {
              // element.products.forEach((products: any, index: any) => {
              // $("#plancheck" + products.id).click();
              // const planCheck = this.renderer.selectRootElement("#plancheck" + products.planLevel, true);
              //   //console.log(planCheck)
              // this.renderer.setProperty(planCheck, 'checked', true);
              if (element.coverage1 && element.coverage1.length > 2) {
                const plan: any = dom.querySelector("#plancheck" + element.planSelectionId2 + ".coverage" + element.coverage1.toUpperCase());


                // this.renderer.setProperty(plan, 'checked', true);
                if (plan) {
                  plan.click(); // Simulate a user click
                }
              }
              else {
                const planCheck = this.renderer.selectRootElement("#plancheck" + element.planSelectionId2, true);
                if (planCheck) {
                  this.renderer.setProperty(planCheck, 'checked', true);
                  planCheck.dispatchEvent(new Event('change')); // Notify Angular of the change
                }

              }
              // if (element.paidByCompany == 1) {
              //   const dom: HTMLElement = this.elementRef.nativeElement;
              //   if (element.coverage) {
              //     const plan: any = dom.querySelector("#plancheck" + products.planLevel + ".coverage" + element.coverage);
              //     if (plan) {
              //       plan.disabled = true;
              //     }
              //   }
              //   else {
              //     const plan = this.renderer.selectRootElement("#plancheck" + products.planLevel, true);
              //     if (plan) {
              //       plan.disabled = true;
              //     }
              //   }
              // }
              // })


            }
          }

          // $("#plancheck" + element.id).prop("checked", true);
          // plan.checked =true
        }, 100);

        // this.plancheckarray.push(element.id)
      });

    }

  }
  public autoSelectCompanyPaidPlans() {
    // console.log(this.companypaidproductid)
    this.companypaidproductid = this.companypaidproductid.filter(
      (item: any) => item !== undefined && item !== null
    );

    var result = this.companypaidproductid.reduce((unique: any, o: any) => {
      if (!unique.some((obj: { name: any; }) => obj.name === o.name)) {
        unique.push(o);
      }
      return unique;
    }, []);
    console.log(result);

    // this.companypaidproductid.forEach((element, index) => {

    result.forEach((element: any, index: any) => {


      setTimeout(() => {
        const dom: HTMLElement = this.elementRef.nativeElement;
        // const plan: any = dom.querySelector("#plancheck" + element.id);
        // this.renderer.selectRootElement("#plancheck" + element.id).click()

        if (element.isBundle) {
          let productKeyArray: any = Object.keys(element.productAddonss)
          for (let productkey of productKeyArray) {
            //console.log(productkey)
            //console.log(element.productAddonss)
            //console.log(productKeyArray)
            for (let i = 0; i < element.productAddonss[productkey].length; i++) {
              //console.log(element.productAddonss[productkey][i])
              let coverage = element.companyPaidCoverage?.replace("SELECTIVE_", "")
              console.log(coverage)
              if (coverage && coverage != "DIRECT") {
                try {
                  const elementSelector = "#plancheck" +
                    element.productAddonss[productkey][i].planId +
                    ".coverage" +
                    coverage;

                  const targetElement = this.renderer.selectRootElement(elementSelector, true);
                  console.log(targetElement)
                  // Use the second argument 'true' to avoid throwing an error if the element is not found
                  if (targetElement.disabled) {
                    targetElement.disabled = false
                    targetElement.click();
                    break;
                  }
                  else {
                    targetElement.click();
                    break;
                  }




                } catch (error) {
                  console.warn('Element not found. Moving to the next element:', error);
                  // Handle the case when the element is not found
                  // You can skip the iteration or log the error as needed
                }
                // this.renderer.selectRootElement("#plancheck" + element.productAddonss[productkey][i].planId + ".coverage" + coverage).click()

              }
              else {

                try {
                  const elementSelector = "#plancheck" +
                    element.productAddonss[productkey][i].planId +
                    ".coverage" +
                    element.productAddonss[productkey][i].planCoverage;

                  const targetElement = this.renderer.selectRootElement(elementSelector, true);
                  // Use the second argument 'true' to avoid throwing an error if the element is not found
                  console.log(targetElement)
                  if (targetElement.disabled) {
                    console.log("disabled click")
                    targetElement.disabled = false
                    targetElement.click();
                  }
                  else {
                    console.log("click")
                    console.log(elementSelector)
                    console.log($(elementSelector).length)
                    setTimeout(function() {
                        $(elementSelector).click();
                    }, 1000);
                  }

                } catch (error) {
                  console.warn('Element not found. Moving to the next element:', error);
                  // Handle the case when the element is not found
                  // You can skip the iteration or log the error as needed
                }
                // this.renderer.selectRootElement("#plancheck" + element.productAddonss[productkey][i].planId + ".coverage" + element.productAddonss[productkey][i].planCoverage).click()

              }

            }

          }

          // Object.keys(element.productAddonss).forEach((key) => {
          //   element.productAddonss[key].forEach((product: any) => {
          //    //console.log(product)
          //    let coverage = element.companyPaidCoverage?.replace("SELECTIVE_","")
          //    //console.log(coverage)
          //   //  //console.log(this.renderer.selectRootElement("#plancheck" + product.planId + ".coverage" + coverage?coverage:product.planCoverage))
          //   //   // //console.log(this.renderer.selectRootElement("#plancheck" + product.planId + ".coverage" + covergae))
          //     // this.renderer.selectRootElement("#plancheck" + product.planId + ".coverage" + coverage?coverage:product.planCoverage).click()

          //     if(coverage!="DIRECT"){
          //       this.renderer.selectRootElement("#plancheck" + product.planId + ".coverage" + coverage).click()

          //     }
          //     else{
          //       this.renderer.selectRootElement("#plancheck" + product.planId + ".coverage" + product.planCoverage).click()
          //     }

          //   })
          // })

        }
        else {
          this.renderer.selectRootElement("#plancheck" + element.id).click()
        }
      }, 100);

    });

    setTimeout(() => {
      let selectplans =
        JSON.parse(sessionStorage.getItem("plansummarymain") || '[]') || "";

      //this.consoleMessage(selectplans)

      console.log(selectplans)
      selectplans.forEach((element: any) => {
        if (element.paidByCompany == 1) {
          element.products.forEach((product: any, index: any) => {
            const dom: HTMLElement = this.elementRef.nativeElement;
            const plan: any = dom.querySelector("#plancheck" + product.id);

            if (plan) {
              plan.disabled = true;
            }
          })

        }
      });
    }, 2000);
    // this.mainarrayFinal.forEach((element: any) => {
    //   element.groups.forEach((group: any) => {
    //     group.plans.forEach((plan: any) => {
    //       if (plan.productAddonss) {
    //         Object.keys(plan.productAddonss).forEach((key) => {
    //           // plan.productAddonss[key].forEach((product) => {
    //           const keys = ['planCoverage'];
    //           const filteredData = plan.productAddonss[key].filter((value: any, index: any, self: any) =>
    //             self.findIndex((v: { [x: string]: any; }) => keys.every(k => v[k] === value[k])) === index
    //           );
    //           plan.productAddonss[key] = filteredData
    //           // });
    //         });
    //       }
    //     });

    //   });
    // });
    //this.consoleMessage(this.mainarray)

    this.mainarrayFinal.forEach((element: { groups: any[]; }) => {
      element.groups.forEach((group: { categorization: { paidByCompany: number; }; plans: any[]; }) => {
        // //this.consoleMessage(element.groups)
        if (element.groups.length == 1) {
          // //this.consoleMessage(group)
          if (group.categorization.paidByCompany == 1) {
            group.plans.forEach((plan: { productAddonss: { [x: string]: any[]; }; }) => {
              Object.keys(plan.productAddonss).forEach((key) => {
                plan.productAddonss[key].forEach((product: { id: any; }) => {
                  this.disabledcompanypaidproductid.push({ id: product.id });
                  const dom: HTMLElement = this.elementRef.nativeElement;

                  const plan: any = dom.querySelector("#plancheck" + product.id);

                  if (plan) {
                    plan.checked = false;
                  }
                  // $("#plancheck" + product.id).prop("checked", false);
                });
              });
            });
          }
        }
      });
    });


    this.disabledcompanypaidproductid.forEach((element: { id: string; }, index: any) => {
      setTimeout(() => {
        const dom: HTMLElement = this.elementRef.nativeElement;
        const plan: any = dom.querySelector("#plancheck" + element.id);

        // plan.disabled=true
      }, 100);
    });
    // if (packagesInBlocks && packagesInBlocks.paidByCompany) {
    //   for (const cpPackage of packagesInBlocks.paidByCompany) {
    //     for (const cpGroup of cpPackage.groupsCP) {
    //       for (const cpPlan of cpGroup.plans) {

    //         for(const product1 in cpPlan.productAddonss){
    //           //this.consoleMessage(product1)
    //           //this.consoleMessage(cpPlan.productAddonss[product1])
    //           $("#plancheck"+cpPlan.productAddonss[product1][0].id).click();

    //         }

    //       }
    //     }
    //   }
    // }
    // this.toastrService.success("Company paid plans are all selected", "");

  }
  calculateBasePlanCPplans(cpplanspackages: string | any[], baseplansMain: any[], compnayplans: any[]) {

    console.log(cpplanspackages)
    console.log(baseplansMain)

    if (baseplansMain) {
      baseplansMain = baseplansMain.filter(name => name.productAddonssNames.length > 0)
    }



    let selectedbasePlanMain;
    console.log(baseplansMain)
    let modifiedCPplanPackages: any = [];
    for (let i = 0; i < cpplanspackages?.length; i++) {
      if (baseplansMain) {
        selectedbasePlanMain = baseplansMain.filter(name => name.packageId == cpplanspackages[i].id)
        if (selectedbasePlanMain.length > 0) {
          selectedbasePlanMain = selectedbasePlanMain[selectedbasePlanMain.length - 1]
        }

      }
      let modifiedCPPackage = cpplanspackages[i];

      let CPplansgroups = cpplanspackages[i].groupsCP;

      modifiedCPPackage.groupsCP = [];
      for (let CPplangroup of CPplansgroups) {
        let modifiedCPgroup = CPplangroup;
        let selectedCoverage = CPplangroup?.categorization?.companyPaidCoverage ?? "DIRECT"
        if (selectedCoverage == "null") {
          selectedCoverage = "DIRECT"
        }
        if (selectedCoverage != "DIRECT") {
          selectedCoverage = selectedCoverage.replace("SELECTIVE_", "")
        }

        console.log(selectedCoverage)


        if (selectedCoverage == "DIRECT") {
          modifiedCPPackage.groupsCP.push(modifiedCPgroup)
          if (modifiedCPPackage.groupsCP.length == CPplansgroups.length) {
            modifiedCPplanPackages.push(modifiedCPPackage)
          }
          continue;
        }
        let CPplans = CPplangroup.plans;

        //console.log(CPplangroup)

        modifiedCPgroup.plans = [];
        let baseplans:any = []
        for (let CPplan of CPplans) {
          let modifiedCPplan = CPplan;


          CPplan.planLevel_parentId = CPplangroup.parentId;

          let payroll = true;
          let EmployeeChoice = 0;

          if (
            this.CORP_PAYROLL_NOT_MANDATORY_PACKAGES.includes(CPplan.packageId)
          ) {
            if (EmployeeChoice == 2) {
              payroll = false;
            }
          } else {
            if (
              this.CORP_PAYROLL_NOT_MANDATORY_PLANLEVELS.includes(
                CPplan.planLevel
              )
            ) {
              if (EmployeeChoice == 2) {
                payroll = false;
              }
            }
          }
          console.log(CPplan)
            let selectedCPplanProductarray: any
          if (CPplan.isBundle == true) {
            selectedCPplanProductarray = CPplan.productAddonss[CPplan.name];
          } else {
            selectedCPplanProductarray = Object.keys(CPplan.productAddonss)
          }

          console.log(selectedCPplanProductarray)
          // let selectedCPplanProductarray: any = Object.keys(CPplan.productAddonss)


          /* this is filtering other products which are not to be displayed */
          selectedCPplanProductarray = selectedCPplanProductarray.filter((prop: any) => prop.display)


          // let selectedCPplanProductarray: any = Object.keys(CPplan.productAddonss)

          console.log(selectedCPplanProductarray)
          if (selectedbasePlanMain) {
            let selectedMainProductarray: any = selectedbasePlanMain.productAddonss[selectedbasePlanMain.name];

            console.log(selectedMainProductarray)
            //console.log(CPplan.productAddonss[CPplan.name])

            for (let i = 0; i < selectedCPplanProductarray.length; i++) {

              for (let j = 0; j < selectedMainProductarray.length; j++) {
                if (selectedMainProductarray[i].planCoverage == selectedCoverage) {

                  baseplans.push(selectedMainProductarray[i])
                }

              }
            }
          }
          else {
            for (let i = 0; i < selectedCPplanProductarray.length; i++) {

              for (let j = 0; j < selectedCPplanProductarray.length; j++) {
                if (selectedCPplanProductarray[i].planCoverage == selectedCoverage) {

                  baseplans.push(selectedCPplanProductarray[i])
                }

              }

            }

          }






          if (CPplan.isBundle) {

            console.log(baseplans)
            var filtered_base_plans = baseplans



            //this.consoleMessage(filtered_base_plans);

            //this.consoleMessage(filtered_compnay_plans)
            let selectedBasePlan:any;
            let selectedCompnayPlan;
            let DeltaPlan;
            let selectedBaseplanProduct: any;
            let selectedBaseplanProductsArray:any = [];
            let selectedCompanyplanProduct: any;
            let selectedCompanyplanProductsArray: any = [];

            //console.log("length" + filtered_base_plans.length)

            selectedBasePlan = filtered_base_plans[0];

            console.log(selectedBasePlan)

            if (selectedBasePlan) {
              // //this.consoleMessage(selectedBasePlan)
              // selectedBaseplanProduct = selectedBasePlan.productAddonss[selectedBasePlan.name][0]
              selectedBaseplanProductsArray = [selectedBasePlan];
              let selectedBaseplanProductsArray2 = [];
              //  //this.consoleMessage(CCplan.packageId)
              if (CPplan.packageId == 5 || CPplan.packageId == 10) {

                // selectedBaseplanProductsArray2 = selectedBaseplanProductsArray
                // for (let i = 0; i < selectedCPplanProductarray.length - selectedBaseplanProductsArray.length; i++) {
                //   selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray[selectedBaseplanProductsArray.length - 1]);
                // }
                // // //this.consoleMessage(selectedBaseplanProductsArray)
                // selectedBaseplanProductsArray = selectedBaseplanProductsArray2
                // //this.consoleMessage(selectedBaseplanProductsArray)
              }
              else {

                // Direct Coverage Method

                // selectedBaseplanProductsArray =this.DirectCoverageMethod(selectedCCplanProductarray,selectedBaseplanProductsArray)


                // Selective single Coverage Method

                //  selectedBaseplanProductsArray =this.selectiveSingleCoverageMethod(selectedCCplanProductarray,selectedBaseplanProductsArray)

                // Selective Couple Coverage Method
                if (selectedCoverage != "DIRECT") {
                  selectedBaseplanProductsArray = this.selectiveCPCoverageMethod(selectedCPplanProductarray, selectedBaseplanProductsArray, selectedCoverage)
                }
                //  // Selective Family Coverage Method


              }
            }
            else {
              selectedBasePlan = {};
              selectedBaseplanProduct = {};
              selectedBaseplanProduct.calculatedTax = {};
              selectedBaseplanProduct.calculatedTax.price = 0;
              selectedBaseplanProduct.calculatedTax.tax = 0;
              selectedBaseplanProduct.calculatedTax.total = 0;
              selectedBaseplanProduct.name = "NA";

              for (let i = 0; i < selectedCPplanProductarray.length; i++) {
                selectedBaseplanProductsArray.push(selectedBaseplanProduct);
              }
            }



            let upgradeText;
            let upgradepaymentText;
            if (payroll) {
              upgradeText = "Employee upgraded using payroll deduction";
              upgradepaymentText = "using payroll deduction";
              //this.consoleMessage("One subscription to parent/corp with base(company tax)+Delta(employee tax)")
            } else {
              upgradeText = "Employee upgraded using Direct payment";
              upgradepaymentText = "using Direct payment";
            }

            modifiedCPplan.products = []

            for (let i = 0; i < selectedCPplanProductarray.length; i++) {
              let selectedBaseplanProduct = selectedBaseplanProductsArray[i];
              console.log(selectedBaseplanProduct)
              let selectedCPplanProduct = selectedCPplanProductarray[i];
              console.log(selectedCPplanProduct)
              let coverage = selectedCPplanProduct.planCoverage

              console.log(coverage)
              if (selectedCoverage == coverage) {

                modifiedCPplan.products.push(selectedCPplanProduct)
                continue;
              }

              console.log(selectedCPplanProduct)
              let selectedCompanyplanProduct =
                selectedCompanyplanProductsArray[i];

              let companyTax;
              let companyTaxPercentage;
              let employeeTax;
              let employeeTaxPercentage;

              if (selectedBaseplanProduct) {
                companyTax =
                  selectedBaseplanProduct?.calculatedTax?.planProductInfos.length > 0
                    ? selectedBaseplanProduct.calculatedTax.planProductInfos[0]
                      .taxRate
                    : 0;
                companyTaxPercentage =
                  selectedBaseplanProduct?.calculatedTax?.planProductInfos.length > 0
                    ? selectedBaseplanProduct.calculatedTax.planProductInfos[0]
                      .taxRatePercentage
                    : 0;
                employeeTax =
                  selectedBaseplanProduct?.calculatedTax?.planProductInfos.length > 0
                    ? selectedBaseplanProduct.calculatedTax.planProductInfos[0]
                      .taxRate
                    : 0;
                employeeTaxPercentage =
                  selectedBaseplanProduct?.calculatedTax?.planProductInfos.length > 0
                    ? selectedBaseplanProduct.calculatedTax.planProductInfos[0]
                      .taxRatePercentage
                    : 0;
              }
              else {
                companyTax =
                  selectedCPplanProduct?.calculatedTax?.planProductInfos.length > 0
                    ? selectedCPplanProduct.calculatedTax.planProductInfos[0]
                      .taxRate
                    : 0;
                companyTaxPercentage =
                  selectedCPplanProduct?.calculatedTax?.planProductInfos.length > 0
                    ? selectedCPplanProduct.calculatedTax.planProductInfos[0]
                      .taxRatePercentage
                    : 0;
                employeeTax =
                  selectedCPplanProduct?.calculatedTax?.planProductInfos.length > 0
                    ? selectedCPplanProduct.calculatedTax.planProductInfos[0]
                      .taxRate
                    : 0;
                employeeTaxPercentage =
                  selectedCPplanProduct?.calculatedTax?.planProductInfos.length > 0
                    ? selectedCPplanProduct.calculatedTax.planProductInfos[0]
                      .taxRatePercentage
                    : 0;
              }




              let baseplanPrice = adjustWith2DecimalsForUI(
                selectedBaseplanProduct.calculatedTax.price
              );
              let baseplanTaxorg = adjustWith2DecimalsForUI(
                selectedBaseplanProduct.calculatedTax.tax
              );
              let baseplanTax = adjustWith2DecimalsForUI(
                baseplanPrice * companyTax
              );
              let baseplanTotalorg = adjustWith2DecimalsForUI(
                selectedBaseplanProduct.calculatedTax.total
              );
              let baseplanTotal = adjustWith2DecimalsForUI(
                baseplanPrice + baseplanTax
              );



              console.log(selectedCPplanProduct)

              let deltaplanPrice = adjustWith2DecimalsForUI(
                selectedCPplanProduct?.calculatedTax?.price -
                selectedBaseplanProduct?.calculatedTax?.price
              );
              console.log(deltaplanPrice)


              //console.log(selectedBaseplanProduct.calculatedTax.price)

              if (selectedBaseplanProduct.name == 'NA') {
                //this.consoleMessage("No Base plan/product for this upgrade plans/product")
                companyTax = employeeTax
                companyTaxPercentage = employeeTaxPercentage
              }
              //Delete plan Total Price and Total Combination
              if (deltaplanPrice <= 0) {
                deltaplanPrice = 0
                /*      baseplanPrice = adjustWith2DecimalsForUI(
                      selectedCPplanProduct.calculatedTax.price
                    );
                     baseplanTaxorg = adjustWith2DecimalsForUI(
                      selectedCPplanProduct.calculatedTax.tax
                    );
                     baseplanTax = adjustWith2DecimalsForUI(
                      baseplanPrice * companyTax
                    );
                     baseplanTotalorg = adjustWith2DecimalsForUI(
                      selectedCPplanProduct.calculatedTax.total
                    );
                     baseplanTotal = adjustWith2DecimalsForUI(
                      baseplanPrice + baseplanTax
                    ); */

                modifiedCPplan.products.push(selectedCPplanProduct)
                continue;

              }


              // let deltaplanTax = adjustWith2DecimalsForUI(
              //   deltaplanPrice *
              //   (this.deltaCompanyTax ? companyTax : employeeTax)
              // );
              let deltaplanTax = adjustWith2DecimalsForUI(deltaplanPrice * employeeTax);
              let deltaplanTotal = adjustWith2DecimalsForUI(
                deltaplanPrice + deltaplanTax
              );
              let combinedplanPrice = adjustWith2DecimalsForUI(
                baseplanPrice + deltaplanPrice
              );
              let combinedplanbasePrice = baseplanPrice;
              let combinedplanDeltaprice = deltaplanPrice;
              let combinedplanTax = adjustWith2DecimalsForUI(
                baseplanTax + deltaplanTax
              );
              let combinedplanCompanyTax = baseplanTax;
              let combinedplanEmployeeTax =
                adjustWith2DecimalsForUI(deltaplanTax);
              let combinedplanCompanyTaxPercentage = companyTaxPercentage;
              let combinedplanemployeeTaxPercentage = this.deltaCompanyTax
                ? companyTaxPercentage
                : employeeTaxPercentage;
              let combinedplanemployeeTaxPercentageorg = employeeTaxPercentage;

              let combinedplanTotal = adjustWith2DecimalsForUI(
                baseplanTotal + deltaplanTotal
              );

              let scenario = `Employee Upgrade from ${selectedBasePlan.name}  (${selectedCoverage}) to ${CPplan.name}`;
              let planName = `${CPplan.name} (${this.capitalize(coverage)}) (${upgradeText})`;
              let compnayShareStatement = `${CPplan.name} (${this.capitalize(selectedCoverage)})  Contribution`;
              let employeeShareStatement = `${CPplan.name} (${this.capitalize(coverage)}) upgrade cost`;
              let planDescription = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanTotal} and Employee- pays ${upgradepaymentText} ${deltaplanTotal} `;
              let planDescription2 = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanPrice}(with tax:${companyTaxPercentage}) and Employee- pays ${upgradepaymentText} ${deltaplanPrice}(with tax:${employeeTaxPercentage}) `;
              let type;

              if (payroll) {
                type = "Split with payroll deduction";
              } else {
                type = "Split with direct pay";
              }
              let basePlanDetails = {
                planId: selectedBasePlan.id, //0
                planName: selectedBasePlan.name, //NA
                planLevelId: selectedBasePlan.planLevel, //0
                amount: baseplanPrice, //0
                amountUI: `$${baseplanPrice}`, //0
                tax: baseplanTax,
                total: baseplanTotal,
                taxUI: `$${baseplanTax}`, //companyTaxpercentage
                totalUI: `$${baseplanTotal}`,
                planLevelName: selectedBasePlan.groupName || "", //if it is Bundle
                planFrequencyID: selectedBasePlan.frqMonthly || "",
                planFusebillID: selectedBasePlan.fusebillId || "",
                products: [selectedBaseplanProduct],
                planLevel_parentId: selectedBasePlan.planLevel_parentId,
                packageName: selectedBasePlan.packageName,
                packageId: selectedBasePlan.packageId,
              };





              let obj = {
                companyTax,
                companyTaxPercentage,
                baseplanPrice,
                baseplanTaxorg,
                baseplanTax,
                baseplanTotalorg,
                baseplanTotal,
                employeeTax,
                employeeTaxPercentage,
                deltaplanPrice,
                deltaplanTax,
                deltaplanTotal,
                combinedplanPrice,
                combinedplanbasePrice,
                combinedplanDeltaprice,
                combinedplanTax,
                combinedplanCompanyTax,
                combinedplanEmployeeTax,
                combinedplanCompanyTaxPercentage,
                combinedplanemployeeTaxPercentage,
                combinedplanTotal,
                payroll,
                scenario,
                planName,
                compnayShareStatement,
                employeeShareStatement,
                planDescription,
                planDescription2,
                type,
                basePlanDetails,
                combinedplanemployeeTaxPercentageorg,
                coverage,
                selectedCoverage
              };

              //this.consoleMessage(obj)

              //console.log(selectedCoverage)
              //console.log(coverage)

              //console.log(obj)
              let cpProduct: any = {}
              cpProduct.upgradeCalculation = obj;
              modifiedCPplan.products.push(cpProduct)
              // modifiedCPplan.upgradeCalculation = obj;

              // if(selectedCoverage == coverage){

              // }else{
              //   cpProduct.upgradeCalculation = obj;
              //   modifiedCPplan.products.push(cpProduct)
              // }

              //console.log(modifiedCPplan)
            }

          }
          else {
            //this.consoleMessage("Not a BundlePlan")

            //this.consoleMessage(baseplans)



            filtered_base_plans = baseplans

            let selectedBasePlan;
            let selectedCompnayPlan;
            let DeltaPlan;
            //console.log("length" + filtered_base_plans.length)
            if (filtered_base_plans.length == 0) {
            } else if (filtered_base_plans.length == 0) {
              selectedBasePlan = filtered_base_plans[0];
            } else {
              //this.consoleMessage(filtered_base_plans.length)
            }

            let selectedbaseplanproduct: any;
            let selectedBaseplanProduct: any;

            if (selectedBasePlan) {
              for (let planname in selectedBasePlan.productAddonss) {
                //this.consoleMessage(planname)
                //this.consoleMessage(selectedBasePlan.productAddonss[planname])
                let products = selectedBasePlan.productAddonss[planname];
                //console.log("length" + products.length)
                if (products.length == 0) {
                } else if (products.length == 1) {
                  selectedbaseplanproduct = products[0];
                  // selectedCompnayPlan= filtered_compnay_plans[0]
                } else {
                  //this.consoleMessage(products.length)
                }
              }
              //this.consoleMessage(selectedbaseplanproduct)
              selectedBaseplanProduct = selectedbaseplanproduct;

            } else {
              selectedBasePlan = {};
              selectedBaseplanProduct = {};
              selectedBaseplanProduct.calculatedTax = {};
              selectedBaseplanProduct.calculatedTax.price = 0;
              selectedBaseplanProduct.calculatedTax.tax = 0;
              selectedBaseplanProduct.calculatedTax.total = 0;
              selectedBaseplanProduct.name = "NA";
            }

            let CCplanProduct;

            for (let planname in CPplan.productAddonss) {
              let products = CPplan.productAddonss[planname];
              //console.log("length" + products.length)

              if (products.length == 0) {
              } else if (products.length == 1) {
                CCplanProduct = products[0];
                // selectedCompnayPlan= filtered_compnay_plans[0]
              } else {
                //this.consoleMessage(products.length)
              }
            }
            let selectedCCplanProduct = CCplanProduct;


            let selectedcompanyplanproduct: any;
            let selectedCompanyplanProduct: any;

            if (selectedCompnayPlan) {

              let upgradeText;
              let upgradepaymentText;
              if (payroll) {
                upgradeText = "Employee upgraded using payroll deduction";
                upgradepaymentText = "using payroll deduction";
                //this.consoleMessage("One subscription to parent/corp with base(company tax)+Delta(employee tax)")
              } else {
                upgradeText = "Employee upgraded using Direct payment";
                upgradepaymentText = "using Direct payment";
              }
              let companyTax =
                selectedCompanyplanProduct.calculatedTax.planProductInfos.length >
                  0
                  ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
                    .taxRate
                  : 0;
              let companyTaxPercentage =
                selectedCompanyplanProduct.calculatedTax.planProductInfos.length >
                  0
                  ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
                    .taxRatePercentage
                  : 0;
              let baseplanPrice = adjustWith2DecimalsForUI(
                selectedBaseplanProduct.calculatedTax.price
              );
              let baseplanTaxorg = adjustWith2DecimalsForUI(
                selectedBaseplanProduct.calculatedTax.tax
              );
              let baseplanTax = adjustWith2DecimalsForUI(
                baseplanPrice * companyTax
              );
              let baseplanTotalorg = adjustWith2DecimalsForUI(
                selectedBaseplanProduct.calculatedTax.total
              );
              let baseplanTotal = adjustWith2DecimalsForUI(
                baseplanPrice + baseplanTax
              );
              let coverage = selectedCCplanProduct.planCoverage
              let employeeTax =
                selectedCCplanProduct.calculatedTax.planProductInfos.length > 0
                  ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
                    .taxRate
                  : 0;
              let employeeTaxPercentage =
                selectedCCplanProduct.calculatedTax.planProductInfos.length > 0
                  ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
                    .taxRatePercentage
                  : 0;

              let deltaplanPrice = adjustWith2DecimalsForUI(
                selectedCCplanProduct.calculatedTax.price -
                selectedBaseplanProduct.calculatedTax.price
              );

              //this.consoleMessage(selectedCCplanProduct.calculatedTax.price)
              //this.consoleMessage(selectedBaseplanProduct.calculatedTax.price)
              //this.consoleMessage(selectedCCplanProduct.calculatedTax.price -selectedBaseplanProduct.calculatedTax.price)
              if (selectedBaseplanProduct.name == 'NA') {
                //this.consoleMessage("No Base plan/product for this upgrade plans/product")
                companyTax = employeeTax
                companyTaxPercentage = employeeTaxPercentage
              }
              // let deltaplanTax = adjustWith2DecimalsForUI(
              //   deltaplanPrice * (this.deltaCompanyTax ? companyTax : employeeTax)
              // );
              let deltaplanTax = adjustWith2DecimalsForUI(deltaplanPrice * employeeTax);
              // let deltaplanTax = deltaplanPrice*(this.deltaCompanyTax?companyTax:employeeTax)

              let deltaplanTotal = adjustWith2DecimalsForUI(
                deltaplanPrice + deltaplanTax
              );

              let combinedplanPrice = baseplanPrice + deltaplanPrice;
              let combinedplanbasePrice = baseplanPrice;
              let combinedplanDeltaprice = deltaplanPrice;
              let combinedplanTax = adjustWith2DecimalsForUI(
                baseplanTax + deltaplanTax
              );
              let combinedplanCompanyTax = baseplanTax;
              let combinedplanEmployeeTax =
                adjustWith2DecimalsForUI(deltaplanTax);
              let combinedplanCompanyTaxPercentage = companyTaxPercentage;
              let combinedplanemployeeTaxPercentage = this.deltaCompanyTax
                ? companyTaxPercentage
                : employeeTaxPercentage;
              let combinedplanemployeeTaxPercentageorg = employeeTaxPercentage;
              let combinedplanTotal = adjustWith2DecimalsForUI(
                baseplanTotal + deltaplanTotal
              );

              let scenario = `Employee Upgrade from ${selectedBaseplanProduct.name} to ${selectedCCplanProduct.name}`;
              let planName = `${CPplan.name}(${selectedCCplanProduct.name}) (${upgradeText})`;
              let compnayShareStatement = `${CPplan.name}(${selectedCCplanProduct.name}) Contribution`;
              let employeeShareStatement = `${CPplan.name}(${selectedCCplanProduct.name}) upgrade cost`;
              let planDescription = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanTotal} and Employee- pays ${upgradepaymentText} ${deltaplanTotal} `;
              let planDescription2 = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanPrice}(with tax:${companyTaxPercentage}) and Employee- pays ${upgradepaymentText} ${deltaplanPrice}(with tax:${employeeTaxPercentage}) `;
              let type;

              if (payroll) {
                type = "Split with payroll deduction";
              } else {
                type = "Split with direct pay";
              }
              let basePlanDetails = {
                planId: selectedBasePlan.id || 0, //0
                planName: selectedBasePlan.name || "NA", //NA
                planLevelId: selectedBasePlan.planLevel || 0, //0
                amount: baseplanPrice || 0, //0
                amountUI: `$${baseplanPrice}` || 0, //0
                tax: baseplanTax,
                total: baseplanTotal,
                taxUI: `$${baseplanTax}`, //companyTaxpercentage
                totalUI: `$${baseplanTotal}`,
                planLevelName: selectedBasePlan.groupName || "", //if it is Bundle
                planFrequencyID: selectedBasePlan.frqMonthly || "",
                planFusebillID: selectedBasePlan.fusebillId || "",
                products: [selectedBaseplanProduct],
                planLevel_parentId: selectedBasePlan.planLevel_parentId || 0,
                packageName: selectedBasePlan.packageName || "",
                packageId: selectedBasePlan.packageId || 0,
              };
              let obj = {
                companyTax,
                companyTaxPercentage,
                baseplanPrice,
                baseplanTaxorg,
                baseplanTax,
                baseplanTotalorg,
                baseplanTotal,
                employeeTax,
                employeeTaxPercentage,
                deltaplanPrice,
                deltaplanTax,
                deltaplanTotal,
                combinedplanPrice,
                combinedplanbasePrice,
                combinedplanDeltaprice,
                combinedplanTax,
                combinedplanCompanyTax,
                combinedplanEmployeeTax,
                combinedplanCompanyTaxPercentage,
                combinedplanemployeeTaxPercentage,
                combinedplanTotal,
                payroll,
                scenario,
                planName,
                compnayShareStatement,
                employeeShareStatement,
                planDescription,
                planDescription2,
                type,
                basePlanDetails,
                combinedplanemployeeTaxPercentageorg,
                coverage
              };

              //this.consoleMessage(obj)
              // modifiedCPplan.upgradeCalculation = obj;
            }
          }
          modifiedCPgroup.plans.push(modifiedCPplan);

          modifiedCPPackage.groupsCP.push(modifiedCPgroup);
        }
        //console.log(modifiedCPPackage)
        modifiedCPplanPackages.push(modifiedCPPackage);
      }

      this.modifiedBlocksPaidByCompany = modifiedCPplanPackages;

      console.log(this.modifiedBlocksPaidByCompany)

      //this.consoleMessage(this.modifiedBlocksCoveredByCompany)
    }
  }
  cobminedcommonfunction(cpPackages: any, ccPackages: any, epPackages: any) {

    // //console.log(cpPackages)
    let commonPackages: any = {};
    if (cpPackages) {
      for (let cpPackage of cpPackages) {
        let pckg = cpPackage;
        pckg.groups = pckg.groupsCP;

        if (commonPackages && commonPackages[pckg.id]) {
          commonPackages[pckg.id].groups.push(pckg.groupsCP);
        } else {
          commonPackages[pckg.id] = pckg;
        }
      }
    }
    //this.consoleMessage(commonPackages)
    if (ccPackages) {
      for (let ccPackage of ccPackages) {
        let pckg = ccPackage;
        //this.consoleMessage(pckg)
        pckg.groups = pckg.groupsCC;

        //this.consoleMessage(pckg.groups)
        //this.consoleMessage(pckg.groupsCC)

        if (commonPackages && commonPackages[pckg.id]) {
          //this.consoleMessage(commonPackages[pckg.id])
          commonPackages[pckg.id].groups = commonPackages[pckg.id].groups.concat(
            pckg.groupsCC
          );
        } else {
          commonPackages[pckg.id] = pckg;
        }
      }
    }
    if (epPackages) {
      for (let epPackage of epPackages) {
        let pckg = epPackage;
        pckg.groups = pckg.groupsEP;

        if (commonPackages && commonPackages[pckg.id]) {
          commonPackages[pckg.id].groups = commonPackages[pckg.id].groups.concat(
            pckg.groupsEP
          );
        } else {
          commonPackages[pckg.id] = pckg;
        }
      }
    }

    return commonPackages;


  }

  cancelDeletion() {
    this.deleteForm.reset();
    this.finalEffectiveDate = null;
    this.clearAllMessages()
    this.closeDependentmodal.nativeElement.click(); // Close the modal
    this.needToUpdate = ''
    this.cobevent = ''
    this.cobeventType = ''
    this.dependentType = ''
    this.maritalStatus = ''
    this.selectedDepId= ""
    this.needToUpdate = false;
    this.firstConfirmMessage = ''
    this.secondConfirmMessage = ''
    this.corpMessage = ''
    this.firstMessage = ''
    this.thirdConfirmMessage = ''
    this.underWritingMessage1 = ''
    this.underWritingMessage2 = ''
    this.deleteForm.reset()
    this.spouseform.reset()
    this.childrenDetails = []
    this.childrenDetailsForNormalReg = []
    this.addToPolicy = ''
    this.secondMessage = ''
    this.dependentform.reset()
    this.cobform.reset()
  }

  confirmDeletion() {
    const deletionReasonControl = this.deleteForm.get('deletionReason');
    const otherReasonControl = this.deleteForm.get('otherReason');
    const effectiveDateControl = this.finalEffectiveDate

    if (deletionReasonControl && effectiveDateControl) {
      const deletionData = {
        reason: deletionReasonControl.value === 'other'
          ? (otherReasonControl ? otherReasonControl.value : '')
          : deletionReasonControl.value,
        effectiveDate: this._CustomDatePipe.transform(effectiveDateControl.value),
      };

      // API call to delete the dependent
      const endPoint = `/${this.customerid}/lifeChanges/${this.dependentType}/remove/false`;
      this.http.post(api.url + endPoint, deletionData, {
        headers: {
          Authorization: 'Bearer ' + this.accessToken,
          'Content-Type': 'application/json'
        }
      }).subscribe(
        (response: any) => {
          if (response.status === 200) {
            Swal.fire({
              allowOutsideClick: false,
              title: this.lang?.Info || 'Info',
              text: response.message
            });
            this.closeDependentmodal.nativeElement.click();
          } else {
            Swal.fire({
              allowOutsideClick: false,
              title: this.lang?.Error || 'Error',
              text: response.message
            });
          }
        },
        (error) => {
          Swal.fire({
            allowOutsideClick: false,
            title: this.lang?.Error || 'Error',
            text: error.error.error.message
          });
        }
      );
    } else {
      this.deleteForm.markAllAsTouched();
    }
  }

  public convertpackagesToPlans2(packages: { paidByCompany: any[]; }) {
    //this.consoleMessage("pacakges");
    //all_plans
    var plans: any[] = [];
    var cp_plans: any[] = [];
    var cc_plans: any[] = [];
    var ep_plans: any[] = [];

    packages?.paidByCompany.forEach((pack: { groupsCP: any[]; name: any; }, index: any) => {
      pack.groupsCP.forEach((group: { plans: any[]; parentId: any; name: any; id: any; categorization: { paidByCompany: any; coveredByCompany: any; paidByEmployee: any; companyPaidCoverage: any }; }, index1: any) => {
        group.plans.forEach((plan: { [x: string]: any; }, index2: any) => {
          if (plan) {
            const coverages = ['SINGLE', 'COUPLE', 'FAMILY'];
            
            plan["planLevel_parentId"] = group.parentId;
            plan["packageName"] = pack.name;
            plan["groupName"] = group.name;
            plan["groupId"] = group.id;
            plan["groupparentId"] = group.parentId;
            plan["companyPaidCoverage"] = group.categorization?.companyPaidCoverage ?? "DIRECT";
            plans.push(plan);

            if (group.categorization.paidByCompany) {
              cp_plans.push(plan);
            }
            if (group.categorization.coveredByCompany) {
              cc_plans.push(plan);
            }
            if (group.categorization.paidByEmployee) {
              ep_plans.push(plan);
            }
          } else {
            //this.consoleMessage("else");
          }
        });
      });
    });



    return [plans, cp_plans, cc_plans, ep_plans];
  }
  calculateBasePlanDeltasforCCplans(ccplanspackages: string | any[], baseplans: any[], compnayplans: any[]) {

    //console.log(ccplanspackages)
    let modifiedCCplanPackages: any = [];
    //console.log(baseplans)
    for (let i = 0; i < ccplanspackages?.length; i++) {
      let modifiedCCPackage = ccplanspackages[i];
      //this.consoleMessage(ccplanspackages[i].name)
      //this.consoleMessage(ccplanspackages[i].id)
      let CCplansgroups = ccplanspackages[i].groupsCC;

      modifiedCCPackage.groupsCC = [];
      for (let CCplangroup of CCplansgroups) {
        let modifiedCCgroup = CCplangroup;

        let bbCoverage = baseplans.filter((bb: any) => { return bb.packageId == modifiedCCPackage.id && bb.planLevel_parentId == modifiedCCgroup.parentId })

        let selectedCoverage = bbCoverage[0]?.companyPaidCoverage ?? "DIRECT"

        // let selectedCoverage = CCplangroup?.categorization?.companyPaidCoverage ?? "DIRECT"

        if (selectedCoverage == "null" || selectedCoverage == "" || selectedCoverage == " ") {
          selectedCoverage = "DIRECT"
        }
        if (selectedCoverage != "DIRECT") {
          selectedCoverage = selectedCoverage.replace("SELECTIVE_", "")
        }

        //console.log(selectedCoverage)
        let CCplans = CCplangroup.plans;
        //console.log(CCplangroup)

        modifiedCCgroup.plans = [];
        for (let CCplan of CCplans) {
          let modifiedCCplan = CCplan;
          //this.consoleMessage(CCplan.id);
          //this.consoleMessage(CCplan.isBundle);
          //this.consoleMessage(CCplan.name);

          CCplan.planLevel_parentId = CCplangroup.parentId;

          let payroll = true;
          let EmployeeChoice = 0;

          if (
            this.CORP_PAYROLL_NOT_MANDATORY_PACKAGES.includes(CCplan.packageId)
          ) {
            if (EmployeeChoice == 2) {
              payroll = false;
            }
          } else {
            if (
              this.CORP_PAYROLL_NOT_MANDATORY_PLANLEVELS.includes(
                CCplan.planLevel
              )
            ) {
              if (EmployeeChoice == 2) {
                payroll = false;
              }
            }
          }
          let selectedCCplanProductarray = CCplan.productAddonss[CCplan.name];
          console.log(CCplan)
          console.log(CCplan.productAddonss[CCplan.name])

          if (CCplan.isBundle) {
            //this.consoleMessage("BundlePlan")

            //this.consoleMessage(baseplans)
            //console.log(baseplans)
            var filtered_base_plans = baseplans.filter(function (plan: { packageId: any; planLevel_parentId: any; planLevel: number; productAddonss: any }) {



              return (
                CCplan.packageId == plan.packageId &&
                CCplan.planLevel_parentId == plan.planLevel_parentId &&
                CCplan.planLevel >= plan.planLevel &&
                plan.productAddonss && JSON.stringify(plan.productAddonss).length > 2
              );
            });

            var filtered_compnay_plans = compnayplans.filter(function (plan: { packageId: any; planLevel_parentId: any; planLevel: number; productAddonss: any }) {
              //this.consoleMessage(plan)
              //cp_plans

              //this.consoleMessage(CCplan.packageId,plan.packageId)
              //this.consoleMessage(CCplan.planLevel_parentId,plan.planLevel_parentId)
              //this.consoleMessage(CCplan.planLevel,plan.planLevel)

              return (
                CCplan.packageId == plan.packageId &&
                CCplan.planLevel_parentId == plan.planLevel_parentId &&
                CCplan.planLevel >= plan.planLevel &&
                plan.productAddonss && JSON.stringify(plan.productAddonss).length > 2
              );
            });

            //this.consoleMessage(filtered_base_plans);

            //this.consoleMessage(filtered_compnay_plans)
            let selectedBasePlan;
            let selectedCompnayPlan;
            let DeltaPlan;
            let selectedBaseplanProduct: any;
            let selectedBaseplanProductsArray: any = [];
            let selectedCompanyplanProduct: any;
            let selectedCompanyplanProductsArray: any = [];


            //console.log("length" + filtered_base_plans.length)
            //console.log(filtered_base_plans)
            //console.log(filtered_compnay_plans)

            if (filtered_base_plans.length == 0) {
            } else if (filtered_base_plans.length == 1) {
              selectedBasePlan = filtered_base_plans[0];
              selectedCompnayPlan = filtered_compnay_plans[0];
            } else {


              var filtered_base_plans2 = filtered_base_plans.filter(function (plan: { id: any; }) {
                return (
                  CCplan.id == plan.id
                );
              });
              var filtered_compnay_plans2 = filtered_compnay_plans.filter(function (plan: { id: any; }) {


                return (
                  CCplan.id == plan.id
                );
              });
              selectedBasePlan = filtered_base_plans2[0];
              selectedCompnayPlan = filtered_compnay_plans2[0];
            }

            //console.log(selectedBasePlan)
            //console.log(selectedCompnayPlan)
            //console.log("name" + selectedBasePlan?.name)
            if (selectedBasePlan) {
              // //this.consoleMessage(selectedBasePlan)
              // selectedBaseplanProduct = selectedBasePlan.productAddonss[selectedBasePlan.name][0]
              selectedBaseplanProductsArray = selectedBasePlan.productAddonss[selectedBasePlan.name];
              let selectedBaseplanProductsArray2: any = [];
              //  //this.consoleMessage(CCplan.packageId)
              if (CCplan.packageId == 5 || CCplan.packageId == 10) {
                selectedBaseplanProductsArray2 = selectedBaseplanProductsArray
                for (let i = 0; i < selectedCCplanProductarray.length - selectedBaseplanProductsArray.length; i++) {
                  selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray[selectedBaseplanProductsArray.length - 1]);
                }

                let remainigProdcuts = selectedCCplanProductarray.length - selectedBaseplanProductsArray2.length
                // //this.consoleMessage(selectedBaseplanProductsArray)

                if (remainigProdcuts > 0) {
                  for (let i = 0; i < remainigProdcuts; i++) {
                    selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray2[selectedBaseplanProductsArray2.length - 1]);
                  }
                }
                selectedBaseplanProductsArray = selectedBaseplanProductsArray2
                // //this.consoleMessage(selectedBaseplanProductsArray)
              }
              else {

                // Direct Coverage Method
                // setTimeout(() => {
                if (selectedCoverage == "DIRECT") {
                  selectedBaseplanProductsArray = this.DirectCoverageMethod(selectedCCplanProductarray, selectedBaseplanProductsArray)
                  //console.log(selectedBaseplanProductsArray)
                }

                // Selective single Coverage Method
                if (selectedCoverage == "SINGLE") {
                  selectedBaseplanProductsArray = this.selectiveSingleCoverageMethod(selectedCCplanProductarray, selectedBaseplanProductsArray)
                }
                // Selective Couple Coverage Method

                if (selectedCoverage == "COUPLE") {
                  selectedBaseplanProductsArray = this.selectiveCoupleCoverageMethod(selectedCCplanProductarray, selectedBaseplanProductsArray)
                }
                //  // Selective Family Coverage Method
                if (selectedCoverage == "FAMILY") {
                  selectedBaseplanProductsArray = this.selectiveFamilyCoverageMethod(selectedCCplanProductarray, selectedBaseplanProductsArray)
                }

                //console.log(selectedBaseplanProductsArray)
                // }, 1000)

                // let productCoverageFound = false;
                // for (let i = 0; i < selectedCCplanProductarray.length; i++) {
                //   for (let j = 0; j < selectedBaseplanProductsArray.length; j++) {

                //     if (selectedCCplanProductarray[i].planCoverage == selectedBaseplanProductsArray[j].planCoverage) {
                //       productCoverageFound = true
                //       selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray[j])
                //       break;
                //     }


                //   }
                //   if (!productCoverageFound) {



                //     selectedBasePlan = {};
                //     selectedBaseplanProduct = {};
                //     selectedBaseplanProduct.calculatedTax = {};
                //     selectedBaseplanProduct.calculatedTax.price = 0;
                //     selectedBaseplanProduct.calculatedTax.tax = 0;
                //     selectedBaseplanProduct.calculatedTax.total = 0;
                //     selectedBaseplanProduct.name = "NA";
                //     selectedBaseplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
                //     selectedBaseplanProductsArray2.push(selectedBaseplanProduct);



                //   }

                // }
                // //this.consoleMessage(selectedBaseplanProductsArray)
                // selectedBaseplanProductsArray = selectedBaseplanProductsArray2
                //this.consoleMessage(selectedBaseplanProductsArray)
              }
            }
            else {
              //console.log("elseStatement")
              selectedBasePlan = {};
              selectedBaseplanProduct = {};
              selectedBaseplanProduct.calculatedTax = {};
              selectedBaseplanProduct.calculatedTax.price = 0;
              selectedBaseplanProduct.calculatedTax.tax = 0;
              selectedBaseplanProduct.calculatedTax.total = 0;
              selectedBaseplanProduct.name = "NA";

              for (let i = 0; i < selectedCCplanProductarray.length; i++) {
                selectedBaseplanProductsArray.push(selectedBaseplanProduct);
              }
            }


            //console.log(selectedBaseplanProductsArray)
            if (selectedCompnayPlan) {
              // selectedCompanyplanProduct = selectedCompnayPlan.productAddonss[selectedCompnayPlan.name][0]
              selectedCompanyplanProductsArray =
                selectedCompnayPlan.productAddonss[selectedCompnayPlan.name];
              // //this.consoleMessage(selectedCompanyplanProductsArray)
              // //this.consoleMessage(selectedCompnayPlan.name)

              let selectedCompanyplanProductsArray2: any = [];

              if (CCplan.packageId == 5 || CCplan.packageId == 10) {
                selectedCompanyplanProductsArray2 = selectedCompanyplanProductsArray
                for (let i = 0; i < selectedCCplanProductarray.length - selectedCompanyplanProductsArray.length; i++) {
                  selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray[selectedCompanyplanProductsArray.length - 1]);
                }
                //this.consoleMessage(selectedCompanyplanProductsArray)

                let remainigProdcuts = selectedCCplanProductarray.length - selectedCompanyplanProductsArray2.length
                // //this.consoleMessage(selectedBaseplanProductsArray)

                if (remainigProdcuts > 0) {
                  for (let i = 0; i < remainigProdcuts; i++) {
                    selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray2[selectedCompanyplanProductsArray2.length - 1]);
                  }
                }
                selectedCompanyplanProductsArray = selectedCompanyplanProductsArray2
                //this.consoleMessage(selectedCompanyplanProductsArray)

              }
              else {

                //console.log(selectedCCplanProductarray)
                // let productCoverageFound = false;
                // for (let i = 0; i < selectedCCplanProductarray.length; i++) {
                //   for (let j = 0; j < selectedCompanyplanProductsArray.length; j++) {

                //     if (selectedCCplanProductarray[i].planCoverage == selectedCompanyplanProductsArray[j].planCoverage) {
                //       productCoverageFound = true
                //       selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray[j])
                //       break;
                //     }


                //   }
                //   if (!productCoverageFound) {


                //     selectedCompanyplanProduct = {};
                //     selectedCompanyplanProduct.calculatedTax = {};
                //     selectedCompanyplanProduct.calculatedTax.planProductInfos = [];
                //     selectedCompanyplanProduct.name = "NA";
                //     selectedCompanyplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
                //     selectedCompanyplanProductsArray2.push(selectedCompanyplanProduct);



                //   }

                // }
                // selectedCompanyplanProductsArray = selectedCompanyplanProductsArray2

                // // setTimeout(() => {
                if (selectedCoverage == "DIRECT") {
                  selectedCompanyplanProductsArray = this.CompanyDirectCoverageMethod(selectedCCplanProductarray, selectedCompanyplanProductsArray)
                  //console.log(selectedBaseplanProductsArray)
                }

                // Selective single Coverage Method
                if (selectedCoverage == "SINGLE") {
                  selectedCompanyplanProductsArray = this.CompanyselectiveSingleCoverageMethod(selectedCCplanProductarray, selectedCompanyplanProductsArray)
                }
                // Selective Couple Coverage Method

                if (selectedCoverage == "COUPLE") {
                  selectedCompanyplanProductsArray = this.CompanyselectiveCoupleCoverageMethod(selectedCCplanProductarray, selectedCompanyplanProductsArray)
                }
                //  // Selective Family Coverage Method
                if (selectedCoverage == "FAMILY") {
                  selectedCompanyplanProductsArray = this.CompanyselectiveFamilyCoverageMethod(selectedCCplanProductarray, selectedCompanyplanProductsArray)
                }


                // // }, 1000)


                //console.log(selectedCompanyplanProductsArray)


              }


            } else {
              selectedCompanyplanProduct = {};
              selectedCompanyplanProduct.calculatedTax = {};
              selectedCompanyplanProduct.calculatedTax.planProductInfos = [];
              for (let i = 0; i < selectedCCplanProductarray.length; i++) {
                selectedCompanyplanProductsArray.push(
                  selectedCompanyplanProduct
                );
              }
              //console.log(selectedCompanyplanProductsArray)
              //this.consoleMessage(selectedCompanyplanProductsArray)
            }


            let upgradeText;
            let upgradepaymentText;
            if (payroll) {
              upgradeText = "Employee upgraded using payroll deduction";
              upgradepaymentText = "using payroll deduction";
              //this.consoleMessage("One subscription to parent/corp with base(company tax)+Delta(employee tax)")
            } else {
              upgradeText = "Employee upgraded using Direct payment";
              upgradepaymentText = "using Direct payment";
            }

            modifiedCCplan.products = []



            for (let i = 0; i < selectedCCplanProductarray.length; i++) {
              let selectedBaseplanProduct = selectedBaseplanProductsArray[i];
              //console.log(selectedBaseplanProduct)
              let selectedCompanyplanProduct =
                selectedCompanyplanProductsArray[i];
              let selectedCCplanProduct = selectedCCplanProductarray[i];
              //console.log(selectedCCplanProduct)
              //console.log(selectedCompanyplanProductsArray[i])
              let companyTax =
                selectedCompanyplanProduct.calculatedTax.planProductInfos
                  .length > 0
                  ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
                    .taxRate
                  : 0;
              let companyTaxPercentage =
                selectedCompanyplanProduct.calculatedTax.planProductInfos
                  .length > 0
                  ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
                    .taxRatePercentage
                  : 0;

              let baseplanPrice = adjustWith2DecimalsForUI(
                selectedBaseplanProduct.calculatedTax.price
              );
              let baseplanTaxorg = adjustWith2DecimalsForUI(
                selectedBaseplanProduct.calculatedTax.tax
              );
              let baseplanTax = adjustWith2DecimalsForUI(
                baseplanPrice * companyTax
              );
              let baseplanTotalorg = adjustWith2DecimalsForUI(
                selectedBaseplanProduct.calculatedTax.total
              );
              let baseplanTotal = adjustWith2DecimalsForUI(
                baseplanPrice + baseplanTax
              );


              let employeeTax =
                selectedCCplanProduct?.calculatedTax?.planProductInfos.length > 0
                  ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
                    .taxRate
                  : 0;
              let employeeTaxPercentage =
                selectedCCplanProduct?.calculatedTax?.planProductInfos.length > 0
                  ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
                    .taxRatePercentage
                  : 0;
              let deltaplanPrice = adjustWith2DecimalsForUI(
                selectedCCplanProduct.calculatedTax.price -
                selectedBaseplanProduct.calculatedTax.price
              );
              //console.log(deltaplanPrice)


              //console.log(selectedBaseplanProduct.calculatedTax.price)

              if (selectedBaseplanProduct.name == 'NA') {
                //this.consoleMessage("No Base plan/product for this upgrade plans/product")
                // companyTax = employeeTax
                companyTax = 0  ////when there is no base planproduct
                // companyTaxPercentage = employeeTaxPercentage
                companyTaxPercentage = "0%" //when there is no base planproduct

              }
              //Delete plan Total Price and Total Combination
              if (deltaplanPrice < 0) {
                deltaplanPrice = 0
                baseplanPrice = adjustWith2DecimalsForUI(
                  selectedCCplanProduct.calculatedTax.price
                );
                baseplanTaxorg = adjustWith2DecimalsForUI(
                  selectedCCplanProduct.calculatedTax.tax
                );
                baseplanTax = adjustWith2DecimalsForUI(
                  baseplanPrice * companyTax
                );
                baseplanTotalorg = adjustWith2DecimalsForUI(
                  selectedCCplanProduct.calculatedTax.total
                );
                baseplanTotal = adjustWith2DecimalsForUI(
                  baseplanPrice + baseplanTax
                );
              }
              // let deltaplanTax = adjustWith2DecimalsForUI(
              //   deltaplanPrice *
              //   (this.deltaCompanyTax ? companyTax : employeeTax)
              // );
              let deltaplanTax = adjustWith2DecimalsForUI(deltaplanPrice * employeeTax);

              let deltaplanTotal = adjustWith2DecimalsForUI(
                deltaplanPrice + deltaplanTax
              );
              let combinedplanPrice = adjustWith2DecimalsForUI(
                baseplanPrice + deltaplanPrice
              );
              let combinedplanbasePrice = baseplanPrice;
              let combinedplanDeltaprice = deltaplanPrice;
              let combinedplanTax = adjustWith2DecimalsForUI(
                baseplanTax + deltaplanTax
              );
              let combinedplanCompanyTax = baseplanTax;
              let combinedplanEmployeeTax =
                adjustWith2DecimalsForUI(deltaplanTax);
              let combinedplanCompanyTaxPercentage = companyTaxPercentage;
              let combinedplanemployeeTaxPercentage = this.deltaCompanyTax
                ? companyTaxPercentage
                : employeeTaxPercentage;
              let combinedplanemployeeTaxPercentageorg = employeeTaxPercentage;

              let combinedplanTotal = adjustWith2DecimalsForUI(
                baseplanTotal + deltaplanTotal
              );

              let scenario = `Employee Upgrade from ${selectedBasePlan.name} to ${CCplan.name}`;
              let planName = `${CCplan.name} (${upgradeText})`;
              let compnayShareStatement = `${CCplan.name} Contribution`;
              let employeeShareStatement = `${CCplan.name} upgrade cost`;
              let planDescription = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanTotal} and Employee- pays ${upgradepaymentText} ${deltaplanTotal} `;
              let planDescription2 = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanPrice}(with tax:${companyTaxPercentage}) and Employee- pays ${upgradepaymentText} ${deltaplanPrice}(with tax:${employeeTaxPercentage}) `;
              let type;

              if (payroll) {
                type = "Split with payroll deduction";
              } else {
                type = "Split with direct pay";
              }
              let basePlanDetails = {
                planId: selectedBasePlan.id, //0
                planName: selectedBasePlan.name, //NA
                planLevelId: selectedBasePlan.planLevel, //0
                amount: baseplanPrice, //0
                amountUI: `$${baseplanPrice}`, //0
                tax: baseplanTax,
                total: baseplanTotal,
                taxUI: `$${baseplanTax}`, //companyTaxpercentage
                totalUI: `$${baseplanTotal}`,
                planLevelName: selectedBasePlan.groupName || "", //if it is Bundle
                planFrequencyID: selectedBasePlan.frqMonthly || "",
                planFusebillID: selectedBasePlan.fusebillId || "",
                products: [selectedBaseplanProduct],
                planLevel_parentId: selectedBasePlan.planLevel_parentId,
                packageName: selectedBasePlan.packageName,
                packageId: selectedBasePlan.packageId,
              };





              let obj = {
                companyTax,
                companyTaxPercentage,
                baseplanPrice,
                baseplanTaxorg,
                baseplanTax,
                baseplanTotalorg,
                baseplanTotal,
                employeeTax,
                employeeTaxPercentage,
                deltaplanPrice,
                deltaplanTax,
                deltaplanTotal,
                combinedplanPrice,
                combinedplanbasePrice,
                combinedplanDeltaprice,
                combinedplanTax,
                combinedplanCompanyTax,
                combinedplanEmployeeTax,
                combinedplanCompanyTaxPercentage,
                combinedplanemployeeTaxPercentage,
                combinedplanTotal,
                payroll,
                scenario,
                planName,
                compnayShareStatement,
                employeeShareStatement,
                planDescription,
                planDescription2,
                type,
                basePlanDetails,
                combinedplanemployeeTaxPercentageorg,
                selectedCoverage
              };

              //this.consoleMessage(obj)

              console.log(obj)
              let ccProduct: any = {}
              ccProduct.upgradeCalculation = obj;
              modifiedCCplan.products.push(ccProduct)
              modifiedCCplan.upgradeCalculation = obj;


            }
            modifiedCCgroup.plans.push(modifiedCCplan);

          }
          else {
            let selectedCCplanNamearray = Object.keys(CCplan.productAddonss)

            let selectedCCplanProductarray: any = []
            for (let name of selectedCCplanNamearray) {
              selectedCCplanProductarray = selectedCCplanProductarray.concat(CCplan.productAddonss[name])
            }
            var filtered_base_plans = baseplans.filter(function (plan: { packageId: any; planLevel_parentId: any; planLevel: number; productAddonss: any }) {


              return (
                CCplan.packageId == plan.packageId &&
                CCplan.planLevel_parentId == plan.planLevel_parentId &&
                CCplan.planLevel >= plan.planLevel &&
                plan.productAddonss && JSON.stringify(plan.productAddonss).length > 2
              );
            });

            var filtered_compnay_plans = compnayplans.filter(function (plan: { packageId: any; planLevel_parentId: any; planLevel: number; productAddonss: any }) {


              return (
                CCplan.packageId == plan.packageId &&
                CCplan.planLevel_parentId == plan.planLevel_parentId &&
                CCplan.planLevel >= plan.planLevel &&
                plan.productAddonss && JSON.stringify(plan.productAddonss).length > 2
              );
            });

            //this.consoleMessage(filtered_base_plans)

            //this.consoleMessage(filtered_compnay_plans)
            let selectedBasePlan;
            let selectedCompnayPlan;
            let DeltaPlan;
            console.log("length" + filtered_base_plans.length)
            console.log(filtered_base_plans)
            console.log(filtered_compnay_plans)
            if (filtered_base_plans.length == 0) {
            } else if (filtered_base_plans.length == 1) {
              selectedBasePlan = filtered_base_plans[0];
              selectedCompnayPlan = filtered_compnay_plans[0];
            } else {
              //this.consoleMessage(filtered_base_plans.length)

            }

            let selectedbaseplanproduct: any;
            let selectedBaseplanProduct: any;
            let selectedBaseplanProductsArray: any = []
            if (selectedBasePlan) {
              for (let planname in selectedBasePlan.productAddonss) {
                console.log(planname)
                console.log(selectedBasePlan.productAddonss[planname])
                let products = selectedBasePlan.productAddonss[planname];
                console.log("length" + products.length)
                if (products.length == 0) {
                } else if (products.length == 1) {
                  selectedbaseplanproduct = products[0];
                  selectedBaseplanProductsArray.push(products[0]);

                  // selectedCompnayPlan= filtered_compnay_plans[0]
                } else {
                  selectedbaseplanproduct = products[products.length - 1]; //

                  for (let i = 0; i < selectedCCplanProductarray.length; i++) {
                    selectedBaseplanProductsArray.push(products[i]);
                  }
                  /* Added for in the case of medacan year roudn care as base plan and with two products one is Individual(single) and(Family)
                  Selecting last product(highest) in this case */
                  console.log(products.length)
                }
              }
              console.log(selectedbaseplanproduct)
              selectedBaseplanProduct = selectedbaseplanproduct;

              //this.consoleMessage(selectedBaseplanProduct.calculatedTax.price)
              //this.consoleMessage(selectedBaseplanProduct.calculatedTax.tax)
              //this.consoleMessage(selectedBaseplanProduct.calculatedTax.total)
            } else {
              selectedBasePlan = {};
              selectedBaseplanProduct = {};
              selectedBaseplanProduct.calculatedTax = {};
              selectedBaseplanProduct.calculatedTax.price = 0;
              selectedBaseplanProduct.calculatedTax.tax = 0;
              selectedBaseplanProduct.calculatedTax.total = 0;
              selectedBaseplanProduct.name = "NA";


              for (let i = 0; i < selectedCCplanProductarray.length; i++) {
                selectedBaseplanProductsArray.push(selectedBaseplanProduct);
              }
            }

            let CCplanProduct;
            let CCproductslength

            for (let planname in CCplan.productAddonss) {
              let products = CCplan.productAddonss[planname];
              CCproductslength = products.length
              console.log("length" + products.length)

              if (products.length == 0) {
              } else if (products.length == 1) {
                CCplanProduct = products[0];
                // selectedCompnayPlan= filtered_compnay_plans[0]
              } else {
                CCplanProduct = products[products.length - 1]; //
                /* Added for in the case of medacan year M care as base plan and with two products one is Individual(single) and(Family)
                Selecting last product(highest) in this case */
                //this.consoleMessage(products.length)
              }
            }
            let selectedCCplanProduct = CCplanProduct;


            let selectedcompanyplanproduct: any;
            let selectedCompanyplanProduct: any;
            let selectedCompanyplanProductsArray: any = []

            if (selectedCompnayPlan) {
              for (let planname in selectedCompnayPlan.productAddonss) {
                //this.consoleMessage(planname)
                //this.consoleMessage(selectedCompnayPlan.productAddonss[planname])
                let products = selectedCompnayPlan.productAddonss[planname];

                if (products.length == 0) {
                } else if (products.length == 1) {
                  selectedcompanyplanproduct = products[0];
                  selectedCompanyplanProductsArray.push(
                    products[0]
                  );
                  // selectedCompnayPlan= filtered_compnay_plans[0]
                } else {
                  selectedcompanyplanproduct = products[products.length - 1]; //
                  for (let i = 0; i < products.length; i++) {
                    selectedCompanyplanProductsArray.push(
                      products[i]
                    );
                  }

                  /* Added for in the case of medacan year M care as base plan and with two products one is Individual(single) and(Family)
                  Selecting last product(highest) in this case */
                }
              }
              selectedCompanyplanProduct = selectedcompanyplanproduct;
              // for (let i = 0; i < selectedCCplanProductarray.length; i++) {
              //   selectedCompanyplanProductsArray.push(
              //     selectedCompanyplanProduct
              //   );
              // }
              //this.consoleMessage("CompanyTax")
              //this.consoleMessage(selectedCompanyplanProduct.calculatedTax.planProductInfos.length>0?selectedCompanyplanProduct.calculatedTax.planProductInfos[0].taxRate:0)
              //this.consoleMessage(selectedCompanyplanProduct.calculatedTax.planProductInfos.length>0?selectedCompanyplanProduct.calculatedTax.planProductInfos[0].taxRatePercentage:0)
            } else {
              selectedCompanyplanProduct = {};
              selectedCompanyplanProduct.calculatedTax = {};
              selectedCompanyplanProduct.calculatedTax.planProductInfos = [];
              console.log(selectedCCplanProductarray)
              console.log(selectedCompanyplanProduct)
              for (let i = 0; i < selectedCCplanProductarray.length; i++) {
                selectedCompanyplanProductsArray.push(
                  selectedCompanyplanProduct
                );
              }


            }

            let upgradeText;
            let upgradepaymentText;
            if (payroll) {
              upgradeText = "Employee upgraded using payroll deduction";
              upgradepaymentText = "using payroll deduction";
              //this.consoleMessage("One subscription to parent/corp with base(company tax)+Delta(employee tax)")
            } else {
              upgradeText = "Employee upgraded using Direct payment";
              upgradepaymentText = "using Direct payment";
            }



            if (CCproductslength == 1) {
              modifiedCCplan = this.singleCCCoverageProduct(selectedCompanyplanProduct, selectedBaseplanProduct, selectedCCplanProduct, CCplan, upgradeText, payroll, selectedBasePlan, upgradepaymentText, modifiedCCplan)

            }
            else {
              modifiedCCplan = this.multipleCCCoverageProduct(selectedCCplanProductarray, selectedBaseplanProductsArray, selectedCompanyplanProductsArray, selectedBasePlan, CCplan, upgradeText, payroll, upgradepaymentText, selectedCoverage, modifiedCCplan)

            }
            modifiedCCgroup.plans.push(modifiedCCplan);
          }
          //           modifiedCCgroup.plans = Array.from(new Set(modifiedCCgroup.plans.map((item:any) => JSON.stringify(item)))
          // ).map((str:any) => JSON.parse(str));
          modifiedCCPackage.groupsCC.push(modifiedCCgroup);
        }

        modifiedCCplanPackages.push(modifiedCCPackage);
      }
      modifiedCCplanPackages = Array.from(new Set(modifiedCCplanPackages.map((item: any) => JSON.stringify(item)))
      ).map((str: any) => JSON.parse(str));
      this.modifiedBlocksCoveredByCompany = modifiedCCplanPackages;

      console.log(this.modifiedBlocksCoveredByCompany)
    }
  }
  public singleCCCoverageProduct(selectedCompanyplanProduct: any, selectedBaseplanProduct: any, selectedCCplanProduct: any, CCplan: any, upgradeText: any, payroll: any, selectedBasePlan: any, upgradepaymentText: any, modifiedCCplan: any) {
    let companyTax =
      selectedCompanyplanProduct.calculatedTax.planProductInfos.length >
        0
        ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
          .taxRate
        : 0;
    let companyTaxPercentage =
      selectedCompanyplanProduct.calculatedTax.planProductInfos.length >
        0
        ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
          .taxRatePercentage
        : 0;
    let baseplanPrice = adjustWith2DecimalsForUI(
      selectedBaseplanProduct.calculatedTax.price
    );
    let baseplanTaxorg = adjustWith2DecimalsForUI(
      selectedBaseplanProduct.calculatedTax.tax
    );
    let baseplanTax = adjustWith2DecimalsForUI(
      baseplanPrice * companyTax
    );
    let baseplanTotalorg = adjustWith2DecimalsForUI(
      selectedBaseplanProduct.calculatedTax.total
    );
    let baseplanTotal = adjustWith2DecimalsForUI(
      baseplanPrice + baseplanTax
    );
    let employeeTax =
      selectedCCplanProduct.calculatedTax.planProductInfos.length > 0
        ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
          .taxRate
        : 0;
    let employeeTaxPercentage =
      selectedCCplanProduct.calculatedTax.planProductInfos.length > 0
        ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
          .taxRatePercentage
        : 0;

    let deltaplanPrice = adjustWith2DecimalsForUI(
      selectedCCplanProduct.calculatedTax.price -
      selectedBaseplanProduct.calculatedTax.price
    );

    //this.consoleMessage(selectedCCplanProduct.calculatedTax.price)
    //this.consoleMessage(selectedBaseplanProduct.calculatedTax.price)
    //this.consoleMessage(selectedCCplanProduct.calculatedTax.price -selectedBaseplanProduct.calculatedTax.price)
    if (selectedBaseplanProduct.name == 'NA') {
      //this.consoleMessage("No Base plan/product for this upgrade plans/product")
      companyTax = employeeTax
      companyTaxPercentage = employeeTaxPercentage
    }
    let deltaplanTax = adjustWith2DecimalsForUI(
      deltaplanPrice * (this.deltaCompanyTax ? companyTax : employeeTax)
    );
    // let deltaplanTax = deltaplanPrice*(this.deltaCompanyTax?companyTax:employeeTax)

    let deltaplanTotal = adjustWith2DecimalsForUI(
      deltaplanPrice + deltaplanTax
    );

    let combinedplanPrice = baseplanPrice + deltaplanPrice;
    let combinedplanbasePrice = baseplanPrice;
    let combinedplanDeltaprice = deltaplanPrice;
    let combinedplanTax = adjustWith2DecimalsForUI(
      baseplanTax + deltaplanTax
    );
    let combinedplanCompanyTax = baseplanTax;
    let combinedplanEmployeeTax =
      adjustWith2DecimalsForUI(deltaplanTax);
    let combinedplanCompanyTaxPercentage = companyTaxPercentage;
    let combinedplanemployeeTaxPercentage = this.deltaCompanyTax
      ? companyTaxPercentage
      : employeeTaxPercentage;
    let combinedplanemployeeTaxPercentageorg = employeeTaxPercentage;
    let combinedplanTotal = adjustWith2DecimalsForUI(
      baseplanTotal + deltaplanTotal
    );

    let scenario = `Employee Upgrade from ${selectedBaseplanProduct.name} to ${selectedCCplanProduct.name}`;
    let planName = `${CCplan.name}(${selectedCCplanProduct.name}) (${upgradeText})`;
    let compnayShareStatement = `${CCplan.name}(${selectedCCplanProduct.name}) Contribution`;
    let employeeShareStatement = `${CCplan.name}(${selectedCCplanProduct.name}) upgrade cost`;
    let planDescription = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanTotal} and Employee- pays ${upgradepaymentText} ${deltaplanTotal} `;
    let planDescription2 = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanPrice}(with tax:${companyTaxPercentage}) and Employee- pays ${upgradepaymentText} ${deltaplanPrice}(with tax:${employeeTaxPercentage}) `;
    let type;

    if (payroll) {
      type = "Split with payroll deduction";
    } else {
      type = "Split with direct pay";
    }
    let basePlanDetails = {
      planId: selectedBasePlan.id || 0, //0
      planName: selectedBasePlan.name || "NA", //NA
      planLevelId: selectedBasePlan.planLevel || 0, //0
      amount: baseplanPrice || 0, //0
      amountUI: `$${baseplanPrice}` || 0, //0
      tax: baseplanTax,
      total: baseplanTotal,
      taxUI: `$${baseplanTax}`, //companyTaxpercentage
      totalUI: `$${baseplanTotal}`,
      planLevelName: selectedBasePlan.groupName || "", //if it is Bundle
      planFrequencyID: selectedBasePlan.frqMonthly || "",
      planFusebillID: selectedBasePlan.fusebillId || "",
      products: [selectedBaseplanProduct],
      planLevel_parentId: selectedBasePlan.planLevel_parentId || 0,
      packageName: selectedBasePlan.packageName || "",
      packageId: selectedBasePlan.packageId || 0,
    };
    let obj = {
      companyTax,
      companyTaxPercentage,
      baseplanPrice,
      baseplanTaxorg,
      baseplanTax,
      baseplanTotalorg,
      baseplanTotal,
      employeeTax,
      employeeTaxPercentage,
      deltaplanPrice,
      deltaplanTax,
      deltaplanTotal,
      combinedplanPrice,
      combinedplanbasePrice,
      combinedplanDeltaprice,
      combinedplanTax,
      combinedplanCompanyTax,
      combinedplanEmployeeTax,
      combinedplanCompanyTaxPercentage,
      combinedplanemployeeTaxPercentage,
      combinedplanTotal,
      payroll,
      scenario,
      planName,
      compnayShareStatement,
      employeeShareStatement,
      planDescription,
      planDescription2,
      type,
      basePlanDetails,
      combinedplanemployeeTaxPercentageorg,
    };

    console.log(obj)
    modifiedCCplan.upgradeCalculation = obj;
    return modifiedCCplan
  }

  public multipleCCCoverageProduct(selectedCCplanProductarray: any, selectedBaseplanProductsArray: any, selectedCompanyplanProductsArray: any, selectedBasePlan: any, CCplan: any, upgradeText: any, payroll: any, upgradepaymentText: any, selectedCoverage: any, modifiedCCplan: any) {

    console.log(selectedCCplanProductarray)
    for (let i = 0; i < selectedCCplanProductarray.length; i++) {
      let selectedBaseplanProduct = selectedBaseplanProductsArray[i];
      console.log(selectedBaseplanProduct)
      let selectedCompanyplanProduct =
        selectedCompanyplanProductsArray[i];
      let selectedCCplanProduct = selectedCCplanProductarray[i];
      console.log(selectedCCplanProduct)
      console.log(selectedCompanyplanProductsArray[i])
      let companyTax =
        selectedCompanyplanProduct.calculatedTax.planProductInfos
          .length > 0
          ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
            .taxRate
          : 0;
      let companyTaxPercentage =
        selectedCompanyplanProduct.calculatedTax.planProductInfos
          .length > 0
          ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
            .taxRatePercentage
          : 0;

      let baseplanPrice = adjustWith2DecimalsForUI(
        selectedBaseplanProduct.calculatedTax.price
      );
      let baseplanTaxorg = adjustWith2DecimalsForUI(
        selectedBaseplanProduct.calculatedTax.tax
      );
      let baseplanTax = adjustWith2DecimalsForUI(
        baseplanPrice * companyTax
      );
      let baseplanTotalorg = adjustWith2DecimalsForUI(
        selectedBaseplanProduct.calculatedTax.total
      );
      let baseplanTotal = adjustWith2DecimalsForUI(
        baseplanPrice + baseplanTax
      );


      let employeeTax =
        selectedCCplanProduct?.calculatedTax?.planProductInfos.length > 0
          ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
            .taxRate
          : 0;
      let employeeTaxPercentage =
        selectedCCplanProduct?.calculatedTax?.planProductInfos.length > 0
          ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
            .taxRatePercentage
          : 0;
      let deltaplanPrice = adjustWith2DecimalsForUI(
        selectedCCplanProduct.calculatedTax.price -
        selectedBaseplanProduct.calculatedTax.price
      );
      //console.log(deltaplanPrice)


      //console.log(selectedBaseplanProduct.calculatedTax.price)

      if (selectedBaseplanProduct.name == 'NA') {
        //this.consoleMessage("No Base plan/product for this upgrade plans/product")
        // companyTax = employeeTax
        companyTax = 0  ////when there is no base planproduct
        // companyTaxPercentage = employeeTaxPercentage
        companyTaxPercentage = "0%" //when there is no base planproduct

      }
      //Delete plan Total Price and Total Combination
      if (deltaplanPrice < 0) {
        deltaplanPrice = 0
        baseplanPrice = adjustWith2DecimalsForUI(
          selectedCCplanProduct.calculatedTax.price
        );
        baseplanTaxorg = adjustWith2DecimalsForUI(
          selectedCCplanProduct.calculatedTax.tax
        );
        baseplanTax = adjustWith2DecimalsForUI(
          baseplanPrice * companyTax
        );
        baseplanTotalorg = adjustWith2DecimalsForUI(
          selectedCCplanProduct.calculatedTax.total
        );
        baseplanTotal = adjustWith2DecimalsForUI(
          baseplanPrice + baseplanTax
        );
      }
      // let deltaplanTax = adjustWith2DecimalsForUI(
      //   deltaplanPrice *
      //   (this.deltaCompanyTax ? companyTax : employeeTax)
      // );
      let deltaplanTax = adjustWith2DecimalsForUI(deltaplanPrice * employeeTax);

      let deltaplanTotal = adjustWith2DecimalsForUI(
        deltaplanPrice + deltaplanTax
      );
      let combinedplanPrice = adjustWith2DecimalsForUI(
        baseplanPrice + deltaplanPrice
      );
      let combinedplanbasePrice = baseplanPrice;
      let combinedplanDeltaprice = deltaplanPrice;
      let combinedplanTax = adjustWith2DecimalsForUI(
        baseplanTax + deltaplanTax
      );
      let combinedplanCompanyTax = baseplanTax;
      let combinedplanEmployeeTax =
        adjustWith2DecimalsForUI(deltaplanTax);
      let combinedplanCompanyTaxPercentage = companyTaxPercentage;
      let combinedplanemployeeTaxPercentage = this.deltaCompanyTax
        ? companyTaxPercentage
        : employeeTaxPercentage;
      let combinedplanemployeeTaxPercentageorg = employeeTaxPercentage;

      let combinedplanTotal = adjustWith2DecimalsForUI(
        baseplanTotal + deltaplanTotal
      );

      let scenario = `Employee Upgrade from ${selectedBasePlan.name} to ${CCplan.name}`;
      let planName = `${CCplan.name} (${upgradeText})`;
      let compnayShareStatement = `${CCplan.name} Contribution`;
      let employeeShareStatement = `${CCplan.name} upgrade cost`;
      let planDescription = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanTotal} and Employee- pays ${upgradepaymentText} ${deltaplanTotal} `;
      let planDescription2 = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanPrice}(with tax:${companyTaxPercentage}) and Employee- pays ${upgradepaymentText} ${deltaplanPrice}(with tax:${employeeTaxPercentage}) `;
      let type;

      if (payroll) {
        type = "Split with payroll deduction";
      } else {
        type = "Split with direct pay";
      }
      let basePlanDetails = {
        planId: selectedBasePlan.id, //0
        planName: selectedBasePlan.name, //NA
        planLevelId: selectedBasePlan.planLevel, //0
        amount: baseplanPrice, //0
        amountUI: `$${baseplanPrice}`, //0
        tax: baseplanTax,
        total: baseplanTotal,
        taxUI: `$${baseplanTax}`, //companyTaxpercentage
        totalUI: `$${baseplanTotal}`,
        planLevelName: selectedBasePlan.groupName || "", //if it is Bundle
        planFrequencyID: selectedBasePlan.frqMonthly || "",
        planFusebillID: selectedBasePlan.fusebillId || "",
        products: [selectedBaseplanProduct],
        planLevel_parentId: selectedBasePlan.planLevel_parentId,
        packageName: selectedBasePlan.packageName,
        packageId: selectedBasePlan.packageId,
      };





      let obj = {
        companyTax,
        companyTaxPercentage,
        baseplanPrice,
        baseplanTaxorg,
        baseplanTax,
        baseplanTotalorg,
        baseplanTotal,
        employeeTax,
        employeeTaxPercentage,
        deltaplanPrice,
        deltaplanTax,
        deltaplanTotal,
        combinedplanPrice,
        combinedplanbasePrice,
        combinedplanDeltaprice,
        combinedplanTax,
        combinedplanCompanyTax,
        combinedplanEmployeeTax,
        combinedplanCompanyTaxPercentage,
        combinedplanemployeeTaxPercentage,
        combinedplanTotal,
        payroll,
        scenario,
        planName,
        compnayShareStatement,
        employeeShareStatement,
        planDescription,
        planDescription2,
        type,
        basePlanDetails,
        combinedplanemployeeTaxPercentageorg,
        selectedCoverage
      };

      //this.consoleMessage(obj)

      console.log(obj)

      if (modifiedCCplan.products) {

      } else {
        modifiedCCplan.products = []
      }
      let ccProduct: any = {}
      ccProduct.upgradeCalculation = obj;
      modifiedCCplan.products.push(ccProduct)
      modifiedCCplan.upgradeCalculation = obj;

      //console.log(modifiedCCplan)
    }

    return modifiedCCplan
  }
  // this.singleCCCoverageProduct()
  // this.multipleCCCoverageProduct()

  public DirectCoverageMethod(selectedCCplanProductarray: any, selectedBaseplanProductsArray: any) {

    //console.log("DirectCoveragemETHOD")
    let productCoverageFound = false;
    let selectedBaseplanProductsArray2: any = []
    let selectedBasePlan = {};
    let selectedBaseplanProduct: any;
    for (let i = 0; i < selectedCCplanProductarray.length; i++) {
      for (let j = 0; j < selectedBaseplanProductsArray.length; j++) {

        //console.log(selectedCCplanProductarray[i])
        //console.log(selectedBaseplanProductsArray[j])

        if (selectedCCplanProductarray[i].planCoverage == selectedBaseplanProductsArray[j].planCoverage) {
          productCoverageFound = true
          selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray[j])
          break;
        }


      }
      if (!productCoverageFound) {


        //console.log("ElseDirectCoveragemETHOD")
        selectedBasePlan = {};
        selectedBaseplanProduct = {};
        selectedBaseplanProduct.calculatedTax = {};
        selectedBaseplanProduct.calculatedTax.price = 0;
        selectedBaseplanProduct.calculatedTax.tax = 0;
        selectedBaseplanProduct.calculatedTax.total = 0;
        selectedBaseplanProduct.name = "NA";
        selectedBaseplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
        selectedBaseplanProductsArray2.push(selectedBaseplanProduct);



      }

    }
    //this.consoleMessage(selectedBaseplanProductsArray)

    //console.log(selectedBaseplanProductsArray2)
    selectedBaseplanProductsArray = selectedBaseplanProductsArray2

    return selectedBaseplanProductsArray
  }

  public selectiveSingleCoverageMethod(selectedCCplanProductarray: any, selectedBaseplanProductsArray: any) {
    let productCoverageFound = false;
    let selectedBaseplanProductsArray2: any = []
    let selectedBasePlan = {};
    let selectedBaseplanProduct: any;

    //console.log(selectedBaseplanProductsArray)
    selectedBaseplanProductsArray = selectedBaseplanProductsArray.filter((bb: any) => { return bb.planCoverage == 'SINGLE' })
    for (let i = 0; i < selectedCCplanProductarray.length; i++) {
      for (let j = 0; j < selectedBaseplanProductsArray.length; j++) {
        productCoverageFound = true
        //console.log(selectedBaseplanProductsArray[j])
        selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray[j])
        break;
        // if (selectedCCplanProductarray[i].planCoverage == selectedBaseplanProductsArray[j].planCoverage) {
        //   productCoverageFound = true
        //   selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray[j])
        //   break;
        // }


      }
      if (!productCoverageFound) {



        selectedBasePlan = {};
        selectedBaseplanProduct = {};
        selectedBaseplanProduct.calculatedTax = {};
        selectedBaseplanProduct.calculatedTax.price = 0;
        selectedBaseplanProduct.calculatedTax.tax = 0;
        selectedBaseplanProduct.calculatedTax.total = 0;
        selectedBaseplanProduct.name = "NA";
        selectedBaseplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
        selectedBaseplanProductsArray2.push(selectedBaseplanProduct);



      }

    }
    //this.consoleMessage(selectedBaseplanProductsArray)

    //console.log(selectedBaseplanProductsArray2)
    selectedBaseplanProductsArray = selectedBaseplanProductsArray2

    return selectedBaseplanProductsArray
  }

  public selectiveCoupleCoverageMethod(selectedCCplanProductarray: any, selectedBaseplanProductsArray: any) {
    let productCoverageFound = false;
    let selectedBaseplanProductsArray2: any = []
    let selectedBasePlan = {};
    let selectedBaseplanProduct: any;
    selectedBaseplanProductsArray = selectedBaseplanProductsArray.filter((bb: any) => { return bb.planCoverage == 'COUPLE' })
    for (let i = 0; i < selectedCCplanProductarray.length; i++) {
      for (let j = 0; j < selectedBaseplanProductsArray.length; j++) {
        productCoverageFound = true
        selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray[j])
        break;


      }
      if (!productCoverageFound) {



        selectedBasePlan = {};
        selectedBaseplanProduct = {};
        selectedBaseplanProduct.calculatedTax = {};
        selectedBaseplanProduct.calculatedTax.price = 0;
        selectedBaseplanProduct.calculatedTax.tax = 0;
        selectedBaseplanProduct.calculatedTax.total = 0;
        selectedBaseplanProduct.name = "NA";
        selectedBaseplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
        selectedBaseplanProductsArray2.push(selectedBaseplanProduct);



      }

    }
    //this.consoleMessage(selectedBaseplanProductsArray)
    selectedBaseplanProductsArray = selectedBaseplanProductsArray2

    return selectedBaseplanProductsArray
  }

  public selectiveFamilyCoverageMethod(selectedCCplanProductarray: any, selectedBaseplanProductsArray: any) {
    let productCoverageFound = false;
    let selectedBaseplanProductsArray2: any = []
    let selectedBasePlan = {};
    let selectedBaseplanProduct: any;
    selectedBaseplanProductsArray = selectedBaseplanProductsArray.filter((bb: any) => { return bb.planCoverage == 'FAMILY' })
    for (let i = 0; i < selectedCCplanProductarray.length; i++) {
      for (let j = 0; j < selectedBaseplanProductsArray.length; j++) {
        productCoverageFound = true
        selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray[j])
        break;


      }
      if (!productCoverageFound) {



        selectedBasePlan = {};
        selectedBaseplanProduct = {};
        selectedBaseplanProduct.calculatedTax = {};
        selectedBaseplanProduct.calculatedTax.price = 0;
        selectedBaseplanProduct.calculatedTax.tax = 0;
        selectedBaseplanProduct.calculatedTax.total = 0;
        selectedBaseplanProduct.name = "NA";
        selectedBaseplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
        selectedBaseplanProductsArray2.push(selectedBaseplanProduct);



      }

    }
    //this.consoleMessage(selectedBaseplanProductsArray)
    selectedBaseplanProductsArray = selectedBaseplanProductsArray2

    return selectedBaseplanProductsArray
  }
  public selectiveCPCoverageMethod(selectedCCplanProductarray: any, selectedBaseplanProductsArray: any, selectedCoverage: any) {
    let productCoverageFound = false;
    let selectedBaseplanProductsArray2: any = []
    let selectedBasePlan = {};
    let selectedBaseplanProduct: any;
    selectedBaseplanProductsArray = selectedBaseplanProductsArray.filter((bb: any) => { return bb.planCoverage == selectedCoverage })
    for (let i = 0; i < selectedCCplanProductarray.length; i++) {
      for (let j = 0; j < selectedBaseplanProductsArray.length; j++) {
        productCoverageFound = true
        selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray[j])
        break;


      }
      if (!productCoverageFound) {



        selectedBasePlan = {};
        selectedBaseplanProduct = {};
        selectedBaseplanProduct.calculatedTax = {};
        selectedBaseplanProduct.calculatedTax.price = 0;
        selectedBaseplanProduct.calculatedTax.tax = 0;
        selectedBaseplanProduct.calculatedTax.total = 0;
        selectedBaseplanProduct.name = "NA";
        selectedBaseplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
        selectedBaseplanProductsArray2.push(selectedBaseplanProduct);



      }

    }
    //this.consoleMessage(selectedBaseplanProductsArray)
    selectedBaseplanProductsArray = selectedBaseplanProductsArray2

    return selectedBaseplanProductsArray
  }
  public CompanyDirectCoverageMethod(selectedCCplanProductarray: any, selectedCompanyplanProductsArray: any) {

    //console.log("DirectCoveragemETHOD")
    let productCoverageFound = false;
    let selectedCompanyplanProductsArray2: any = []
    let selectedBasePlan = {};
    let selectedCompanyplanProduct: any;



    for (let i = 0; i < selectedCCplanProductarray.length; i++) {
      for (let j = 0; j < selectedCompanyplanProductsArray.length; j++) {

        if (selectedCCplanProductarray[i].planCoverage == selectedCompanyplanProductsArray[j].planCoverage) {
          productCoverageFound = true
          selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray[j])
          break;
        }


      }
      if (!productCoverageFound) {


        selectedCompanyplanProduct = {};
        selectedCompanyplanProduct.calculatedTax = {};
        selectedCompanyplanProduct.calculatedTax.planProductInfos = [];
        selectedCompanyplanProduct.name = "NA";
        selectedCompanyplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
        selectedCompanyplanProductsArray2.push(selectedCompanyplanProduct);



      }

    }
    selectedCompanyplanProductsArray = selectedCompanyplanProductsArray2

    return selectedCompanyplanProductsArray
  }

  public CompanyselectiveSingleCoverageMethod(selectedCCplanProductarray: any, selectedCompanyplanProductsArray: any) {
    let productCoverageFound = false;
    let selectedCompanyplanProductsArray2: any = []
    let selectedBasePlan = {};
    let selectedCompanyplanProduct: any;
    selectedCompanyplanProductsArray = selectedCompanyplanProductsArray.filter((bb: any) => { return bb.planCoverage == 'SINGLE' })
    for (let i = 0; i < selectedCCplanProductarray.length; i++) {
      for (let j = 0; j < selectedCompanyplanProductsArray.length; j++) {

        productCoverageFound = true
        selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray[j])
        break;
        // if (selectedCCplanProductarray[i].planCoverage == selectedCompanyplanProductsArray[j].planCoverage) {
        //   productCoverageFound = true
        //   selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray[j])
        //   break;
        // }


      }
      if (!productCoverageFound) {


        selectedCompanyplanProduct = {};
        selectedCompanyplanProduct.calculatedTax = {};
        selectedCompanyplanProduct.calculatedTax.planProductInfos = [];
        selectedCompanyplanProduct.name = "NA";
        selectedCompanyplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
        selectedCompanyplanProductsArray2.push(selectedCompanyplanProduct);



      }

    }
    selectedCompanyplanProductsArray = selectedCompanyplanProductsArray2

    return selectedCompanyplanProductsArray
  }

  public CompanyselectiveCoupleCoverageMethod(selectedCCplanProductarray: any, selectedCompanyplanProductsArray: any) {
    let productCoverageFound = false;
    let selectedCompanyplanProductsArray2: any = []
    let selectedBasePlan = {};
    let selectedCompanyplanProduct: any;
    selectedCompanyplanProductsArray = selectedCompanyplanProductsArray.filter((bb: any) => { return bb.planCoverage == 'COUPLE' })
    for (let i = 0; i < selectedCCplanProductarray.length; i++) {
      for (let j = 0; j < selectedCompanyplanProductsArray.length; j++) {

        productCoverageFound = true
        selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray[j])
        break;
        // if (selectedCCplanProductarray[i].planCoverage == selectedCompanyplanProductsArray[j].planCoverage) {
        //   productCoverageFound = true
        //   selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray[j])
        //   break;
        // }


      }
      if (!productCoverageFound) {


        selectedCompanyplanProduct = {};
        selectedCompanyplanProduct.calculatedTax = {};
        selectedCompanyplanProduct.calculatedTax.planProductInfos = [];
        selectedCompanyplanProduct.name = "NA";
        selectedCompanyplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
        selectedCompanyplanProductsArray2.push(selectedCompanyplanProduct);



      }

    }
    selectedCompanyplanProductsArray = selectedCompanyplanProductsArray2

    return selectedCompanyplanProductsArray
  }
  public CompanyselectiveFamilyCoverageMethod(selectedCCplanProductarray: any, selectedCompanyplanProductsArray: any) {
    let productCoverageFound = false;
    let selectedCompanyplanProductsArray2: any = []
    let selectedBasePlan = {};
    let selectedCompanyplanProduct: any;
    selectedCompanyplanProductsArray = selectedCompanyplanProductsArray.filter((bb: any) => { return bb.planCoverage == 'FAMILY' })
    for (let i = 0; i < selectedCCplanProductarray.length; i++) {
      for (let j = 0; j < selectedCompanyplanProductsArray.length; j++) {

        productCoverageFound = true
        selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray[j])
        break;
        // if (selectedCCplanProductarray[i].planCoverage == selectedCompanyplanProductsArray[j].planCoverage) {
        //   productCoverageFound = true
        //   selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray[j])
        //   break;
        // }


      }
      if (!productCoverageFound) {


        selectedCompanyplanProduct = {};
        selectedCompanyplanProduct.calculatedTax = {};
        selectedCompanyplanProduct.calculatedTax.planProductInfos = [];
        selectedCompanyplanProduct.name = "NA";
        selectedCompanyplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
        selectedCompanyplanProductsArray2.push(selectedCompanyplanProduct);



      }

    }
    selectedCompanyplanProductsArray = selectedCompanyplanProductsArray2

    return selectedCompanyplanProductsArray
  }

  public handleGenerateNotes(plansData: any = [], approvalStatus: any, event: any, eventType: any, marriedDate: any) {
    let notesObj = {
      plans: plansData, // old plans and new plans data
      status: approvalStatus, // will be the approval stauts
      event: event,
      eventType: eventType,
      marriedDate: marriedDate
    }

    return notesObj;
  }

  public handleConfigureDependent(slug: any = '') {
    this.showPlanDetails = true;
    this.showAfterPlanDetails = false;
    this.dependentType = this.dependentType ?? 'spouse'
    console.log(this.dependentTypeForm.get('effectiveDate')?.value)
    console.log(this.dependentform.get('effectiveDate')?.value)
    let effectiveDate: any;

    let endPoint: any
    if (slug == 'remove') {
      // Create a Date object from the newDate (assuming it's in ISO format)
      // const date = new Date(this.dependentTypeForm1.get('effectiveDate')?.value)??'';

      // if (date.getFullYear() < 2000) {
      //   console.error('The date cannot be before the year 2000');
      //   return;  // Prevent proceeding if the date is before 2000
      // }

      // // Format the date as 'Jan-15-2024'
      // const formattedDate = date.toLocaleString('en-US', {
      //   year: 'numeric',
      //   month: 'short',
      //   day: '2-digit',
      // }).replace(/ /g, '-').replace(',','').replace(' ','');

      // console.log(formattedDate);
      // effectiveDate = formattedDate

      effectiveDate = this.dependentTypeForm1.get('effectiveDate')?.value

      endPoint = `/${this.customerid}/customerPlans/${this.dependentType ?? 'spouse'}/${slug}`
    } else {
      endPoint = `/${this.customerid}/customerPlans/${this.dependentType == 'child' ? 'dependent' : this.dependentType}/add`
    }
    console.log('this.dependentCoverage', this.dependentCoverage)
    let payload = {
      "enrollmentDate": slug == 'remove' ? effectiveDate : this.dependentTypeForm.get('effectiveDate')?.value,
      // "enrollmentDate": 'Feb-01-2025',
      "removeRoleBasedPlans": false,
      spouseCovered: this.spouseCovered,
      // spouseCovered: false,
      childCovered: this.childCovered,
      totalCount: this.totalCount
    }
    console.log({ payload })
    // commented
    // return;
    this.http.post(api.url + endPoint, payload, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      if (response.status == 200) {
        console.log(response?.data, 'asda')
        this.coverageChange = response?.data?.coverageChange;
        let prs = response?.data?.gsOrEqMemberStatus ?? {}
        let prsStatus: any = []
        const prsKeys = Object.keys(prs);
        if (prsKeys.length > 0) {
          for (const prk of prsKeys) {
            if (prs[prk] == true) {
              if (prk == 'greenShildCustomer') {
                prsStatus.push('GreenShield')
              }
              if (prk == 'hcdSecuremePlans') {
                prsStatus.push('HCD Secureme')
              }
              if (prk == 'equitableCustomer') {
                prsStatus.push('Equitable')
              }
              if (prk == 'phrCustomer') {
                prsStatus.push('PHR')
              }
              if (prk == 'waddelCustomer') {
                prsStatus.push('Waddel')
              }
            }
          }
        }
        this.provisioningSites = prsStatus.toString() ?? ""

        console.log("calledoooo")
        let data__ = response?.data?.packages
        this.selectedPlans_ = [];
        this.oldExistingPlans = []
        this.selectedTrues = []
        this.unSelectedPlans_ = []
        this.totalSummaryPrice = 0;
        for (let package_ of data__) {
          console.log(package_, 'asdaas2')
          let groupKeys_ = Object.keys(package_.groups);
          for (let groups of groupKeys_) {
            for (let group of package_.groups[groups]) {
              for (let plan of group.plans) {
                let pan = plan.productAddonssNames
                for (let product of plan.productAddonssNames) {
                  if (plan.productAddonss[product]) {
                    const paon = plan.productAddonss[product]
                    for (const paon_ of paon) {
                      console.log(paon_, '12345')
                      if (paon_.selected == true) {
                        this.selectedTrues.push({ id: paon_.id, productId: paon_.productId, planId: paon_.planId })
                        paon_['checked'] = true;
                        this.totalSummaryPrice += paon_.calculatedTax.total
                        this.selectedPlans_.push(paon_);
                        this.oldExistingPlans.push(paon_)
                      } else {
                        this.unSelectedPlans_.push(paon_)
                      }
                    }
                  }
                }

              }
            }
          }
          console.log(this.selectedPlans_, 'asd2342')
          console.log(this.unSelectedPlans_, 'asd23421')

          // setTimeout(() => {
          //   this.selectedTrues.forEach(element => {
          //     const dom = "#plancheck" + element.id
          //     console.log("selectedPlan123", dom)
          //     $(dom).click()
          //   });
          // }, 1000);

          this.getPlanSummaryObject();

        }
        console.log('selectedTrues', this.selectedTrues)

        // setTimeout(() => {
        //   this.selectedTrues.forEach(element => {
        //     const dom = "#plancheck" + element.id
        //     console.log("selectedPlan123", dom)
        //     $(dom).click()
        //   });
        // }, 1000);


        // for (let package_ of data__) {
        //   console.log(package_, 'asdaas2');

        //   let groupKeys_ = Object.keys(package_.groups);

        //   for (let groups of groupKeys_) {
        //     for (let group of package_.groups[groups]) {
        //       for (let plan of group.plans) {
        //         let pan = plan.productAddonssNames;

        //         for (let product of pan) {
        //           if (plan.productAddonss[product]) {
        //             let unSelectedCount = 0;
        //             const paon = plan.productAddonss[product];

        //             for (const paon_ of paon) {
        //               console.log(paon_, '12345');

        //               if (paon_.selected === true) {
        //                 paon_['checked'] = true;
        //                 this.totalSummaryPrice += paon_.calculatedTax.total;
        //                 this.selectedPlans_.push(paon_);
        //                 console.log(this.selectedPlans_, '123456');
        //                 this.oldExistingPlans.push(paon_);
        //               } else {
        //                 unSelectedCount += 1;
        //                 this.unSelectedPlans_.push(paon_);

        //                 // If all items in the group are unselected, select the first one
        //                 // if (unSelectedCount === paon.length) {
        //                 //   // paon_['checked'] = true;
        //                 //   paon_['selected'] = true;
        //                 //   this.totalSummaryPrice += paon_.calculatedTax.total;
        //                 //   this.selectedPlans_.push(paon_);
        //                 //   this.oldExistingPlans.push(paon_);
        //                 // } else {
        //                 //   this.unSelectedPlans_.push(paon_);
        //                 // }
        //               }
        //             }
        //           }
        //         }
        //       }
        //     }
        //   }

        //   console.log(this.selectedPlans_, 'asd2342');
        //   console.log(this.unSelectedPlans_, 'asd23421');

        //   // Click checkboxes after the data is updated
        //   // setTimeout(() => {
        //   //   this.selectedPlans_.forEach(element => {
        //   //     const dom = "#plancheck" + element.id;
        //   //     console.log("selectedPlan", dom);
        //   //     $(dom).click();
        //   //   });
        //   // }, 1000);

        //   this.getPlanSummaryObject();
        // }


        this.specialpackages = data__ ?? []


        //get the selected coverages




        // this.closeDependentmodal.nativeElement.click();
        // Swal.fire({allowOutsideClick: false, title: this.lang?.Info, text: response.message });
      }
      else {
        // Swal.fire({allowOutsideClick: false,title: this.lang?.Info, text:response.message})
      }
    }, (error) => {
      // Swal.fire({allowOutsideClick: false,title: this.lang?.Info, text: error.error.error.message})
    });
    if (this.specialpackages && this.specialpackages.length > 0) {
      let filteredPackages_: any = [];
      console.log("called")
      //filter the repeated packages for medcan care
      for (let package_ of this.specialpackages) {
        console.log(package_, 'asdaas2')
        let groupKeys_ = Object.keys(package_.groups);
        for (let groups of groupKeys_) {
          for (let group of package_.groups[groups]) {
            for (let plan of group.plans) {
              let pan = plan.productAddonssNames
              for (let product of plan.productAddonssNames) {
                if (plan.productAddonss[product]) {
                  const paon = plan.productAddonss[product]
                  for (const paon_ of paon) {
                    if (paon_.selected == true) {
                      this.selectedPlans_.push(paon_);
                    }
                  }
                }
              }

            }
          }
        }
        console.log(this.selectedPlans_, 'asd2342')
        if (package_.id == 5) {
          let groupKeys_ = Object.keys(package_.groups);
          for (let groups of groupKeys_) {
            for (let group of package_.groups[groups]) {
              for (let plan of group.plans) {
                let pan = plan.productAddonssNames
                for (let product of plan.productAddonssNames) {

                  // plan.productAddonss[product][0]?.planlevel.id, plan.productAddonss[product][0].product_id
                  if (filteredPackages_[product]) {
                    if (filteredPackages_[product]['planProductIds']?.includes(plan.productAddonss[product][0]?.planlevel.id) && filteredPackages_[product]['planProductIds'].includes(plan.productAddonss[product][0].product_id)) {
                      let index = pan.indexOf(product);
                      if (index !== -1) {
                        pan.splice(index, 1);
                      }
                    }
                  } else {
                    filteredPackages_[product] = { 'planProductIds': [] }
                    filteredPackages_[product]['planProductIds'] = [plan.productAddonss[product][0]?.planlevel.id, plan.productAddonss[product][0].product_id]
                  }

                  console.log(plan.productAddonss, product);

                }

                plan.productAddonssNames = pan;
              }
            }
          }
        }
      }

      // console.log(this.specialpackages)
    }
  }

  public handleShowText(product: any, coverage: any) {
    if (coverage == 'STC') {
      this.coverageChangeText = 'Plan coverage will change from SINGLE to COUPLE'
    }
    if (coverage == 'CTS') {
      this.coverageChangeText = 'Plan coverage will change from COUPLE to SINGLE'
    }
    this.priceChangeText = `old price - $${product.oldPrice} | new price - $${product.newPrice} | change in amount - ${product.newPrice - product.oldPrice < 0 ? '- $' + Math.abs(product.newPrice - product.oldPrice) : '$' + (product.newPrice - product.oldPrice)}`
    return this.coverageChangeText + '\n' + this.priceChangeText;
  }

  public handleCheckStatus(product_: any, allProducts: any): any {

    for (const ap of allProducts) {
      this.unSelectedPlans_ = allProducts.filter(item => item.id != product_.id);
      this.newlySelectedPlans = allProducts.filter(item => item.id == product_.id);
    }

    for (const sp of this.selectedPlans_) {
      //fetch the unselected plans from specialpackages
      //selected plans

      if (sp.id == product_.id) {
        return true;
      }
      else {
        continue;
      }

      if (this.handlePlanUpgrade == true) {
        if (sp.id != product_.id) {
          return true;
        }
        else {
          continue;
        }
      } else {


      }

    }
  }



  public onCheckboxChange_v2(
    e,
    allowMultiple,
    disallowedPlanLevels,
    options,
    pname,
    groupname,
    plancoverage,
    planprice,
    gst,
    hst,
    pst,
    event,
    event1,
    packageindex,
    groupindex,
    planindex,
    plan,
    product, pckage, group
  ) {

    console.log("called12")
    console.log({ product, pckage, group, e: e.target.checked })
    if (e.target.checked == false && product.selected == true) {
      this.unselected.push({ planId: product.planId, packId: pckage.id })
    }
    else {
      this.unselected = this.unselected.filter((ele) => (
        ele.planId != product.planId

      ))
    }
    console.log(this.unselected)
    // let multiple = allowMultiple ? Boolean(allowMultiple.data[0]) : false;
    let multiple = allowMultiple == true ? true : false;
    console.log(disallowedPlanLevels)

    if (disallowedPlanLevels != null) {
      console.log(disallowedPlanLevels)
      let disallowed_plans = disallowedPlanLevels.split(",");
      const dom1: HTMLElement = this.elementRef.nativeElement;
      const disallowed_elements = dom1.querySelectorAll(
        ".plansscreen input[type='checkbox']"
      );
      console.log(disallowed_elements)

      // disallowed_elements.forEach((elem: any) => {

      for (let i = 0; i < disallowed_elements.length; i++) {

        let elem: any = disallowed_elements[i]
        console.log(elem)
        // elementcv.checked=false

        let plandetails = elem.attributes.data.value;

        let plandetailsobj = plandetails.split("##");

        console.log("main", plandetailsobj)

        if (e.target.checked) {
          if (!elem.disabled) {
            if (plandetailsobj[12] == null || plandetailsobj[12] == "") {
              if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                //  elem.checked=false
                elem.disabled = true;

                this.disabledelement =
                  "Already included in GroupBenefitz All-In";
              }
            } else {
              if (disallowed_plans.indexOf(plandetailsobj[12]) >= 0) {
                //  elem.checked=false
                elem.disabled = true;
                this.disabledelement =
                  "Already included in GroupBenefitz All-In";
              }
            }
          }
          if (elem.checked) {
            //console.log(disallowed_plans)
            //console.log(plandetailsobj)

            if (plandetailsobj[12] == null || plandetailsobj[12] == "") {
              if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                elem.checked = false;
                this.unselectplan(elem, options, plan, product, pckage, group, disallowedPlanLevels)
              }
            } else {
              //console.log(disallowed_plans)
              //console.log(plandetailsobj)
              if (disallowed_plans.indexOf(plandetailsobj[12]) >= 0) {
                elem.checked = false;
                this.unselectplan(elem, options, plan, product, pckage, group, disallowedPlanLevels)
                // elem.disabled =true
              }
            }
          }
        }
        else {
          if (elem.disabled) {
            if (plandetailsobj[12] == null || plandetailsobj[12] == "") {
              if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                //  elem.checked=false
                elem.disabled = false;
              }
            } else {
              if (disallowed_plans.indexOf(plandetailsobj[12]) >= 0) {
                //  elem.checked=false
                elem.disabled = false;
              }
            }
          }
          if (elem.checked) {
            if (plandetailsobj[12] == null || plandetailsobj[12] == "") {
              if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                elem.checked = false;
                // elem.disabled =true
              }
            } else {
              if (disallowed_plans.indexOf(plandetailsobj[12]) >= 0) {
                elem.checked = false;
                // elem.disabled =true
              }
            }
          }
        }
      };
    }

    // ////console.log(e)
    let classname = e.target.className;
    classname = classname.split(" ").join(".");

    // ////console.log(classname)
    const dom: HTMLElement = this.elementRef.nativeElement;
    const elements = dom.querySelectorAll("." + classname);

    // ////console.log(elements);

    let element: any;
    let elementcv: any;

    if (!multiple) {
      if (e.target.checked) {


        for (let i = 0; i < elements.length; i++) {
          let elem = elements[i]
          element = elem;

          if (element.checked) {
            this.unselectplan(elem, options, plan, product, pckage, group, disallowedPlanLevels)
            element.checked = false;
          }


        }



        e.checked = true;
        e.target.checked = true;

      } else {

      }
    } else {
      //no checking for other checkboxes you can selet multiple
    }
    setTimeout(() => {


      if (e.target.checked) {


        this.selectplan_v2(e.target, options, plan, product, pckage, group)
      }
      else {
        this.unselectplan(e.target, options, plan, product, pckage, group, disallowedPlanLevels)
      }

    }, 10);
  }

  public onCheckboxChange(
    e: any,
    allowMultiple: any,
    disallowedPlanLevels: any,
    options: any,
    pname: any,
    groupname: any,
    plancoverage: any,
    planprice: any,
    gst: any,
    hst: any,
    pst: any,
    event: any,
    event1: any,
    packageindex: any,
    groupindex: any,
    planindex: any,
    plan: any,
    product: any,
    pckage: any,
    group: any,
    coverage: any
  ) {
    console.log("called1", plan)
    console.log(this.showAfterPlanDetails, "asdjjjj1233", this.childCovered)
    // if(this.showAfterPlanDetails){
    //   this.secondTarget = coverage.toUpperCase();
    //   console.log(e, "etarget990", coverage)
    //   this.handleEffectiveDateChange()
    // }
    // e.preventDefault();
    // let multiple = allowMultiple ? Boolean(allowMultiple.data[0]) : false;

    let multiple = allowMultiple == true ? true : false;

    console.log(multiple)

    if (e.target.checked == false && product.selected == true) {
      this.unselected.push({ planId: product.planId, packId: pckage.id })
    }
    else {
      this.unselected = this.unselected.filter((ele) => (
        ele.planId != product.planId
      ))
    }

    if (e.target.checked) {
      console.log("inside checked")
      //unselect all checkboxes with same id(fix for single.couple and family multiple seelction)
      const dom: HTMLElement = this.elementRef.nativeElement;

      const samePlanIdElements = dom.querySelectorAll('#' + e.target.id);
      console.log(samePlanIdElements)

      for (let i = 0; i < samePlanIdElements.length; i++) {
        let elem = samePlanIdElements[i];
        let element: any = elem;
        //  console.log(elem)

        if (element.checked) {
          element.checked = false;
          this.unselectplan(elem, options, plan, product, pckage, group, disallowedPlanLevels);

        }
      }
      e.target.checked = true
      e.target.disabled = true
      // if(this.isUpgradeOrDowngrade == 'downgrade'){
      //   e.target.disabled = true
      // }
    } else {
      //      this.planCoverageName = ''
      // this.insuranceplanid =''
    }

    // console.log(multiple)

    // console.log(plan)
    // console.log(product)


    //this.consoleMessage(disallowedPlanLevels)

    console.log(disallowedPlanLevels)

    if (disallowedPlanLevels != null) {
      //this.consoleMessage(disallowedPlanLevels)
      let disallowed_plans = disallowedPlanLevels.split(',');
      const dom1: HTMLElement = this.elementRef.nativeElement;
      const disallowed_elements = dom1.querySelectorAll(
        ".plansscreen input[type='checkbox']"
      );

      // disallowed_elements.forEach((elem: any) => {

      // console.log(disallowed_elements)

      for (let i = 0; i < disallowed_elements.length; i++) {
        let elem: any = disallowed_elements[i];
        // elementcv.checked=false

        if (!elem.attributes.data) {
          continue;
        }

        let plandetails = elem.attributes.data.value;

        let plandetailsobj = plandetails.split('##');

        //this.consoleMessage(plandetailsobj)

        // console.log(disallowed_plans)   //[1,10,19,20,21]
        // console.log(plandetailsobj[12])  //[24]
        // console.log(plandetailsobj[20]) //[10]
        // console.log(plandetailsobj[12])  //[24]
        // console.log(plandetailsobj[13])
        // console.log(plandetailsobj[19])
        // console.log(plandetailsobj[21])


        // console.log(typeof plandetailsobj[21])
        // console.log(plandetailsobj[12])
        // console.log(plandetailsobj[13])
        // console.log(plandetailsobj[20])


        let isBundle = plandetailsobj[21] == "true" ? true : false
        // console.log(isBundle)
        if (e.target.checked) {

          if (!elem.disabled) {

            if (plandetailsobj[12] == null || plandetailsobj[12] == '') {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                  //  elem.checked=false
                  console.log("1")
                  elem.disabled = true;
                  this.disabledelement =
                    'Already included in GroupBenefitz All-In';
                }
              } else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  //  elem.checked=false
                  console.log("2")

                  console.log(elem)

                  elem.disabled = true;
                  this.disabledelement =
                    'Already included in GroupBenefitz All-In';
                }
              }

            } else {

              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                  console.log(elem)

                  if (elem.checked) {
                    console.log("checkehd")
                    elem.checked = false;
                    this.unselectplan(elem, options, plan, product, pckage, group, disallowedPlanLevels);
                  }

                  // elem.disabled = true;

                  this.disabledelement =
                    'Already included in GroupBenefitz All-In';
                }
              } else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  console.log("4")
                  console.log(elem)
                  // elem.disabled = true;

                  this.disabledelement =
                    'Already included in GroupBenefitz All-In';
                }
              }

            }
          }
          if (elem.checked) {

            if (plandetailsobj[12] == null || plandetailsobj[12] == '') {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                  elem.checked = false;
                  this.unselectplan(elem, options, plan, product, pckage, group, disallowedPlanLevels);
                }

              }
              else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  elem.checked = false;
                  this.unselectplan(elem, options, plan, product, pckage, group, disallowedPlanLevels);
                }
              }
            } else {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[12]) >= 0) {
                  elem.checked = false;
                  this.unselectplan(elem, options, plan, product, pckage, group, disallowedPlanLevels);
                  // elem.disabled =true
                }
              }
              else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  elem.checked = false;
                  this.unselectplan(elem, options, plan, product, pckage, group, disallowedPlanLevels);
                  // elem.disabled =true
                }
              }

            }
          }
        }
        else {
          if (elem.disabled) {
            if (plandetailsobj[12] == null || plandetailsobj[12] == '') {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                  //  elem.checked=false
                  elem.disabled = false;
                }
              } else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  //  elem.checked=false
                  elem.disabled = false;
                }
              }
            }
            if (isBundle) {
              if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {

                elem.disabled = false;

                this.disabledelement =
                  'Already included in GroupBenefitz All-In';
              }
            } else {
              if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {

                elem.disabled = false;

                this.disabledelement =
                  'Already included in GroupBenefitz All-In';
              }
            }

            // else {
            //   if (disallowed_plans.indexOf(plandetailsobj[12]) >= 0) {
            //     //  elem.checked=false
            //     elem.disabled = false;
            //   }
            // }
          }
          if (elem.checked) {

            console.log("elechecked")

            if (plandetailsobj[12] == null || plandetailsobj[12] == '') {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                  elem.checked = false;
                  console.log("elechecked1")
                  this.unselectplan(elem, options, plan, product, pckage, group, disallowedPlanLevels);
                }

              }
              else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  elem.checked = false;
                  console.log("elechecked2")
                  this.unselectplan(elem, options, plan, product, pckage, group, disallowedPlanLevels);
                }
              }
            } else {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[12]) >= 0) {
                  elem.checked = false;
                  this.unselectplan(elem, options, plan, product, pckage, group, disallowedPlanLevels);
                  // elem.disabled =true
                }
              }
              else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  elem.checked = false;
                  this.unselectplan(elem, options, plan, product, pckage, group, disallowedPlanLevels);
                  // elem.disabled =true
                }
              }

            }
          }
        }
      }
    }

    // let sameplanclassname = `newPlan${plan.id}`
    let covergaClassNmae = `coverage${coverage.toUpperCase()}` // //////this.consoleMessage(e)
    // let classname = e.target.className.replace(sameplanclassname, '').replace(covergaClassNmae, '');
    // classname = classname.split(' ').join('.').replaceAll('..', '.');

    // console.log(classname)
    // console.log(sameplanclassname)
    const getValidSelector = (className: string, planId: string, coverage: string) => {
      // Remove the specific plan and coverage classes
      let baseClasses = className
        .replace(`newPlan${planId}`, '')
        .replace(`coverage${coverage.toUpperCase()}`, '')
        .trim();

      // Split into individual classes and filter out empty strings
      const classes = baseClasses.split(' ').filter(c => c);

      // Join with dots and ensure it starts with a dot for class selection
      return '.' + classes.join('.');
    };

    // Usage in your function
    const sameplanclassname = `newPlan${plan.id}`;
    const coverageClassName = `coverage${coverage.toUpperCase()}`;

    // Create valid selector
    const selector = getValidSelector(e.target.className || '', plan.id, coverage);

    // Now use the selector
    const dom: HTMLElement = this.elementRef.nativeElement;
    const elements = dom.querySelectorAll(selector);
    // //////this.consoleMessage(classname)
    // const dom: HTMLElement = this.elementRef.nativeElement;
    // const elements = dom.querySelectorAll(classname);
    // const elements = dom.querySelectorAll(e.target.className);

    // const samePlanElements = dom.querySelectorAll('.' + sameplanclassname);

    // //////this.consoleMessage(elements);

    let element: any;
    let elementcv: any;

    if (!multiple) {
      if (e.target.checked) {


        for (let i = 0; i < elements.length; i++) {
          let elem = elements[i]
          element = elem;

          if (element.checked) {
            this.unselectplan(elem, options, plan, product, pckage, group, disallowedPlanLevels)
            element.checked = false;
          }


        }



        e.checked = true;
        e.target.checked = true;

      } else {

      }
    } else {
      //no checking for other checkboxes you can selet multiple
    }
    setTimeout(() => {
      if (e.target.checked) {
        this.selectplan(e.target, options, plan, product, pckage, group, disallowedPlanLevels);
      } else {
        this.unselectplan(e.target, options, plan, product, pckage, group, disallowedPlanLevels);
      }
    }, 10);
  }



  public onCheckboxChange_v3(
    e: any,
    allowMultiple: any,
    disallowedPlanLevels: any,
    options: any,
    pname: any,
    groupname: any,
    plancoverage: any,
    planprice: any,
    gst: any,
    hst: any,
    pst: any,
    event: any,
    event1: any,
    packageindex: any,
    groupindex: any,
    planindex: any,
    plan: any,
    product: any,
    pckage: any,
    group: any,
    coverage: any
  ) {
    console.log("called1", e)
    // e.preventDefault();
    // let multiple = allowMultiple ? Boolean(allowMultiple.data[0]) : false;

    let multiple = allowMultiple == true ? true : false;

    console.log(multiple)

    if (e.target.checked == false && product.selected == true) {
      this.unselected.push({ planId: product.planId, packId: pckage.id })
    }
    else {
      this.unselected = this.unselected.filter((ele) => (
        ele.planId != product.planId

      ))
    }

    if (e.target.checked) {
      console.log("inside checked")
      //unselect all checkboxes with same id(fix for single.couple and family multiple seelction)
      const dom: HTMLElement = this.elementRef.nativeElement;

      const samePlanIdElements = dom.querySelectorAll('#' + e.target.id);
      console.log(samePlanIdElements)

      for (let i = 0; i < samePlanIdElements.length; i++) {
        let elem = samePlanIdElements[i];
        let element: any = elem;
        //  console.log(elem)

        if (element.checked) {
          element.checked = false;
          this.unselectplan_v3(elem);

        }
      }
      e.target.checked = true
      e.target.disabled = true
    } else {
      //      this.planCoverageName = ''
      // this.insuranceplanid =''
    }

    // console.log(multiple)

    // console.log(plan)
    // console.log(product)


    //this.consoleMessage(disallowedPlanLevels)

    console.log(disallowedPlanLevels)

    if (disallowedPlanLevels != null) {
      //this.consoleMessage(disallowedPlanLevels)
      let disallowed_plans = disallowedPlanLevels.split(',');
      const dom1: HTMLElement = this.elementRef.nativeElement;
      const disallowed_elements = dom1.querySelectorAll(
        ".plansscreen input[type='checkbox']"
      );

      // disallowed_elements.forEach((elem: any) => {

      // console.log(disallowed_elements)

      for (let i = 0; i < disallowed_elements.length; i++) {
        let elem: any = disallowed_elements[i];
        // elementcv.checked=false

        if (!elem.attributes.data) {
          continue;
        }

        let plandetails = elem.attributes.data.value;

        let plandetailsobj = plandetails.split('##');

        //this.consoleMessage(plandetailsobj)

        // console.log(disallowed_plans)   //[1,10,19,20,21]
        // console.log(plandetailsobj[12])  //[24]
        // console.log(plandetailsobj[20]) //[10]
        // console.log(plandetailsobj[12])  //[24]
        // console.log(plandetailsobj[13])
        // console.log(plandetailsobj[19])
        // console.log(plandetailsobj[21])


        // console.log(typeof plandetailsobj[21])
        // console.log(plandetailsobj[12])
        // console.log(plandetailsobj[13])
        // console.log(plandetailsobj[20])


        let isBundle = plandetailsobj[21] == "true" ? true : false
        // console.log(isBundle)
        if (e.target.checked) {

          if (!elem.disabled) {

            if (plandetailsobj[12] == null || plandetailsobj[12] == '') {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                  //  elem.checked=false
                  console.log("1")
                  elem.disabled = true;
                  this.disabledelement =
                    'Already included in GroupBenefitz All-In';
                }
              } else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  //  elem.checked=false
                  console.log("2")

                  console.log(elem)

                  elem.disabled = true;
                  this.disabledelement =
                    'Already included in GroupBenefitz All-In';
                }
              }

            } else {

              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                  console.log(elem)

                  if (elem.checked) {
                    console.log("checkehd")
                    elem.checked = false;
                    this.unselectplan_v3(elem);
                  }

                  elem.disabled = true;

                  this.disabledelement =
                    'Already included in GroupBenefitz All-In';
                }
              } else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  console.log("4")
                  console.log(elem)
                  elem.disabled = true;

                  this.disabledelement =
                    'Already included in GroupBenefitz All-In';
                }
              }

            }
          }
          if (elem.checked) {

            if (plandetailsobj[12] == null || plandetailsobj[12] == '') {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                  elem.checked = false;
                  this.unselectplan_v3(elem);
                }

              }
              else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  elem.checked = false;
                  this.unselectplan_v3(elem);
                }
              }
            } else {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[12]) >= 0) {
                  elem.checked = false;
                  this.unselectplan_v3(elem);
                  // elem.disabled =true
                }
              }
              else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  elem.checked = false;
                  this.unselectplan_v3(elem);
                  // elem.disabled =true
                }
              }

            }
          }
        }
        else {
          if (elem.disabled) {
            if (plandetailsobj[12] == null || plandetailsobj[12] == '') {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                  //  elem.checked=false
                  elem.disabled = false;
                }
              } else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  //  elem.checked=false
                  elem.disabled = false;
                }
              }
            }
            if (isBundle) {
              if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {

                elem.disabled = false;

                this.disabledelement =
                  'Already included in GroupBenefitz All-In';
              }
            } else {
              if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {

                elem.disabled = false;

                this.disabledelement =
                  'Already included in GroupBenefitz All-In';
              }
            }

            // else {
            //   if (disallowed_plans.indexOf(plandetailsobj[12]) >= 0) {
            //     //  elem.checked=false
            //     elem.disabled = false;
            //   }
            // }
          }
          if (elem.checked) {

            console.log("elechecked")

            if (plandetailsobj[12] == null || plandetailsobj[12] == '') {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                  elem.checked = false;
                  console.log("elechecked1")
                  this.unselectplan_v3(elem);
                }

              }
              else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  elem.checked = false;
                  console.log("elechecked2")
                  this.unselectplan_v3(elem);
                }
              }
            } else {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[12]) >= 0) {
                  elem.checked = false;
                  this.unselectplan_v3(elem);
                  // elem.disabled =true
                }
              }
              else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  elem.checked = false;
                  this.unselectplan_v3(elem);
                  // elem.disabled =true
                }
              }

            }
          }
        }
      }
    }

    // let sameplanclassname = `newPlan${plan.id}`
    let covergaClassNmae = `coverage${coverage.toUpperCase()}` // //////this.consoleMessage(e)
    // let classname = e.target.className.replace(sameplanclassname, '').replace(covergaClassNmae, '');
    // classname = classname.split(' ').join('.').replaceAll('..', '.');

    // console.log(classname)
    // console.log(sameplanclassname)
    const getValidSelector = (className: string, planId: string, coverage: string) => {
      // Remove the specific plan and coverage classes
      let baseClasses = className
        .replace(`newPlan${planId}`, '')
        .replace(`coverage${coverage.toUpperCase()}`, '')
        .trim();

      // Split into individual classes and filter out empty strings
      const classes = baseClasses.split(' ').filter(c => c);

      // Join with dots and ensure it starts with a dot for class selection
      return '.' + classes.join('.');
    };

    // Usage in your function
    const sameplanclassname = `newPlan${plan.id}`;
    const coverageClassName = `coverage${coverage.toUpperCase()}`;

    // Create valid selector
    const selector = getValidSelector(e.target.className || '', plan.id, coverage);

    // Now use the selector
    const dom: HTMLElement = this.elementRef.nativeElement;
    const elements = dom.querySelectorAll(selector);
    // //////this.consoleMessage(classname)
    // const dom: HTMLElement = this.elementRef.nativeElement;
    // const elements = dom.querySelectorAll(classname);
    // const elements = dom.querySelectorAll(e.target.className);

    // const samePlanElements = dom.querySelectorAll('.' + sameplanclassname);

    // //////this.consoleMessage(elements);

    let element: any;
    let elementcv: any;

    if (!multiple) {
      if (e.target.checked) {


        for (let i = 0; i < elements.length; i++) {
          let elem = elements[i]
          element = elem;

          if (element.checked) {
            this.unselectplan_v3(elem)
            element.checked = false;
          }


        }



        e.checked = true;
        e.target.checked = true;

      } else {

      }
    } else {
      //no checking for other checkboxes you can selet multiple
    }
    setTimeout(() => {
      if (e.target.checked) {
        this.selectplan_v3(e.target, options, plan, product, pckage, group, disallowedPlanLevels);
      } else {
        this.unselectplan_v3(e.target);
      }
    }, 10);
  }


  public onCheckboxChange_v4(
    e: any,
    allowMultiple: any,
    disallowedPlanLevels: any,
    options: any,
    pname: any,
    groupname: any,
    plancoverage: any,
    planprice: any,
    gst: any,
    hst: any,
    pst: any,
    event: any,
    event1: any,
    packageindex: any,
    groupindex: any,
    planindex: any,
    plan: any,
    product: any,
    pckage: any,
    group: any,
    coverage: any
  ) {
    console.log("called1", e)
    // e.preventDefault();
    // let multiple = allowMultiple ? Boolean(allowMultiple.data[0]) : false;

    let multiple = allowMultiple == true ? true : false;

    console.log(multiple)

    if (e.target.checked == false && product.selected == true) {
      this.unselected.push({ planId: product.planId, packId: pckage.id })
    }
    else {
      this.unselected = this.unselected.filter((ele) => (
        ele.planId != product.planId

      ))
    }

    if (e.target.checked) {
      console.log("inside checked")
      //unselect all checkboxes with same id(fix for single.couple and family multiple seelction)
      const dom: HTMLElement = this.elementRef.nativeElement;

      const samePlanIdElements = dom.querySelectorAll('#' + e.target.id);
      console.log(samePlanIdElements)

      for (let i = 0; i < samePlanIdElements.length; i++) {
        let elem = samePlanIdElements[i];
        let element: any = elem;
        //  console.log(elem)

        if (element.checked) {
          element.checked = false;
          this.unselectplan_v3(elem);

        }
      }
      e.target.checked = true
    } else {
      //      this.planCoverageName = ''
      // this.insuranceplanid =''
    }

    // console.log(multiple)

    // console.log(plan)
    // console.log(product)


    //this.consoleMessage(disallowedPlanLevels)

    console.log(disallowedPlanLevels)

    if (disallowedPlanLevels != null) {
      //this.consoleMessage(disallowedPlanLevels)
      let disallowed_plans = disallowedPlanLevels.split(',');
      const dom1: HTMLElement = this.elementRef.nativeElement;
      const disallowed_elements = dom1.querySelectorAll(
        ".plansscreen input[type='checkbox']"
      );

      // disallowed_elements.forEach((elem: any) => {

      // console.log(disallowed_elements)

      for (let i = 0; i < disallowed_elements.length; i++) {
        let elem: any = disallowed_elements[i];
        // elementcv.checked=false

        if (!elem.attributes.data) {
          continue;
        }

        let plandetails = elem.attributes.data.value;

        let plandetailsobj = plandetails.split('##');

        //this.consoleMessage(plandetailsobj)

        // console.log(disallowed_plans)   //[1,10,19,20,21]
        // console.log(plandetailsobj[12])  //[24]
        // console.log(plandetailsobj[20]) //[10]
        // console.log(plandetailsobj[12])  //[24]
        // console.log(plandetailsobj[13])
        // console.log(plandetailsobj[19])
        // console.log(plandetailsobj[21])


        // console.log(typeof plandetailsobj[21])
        // console.log(plandetailsobj[12])
        // console.log(plandetailsobj[13])
        // console.log(plandetailsobj[20])


        let isBundle = plandetailsobj[21] == "true" ? true : false
        // console.log(isBundle)
        if (e.target.checked) {

          if (!elem.disabled) {

            if (plandetailsobj[12] == null || plandetailsobj[12] == '') {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                  //  elem.checked=false
                  console.log("1")
                  elem.disabled = true;
                  this.disabledelement =
                    'Already included in GroupBenefitz All-In';
                }
              } else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  //  elem.checked=false
                  console.log("2")

                  console.log(elem)

                  elem.disabled = true;
                  this.disabledelement =
                    'Already included in GroupBenefitz All-In';
                }
              }

            } else {

              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                  console.log(elem)

                  if (elem.checked) {
                    console.log("checkehd")
                    elem.checked = false;
                    this.unselectplan_v3(elem);
                  }

                  elem.disabled = true;

                  this.disabledelement =
                    'Already included in GroupBenefitz All-In';
                }
              } else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  console.log("4")
                  console.log(elem)
                  elem.disabled = true;

                  this.disabledelement =
                    'Already included in GroupBenefitz All-In';
                }
              }

            }
          }
          if (elem.checked) {

            if (plandetailsobj[12] == null || plandetailsobj[12] == '') {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                  elem.checked = false;
                  this.unselectplan_v3(elem);
                }

              }
              else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  elem.checked = false;
                  this.unselectplan_v3(elem);
                }
              }
            } else {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[12]) >= 0) {
                  elem.checked = false;
                  this.unselectplan_v3(elem);
                  // elem.disabled =true
                }
              }
              else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  elem.checked = false;
                  this.unselectplan_v3(elem);
                  // elem.disabled =true
                }
              }

            }
          }
        }
        else {
          if (elem.disabled) {
            if (plandetailsobj[12] == null || plandetailsobj[12] == '') {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                  //  elem.checked=false
                  elem.disabled = false;
                }
              } else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  //  elem.checked=false
                  elem.disabled = false;
                }
              }
            }
            if (isBundle) {
              if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {

                elem.disabled = false;

                this.disabledelement =
                  'Already included in GroupBenefitz All-In';
              }
            } else {
              if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {

                elem.disabled = false;

                this.disabledelement =
                  'Already included in GroupBenefitz All-In';
              }
            }

            // else {
            //   if (disallowed_plans.indexOf(plandetailsobj[12]) >= 0) {
            //     //  elem.checked=false
            //     elem.disabled = false;
            //   }
            // }
          }
          if (elem.checked) {

            console.log("elechecked")

            if (plandetailsobj[12] == null || plandetailsobj[12] == '') {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                  elem.checked = false;
                  console.log("elechecked1")
                  this.unselectplan_v3(elem);
                }

              }
              else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  elem.checked = false;
                  console.log("elechecked2")
                  this.unselectplan_v3(elem);
                }
              }
            } else {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[12]) >= 0) {
                  elem.checked = false;
                  this.unselectplan_v3(elem);
                  // elem.disabled =true
                }
              }
              else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  elem.checked = false;
                  this.unselectplan_v3(elem);
                  // elem.disabled =true
                }
              }

            }
          }
        }
      }
    }

    // let sameplanclassname = `newPlan${plan.id}`
    let covergaClassNmae = `coverage${coverage.toUpperCase()}` // //////this.consoleMessage(e)
    // let classname = e.target.className.replace(sameplanclassname, '').replace(covergaClassNmae, '');
    // classname = classname.split(' ').join('.').replaceAll('..', '.');

    // console.log(classname)
    // console.log(sameplanclassname)
    const getValidSelector = (className: string, planId: string, coverage: string) => {
      // Remove the specific plan and coverage classes
      let baseClasses = className
        .replace(`newPlan${planId}`, '')
        .replace(`coverage${coverage.toUpperCase()}`, '')
        .trim();

      // Split into individual classes and filter out empty strings
      const classes = baseClasses.split(' ').filter(c => c);

      // Join with dots and ensure it starts with a dot for class selection
      return '.' + classes.join('.');
    };

    // Usage in your function
    const sameplanclassname = `newPlan${plan.id}`;
    const coverageClassName = `coverage${coverage.toUpperCase()}`;

    // Create valid selector
    const selector = getValidSelector(e.target.className || '', plan.id, coverage);

    // Now use the selector
    const dom: HTMLElement = this.elementRef.nativeElement;
    const elements = dom.querySelectorAll(selector);
    // //////this.consoleMessage(classname)
    // const dom: HTMLElement = this.elementRef.nativeElement;
    // const elements = dom.querySelectorAll(classname);
    // const elements = dom.querySelectorAll(e.target.className);

    // const samePlanElements = dom.querySelectorAll('.' + sameplanclassname);

    // //////this.consoleMessage(elements);

    let element: any;
    let elementcv: any;

    if (!multiple) {
      if (e.target.checked) {


        for (let i = 0; i < elements.length; i++) {
          let elem = elements[i]
          element = elem;

          if (element.checked) {
            this.unselectplan_v3(elem)
            element.checked = false;
          }


        }



        e.checked = true;
        e.target.checked = true;

      } else {

      }
    } else {
      //no checking for other checkboxes you can selet multiple
    }
    setTimeout(() => {
      if (e.target.checked) {
        this.selectplan_v3(e.target, options, plan, product, pckage, group, disallowedPlanLevels);
      } else {
        this.unselectplan_v3(e.target);
      }
    }, 10);
  }



  // public onCheckboxChange(
  //   e: any,
  //   allowMultiple: any,
  //   disallowedPlanLevels: any,
  //   options: any,
  //   pname: any,
  //   groupname: any,
  //   plancoverage: any,
  //   planprice: any,
  //   gst: any,
  //   hst: any,
  //   pst: any,
  //   event: any,
  //   event1: any,
  //   packageindex: any,
  //   groupindex: any,
  //   planindex: any,
  //   plan: any,
  //   product: any,
  //   pckage: any,
  //   group: any,
  //   coverage: any
  // ) {
  //   // e.preventDefault();
  //   // let multiple = allowMultiple ? Boolean(allowMultiple.data[0]) : false;

  //   let multiple = allowMultiple==true?true: false;

  //   console.log(multiple)

  //   if(e.target.checked){
  //            //unselect all checkboxes with same id(fix for single.couple and family multiple seelction)
  //            const dom: HTMLElement = this.elementRef.nativeElement;

  //            const samePlanIdElements = dom.querySelectorAll('#' + e.target.id);
  //            console.log(samePlanIdElements)

  //            for (let i = 0; i < samePlanIdElements.length; i++) {
  //              let elem = samePlanIdElements[i];
  //              let element:any = elem;
  //             //  console.log(elem)

  //              if (element.checked) {
  //                element.checked = false;
  //                this.unselectplan(elem);

  //              }
  //            }
  //            e.target.checked =true
  //   }else{
  //   //      this.planCoverageName = ''
  //   // this.insuranceplanid =''
  //   }

  //   // console.log(multiple)

  //   // console.log(plan)
  //   // console.log(product)


  //   //this.consoleMessage(disallowedPlanLevels)

  //   console.log(disallowedPlanLevels)

  //   if (disallowedPlanLevels != null) {
  //     //this.consoleMessage(disallowedPlanLevels)
  //     let disallowed_plans = disallowedPlanLevels.split(',');
  //     const dom1: HTMLElement = this.elementRef.nativeElement;
  //     const disallowed_elements = dom1.querySelectorAll(
  //       ".plansscreen input[type='checkbox']"
  //     );

  //     // disallowed_elements.forEach((elem: any) => {

  //     // console.log(disallowed_elements)

  //     for (let i = 0; i < disallowed_elements.length; i++) {
  //       let elem: any = disallowed_elements[i];
  //       // elementcv.checked=false

  //       if (!elem.attributes.data) {
  //         continue;
  //       }

  //       let plandetails = elem.attributes.data.value;

  //       let plandetailsobj = plandetails.split('##');

  //       //this.consoleMessage(plandetailsobj)

  //       // console.log(disallowed_plans)   //[1,10,19,20,21]
  //       // console.log(plandetailsobj[12])  //[24]
  //       // console.log(plandetailsobj[20]) //[10]
  //       // console.log(plandetailsobj[12])  //[24]
  //       // console.log(plandetailsobj[13])
  //       // console.log(plandetailsobj[19])
  //       // console.log(plandetailsobj[21])


  //       // console.log(typeof plandetailsobj[21])
  //       // console.log(plandetailsobj[12])
  //       // console.log(plandetailsobj[13])
  //       // console.log(plandetailsobj[20])


  //       let isBundle= plandetailsobj[21]=="true"?true:false
  //       // console.log(isBundle)
  //       if (e.target.checked) {

  //         if (!elem.disabled) {

  //           if (plandetailsobj[12] == null || plandetailsobj[12] == '') {
  //             if(isBundle){
  //               if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
  //                 //  elem.checked=false
  //                 console.log("1")
  //                 elem.disabled = true;
  //                 this.disabledelement =
  //                   'Already included in GroupBenefitz All-In';
  //               }
  //             }else{
  //               if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
  //                 //  elem.checked=false
  //                 console.log("2")

  //                 console.log(elem)

  //                 elem.disabled = true;
  //                 this.disabledelement =
  //                   'Already included in GroupBenefitz All-In';
  //               }
  //             }

  //           } else {

  //             if(isBundle){
  //               if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
  //                 console.log(elem)

  //                 if(elem.checked){
  //                   console.log("checkehd")
  //                   elem.checked = false;
  //                   this.unselectplan(elem);
  //                 }

  //                   elem.disabled = true;

  //                   this.disabledelement =
  //                     'Already included in GroupBenefitz All-In';
  //                 }
  //             }else{
  //               if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
  //                 console.log("4")
  //                 console.log(elem)
  //                 elem.disabled = true;

  //                 this.disabledelement =
  //                   'Already included in GroupBenefitz All-In';
  //               }
  //             }

  //           }
  //         }
  //         if (elem.checked) {

  //           if (plandetailsobj[12] == null || plandetailsobj[12] == '') {
  //             if(isBundle){
  //             if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
  //               elem.checked = false;
  //               this.unselectplan(elem);
  //             }

  //           }
  //           else{
  //             if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
  //               elem.checked = false;
  //               this.unselectplan(elem);
  //             }
  //           }
  //           } else {
  //             if(isBundle){
  //               if (disallowed_plans.indexOf(plandetailsobj[12]) >= 0) {
  //                 elem.checked = false;
  //                 this.unselectplan(elem);
  //                 // elem.disabled =true
  //               }
  //             }
  //             else{
  //               if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
  //                 elem.checked = false;
  //                 this.unselectplan(elem);
  //                 // elem.disabled =true
  //               }
  //             }

  //           }
  //         }
  //       }
  //       else {
  //         if (elem.disabled) {
  //           if (plandetailsobj[12] == null || plandetailsobj[12] == '') {
  //             if(isBundle){
  //             if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
  //               //  elem.checked=false
  //               elem.disabled = false;
  //             }
  //           }else{
  //             if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
  //               //  elem.checked=false
  //               elem.disabled = false;
  //             }
  //           }
  //           }
  //           if(isBundle){
  //             if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {

  //                 elem.disabled = false;

  //                 this.disabledelement =
  //                   'Already included in GroupBenefitz All-In';
  //               }
  //           }else{
  //             if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {

  //               elem.disabled = false;

  //               this.disabledelement =
  //                 'Already included in GroupBenefitz All-In';
  //             }
  //           }

  //           // else {
  //           //   if (disallowed_plans.indexOf(plandetailsobj[12]) >= 0) {
  //           //     //  elem.checked=false
  //           //     elem.disabled = false;
  //           //   }
  //           // }
  //         }
  //         if (elem.checked) {

  //           console.log("elechecked")

  //           if (plandetailsobj[12] == null || plandetailsobj[12] == '') {
  //             if(isBundle){
  //             if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
  //               elem.checked = false;
  //               console.log("elechecked1")
  //               this.unselectplan(elem);
  //             }

  //           }
  //           else{
  //             if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
  //               elem.checked = false;
  //               console.log("elechecked2")
  //               this.unselectplan(elem);
  //             }
  //           }
  //           } else {
  //             if(isBundle){
  //               if (disallowed_plans.indexOf(plandetailsobj[12]) >= 0) {
  //                 elem.checked = false;
  //                 this.unselectplan(elem);
  //                 // elem.disabled =true
  //               }
  //             }
  //             else{
  //               if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
  //                 elem.checked = false;
  //                 this.unselectplan(elem);
  //                 // elem.disabled =true
  //               }
  //             }

  //           }
  //         }
  //       }
  //     }
  //   }

  //   let sameplanclassname = `newPlan${plan.id}`
  //   let covergaClassNmae =`coverage${coverage.toUpperCase()}` // //////this.consoleMessage(e)
  //   let classname = e.target.className.replace(sameplanclassname,'').replace(covergaClassNmae,'');
  //   classname = classname.split(' ').join('.').replaceAll('..','.');

  //   console.log(classname)
  //   console.log(sameplanclassname)
  //   // //////this.consoleMessage(classname)
  //   const dom: HTMLElement = this.elementRef.nativeElement;
  //   const elements = dom.querySelectorAll(classname);
  //   // const elements = dom.querySelectorAll(e.target.className);

  //   // const samePlanElements = dom.querySelectorAll('.' + sameplanclassname);

  //   // //////this.consoleMessage(elements);

  //   let element: any;
  //   let elementcv: any;

  //   if (!multiple) {
  //     console.log("multiple elesehere")
  //     if (e.target.checked) {

  //        console.log(elements)
  //       for (let i = 0; i < elements.length; i++) {
  //         let elem = elements[i];
  //         element = elem;

  //         if (element.checked) {

  //           this.unselectplan(elem);
  //           element.checked = false;
  //         }
  //       }

  //       e.checked = true;
  //       e.target.checked = true;
  //     } else {
  //     }
  //   }
  //   else {

  //     // console.log("elesehere")
  //     if (e.target.checked) {


  //       // for (let i = 0; i < samePlanElements.length; i++) {
  //       //   let elem = samePlanElements[i];
  //       //   element = elem;

  //       //   if (element.checked) {

  //       //     this.unselectplan(elem);
  //       //     element.checked = false;
  //       //   }
  //       // }

  //       e.checked = true;
  //       e.target.checked = true;
  //     } else {
  //     }
  //     // alert("!")
  //     //no checking for other checkboxes you can selet multiple
  //   }
  //   setTimeout(() => {
  //     if (e.target.checked) {
  //       this.selectplan(e.target, options, plan, product, pckage, group,disallowedPlanLevels);
  //     } else {
  //       this.unselectplan(e.target);
  //     }
  //   }, 10);
  // }





  public handleDowngradeCheck() {
    // first check if the plan in the selected is unchecked & then check it


  }


  public selectplan_v2(elementcv: any, options: any, plan: any, product: any, pckage: any, group: any) {
    console.log(plan)
    console.log(product)
    let plandetails = elementcv.attributes.data.value;

    let plandetailsobj = plandetails.split("##");
    if (options && options.length > 0) {

      let coverage = product.planCoverage

      coverage = ["SINGLE", "COUPLE", "FAMILY"].includes(coverage) ? coverage : null
      //console.log(obj)
      let productobj = {

        id: product.id,
        productId: product.productId,
        name: product.name,
        planProductId: product.planProductId,
        price: this._decimalPipe.transform(product.price1 || product.price, "1.2-2")?.replace(/,/g, ""),
        tax: this._decimalPipe.transform(product.calculatedTax ? product.calculatedTax.tax : 0, "1.2-2")?.replace(/,/g, ""),
        total: this._decimalPipe.transform(product.calculatedTax ? product.calculatedTax.total : 0, "1.2-2")?.replace(/,/g, "") || '',
        tax_details: product.bundledTaxes && product.bundledTaxes.length > 0 ? product.bundledTaxes : product.taxesDataJSON,
        calculatedTax: product.calculatedTax,
        bundledProducts: product.bundledProducts,
        planCoverage: product.planCoverage,
        planLevel: product.planlevel ? product.planlevel.id : '',
        planLevelParent: product.planlevel ? product.planlevel.parentId : "",
        description: product.description,
        coverage: coverage
      };


      let obj1: any = {

        packageId: plan.packageId,
        packageName: pckage.name,

        planproductname: productobj.name,

        groupid: plan.planLevel,
        groupName: group.name,
        id: plan.id,
        name: plan.name,
        planLevel: plan.planLevel ? plan.planLevel : group.id,
        planLevelParent: group.parentId,
        fusebillPlanID: plan.fusebillId,
        planFrequencyID: plan.frqMonthly,
        isBundle: plan.isBundle,
        coverage: coverage,
        planCoverage: product.planCoverage,
        bundledProducts: [],
        products: [],

      };
      obj1.products.push(productobj);
      this.planobjdata = obj1

      // // Update totalSummaryPrice when plan is selected
      // let planPrice = parseFloat(productobj.total.replace(/,/g, '')); // Remove commas and parse to float
      // this.totalSummaryPrice += planPrice;

      this.openplanoptions(elementcv, options, plan, product);
    }
    else {
      let obj = {
        isBundle: plan.isBundle,
        enrollmentDate: "",
        // "name":plandetailsobj[1]+"-"+plandetailsobj[2],
        name: plandetailsobj[14],
        details: plandetailsobj[0],
        packagename: plandetailsobj[0],
        groupName: plandetailsobj[1],
        amount: parseFloat(product.calculatedTax.price),
        planCoverage: plandetailsobj[2],
        planPrice: parseFloat(product.calculatedTax.price),
        amountUI:
          "$" + this._decimalPipe.transform(product.calculatedTax.price, "1.2-2"),
        gst:
          plandetailsobj[4] == null ||
            plandetailsobj[4] == "" ||
            plandetailsobj[4] == undefined ||
            plandetailsobj[4] == "null"
            ? 0
            : parseFloat(plandetailsobj[4]),
        hst:
          plandetailsobj[5] == null ||
            plandetailsobj[5] == "" ||
            plandetailsobj[5] == undefined ||
            plandetailsobj[5] == "null"
            ? 0
            : parseFloat(plandetailsobj[5]),
        pst:
          plandetailsobj[6] == null ||
            plandetailsobj[6] == "" ||
            plandetailsobj[6] == undefined ||
            plandetailsobj[6] == "null"
            ? 0
            : parseFloat(plandetailsobj[6]),
        qst:
          plandetailsobj[17] == null ||
            plandetailsobj[17] == "" ||
            plandetailsobj[17] == undefined ||
            plandetailsobj[17] == "null"
            ? 0
            : parseFloat(plandetailsobj[17]),
        gstCheck:
          plandetailsobj[4] == null ||
            plandetailsobj[4] == "" ||
            plandetailsobj[4] == undefined ||
            plandetailsobj[4] == "null"
            ? false
            : true,
        hstCheck:
          plandetailsobj[5] == null ||
            plandetailsobj[5] == "" ||
            plandetailsobj[5] == undefined ||
            plandetailsobj[5] == "null"
            ? false
            : true,
        pstCheck:
          plandetailsobj[6] == null ||
            plandetailsobj[6] == "" ||
            plandetailsobj[6] == undefined ||
            plandetailsobj[6] == "null"
            ? false
            : true,
        qstCheck:
          plandetailsobj[17] == null ||
            plandetailsobj[17] == "" ||
            plandetailsobj[17] == undefined ||
            plandetailsobj[17] == "null"
            ? false
            : true,
        id: parseFloat(plandetailsobj[7]),
        fusebillPlanID:
          plandetailsobj[8] == null ||
            plandetailsobj[8] == "" ||
            plandetailsobj[8] == undefined ||
            plandetailsobj[8] == "null"
            ? 0
            : parseFloat(plandetailsobj[8]),
        planFrequencyID:
          plandetailsobj[9] == null ||
            plandetailsobj[9] == "" ||
            plandetailsobj[9] == undefined ||
            plandetailsobj[9] == "null"
            ? 0
            : parseFloat(plandetailsobj[9]),
        optIn: plandetailsobj[10] == "true" ? true : false,
        planname: plandetailsobj[14],
        planLevel: parseInt(plandetailsobj[15]),
        packageId: parseInt(plandetailsobj[16]),
        options: [],
        //  "disallowedPlanLevels":plandetailsobj[11]
      };
      if (plandetailsobj[11] != null || plandetailsobj[11] != "null") {
        if (plandetailsobj[11].includes(plandetailsobj[12])) {

        }
      }

      let coverage = product.planCoverage

      coverage = ["SINGLE", "COUPLE", "FAMILY"].includes(coverage) ? coverage : null
      //console.log(obj)
      let productobj = {
        id: product.id,
        productId: product.productId,
        name: product.name,
        planProductId: product.planProductId,
        price: this._decimalPipe.transform(product.price1 || product.price, "1.2-2")?.replace(/,/g, ""),
        tax: this._decimalPipe.transform(product.calculatedTax ? product.calculatedTax.tax : 0, "1.2-2")?.replace(/,/g, ""),
        total: this._decimalPipe.transform(product.calculatedTax ? product.calculatedTax.total : 0, "1.2-2")?.replace(/,/g, "") || '',
        tax_details: product.bundledTaxes && product.bundledTaxes.length > 0 ? product.bundledTaxes : product.taxesDataJSON,
        calculatedTax: product.calculatedTax,
        bundledProducts: product.bundledProducts,
        planCoverage: product.planCoverage,
        planLevel: product.planlevel ? product.planlevel.id : '',
        planLevelParent: product.planlevel ? product.planlevel.parentId : "",
        description: product.description,
        coverage: coverage,
        selected: product.selected
      };


      let obj1: any = {

        packageId: plan.packageId,
        packageName: pckage.name,

        planproductname: productobj.name,

        groupid: plan.planLevel,
        groupName: group.name,
        id: plan.id,
        name: plan.name,
        planLevel: plan.planLevel ? plan.planLevel : group.id,
        planLevelParent: group.parentId,
        fusebillPlanID: plan.fusebillId,
        planFrequencyID: plan.frqMonthly,
        isBundle: plan.isBundle,
        coverage: coverage,
        planCoverage: product.planCoverage,
        bundledProducts: [],
        products: [],
        // selected: plan.seelcted

      };
      obj1.products.push(productobj);
      console.log(obj1)

      //  // Update totalSummaryPrice when plan is selected
      //  let planPrice = parseFloat(productobj.total.replace(/,/g, '')); // Remove commas and parse to float
      //  this.totalSummaryPrice += planPrice;

      this.addtoplansummary(obj, obj1)
    }
  }

  public selectplan(
    elementcv: any,
    options: any,
    plan: any,
    product: any,
    pckage: any,
    group: any,
    disallowedPlanLevels: any
  ) {

    console.log(options)

    if (options && options.length > 0) {
      sessionStorage.setItem('options', JSON.stringify(options));
    }

    let plandetails = elementcv.attributes.data.value;

    let plandetailsobj = plandetails.split('##');
    // if (options && options.length > 0) {
    //   let coverage = product.planCoverage;

    //   coverage = ['SINGLE', 'COUPLE', 'FAMILY'].includes(coverage)
    //     ? coverage
    //     : null;
    //   ////this.consoleMessage(obj)
    //   this.productobj = {
    //     id: product.id,
    //     productId: product.productId,
    //     name: product.name,
    //     planProductId: product.planProductId,
    //     price: this._decimalPipe
    //       .transform(product.price1 || product.price, '1.2-2')
    //       ?.replace(/,/g, ''),
    //     tax: this._decimalPipe
    //       .transform(
    //         product.calculatedTax ? product.calculatedTax.tax : 0,
    //         '1.2-2'
    //       )
    //       ?.replace(/,/g, ''),
    //     total: this._decimalPipe
    //       .transform(
    //         product.calculatedTax ? product.calculatedTax.total : 0,
    //         '1.2-2'
    //       )
    //       ?.replace(/,/g, ''),
    //     tax_details:
    //       product.bundledTaxes && product.bundledTaxes.length > 0
    //         ? product.bundledTaxes
    //         : product.taxesDataJSON,
    //     calculatedTax: product.calculatedTax,
    //     bundledProducts: product.bundledProducts,
    //     planCoverage: product.planCoverage,
    //     planLevel: product.planlevel ? product.planlevel.id : '',
    //     planLevelParent: product.planlevel ? product.planlevel.parentId : '',
    //     description: product.description,
    //     coverage: coverage,
    //   };

    //   let obj1: any = {
    //     packageId: plan.packageId,
    //     packageName: pckage.name,

    //     planproductname: this.productobj.name,

    //     groupid: plan.planLevel,
    //     groupName: group.name,
    //     id: plan.id,
    //     name: plan.name,
    //     planLevel: plan.planLevel ? plan.planLevel : group.id,
    //     planLevelParent: group.parentId,
    //     fusebillPlanID: plan.fusebillId,
    //     planFrequencyID: plan.frqMonthly,
    //     isBundle: plan.isBundle,
    //     coverage: coverage,
    //     planCoverage: product.planCoverage,
    //     bundledProducts: [],
    //     products: [],
    //   };
    //   obj1.products.push(this.productobj);
    //   this.planobjdata = obj1;

    //   this.openplanoptions(elementcv, options, plan, product);
    // }

    // else {

    let obj: any = {
      isBundle: plan.isBundle,
      disallowedPlanLevels: disallowedPlanLevels,
      // enrollmentDate: moment(
      //   this.userForm.get("planenrollmentdate").value,
      //   "MM-DD-YYYY"
      // ).format("YYYY-MM-DD"),
      enrollmentDate: this.dependentTypeForm.get('effectiveDate')?.value
        ? this._CustomDatePipe.transform(
          this.dependentTypeForm.get('effectiveDate')?.value
        )
        : undefined,
      // "name":plandetailsobj[1]+"-"+plandetailsobj[2],
      name: plandetailsobj[14],
      details: plandetailsobj[0],
      packagename: plandetailsobj[0],
      groupName: plandetailsobj[1],
      amount: parseFloat(product.calculatedTax.price),
      planCoverage: plandetailsobj[2],
      planPrice: parseFloat(product.calculatedTax.price),
      amountUI:
        '$' +
        this._decimalPipe.transform(product.calculatedTax.price, '1.2-2'),
      gst:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == '' ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == 'null'
          ? 0
          : parseFloat(plandetailsobj[4]),
      hst:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == '' ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == 'null'
          ? 0
          : parseFloat(plandetailsobj[5]),
      pst:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == '' ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == 'null'
          ? 0
          : parseFloat(plandetailsobj[6]),
      qst:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == '' ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == 'null'
          ? 0
          : parseFloat(plandetailsobj[17]),
      gstCheck:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == '' ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == 'null'
          ? false
          : true,
      hstCheck:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == '' ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == 'null'
          ? false
          : true,
      pstCheck:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == '' ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == 'null'
          ? false
          : true,
      qstCheck:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == '' ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == 'null'
          ? false
          : true,
      id: parseFloat(plandetailsobj[7]),
      fusebillPlanID:
        plandetailsobj[8] == null ||
          plandetailsobj[8] == '' ||
          plandetailsobj[8] == undefined ||
          plandetailsobj[8] == 'null'
          ? 0
          : parseFloat(plandetailsobj[8]),
      planFrequencyID:
        plandetailsobj[9] == null ||
          plandetailsobj[9] == '' ||
          plandetailsobj[9] == undefined ||
          plandetailsobj[9] == 'null'
          ? 0
          : parseFloat(plandetailsobj[9]),
      optIn: plandetailsobj[10] == 'true' ? true : false,
      planname: plandetailsobj[14],
      planLevel: parseInt(plandetailsobj[15]),
      packageId: parseInt(plandetailsobj[16]),
      options: [],
      version: plan.version,
      description: plan.description,
      insuranceType: plan.insuranceType,
      //  "disallowedPlanLevels":plandetailsobj[11]
    };
    if (plandetailsobj[11] != null || plandetailsobj[11] != 'null') {
      if (plandetailsobj[11].includes(plandetailsobj[12])) {
      }
    }

    let coverage = product.planCoverage;

    coverage = ['SINGLE', 'COUPLE', 'FAMILY'].includes(coverage)
      ? coverage
      : null;
    ////this.consoleMessage(obj)
    this.productobj = {
      id: product.id,
      productId: product.productId,
      name: product.name,
      planProductId: product.planProductId,
      price: this._decimalPipe
        .transform(product.price1 || product.price, '1.2-2')
        ?.replace(/,/g, ''),
      tax: this._decimalPipe
        .transform(
          product.calculatedTax ? product.calculatedTax.tax : 0,
          '1.2-2'
        )
        ?.replace(/,/g, ''),
      total: this._decimalPipe
        .transform(
          product.calculatedTax ? product.calculatedTax.total : 0,
          '1.2-2'
        )
        ?.replace(/,/g, ''),
      tax_details:
        product.bundledTaxes && product.bundledTaxes.length > 0
          ? product.bundledTaxes
          : product.taxesDataJSON,
      calculatedTax: product.calculatedTax,
      bundledProducts: product.bundledProducts,
      planCoverage: product.planCoverage,
      planLevel: product.planlevel ? product.planlevel.id : '',
      planLevelParent: product.planlevel ? product.planlevel.parentId : '',
      description: product.description,
      coverage: coverage,
    };

    let obj1: any = {
      packageId: plan.packageId,
      packageName: pckage.name,

      planproductname: this.productobj.name,

      groupid: plan.planLevel,
      groupName: group.name,
      id: plan.id,
      name: plan.name,
      planLevel: plan.planLevel ? plan.planLevel : group.id,
      planLevelParent: group.parentId,
      fusebillPlanID: plan.fusebillId,
      planFrequencyID: plan.frqMonthly,
      isBundle: plan.isBundle,
      coverage: coverage,
      planCoverage: product.planCoverage,
      bundledProducts: [],
      products: [],
    };
    obj1.products.push(this.productobj);
    //this.consoleMessage(obj1)
    this._LoaderService.ShowLoader()
    this.addtoplansummary(obj, obj1);
    setTimeout(() => {


      // this.openplanoptions(elementcv, options, plan, product)
      // this.openplanoptions(elementcv)


    }, 1000);

    // }
  }


  public selectplan_v3(
    elementcv: any,
    options: any,
    plan: any,
    product: any,
    pckage: any,
    group: any,
    disallowedPlanLevels: any
  ) {

    console.log(options)

    if (options && options.length > 0) {
      sessionStorage.setItem('options', JSON.stringify(options));
    }

    let plandetails = elementcv.attributes.data.value;

    let plandetailsobj = plandetails.split('##');
    // if (options && options.length > 0) {
    //   let coverage = product.planCoverage;

    //   coverage = ['SINGLE', 'COUPLE', 'FAMILY'].includes(coverage)
    //     ? coverage
    //     : null;
    //   ////this.consoleMessage(obj)
    //   this.productobj = {
    //     id: product.id,
    //     productId: product.productId,
    //     name: product.name,
    //     planProductId: product.planProductId,
    //     price: this._decimalPipe
    //       .transform(product.price1 || product.price, '1.2-2')
    //       ?.replace(/,/g, ''),
    //     tax: this._decimalPipe
    //       .transform(
    //         product.calculatedTax ? product.calculatedTax.tax : 0,
    //         '1.2-2'
    //       )
    //       ?.replace(/,/g, ''),
    //     total: this._decimalPipe
    //       .transform(
    //         product.calculatedTax ? product.calculatedTax.total : 0,
    //         '1.2-2'
    //       )
    //       ?.replace(/,/g, ''),
    //     tax_details:
    //       product.bundledTaxes && product.bundledTaxes.length > 0
    //         ? product.bundledTaxes
    //         : product.taxesDataJSON,
    //     calculatedTax: product.calculatedTax,
    //     bundledProducts: product.bundledProducts,
    //     planCoverage: product.planCoverage,
    //     planLevel: product.planlevel ? product.planlevel.id : '',
    //     planLevelParent: product.planlevel ? product.planlevel.parentId : '',
    //     description: product.description,
    //     coverage: coverage,
    //   };

    //   let obj1: any = {
    //     packageId: plan.packageId,
    //     packageName: pckage.name,

    //     planproductname: this.productobj.name,

    //     groupid: plan.planLevel,
    //     groupName: group.name,
    //     id: plan.id,
    //     name: plan.name,
    //     planLevel: plan.planLevel ? plan.planLevel : group.id,
    //     planLevelParent: group.parentId,
    //     fusebillPlanID: plan.fusebillId,
    //     planFrequencyID: plan.frqMonthly,
    //     isBundle: plan.isBundle,
    //     coverage: coverage,
    //     planCoverage: product.planCoverage,
    //     bundledProducts: [],
    //     products: [],
    //   };
    //   obj1.products.push(this.productobj);
    //   this.planobjdata = obj1;

    //   this.openplanoptions(elementcv, options, plan, product);
    // }

    // else {

    let obj: any = {
      isBundle: plan.isBundle,
      disallowedPlanLevels: disallowedPlanLevels,
      // enrollmentDate: moment(
      //   this.userForm.get("planenrollmentdate").value,
      //   "MM-DD-YYYY"
      // ).format("YYYY-MM-DD"),
      enrollmentDate: this.dependentTypeForm.get('effectiveDate')?.value
        ? this._CustomDatePipe.transform(
          this.dependentTypeForm.get('effectiveDate')?.value
        )
        : undefined,
      // "name":plandetailsobj[1]+"-"+plandetailsobj[2],
      name: plandetailsobj[14],
      details: plandetailsobj[0],
      packagename: plandetailsobj[0],
      groupName: plandetailsobj[1],
      amount: parseFloat(product.calculatedTax.price),
      planCoverage: plandetailsobj[2],
      planPrice: parseFloat(product.calculatedTax.price),
      amountUI:
        '$' +
        this._decimalPipe.transform(product.calculatedTax.price, '1.2-2'),
      gst:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == '' ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == 'null'
          ? 0
          : parseFloat(plandetailsobj[4]),
      hst:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == '' ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == 'null'
          ? 0
          : parseFloat(plandetailsobj[5]),
      pst:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == '' ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == 'null'
          ? 0
          : parseFloat(plandetailsobj[6]),
      qst:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == '' ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == 'null'
          ? 0
          : parseFloat(plandetailsobj[17]),
      gstCheck:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == '' ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == 'null'
          ? false
          : true,
      hstCheck:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == '' ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == 'null'
          ? false
          : true,
      pstCheck:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == '' ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == 'null'
          ? false
          : true,
      qstCheck:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == '' ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == 'null'
          ? false
          : true,
      id: parseFloat(plandetailsobj[7]),
      fusebillPlanID:
        plandetailsobj[8] == null ||
          plandetailsobj[8] == '' ||
          plandetailsobj[8] == undefined ||
          plandetailsobj[8] == 'null'
          ? 0
          : parseFloat(plandetailsobj[8]),
      planFrequencyID:
        plandetailsobj[9] == null ||
          plandetailsobj[9] == '' ||
          plandetailsobj[9] == undefined ||
          plandetailsobj[9] == 'null'
          ? 0
          : parseFloat(plandetailsobj[9]),
      optIn: plandetailsobj[10] == 'true' ? true : false,
      planname: plandetailsobj[14],
      planLevel: parseInt(plandetailsobj[15]),
      packageId: parseInt(plandetailsobj[16]),
      options: [],
      version: plan.version,
      description: plan.description,
      insuranceType: plan.insuranceType,
      //  "disallowedPlanLevels":plandetailsobj[11]
    };
    if (plandetailsobj[11] != null || plandetailsobj[11] != 'null') {
      if (plandetailsobj[11].includes(plandetailsobj[12])) {
      }
    }

    let coverage = product.planCoverage;

    coverage = ['SINGLE', 'COUPLE', 'FAMILY'].includes(coverage)
      ? coverage
      : null;
    ////this.consoleMessage(obj)
    this.productobj = {
      id: product.id,
      productId: product.productId,
      name: product.name,
      planProductId: product.planProductId,
      price: this._decimalPipe
        .transform(product.price1 || product.price, '1.2-2')
        ?.replace(/,/g, ''),
      tax: this._decimalPipe
        .transform(
          product.calculatedTax ? product.calculatedTax.tax : 0,
          '1.2-2'
        )
        ?.replace(/,/g, ''),
      total: this._decimalPipe
        .transform(
          product.calculatedTax ? product.calculatedTax.total : 0,
          '1.2-2'
        )
        ?.replace(/,/g, ''),
      tax_details:
        product.bundledTaxes && product.bundledTaxes.length > 0
          ? product.bundledTaxes
          : product.taxesDataJSON,
      calculatedTax: product.calculatedTax,
      bundledProducts: product.bundledProducts,
      planCoverage: product.planCoverage,
      planLevel: product.planlevel ? product.planlevel.id : '',
      planLevelParent: product.planlevel ? product.planlevel.parentId : '',
      description: product.description,
      coverage: coverage,
    };

    let obj1: any = {
      packageId: plan.packageId,
      packageName: pckage.name,

      planproductname: this.productobj.name,

      groupid: plan.planLevel,
      groupName: group.name,
      id: plan.id,
      name: plan.name,
      planLevel: plan.planLevel ? plan.planLevel : group.id,
      planLevelParent: group.parentId,
      fusebillPlanID: plan.fusebillId,
      planFrequencyID: plan.frqMonthly,
      isBundle: plan.isBundle,
      coverage: coverage,
      planCoverage: product.planCoverage,
      bundledProducts: [],
      products: [],
    };
    obj1.products.push(this.productobj);
    //this.consoleMessage(obj1)

    this.addtoplansummary_v3(obj, obj1);
    setTimeout(() => {


      // this.openplanoptions(elementcv, options, plan, product)
      // this.openplanoptions(elementcv)


    }, 1000);

    // }
  }


  calculateTotalSummaryPrice() {
    let total = 0;
    let selectedPlans: any = sessionStorage.getItem("plansummarymain");
    if (selectedPlans) {
      selectedPlans = JSON.parse(selectedPlans);

      // Ensure uniqueness based on 'id'
      const uniquePlansMap = new Map();
      selectedPlans.forEach((plan: any) => {
        uniquePlansMap.set(plan.id, plan);  // Use 'id' as the key to remove duplicates
      });

      // Convert the map back to an array of unique plans
      selectedPlans = Array.from(uniquePlansMap.values());
    } else {
      selectedPlans = []; // Set a default value if the session storage is empty or null
    }

    // console.log('this.specialpackages', this.specialpackages)

    // 1st
    // this.plansObj = []
    // for (let pack of this.specialpackages) {
    //   let selected: any = {};
    //   let obj: any = {};

    //   if (pack.selected) {
    //     Object.keys(pack.groups).forEach((group: any) => {
    //       for (let plan of pack.groups[group]) {
    //         for (let plans of plan.plans) {
    //           if (plans.selected) {
    //             Object.keys(plans.productAddonss).forEach((addon: any) => {
    //               for (let c of plans.productAddonss[addon]) {
    //                 if (c.selected) {
    //                   selected = { ...c };
    //                   console.log("Selected addon:", selected);  // Debugging selected addon

    //                   for (let sc of selectedPlans) {
    //                     console.log("Comparing with selected plan:", sc);  // Debugging comparison with selected plans
    //                     console.log('c.planId',c.planId, sc?.id ,sc?.products[0]?.selected)
    //                     if (c.planId == sc?.id && sc?.products[0]?.selected) {
    //                       total += parseFloat(sc.amount||0)
    //                     }
    //                   }
    //                 }
    //               }
    //             }
    //           )}
    //         }
    //       }
    //     }
    //   )}
    // }

    // 2nd - Iterate over all the plans
    selectedPlans.forEach(plan => {
      total += parseFloat(plan.total)
    });
    total = Number(total.toString().slice(0, 6))

    this.totalSummaryPrice = total;
    // Return the calculated total summary price
    return total;
  }


  public addtoplansummary_v2(obj: any, obj1: any) {
    console.log("summary3 called", obj, obj1)
    let planSummary = JSON.parse(sessionStorage.getItem('plansummary') || '[]');

    //  console.log(obj1);
    // console.log(planSummary);
    // console.log('addroplansummaryplans');
    // console.log(planSummary.length);
    // console.log(obj.id);
    // console.log(obj);

    this.addtoslectplans(obj.id, planSummary.length);
    planSummary.push(obj);
    this.getPlanSummaryObject()

    let gstprice = 0;
    let hstprice = 0;
    let pstprice = 0;
    let qstprice = 0;

    if (obj.gst > 0) {
      gstprice = obj.planPrice * obj.gst;
      obj['gstPrice'] = gstprice
        ? this._decimalPipe.transform(gstprice, '1.2-2')
        : 0;
      obj['gstPrice'] = parseFloat(obj['gstPrice']);
    } else {
      obj['gstPrice'] = 0;
    }

    if (obj.hst > 0) {
      hstprice = obj.planPrice * obj.hst;

      obj['hstPrice'] = hstprice
        ? this._decimalPipe.transform(gstprice, '1.2-2')
        : 0;
      obj['hstPrice'] = parseFloat(obj['hstPrice']);
    } else {
      obj['hstPrice'] = 0;
    }

    if (obj.pst > 0) {
      pstprice = obj.planPrice * obj.pst;
      obj['pstPrice'] = pstprice
        ? this._decimalPipe.transform(pstprice, '1.2-2')
        : 0;
      obj['pstPrice'] = parseFloat(obj['pstPrice']);
    } else {
      obj['pstPrice'] = 0;
    }

    if (obj.qst > 0) {
      qstprice = obj.planPrice * obj.qst;

      obj['qstPrice'] = qstprice
        ? this._decimalPipe.transform(qstprice, '1.2-2')
        : 0;
      obj['qstPrice'] = parseFloat(obj['qstPrice']);
    } else {
      obj['qstPrice'] = 0;
    }

    obj['taxUI'] = '';
    if (obj['gstCheck']) {
      obj['taxUI'] += '<span>';
      if (obj['gstPrice'] == 0) {
        obj['taxUI'] += '-';
      } else {
        obj['taxUI'] +=
          '$' +
          this._decimalPipe.transform(obj['gstPrice'], '1.2-2') +
          '&nbsp;(GST)';
      }
      obj['taxUI'] += '</span>';
    }

    if (obj['pstCheck']) {
      obj['taxUI'] += '<span>';
      if (obj['pstPrice'] == 0) {
        obj['taxUI'] += '-';
      } else {
        obj['taxUI'] +=
          '$' +
          this._decimalPipe.transform(obj['pstPrice'], '1.2-2') +
          '&nbsp;(PST)';
      }
      obj['taxUI'] += '</span>';
    }

    if (obj['qstCheck']) {
      obj['taxUI'] += '<span>';
      if (obj['qstPrice'] == 0) {
        obj['taxUI'] += '-';
      } else {
        obj['taxUI'] +=
          '$' +
          this._decimalPipe.transform(obj['qstPrice'], '1.2-2') +
          '&nbsp;(QST)';
      }
      obj['taxUI'] += '</span>';
    }

    if (obj['hstCheck']) {
      obj['taxUI'] += '<span> ';
      if (obj['hstPrice'] == 0) {
        obj['taxUI'] += '-';
      } else {
        obj['taxUI'] +=
          '$' +
          this._decimalPipe.transform(obj['hstPrice'], '1.2-2') +
          '&nbsp;(HST)';
      }
      obj['taxUI'] += '</span>';
    }

    if (
      !obj['hstCheck'] &&
      !obj['gstCheck'] &&
      !obj['pstCheck'] &&
      !obj['qstCheck']
    ) {
      obj['taxUI'] += '<span>-';

      obj['taxUI'] += '</span>';
    }

    // ////this.consoleMessage(object["taxUI"])

    obj['tax'] = obj1.products
      ? this._decimalPipe.transform(
        obj1.products?.reduce((acc: any, calculatedTax: any) => {
          return acc + calculatedTax.tax;
        }, 0),
        '1.2-2'
      )
      : 0;
    obj['tax'] = parseFloat(obj['tax']);

    // obj["products"] =obj1
    obj['coverage'] = obj1.coverage;
    obj['planCoverage'] = obj1.planCoverage;
    obj['planLevelParent'] = obj1.planLevelParent;
    obj['planproductname'] = obj1.planproductname;

    obj['products'] = obj1.products;

    //this.consoleMessage(obj.planPrice)
    //this.consoleMessage(gstprice)
    //this.consoleMessage(hstprice)
    //this.consoleMessage(pstprice)

    //this.consoleMessage(qstprice)
    let pricecal = obj1.products.reduce((acc: any, calculatedTax: any) => {
      return acc + calculatedTax.total;
    }, 0);
    obj['totalPrice'] = parseFloat(pricecal);

    obj['totalUI'] = '$' + this._decimalPipe.transform(pricecal, '1.2-2');

    obj['total'] = this._decimalPipe.transform(pricecal, '1.2-2');

    //this.consoleMessage(obj1)

    obj['skuTotalPrice'] = parseFloat(obj1.products.reduce(
      (acc: any, calculatedTax: any) => {
        return acc + calculatedTax.total;
      },
      0
    ))

    let updatedSum = this.addtosum(obj.totalPrice);
    this.planssummarymain = [];
    this.planssummaryopt = [];

    planSummary.forEach((element: any) => {
      if (element.packagename != 'Opt-in') {
        this.planssummarymain.push(element);
      } else {
        this.planssummaryopt.push(element);
      }
    });

    this.plansskumain.push(obj1);

    sessionStorage.setItem('plansskumain', JSON.stringify(this.plansskumain));
    console.log("setting here");
    sessionStorage.setItem(
      'plansummarymain',
      JSON.stringify(this.planssummarymain)
    );
    sessionStorage.setItem(
      'plansummaryopt',
      JSON.stringify(this.planssummaryopt)
    );

    sessionStorage.setItem('plansummary', JSON.stringify(planSummary));
    let planSummaryData = JSON.parse(sessionStorage.getItem('plansummaryLife') || '[]');

    // if (planSummary.length > 0 || planSummaryData.length > 0) {
    //   this.plansnexttab = false;

    // } else {
    //   this.plansnexttab = true;
    // }
    if (updatedSum > 0) {
      this.cartcheckvalue = false;
    } else {
      this.cartcheckvalue = true;
    }

    setTimeout(() => {

      this.planssummarymain = JSON.parse(
        sessionStorage.getItem('plansummarymain') || '[]'
      );
      console.log(this.planssummarymain)
      var total = 0;
      for (let i = 0; i < this.planssummarymain.length; i++) {
        if (obj.planproductname.includes("La Vie")) {

          if (this.planssummarymain[i].planLevel == 18) {

            if (this.planssummarymain[i].coverage == obj.coverage) {

            } else {
              // const dom: HTMLElement = this.elementRef.nativeElement;
              // // const plan: any = dom.querySelector(`#plancheck792`)
              // const plan: any = dom.querySelector("#plancheck792" + ".coverage" + obj.coverage);
              // setTimeout(() => {
              //   plan.click()
              //   // this.toastrService.success("La Vie plan selection automatically includes Complete Executive Care plan", "");
              // }, 1000);
            }
            break;
          }
          else {

            // const dom: HTMLElement = this.elementRef.nativeElement;
            // // const plan: any = dom.querySelector(`#plancheck792`)
            // const plan: any = dom.querySelector("#plancheck792" + ".coverage" + obj.coverage);

            // console.log(plan)
            // setTimeout(() => {
            //   plan.click()
            //   // this.toastrService.success("La Vie plan selection automatically includes Complete Executive Care plan", "");
            // }, 1000);
          }
        }
      }

      for (let i = 0; i < this.planssummarymain.length; i++) {

        total += parseFloat(this.planssummarymain[i].skuTotalPrice);
      }

      //this.consoleMessage(total);

      this.planAmount = this._decimalPipe
        .transform(total, '1.2-2')
        ?.replace(/,/g, '');
      sessionStorage.setItem('totalAmount', this.planAmount);

      if (this.planAmount > 0) {
        this.cartcheckvalue = false;
      } else {
        this.cartcheckvalue = true;
      }




      // here we can call the select plans one sudeep
    }, 100);
  }

  public addtoplansummary_v3(obj: any, obj1: any) {
    console.log("summary3 called", obj, obj1)
    let planSummary = JSON.parse(sessionStorage.getItem('plansummary') || '[]');

    //  console.log(obj1);
    // console.log(planSummary);
    // console.log('addroplansummaryplans');
    // console.log(planSummary.length);
    // console.log(obj.id);
    // console.log(obj);

    this.addtoslectplans(obj.id, planSummary.length);
    planSummary.push(obj);
    this.getPlanSummaryObject()

    let gstprice = 0;
    let hstprice = 0;
    let pstprice = 0;
    let qstprice = 0;

    if (obj.gst > 0) {
      gstprice = obj.planPrice * obj.gst;
      obj['gstPrice'] = gstprice
        ? this._decimalPipe.transform(gstprice, '1.2-2')
        : 0;
      obj['gstPrice'] = parseFloat(obj['gstPrice']);
    } else {
      obj['gstPrice'] = 0;
    }

    if (obj.hst > 0) {
      hstprice = obj.planPrice * obj.hst;

      obj['hstPrice'] = hstprice
        ? this._decimalPipe.transform(gstprice, '1.2-2')
        : 0;
      obj['hstPrice'] = parseFloat(obj['hstPrice']);
    } else {
      obj['hstPrice'] = 0;
    }

    if (obj.pst > 0) {
      pstprice = obj.planPrice * obj.pst;
      obj['pstPrice'] = pstprice
        ? this._decimalPipe.transform(pstprice, '1.2-2')
        : 0;
      obj['pstPrice'] = parseFloat(obj['pstPrice']);
    } else {
      obj['pstPrice'] = 0;
    }

    if (obj.qst > 0) {
      qstprice = obj.planPrice * obj.qst;

      obj['qstPrice'] = qstprice
        ? this._decimalPipe.transform(qstprice, '1.2-2')
        : 0;
      obj['qstPrice'] = parseFloat(obj['qstPrice']);
    } else {
      obj['qstPrice'] = 0;
    }

    obj['taxUI'] = '';
    if (obj['gstCheck']) {
      obj['taxUI'] += '<span>';
      if (obj['gstPrice'] == 0) {
        obj['taxUI'] += '-';
      } else {
        obj['taxUI'] +=
          '$' +
          this._decimalPipe.transform(obj['gstPrice'], '1.2-2') +
          '&nbsp;(GST)';
      }
      obj['taxUI'] += '</span>';
    }

    if (obj['pstCheck']) {
      obj['taxUI'] += '<span>';
      if (obj['pstPrice'] == 0) {
        obj['taxUI'] += '-';
      } else {
        obj['taxUI'] +=
          '$' +
          this._decimalPipe.transform(obj['pstPrice'], '1.2-2') +
          '&nbsp;(PST)';
      }
      obj['taxUI'] += '</span>';
    }

    if (obj['qstCheck']) {
      obj['taxUI'] += '<span>';
      if (obj['qstPrice'] == 0) {
        obj['taxUI'] += '-';
      } else {
        obj['taxUI'] +=
          '$' +
          this._decimalPipe.transform(obj['qstPrice'], '1.2-2') +
          '&nbsp;(QST)';
      }
      obj['taxUI'] += '</span>';
    }

    if (obj['hstCheck']) {
      obj['taxUI'] += '<span> ';
      if (obj['hstPrice'] == 0) {
        obj['taxUI'] += '-';
      } else {
        obj['taxUI'] +=
          '$' +
          this._decimalPipe.transform(obj['hstPrice'], '1.2-2') +
          '&nbsp;(HST)';
      }
      obj['taxUI'] += '</span>';
    }

    if (
      !obj['hstCheck'] &&
      !obj['gstCheck'] &&
      !obj['pstCheck'] &&
      !obj['qstCheck']
    ) {
      obj['taxUI'] += '<span>-';

      obj['taxUI'] += '</span>';
    }

    // ////this.consoleMessage(object["taxUI"])

    obj['tax'] = obj1.products
      ? this._decimalPipe.transform(
        obj1.products?.reduce((acc: any, calculatedTax: any) => {
          return acc + calculatedTax.tax;
        }, 0),
        '1.2-2'
      )
      : 0;
    obj['tax'] = parseFloat(obj['tax']);

    // obj["products"] =obj1
    obj['coverage'] = obj1.coverage;
    obj['planCoverage'] = obj1.planCoverage;
    obj['planLevelParent'] = obj1.planLevelParent;
    obj['planproductname'] = obj1.planproductname;

    obj['products'] = obj1.products;

    //this.consoleMessage(obj.planPrice)
    //this.consoleMessage(gstprice)
    //this.consoleMessage(hstprice)
    //this.consoleMessage(pstprice)

    //this.consoleMessage(qstprice)
    let pricecal = obj1.products.reduce((acc: any, calculatedTax: any) => {
      return acc + calculatedTax.total;
    }, 0);
    obj['totalPrice'] = parseFloat(pricecal);

    obj['totalUI'] = '$' + this._decimalPipe.transform(pricecal, '1.2-2');

    obj['total'] = this._decimalPipe.transform(pricecal, '1.2-2');

    //this.consoleMessage(obj1)

    obj['skuTotalPrice'] = parseFloat(obj1.products.reduce(
      (acc: any, calculatedTax: any) => {
        return acc + calculatedTax.total;
      },
      0
    ))

    let updatedSum = this.addtosum(obj.totalPrice);
    this.planssummarymain = [];
    this.planssummaryopt = [];

    planSummary.forEach((element: any) => {
      if (element.packagename != 'Opt-in') {
        this.planssummarymain.push(element);
      } else {
        this.planssummaryopt.push(element);
      }
    });

    this.plansskumain.push(obj1);

    sessionStorage.setItem('plansskumain', JSON.stringify(this.plansskumain));
    console.log("setting here");
    sessionStorage.setItem(
      'plansummarymain',
      JSON.stringify(this.planssummarymain)
    );
    sessionStorage.setItem(
      'plansummaryopt',
      JSON.stringify(this.planssummaryopt)
    );

    sessionStorage.setItem('plansummary', JSON.stringify(planSummary));
    let planSummaryData = JSON.parse(sessionStorage.getItem('plansummaryLife') || '[]');

    // if (planSummary.length > 0 || planSummaryData.length > 0) {
    //   this.plansnexttab = false;

    // } else {
    //   this.plansnexttab = true;
    // }
    if (updatedSum > 0) {
      this.cartcheckvalue = false;
    } else {
      this.cartcheckvalue = true;
    }

    setTimeout(() => {

      this.planssummarymain = JSON.parse(
        sessionStorage.getItem('plansummarymain') || '[]'
      );
      console.log(this.planssummarymain)
      var total = 0;
      for (let i = 0; i < this.planssummarymain.length; i++) {
        if (obj.planproductname.includes("La Vie")) {

          if (this.planssummarymain[i].planLevel == 18) {

            if (this.planssummarymain[i].coverage == obj.coverage) {

            } else {
              const dom: HTMLElement = this.elementRef.nativeElement;
              // const plan: any = dom.querySelector(`#plancheck792`)
              const plan: any = dom.querySelector("#plancheck2792" + ".coverage" + obj.coverage);
              setTimeout(() => {
                plan.click()
                // this.toastrService.success("La Vie plan selection automatically includes Complete Executive Care plan", "");
              }, 1000);
            }
            break;
          }
          else {

            const dom: HTMLElement = this.elementRef.nativeElement;
            // const plan: any = dom.querySelector(`#plancheck792`)
            const plan: any = dom.querySelector("#plancheck2792" + ".coverage" + obj.coverage);

            console.log(plan)
            setTimeout(() => {
              plan.click()
              // this.toastrService.success("La Vie plan selection automatically includes Complete Executive Care plan", "");
            }, 1000);
          }
        }
      }

      for (let i = 0; i < this.planssummarymain.length; i++) {

        total += parseFloat(this.planssummarymain[i].skuTotalPrice);
      }

      //this.consoleMessage(total);

      this.planAmount = this._decimalPipe
        .transform(total, '1.2-2')
        ?.replace(/,/g, '');
      sessionStorage.setItem('totalAmount', this.planAmount);

      if (this.planAmount > 0) {
        this.cartcheckvalue = false;
      } else {
        this.cartcheckvalue = true;
      }




      // here we can call the select plans one sudeep
    }, 100);
  }


  public addtoplansummary(obj: any, obj1: any) {
    this._LoaderService.ShowLoader()
    let planSummary = JSON.parse(sessionStorage.getItem('plansummary') || '[]');

    //  console.log(obj1);
    // console.log(planSummary);
    // console.log('addroplansummaryplans');
    // console.log(planSummary.length);
    // console.log(obj.id);
    // console.log(obj);

    this.addtoslectplans(obj.id, planSummary.length);
    planSummary.push(obj);
    this.getPlanSummaryObject()

    let gstprice = 0;
    let hstprice = 0;
    let pstprice = 0;
    let qstprice = 0;

    if (obj.gst > 0) {
      gstprice = obj.planPrice * obj.gst;
      obj['gstPrice'] = gstprice
        ? this._decimalPipe.transform(gstprice, '1.2-2')
        : 0;
      obj['gstPrice'] = parseFloat(obj['gstPrice']);
    } else {
      obj['gstPrice'] = 0;
    }

    if (obj.hst > 0) {
      hstprice = obj.planPrice * obj.hst;

      obj['hstPrice'] = hstprice
        ? this._decimalPipe.transform(gstprice, '1.2-2')
        : 0;
      obj['hstPrice'] = parseFloat(obj['hstPrice']);
    } else {
      obj['hstPrice'] = 0;
    }

    if (obj.pst > 0) {
      pstprice = obj.planPrice * obj.pst;
      obj['pstPrice'] = pstprice
        ? this._decimalPipe.transform(pstprice, '1.2-2')
        : 0;
      obj['pstPrice'] = parseFloat(obj['pstPrice']);
    } else {
      obj['pstPrice'] = 0;
    }

    if (obj.qst > 0) {
      qstprice = obj.planPrice * obj.qst;

      obj['qstPrice'] = qstprice
        ? this._decimalPipe.transform(qstprice, '1.2-2')
        : 0;
      obj['qstPrice'] = parseFloat(obj['qstPrice']);
    } else {
      obj['qstPrice'] = 0;
    }

    obj['taxUI'] = '';
    if (obj['gstCheck']) {
      obj['taxUI'] += '<span>';
      if (obj['gstPrice'] == 0) {
        obj['taxUI'] += '-';
      } else {
        obj['taxUI'] +=
          '$' +
          this._decimalPipe.transform(obj['gstPrice'], '1.2-2') +
          '&nbsp;(GST)';
      }
      obj['taxUI'] += '</span>';
    }

    if (obj['pstCheck']) {
      obj['taxUI'] += '<span>';
      if (obj['pstPrice'] == 0) {
        obj['taxUI'] += '-';
      } else {
        obj['taxUI'] +=
          '$' +
          this._decimalPipe.transform(obj['pstPrice'], '1.2-2') +
          '&nbsp;(PST)';
      }
      obj['taxUI'] += '</span>';
    }

    if (obj['qstCheck']) {
      obj['taxUI'] += '<span>';
      if (obj['qstPrice'] == 0) {
        obj['taxUI'] += '-';
      } else {
        obj['taxUI'] +=
          '$' +
          this._decimalPipe.transform(obj['qstPrice'], '1.2-2') +
          '&nbsp;(QST)';
      }
      obj['taxUI'] += '</span>';
    }

    if (obj['hstCheck']) {
      obj['taxUI'] += '<span> ';
      if (obj['hstPrice'] == 0) {
        obj['taxUI'] += '-';
      } else {
        obj['taxUI'] +=
          '$' +
          this._decimalPipe.transform(obj['hstPrice'], '1.2-2') +
          '&nbsp;(HST)';
      }
      obj['taxUI'] += '</span>';
    }

    if (
      !obj['hstCheck'] &&
      !obj['gstCheck'] &&
      !obj['pstCheck'] &&
      !obj['qstCheck']
    ) {
      obj['taxUI'] += '<span>-';

      obj['taxUI'] += '</span>';
    }

    // ////this.consoleMessage(object["taxUI"])

    obj['tax'] = obj1.products
      ? this._decimalPipe.transform(
        obj1.products?.reduce((acc: any, calculatedTax: any) => {
          return acc + calculatedTax.tax;
        }, 0),
        '1.2-2'
      )
      : 0;
    obj['tax'] = parseFloat(obj['tax']);

    // obj["products"] =obj1
    obj['coverage'] = obj1.coverage;
    obj['planCoverage'] = obj1.planCoverage;
    obj['planLevelParent'] = obj1.planLevelParent;
    obj['planproductname'] = obj1.planproductname;

    obj['products'] = obj1.products;

    //this.consoleMessage(obj.planPrice)
    //this.consoleMessage(gstprice)
    //this.consoleMessage(hstprice)
    //this.consoleMessage(pstprice)

    //this.consoleMessage(qstprice)
    let pricecal = obj1.products.reduce((acc: any, calculatedTax: any) => {
      return acc + calculatedTax.total;
    }, 0);
    obj['totalPrice'] = parseFloat(pricecal);

    obj['totalUI'] = '$' + this._decimalPipe.transform(pricecal, '1.2-2');

    obj['total'] = this._decimalPipe.transform(pricecal, '1.2-2');

    //this.consoleMessage(obj1)

    obj['skuTotalPrice'] = parseFloat(obj1.products.reduce(
      (acc: any, calculatedTax: any) => {
        return acc + calculatedTax.total;
      },
      0
    ))

    let updatedSum = this.addtosum(obj.totalPrice);
    this.planssummarymain = [];
    this.planssummaryopt = [];

    planSummary.forEach((element: any) => {
      if (element.packagename != 'Opt-in') {
        this.planssummarymain.push(element);
      } else {
        this.planssummaryopt.push(element);
      }
    });

    this.plansskumain.push(obj1);

    sessionStorage.setItem('plansskumain', JSON.stringify(this.plansskumain));
    console.log("setting here");
    sessionStorage.setItem(
      'plansummarymain',
      JSON.stringify(this.planssummarymain)
    );
    sessionStorage.setItem(
      'plansummaryopt',
      JSON.stringify(this.planssummaryopt)
    );

    sessionStorage.setItem('plansummary', JSON.stringify(planSummary));
    let planSummaryData = JSON.parse(sessionStorage.getItem('plansummaryLife') || '[]');

    // if (planSummary.length > 0 || planSummaryData.length > 0) {
    //   this.plansnexttab = false;

    // } else {
    //   this.plansnexttab = true;
    // }
    if (updatedSum > 0) {
      this.cartcheckvalue = false;
    } else {
      this.cartcheckvalue = true;
    }

    setTimeout(() => {

      this.planssummarymain = JSON.parse(
        sessionStorage.getItem('plansummarymain') || '[]'
      );
      console.log(this.planssummarymain)
      var total = 0;
      for (let i = 0; i < this.planssummarymain.length; i++) {
        if (obj.planproductname.includes("La Vie")) {
          console.log(this.planssummarymain[i].planLevel, "assssiiiooo")
          if (this.planssummarymain[i].planLevel == 18) {

            if (this.planssummarymain[i].coverage == obj.coverage) {

            } else {
              const dom: HTMLElement = this.elementRef.nativeElement;
              // const plan: any = dom.querySelector(`#plancheck792`)
              // const plan: any = dom.querySelector("#plancheck792" + ".coverage" + obj.coverage);
              console.log(dom.querySelector("#plancheck792" + ".coverage" + obj.coverage), "iiiooooouu")
              $("#plancheck792" + ".coverage" + obj.coverage.toUpperCase()).click()
            }
            break;
          }
          else {

            // const dom: HTMLElement = this.elementRef.nativeElement;
            // // const plan: any = dom.querySelector(`#plancheck792`)
            // const plan: any = dom.querySelector("#plancheck792" + ".coverage" + obj.coverage);

            console.log(obj.coverage, "ioasaddahhdh", $("#plancheck792" + ".coverage" + obj.coverage.toUpperCase()))
            setTimeout(() => {
              $("#plancheck792" + ".coverage" + obj.coverage.toUpperCase()).click()
              // this.toastrService.success("La Vie plan selection automatically includes Complete Executive Care plan", "");
            }, 1000);
          }
        }
      }

      for (let i = 0; i < this.planssummarymain.length; i++) {

        total += parseFloat(this.planssummarymain[i].skuTotalPrice);
      }

      //this.consoleMessage(total);

      this.planAmount = this._decimalPipe
        .transform(total, '1.2-2')
        ?.replace(/,/g, '');
      sessionStorage.setItem('totalAmount', this.planAmount);

      if (this.planAmount > 0) {
        this.cartcheckvalue = false;
      } else {
        this.cartcheckvalue = true;
      }



      this.showPlanDetails = false;
      this.showAfterPlanDetails = true;
      this._LoaderService.hide()
      // here we can call the select plans one sudeep
    }, 100);
  }

  // Function to remove duplicates based on a unique identifier (e.g., 'id')
  removeDuplicates(arr, key) {
    if (!arr || arr == undefined) return;
    let result: any = [];
    if (Array.isArray(arr)) {
      result = arr?.filter((value, index, self) =>
        index === self.findIndex((t) => (
          t[key] === value[key]  // Filtering by 'id'
        ))
      );
    }
    return result;
  }




  public addtosum_v2(amount: any) {


    console.log("addtosum" + amount)

    // amount = Math.round((amount + Number.EPSILON) * 100) / 100;

    let selectedPlansAmount = parseFloat(sessionStorage.getItem("totalAmount") || "0.00")

    selectedPlansAmount = selectedPlansAmount + parseFloat(amount)

    console.log("selectedPlansAmount" + selectedPlansAmount)
    sessionStorage.setItem("totalAmount", this._decimalPipe.transform(selectedPlansAmount, "1.2-2")?.replace(/,/g, "") ?? "")

    sessionStorage.setItem(
      "totalAmountUI",
      "$" + this._decimalPipe.transform(selectedPlansAmount, "1.2-2")?.replace(/,/g, "")
    );



    this.planAmount = this._decimalPipe.transform(selectedPlansAmount, "1.2-2")?.replace(/,/g, "")


    return selectedPlansAmount


  }

  public removetosum_v2(amount: number) {

    let selectedPlansAmount = parseFloat(sessionStorage.getItem("totalAmount")?.replace(/,/g, "") ?? "")


    selectedPlansAmount = selectedPlansAmount - amount
    sessionStorage.setItem("totalAmount", this._decimalPipe.transform(selectedPlansAmount, "1.2-2")?.replace(/,/g, "") ?? "")
    sessionStorage.setItem(
      "totalAmountUI",
      "$" + this._decimalPipe.transform(selectedPlansAmount, "1.2-2")?.replace(/,/g, "")
    );


    this.planAmount = this._decimalPipe.transform(selectedPlansAmount, "1.2-2")?.replace(/,/g, "")
    return selectedPlansAmount

  }


  public capitalizeFirstLetter(str: string): string {
    if (str) {
      return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    }
    return ''; // Return an empty string if the input is falsy (null, undefined, or empty)
  }

  public addtosum(amount: any) {
    //this.consoleMessage("addtosum"+amount)

    // amount = Math.round((amount + Number.EPSILON) * 100) / 100;

    let selectedPlansAmount = parseFloat(
      sessionStorage.getItem('totalAmount') || '0.00'
    );

    selectedPlansAmount = selectedPlansAmount + parseFloat(amount);

    //this.consoleMessage("selectedPlansAmount"+selectedPlansAmount)
    sessionStorage.setItem(
      'totalAmount',
      this._decimalPipe
        .transform(selectedPlansAmount, '1.2-2')
        ?.replace(/,/g, '') ?? '0'
    );

    sessionStorage.setItem(
      'totalAmountUI',
      '$' +
      this._decimalPipe
        .transform(selectedPlansAmount, '1.2-2')
        ?.replace(/,/g, '')
    );

    this.planAmount = this._decimalPipe
      .transform(selectedPlansAmount, '1.2-2')
      ?.replace(/,/g, '');

    return selectedPlansAmount;
  }

  public removetosum(amount: number) {
    let selectedPlansAmount = parseFloat(
      sessionStorage.getItem('totalAmount')?.replace(/,/g, '') ?? '0'
    );

    selectedPlansAmount = selectedPlansAmount - amount;
    sessionStorage.setItem(
      'totalAmount',
      this._decimalPipe
        .transform(selectedPlansAmount, '1.2-2')
        ?.replace(/,/g, '') ?? '0'
    );
    sessionStorage.setItem(
      'totalAmountUI',
      '$' +
      this._decimalPipe
        .transform(selectedPlansAmount, '1.2-2')
        ?.replace(/,/g, '')
    );

    this.planAmount = this._decimalPipe
      .transform(selectedPlansAmount, '1.2-2')
      ?.replace(/,/g, '');
    return selectedPlansAmount;
  }

  public addtoslectplans_v2(planid: number, plansumamryindex: number) {

    //console.log("beforeaddtoplans")
    //console.log(planid)
    //console.log(plansumamryindex)
    let selectedPlans = JSON.parse(sessionStorage.getItem("selectedPlans") || "{}")
    //console.log(selectedPlans)
    selectedPlans[planid] = plansumamryindex
    //console.log("afteraddtoplans")
    //console.log(selectedPlans)
    sessionStorage.setItem("selectedPlans", JSON.stringify(selectedPlans))

  }

  public addtoslectplans(planid: number, plansumamryindex: number) {
    ////this.consoleMessage("beforeaddtoplans")
    ////this.consoleMessage(planid)
    ////this.consoleMessage(plansumamryindex)
    let selectedPlans = JSON.parse(
      sessionStorage.getItem('selectedPlans') || '{}'
    );
    ////this.consoleMessage(selectedPlans)
    selectedPlans[planid] = plansumamryindex;
    ////this.consoleMessage("afteraddtoplans")
    ////this.consoleMessage(selectedPlans)
    sessionStorage.setItem('selectedPlans', JSON.stringify(selectedPlans));
  }

  public removeslectplans_v2(planid: number, plansumamryindex: number) {


    //console.log("beforeremoveplans")
    let selectedPlans = JSON.parse(sessionStorage.getItem("selectedPlans") ?? "")

    //console.log(selectedPlans)
    delete selectedPlans[planid]




    for (const planid in selectedPlans) {

      //console.log(planid)
      //console.log(selectedPlans[planid])

      if (selectedPlans[planid] != 0) {
        selectedPlans[planid] = selectedPlans[planid] - 1
        if (selectedPlans[planid]) {

        }
      }
    }
    //console.log("adjustedselectedPlans")
    //console.log(selectedPlans)
    sessionStorage.setItem("selectedPlans", JSON.stringify(selectedPlans))


  }

  public removeslectplans(planid: number, plansumamryindex: number) {
    ////this.consoleMessage("beforeremoveplans")
    let selectedPlans = JSON.parse(
      sessionStorage.getItem('selectedPlans') || '{}'
    );

    ////this.consoleMessage(selectedPlans)
    delete selectedPlans[planid];

    for (const planid in selectedPlans) {
      ////this.consoleMessage(planid)
      ////this.consoleMessage(selectedPlans[planid])

      if (selectedPlans[planid] != 0) {
        selectedPlans[planid] = selectedPlans[planid] - 1;
        if (selectedPlans[planid]) {
        }
      }
    }
    ////this.consoleMessage("adjustedselectedPlans")
    ////this.consoleMessage(selectedPlans)
    sessionStorage.setItem('selectedPlans', JSON.stringify(selectedPlans));
  }

  public getslectedplans_v2(planid: number) {
    //console.log(planid)
    let selectedPlans = JSON.parse(sessionStorage.getItem("selectedPlans") || "{}")
    //console.log(selectedPlans)
    return selectedPlans[planid]


  }


  public getslectedplans(planid: number) {
    ////this.consoleMessage(planid)
    let selectedPlans = JSON.parse(
      sessionStorage.getItem('selectedPlans') || '{}'
    );
    ////this.consoleMessage(selectedPlans)
    return selectedPlans[planid];
  }

  public openplanoptions(elementcv, options, plan, product) {
    let plandetails = elementcv.attributes.data.value;

    let plandetailsobj = plandetails.split("##");


    let modifiedOptions: any = [];


    // this.plandetailsobjvalue = plandetailsobj;
    console.log(plandetails)
    console.log(product.id)

    this.plandetailsobjvalue = plandetails;


    options.forEach((element) => {
      element.planOptionsValues.forEach((options) => {
        options.planOptionName = element.name;
        options.json = JSON.stringify(options);
      });

      modifiedOptions.push(element);
    });

    this.optionstitle = modifiedOptions;
    this.showoptions = true;
    // alert("startrhetre")
    setTimeout(() => {
      $('#showplanoptions-modal').show()

    }, 1000);


  }


  getplansData() {
    if (this.addPlanForm.invalid) {
      this.addPlanForm.markAllAsTouched()
      return;
    }
    this.addPlanEnrollmentDate = moment(this.addPlanForm.value.planEnrollmentDate).format('DD-MM-YYYY') || ""
    const payload = {
      enrollmentDate: this.addPlanEnrollmentDate,
      removeRoleBasedPlans: false,
      spouseCovered: this.spouseCovered,
      childCovered: this.childCovered
    }
    $("#addPlanFormModal").hide()
    this.addPlanForm.reset();

    $("#planDetails").show()
    let plans = '/member/' + this.customerid + '/customerPlans';
    if (this.dependentType == 'spouse' || this.dependentType == 'multiple') {
      this.http.post(api.url + '/api/ap' + plans, payload, {
        headers: {
          Authorization: 'Bearer ' + this.accessToken,
          'Content-Type': 'application/json',
        }
      }).subscribe((response: any) => {
        // console.log(response)
        if (response.status == 200) {
          this.specialpackages = response.data.packages
          // this.customerPlans
          // $("#plancheck" + plandetailsobj[19]).click()

          console.log("called")


          for (let package_ of this.specialpackages) {
            console.log(package_, 'asdaas2')
            let groupKeys_ = Object.keys(package_.groups);
            for (let groups of groupKeys_) {
              for (let group of package_.groups[groups]) {
                for (let plan of group.plans) {


                  //filter the downgrade and the selected plans

                  if (plan.selected) {
                    let pan = plan.productAddonssNames
                    for (let product of plan.productAddonssNames) {
                      if (plan.productAddonss[product]) {
                        const paon = plan.productAddonss[product]
                        for (const paon_ of paon) {
                          if (paon_.selected == true) {
                            this.selectedPlans_.push(paon_);
                          }
                        }
                      }
                    }
                  }

                  if (!plan.selected) {
                    let pan = plan.productAddonssNames
                    for (let product of plan.productAddonssNames) {
                      if (plan.productAddonss[product]) {
                        const paon = plan.productAddonss[product]
                        for (const paon_ of paon) {
                          this.downgradePlans.push(paon_);
                        }
                      }
                    }
                  }



                }
              }
            }
          }
          let filteredPackages_: any = [];
          //filter the repeated packages for medcan care
          for (let package_ of this.specialpackages) {
            if (package_.id == 5) {
              let groupKeys_ = Object.keys(package_.groups);
              for (let groups of groupKeys_) {
                for (let group of package_.groups[groups]) {
                  for (let plan of group.plans) {
                    let pan = plan.productAddonssNames
                    for (let product of plan.productAddonssNames) {
                      // plan.productAddonss[product][0]?.planlevel.id, plan.productAddonss[product][0].product_id
                      if (filteredPackages_[product]) {
                        if (filteredPackages_[product]['planProductIds']?.includes(plan.productAddonss[product][0]?.planlevel.id) && filteredPackages_[product]['planProductIds'].includes(plan.productAddonss[product][0].product_id)) {
                          let index = pan.indexOf(product);
                          if (index !== -1) {
                            pan.splice(index, 1);
                          }
                        }
                      } else {
                        filteredPackages_[product] = { 'planProductIds': [] }
                        filteredPackages_[product]['planProductIds'] = [plan.productAddonss[product][0]?.planlevel.id, plan.productAddonss[product][0].product_id]
                      }
                    }

                    plan.productAddonssNames = pan;
                  }
                }
              }
            }

          }

          // console.log(this.specialpackages)
        }
        else {
          Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: response.message })
        }
      }, (error) => {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: error.error.error.message })
      });
    } else {
      this.specialpackages = []
    }
  }




  public unselectplan_v2(elementcv: any) {



    let plandetails = elementcv.attributes.data.value;

    let plandetailsobj = plandetails.split("##");
    let obj = {
      enrollmentDate: "",
      // "name":plandetailsobj[1]+"-"+plandetailsobj[2],
      name: plandetailsobj[14],
      details: plandetailsobj[0],
      packagename: plandetailsobj[0],
      groupName: plandetailsobj[1],
      amount: parseFloat(plandetailsobj[3]),
      planCoverage: plandetailsobj[2],
      planPrice: parseFloat(plandetailsobj[3]),
      amountUI:
        "$" + this._decimalPipe.transform(plandetailsobj[3], "1.2-2"),
      gst:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == "" ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == "null"
          ? 0
          : parseFloat(plandetailsobj[4]),
      hst:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == "" ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == "null"
          ? 0
          : parseFloat(plandetailsobj[5]),
      pst:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == "" ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == "null"
          ? 0
          : parseFloat(plandetailsobj[6]),
      qst:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == "" ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == "null"
          ? 0
          : parseFloat(plandetailsobj[17]),
      gstCheck:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == "" ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == "null"
          ? false
          : true,
      hstCheck:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == "" ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == "null"
          ? false
          : true,
      pstCheck:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == "" ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == "null"
          ? false
          : true,
      qstCheck:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == "" ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == "null"
          ? false
          : true,
      id: parseFloat(plandetailsobj[7]),
      fusebillPlanID:
        plandetailsobj[8] == null ||
          plandetailsobj[8] == "" ||
          plandetailsobj[8] == undefined ||
          plandetailsobj[8] == "null"
          ? 0
          : parseFloat(plandetailsobj[8]),
      planFrequencyID:
        plandetailsobj[9] == null ||
          plandetailsobj[9] == "" ||
          plandetailsobj[9] == undefined ||
          plandetailsobj[9] == "null"
          ? 0
          : parseFloat(plandetailsobj[9]),
      optIn: plandetailsobj[10] == "true" ? true : false,
      planname: plandetailsobj[14],
      planLevel: parseInt(plandetailsobj[15]),
      packageId: parseInt(plandetailsobj[16]),
      options: [],
      //  "disallowedPlanLevels":plandetailsobj[11]
    };
    if (plandetailsobj[11] != null || plandetailsobj[11] != "null") {
      if (plandetailsobj[11].includes(plandetailsobj[12])) {

      }
    }

    // let planPrice = parseFloat(obj.amount.toString().replace(/,/g, '')); // Ensure the amount is a valid float value
    // this.totalSummaryPrice -= planPrice; // Subtract from totalSummaryPrice

    this.removeplansummary(obj)


  }

  public unselectplan(
    elementcv: any,
    options: any,
    plan: any,
    product: any,
    pckage: any,
    group: any,
    disallowedPlanLevels: any
  ) {
    console.log(elementcv, "unselected")

    // this.planCoverageName = ''
    // this.insuranceplanid =''

    let plandetails = elementcv.attributes.data.value;

    let plandetailsobj = plandetails.split('##');
    let obj = {
      // enrollmentDate: moment(
      //   this.userForm.get("planenrollmentdate").value,
      //   "MM-DD-YYYY"
      // ).format("YYYY-MM-DD"),
      enrollmentDate: this.dependentTypeForm.get('effectiveDate')?.value
        ? this._CustomDatePipe.transform(this.dependentTypeForm.get('effectiveDate')?.value)
        : undefined,
      // "name":plandetailsobj[1]+"-"+plandetailsobj[2],
      name: plandetailsobj[14],
      details: plandetailsobj[0],
      packagename: plandetailsobj[0],
      groupName: plandetailsobj[1],
      amount: parseFloat(plandetailsobj[3]),
      planCoverage: plandetailsobj[2],
      planPrice: parseFloat(plandetailsobj[3]),
      amountUI: '$' + this._decimalPipe.transform(plandetailsobj[3], '1.2-2'),
      gst:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == '' ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == 'null'
          ? 0
          : parseFloat(plandetailsobj[4]),
      hst:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == '' ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == 'null'
          ? 0
          : parseFloat(plandetailsobj[5]),
      pst:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == '' ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == 'null'
          ? 0
          : parseFloat(plandetailsobj[6]),
      qst:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == '' ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == 'null'
          ? 0
          : parseFloat(plandetailsobj[17]),
      gstCheck:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == '' ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == 'null'
          ? false
          : true,
      hstCheck:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == '' ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == 'null'
          ? false
          : true,
      pstCheck:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == '' ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == 'null'
          ? false
          : true,
      qstCheck:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == '' ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == 'null'
          ? false
          : true,
      id: parseFloat(plandetailsobj[7]),
      fusebillPlanID:
        plandetailsobj[8] == null ||
          plandetailsobj[8] == '' ||
          plandetailsobj[8] == undefined ||
          plandetailsobj[8] == 'null'
          ? 0
          : parseFloat(plandetailsobj[8]),
      planFrequencyID:
        plandetailsobj[9] == null ||
          plandetailsobj[9] == '' ||
          plandetailsobj[9] == undefined ||
          plandetailsobj[9] == 'null'
          ? 0
          : parseFloat(plandetailsobj[9]),
      optIn: plandetailsobj[10] == 'true' ? true : false,
      planname: plandetailsobj[14],
      planLevel: parseInt(plandetailsobj[15]),
      packageId: parseInt(plandetailsobj[16]),
      options: [],
      //  "disallowedPlanLevels":plandetailsobj[11]
    };
    if (plandetailsobj[11] != null || plandetailsobj[11] != 'null') {
      if (plandetailsobj[11].includes(plandetailsobj[12])) {
      }
    }

    let coverage = product.planCoverage;

    coverage = ['SINGLE', 'COUPLE', 'FAMILY'].includes(coverage)
      ? coverage
      : null;
    ////this.consoleMessage(obj)
    this.productobj = {
      id: product.id,
      productId: product.productId,
      name: product.name,
      planProductId: product.planProductId,
      price: this._decimalPipe
        .transform(product.price1 || product.price, '1.2-2')
        ?.replace(/,/g, ''),
      tax: this._decimalPipe
        .transform(
          product.calculatedTax ? product.calculatedTax.tax : 0,
          '1.2-2'
        )
        ?.replace(/,/g, ''),
      total: this._decimalPipe
        .transform(
          product.calculatedTax ? product.calculatedTax.total : 0,
          '1.2-2'
        )
        ?.replace(/,/g, ''),
      tax_details:
        product.bundledTaxes && product.bundledTaxes.length > 0
          ? product.bundledTaxes
          : product.taxesDataJSON,
      calculatedTax: product.calculatedTax,
      bundledProducts: product.bundledProducts,
      planCoverage: product.planCoverage,
      planLevel: product.planlevel ? product.planlevel.id : '',
      planLevelParent: product.planlevel ? product.planlevel.parentId : '',
      description: product.description,
      coverage: coverage,
    };

    let obj1: any = {
      packageId: plan.packageId,
      packageName: pckage.name,

      planproductname: this.productobj.name,

      groupid: plan.planLevel,
      groupName: group.name,
      id: plan.id,
      name: plan.name,
      planLevel: plan.planLevel ? plan.planLevel : group.id,
      planLevelParent: group.parentId,
      fusebillPlanID: plan.fusebillId,
      planFrequencyID: plan.frqMonthly,
      isBundle: plan.isBundle,
      coverage: coverage,
      planCoverage: product.planCoverage,
      bundledProducts: [],
      products: [],
    };
    obj1.products.push(this.productobj);

    this.handleDisableCheckAndUnCheck(true, false, obj)
    this.removeplansummary(obj);
    setTimeout(() => {

      // this.openplanoptions(elementcv)


    }, 1000);
  }


  public handleDisableCheckAndUnCheck_v2(unchecked: any, checked: any, obj: any) {
    console.log(obj)

    let planSummary = JSON.parse(sessionStorage.getItem('plansummary') || '[]');

    if (obj.planLevel == 15) {
      for (let i = 0; i < planSummary.length; i++) {

        if (planSummary[i].planLevel == 18) {
          planSummary[i].options = []
        }

      }

    }


    if (planSummary && planSummary.length > 0) {
      ////this.consoleMessage("removeinplanid"+obj.id)
      let index: any = this.getslectedplans(obj.id);
      console.log(index)
      console.log(planSummary)

      if (index > -1) {
        // console.log(index);
        let element = planSummary[index];
        if (element.isBundle) {

          $("#plancheck2" + element.id + ".coverage" + element.coverage.toUpperCase()).prop("disabled", false);
          console.log($("#2" + element.id + ".coverage" + element.coverage.toUpperCase()), "called3322")

        }
        else {
          console.log(element?.coverage, "after else")
          if (element?.coverage) {
            // const plan: any = dom.querySelector("#plancheck" + element.planSelectionId2 + ".coverage" + element.coverage.toUpperCase());

            // $("#plancheck" + element.planSelectionId2 + ".coverage"+element.coverage).click()
            $("#plancheck2" + element.id + ".coverage" + element.coverage.toUpperCase()).prop("disabled", false);
          }
          else {
            // check here once
            $("#plancheck2" + element.id).prop("disabled", false);

          }
        }

      } else {
        return;
      }
    }

  }

  public handleDisableCheckAndUnCheck(unchecked: any, checked: any, obj: any) {
    console.log(obj)

    let planSummary = JSON.parse(sessionStorage.getItem('plansummary') || '[]');

    if (obj.planLevel == 15) {
      for (let i = 0; i < planSummary.length; i++) {

        if (planSummary[i].planLevel == 18) {
          planSummary[i].options = []
        }

      }

    }


    if (planSummary && planSummary.length > 0) {
      ////this.consoleMessage("removeinplanid"+obj.id)
      let index: any = this.getslectedplans(obj.id);
      console.log(index)
      console.log(planSummary)

      if (index > -1) {
        // console.log(index);
        let element = planSummary[index];
        if (element.isBundle) {

          $("#plancheck" + element.id + ".coverage" + element.coverage.toUpperCase()).prop("disabled", false);
          console.log($("#plancheck" + element.id + ".coverage" + element.coverage.toUpperCase()), "called3322")

        }
        else {
          console.log(element?.coverage, "after else")
          if (element?.coverage) {
            // const plan: any = dom.querySelector("#plancheck" + element.planSelectionId2 + ".coverage" + element.coverage.toUpperCase());

            // $("#plancheck" + element.planSelectionId2 + ".coverage"+element.coverage).click()
            $("#plancheck" + element.id + ".coverage" + element.coverage.toUpperCase()).prop("disabled", false);
          }
          else {
            // check here once
            $("#plancheck" + element.id).prop("disabled", false);

          }
        }

      } else {
        return;
      }
    }

  }

  public unselectplan_v3(elementcv: any) {

    // this.planCoverageName = ''
    // this.insuranceplanid =''

    let plandetails = elementcv.attributes.data.value;

    let plandetailsobj = plandetails.split('##');
    let obj = {
      // enrollmentDate: moment(
      //   this.userForm.get("planenrollmentdate").value,
      //   "MM-DD-YYYY"
      // ).format("YYYY-MM-DD"),
      enrollmentDate: this.dependentTypeForm.get('effectiveDate')?.value
        ? this._CustomDatePipe.transform(this.dependentTypeForm.get('effectiveDate')?.value)
        : undefined,
      // "name":plandetailsobj[1]+"-"+plandetailsobj[2],
      name: plandetailsobj[14],
      details: plandetailsobj[0],
      packagename: plandetailsobj[0],
      groupName: plandetailsobj[1],
      amount: parseFloat(plandetailsobj[3]),
      planCoverage: plandetailsobj[2],
      planPrice: parseFloat(plandetailsobj[3]),
      amountUI: '$' + this._decimalPipe.transform(plandetailsobj[3], '1.2-2'),
      gst:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == '' ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == 'null'
          ? 0
          : parseFloat(plandetailsobj[4]),
      hst:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == '' ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == 'null'
          ? 0
          : parseFloat(plandetailsobj[5]),
      pst:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == '' ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == 'null'
          ? 0
          : parseFloat(plandetailsobj[6]),
      qst:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == '' ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == 'null'
          ? 0
          : parseFloat(plandetailsobj[17]),
      gstCheck:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == '' ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == 'null'
          ? false
          : true,
      hstCheck:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == '' ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == 'null'
          ? false
          : true,
      pstCheck:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == '' ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == 'null'
          ? false
          : true,
      qstCheck:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == '' ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == 'null'
          ? false
          : true,
      id: parseFloat(plandetailsobj[7]),
      fusebillPlanID:
        plandetailsobj[8] == null ||
          plandetailsobj[8] == '' ||
          plandetailsobj[8] == undefined ||
          plandetailsobj[8] == 'null'
          ? 0
          : parseFloat(plandetailsobj[8]),
      planFrequencyID:
        plandetailsobj[9] == null ||
          plandetailsobj[9] == '' ||
          plandetailsobj[9] == undefined ||
          plandetailsobj[9] == 'null'
          ? 0
          : parseFloat(plandetailsobj[9]),
      optIn: plandetailsobj[10] == 'true' ? true : false,
      planname: plandetailsobj[14],
      planLevel: parseInt(plandetailsobj[15]),
      packageId: parseInt(plandetailsobj[16]),
      options: [],
      //  "disallowedPlanLevels":plandetailsobj[11]
    };
    if (plandetailsobj[11] != null || plandetailsobj[11] != 'null') {
      if (plandetailsobj[11].includes(plandetailsobj[12])) {
      }
    }
    this.handleDisableCheckAndUnCheck_v2(true, false, obj)
    this.removeplansummary_v3(obj);
    setTimeout(() => {


      // this.openplanoptions(elementcv)


    }, 1000);
  }

  public removeplansummary_v2(obj: any) {

    // let planSummary = JSON.parse(sessionStorage.getItem("plansummary") ?? "")

    let planSummary: any = sessionStorage.getItem("plansummary");
    if (planSummary) {
      planSummary = JSON.parse(planSummary);
    } else {
      planSummary = {}; // Set a default value if the session storage is empty or null
    }
    console.log({ planSummary });

    //  //console.log("Beforeremoving")
    //console.log(planSummary)
    //console.log("removeingobject")
    //console.log(obj)


    // //console.log(obj.name)


    if (planSummary) {
      //console.log("removeinplanid"+obj.id)
      let index = this.getslectedplans(obj.id)
      //console.log(index)

      if (index > -1) {
        // planSummary.splice(index, 1)
        if (Array.isArray(planSummary)) {
          planSummary?.splice(0, 1); // example operation, remove first element
        } else {
          console.log("planSummary is not an array!");
        }
        //console.log("afterremove")
        //console.log(planSummary)
      }
      else {
        return
      }

      // //console.log(planSummary)
      // //console.log(planSummary.length)
      //console.log("beforeremoveplans")
      let selectedPlans = JSON.parse(sessionStorage.getItem("selectedPlans") ?? "")
      var newselectedplans = {}
      for (var i = 0; i < planSummary.length; i++) {
        newselectedplans[planSummary[i].id] = i

      }

      //console.log("newselectedPlans")
      //console.log(newselectedplans)
      sessionStorage.setItem("selectedPlans", JSON.stringify(newselectedplans))
      // this.removeslectplans(obj.id,planSummary.length)

      let gstprice = 0;
      let hstprice = 0;
      let pstprice = 0;
      let qstprice = 0;

      if (obj.gst > 0) {
        gstprice = obj.planPrice * obj.gst;
        obj["gstPrice"] = parseFloat(
          this._decimalPipe.transform(gstprice, "1.2-2") ?? ""
        );
      } else {
        obj["gstPrice"] = 0;
      }

      if (obj.hst > 0) {
        hstprice = obj.planPrice * obj.hst;

        obj["hstPrice"] = parseFloat(
          this._decimalPipe.transform(hstprice, "1.2-2") ?? ""
        );
      } else {
        obj["hstPrice"] = 0;
      }

      if (obj.pst > 0) {
        pstprice = obj.planPrice * obj.pst;
        obj["pstPrice"] = parseFloat(
          this._decimalPipe.transform(pstprice, "1.2-2") ?? ""
        );
      } else {
        obj["pstPrice"] = 0;
      }
      if (obj.qst > 0) {
        qstprice = obj.planPrice * obj.qst;
        obj["qstPrice"] = parseFloat(
          this._decimalPipe.transform(qstprice, "1.2-2") ?? ""
        );
      } else {
        obj["qstPrice"] = 0;
      }

      obj["taxUI"] = "";
      if (obj["gstCheck"]) {
        obj["taxUI"] += "<span>";
        if (obj["gstPrice"] == 0) {
          obj["taxUI"] += "-";
        } else {
          obj["taxUI"] +=
            "$" +
            this._decimalPipe.transform(obj["gstPrice"], "1.2-2") +
            "&nbsp;(GST)";
        }
        obj["taxUI"] += "</span>";
      }

      if (obj["pstCheck"]) {
        obj["taxUI"] += "<span>";
        if (obj["pstPrice"] == 0) {
          obj["taxUI"] += "-";
        } else {
          obj["taxUI"] +=
            "$" +
            this._decimalPipe.transform(obj["pstPrice"], "1.2-2") +
            "&nbsp;(PST)";
        }
        obj["taxUI"] += "</span>";
      }

      if (obj["qstCheck"]) {
        obj["taxUI"] += "<span>";
        if (obj["qstPrice"] == 0) {
          obj["taxUI"] += "-";
        } else {
          obj["taxUI"] +=
            "$" +
            this._decimalPipe.transform(obj["qstPrice"], "1.2-2") +
            "&nbsp;(QST)";
        }
        obj["taxUI"] += "</span>";
      }

      if (obj["hstCheck"]) {
        obj["taxUI"] += "<span> ";
        if (obj["hstPrice"] == 0) {
          obj["taxUI"] += "-";
        } else {
          obj["taxUI"] +=
            "$" +
            this._decimalPipe.transform(obj["hstPrice"], "1.2-2") +
            "&nbsp;(HST)";
        }
        obj["taxUI"] += "</span>";
      }

      if (
        !obj["hstCheck"] &&
        !obj["gstCheck"] &&
        !obj["pstCheck"] &&
        !obj["qstCheck"]
      ) {
        obj["taxUI"] += "<span>-";

        obj["taxUI"] += "</span>";
      }

      // //console.log(object["taxUI"])

      obj["tax"] = parseFloat(
        this._decimalPipe.transform(
          gstprice + hstprice + pstprice + qstprice,
          "1.2-2"
        ) ?? ""
      );
      obj["totalPrice"] =
        obj.planPrice + gstprice + hstprice + pstprice + qstprice,


        obj["totalUI"] =
        "$" +
        this._decimalPipe.transform(
          obj.planPrice + gstprice + hstprice + pstprice + qstprice,
          "1.2-2"
        );

      obj["total"] = parseFloat(
        this._decimalPipe.transform(
          obj.planPrice + gstprice + hstprice + pstprice + qstprice,
          "1.2-2"
        ) ?? ""
      );


      let updatedSum = this.removetosum(obj.totalPrice)
      this.planssummarymain = [];
      this.planssummaryopt = [];

      if (Array.isArray(planSummary)) {
        planSummary?.forEach((element: any) => {
          if (element.packagename != "Opt-in") {
            this.planssummarymain.push(element);
          } else {
            this.planssummaryopt.push(element);
          }
        });
      } else {
        console.error("planSummary is not an array.");
      }



      // Remove duplicates in `planssummarymain` based on 'id'
      this.planssummarymain = this.removeDuplicates(this.planssummarymain, 'id');

      // Remove duplicates in `plansummary` based on 'id'
      planSummary = this.removeDuplicates(planSummary, 'id');

      console.log("setting here1");

      sessionStorage.setItem(
        "plansummarymain",
        JSON.stringify(this.planssummarymain)
      );
      sessionStorage.setItem(
        "plansummaryopt",
        JSON.stringify(this.planssummaryopt)
      );

      sessionStorage.setItem(
        "plansummary",
        JSON.stringify(planSummary)
      );

      if (planSummary.length > 0) {
        // this.plansnexttab = false;
      } else {
        // this.plansnexttab = true;
      }
      if (updatedSum > 0) {
        this.cartcheckvalue = false;
      } else {
        this.cartcheckvalue = true;
      }
      this.getPlanSummaryObject();
      this.calculateTotalSummaryPrice();
    }

    setTimeout(() => {



      this.planssummarymain =
        JSON.parse(sessionStorage.getItem("plansummarymain") ?? "") || "";

      var total = 0;
      for (let i = 0; i < this.planssummarymain.length; i++) {
        total += parseFloat(this.planssummarymain[i].skuTotalPrice);
      }

      console.log(total);

      this.planAmount = this._decimalPipe
        .transform(total, "1.2-2")?.replace(/,/g, "");
      sessionStorage.setItem("totalAmount", this.planAmount);

      this.getPlanSummaryObject();

      console.log('planssummarymain', this.planssummarymain)


    }, 100);
  }

  public removeplansummary(obj: any) {
    let planSummary = JSON.parse(sessionStorage.getItem('plansummary') || '[]');

    console.log(obj);


    this.getPlanSummaryObject()
    if (obj.planLevel == 15) {
      for (let i = 0; i < planSummary.length; i++) {

        if (planSummary[i].planLevel == 18) {
          planSummary[i].options = []
        }

      }

    }

    console.log(planSummary)


    if (planSummary) {
      ////this.consoleMessage("removeinplanid"+obj.id)
      let index: any = this.getslectedplans(obj.id);
      ////this.consoleMessage(index)

      if (index > -1) {
        // console.log(index);
        planSummary.splice(index, 1);

      } else {
        return;
      }

      // ////this.consoleMessage(planSummary)
      // ////this.consoleMessage(planSummary.length)
      ////this.consoleMessage("beforeremoveplans")
      let selectedPlans = JSON.parse(
        sessionStorage.getItem('selectedPlans') || '[]'
      );
      var newselectedplans: any = {};
      for (var i = 0; i < planSummary.length; i++) {
        newselectedplans[planSummary[i].id] = i;
      }

      ////this.consoleMessage("newselectedPlans")
      ////this.consoleMessage(newselectedplans)
      sessionStorage.setItem('selectedPlans', JSON.stringify(newselectedplans));
      // this.removeslectplans(obj.id,planSummary.length)

      let gstprice = 0;
      let hstprice = 0;
      let pstprice = 0;
      let qstprice = 0;

      if (obj.gst > 0) {
        gstprice = obj.planPrice * obj.gst;
        obj['gstPrice'] = gstprice
          ? this._decimalPipe.transform(gstprice, '1.2-2')
          : 0;
        obj['gstPrice'] = parseFloat(obj['gstPrice']);
      } else {
        obj['gstPrice'] = 0;
      }

      if (obj.hst > 0) {
        hstprice = obj.planPrice * obj.hst;

        obj['hstPrice'] = hstprice
          ? this._decimalPipe.transform(gstprice, '1.2-2')
          : 0;
        obj['hstPrice'] = parseFloat(obj['hstPrice']);
      } else {
        obj['hstPrice'] = 0;
      }

      if (obj.pst > 0) {
        pstprice = obj.planPrice * obj.pst;
        obj['pstPrice'] = pstprice
          ? this._decimalPipe.transform(pstprice, '1.2-2')
          : 0;
        obj['pstPrice'] = parseFloat(obj['pstPrice']);
      } else {
        obj['pstPrice'] = 0;
      }

      if (obj.qst > 0) {
        qstprice = obj.planPrice * obj.qst;

        obj['qstPrice'] = qstprice
          ? this._decimalPipe.transform(qstprice, '1.2-2')
          : 0;
        obj['qstPrice'] = parseFloat(obj['qstPrice']);
      } else {
        obj['qstPrice'] = 0;
      }
      obj['taxUI'] = '';
      if (obj['gstCheck']) {
        obj['taxUI'] += '<span>';
        if (obj['gstPrice'] == 0) {
          obj['taxUI'] += '-';
        } else {
          obj['taxUI'] +=
            '$' +
            this._decimalPipe.transform(obj['gstPrice'], '1.2-2') +
            '&nbsp;(GST)';
        }
        obj['taxUI'] += '</span>';
      }

      if (obj['pstCheck']) {
        obj['taxUI'] += '<span>';
        if (obj['pstPrice'] == 0) {
          obj['taxUI'] += '-';
        } else {
          obj['taxUI'] +=
            '$' +
            this._decimalPipe.transform(obj['pstPrice'], '1.2-2') +
            '&nbsp;(PST)';
        }
        obj['taxUI'] += '</span>';
      }

      if (obj['qstCheck']) {
        obj['taxUI'] += '<span>';
        if (obj['qstPrice'] == 0) {
          obj['taxUI'] += '-';
        } else {
          obj['taxUI'] +=
            '$' +
            this._decimalPipe.transform(obj['qstPrice'], '1.2-2') +
            '&nbsp;(QST)';
        }
        obj['taxUI'] += '</span>';
      }

      if (obj['hstCheck']) {
        obj['taxUI'] += '<span> ';
        if (obj['hstPrice'] == 0) {
          obj['taxUI'] += '-';
        } else {
          obj['taxUI'] +=
            '$' +
            this._decimalPipe.transform(obj['hstPrice'], '1.2-2') +
            '&nbsp;(HST)';
        }
        obj['taxUI'] += '</span>';
      }

      if (
        !obj['hstCheck'] &&
        !obj['gstCheck'] &&
        !obj['pstCheck'] &&
        !obj['qstCheck']
      ) {
        obj['taxUI'] += '<span>-';

        obj['taxUI'] += '</span>';
      }

      // ////this.consoleMessage(object["taxUI"])

      obj['tax'] = parseFloat(
        this._decimalPipe.transform(
          gstprice + hstprice + pstprice + qstprice,
          '1.2-2'
        ) ?? ''
      );

      (obj['totalPrice'] =
        obj.planPrice + gstprice + hstprice + pstprice + qstprice),
        (obj['totalUI'] =
          '$' +
          this._decimalPipe.transform(
            obj.planPrice + gstprice + hstprice + pstprice + qstprice,
            '1.2-2'
          ));

      obj['total'] = parseFloat(
        this._decimalPipe.transform(
          obj.planPrice + gstprice + hstprice + pstprice + qstprice,
          '1.2-2'
        ) ?? ''
      );

      let updatedSum = this.removetosum(obj.totalPrice);
      this.planssummarymain = [];
      this.planssummaryopt = [];

      planSummary.forEach((element: any) => {
        if (element.packagename != 'Opt-in') {
          this.planssummarymain.push(element);
        } else {
          this.planssummaryopt.push(element);
        }
      });
      console.log("setting here2");

      sessionStorage.setItem(
        'plansummarymain',
        JSON.stringify(this.planssummarymain)
      );
      sessionStorage.setItem(
        'plansummaryopt',
        JSON.stringify(this.planssummaryopt)
      );

      sessionStorage.setItem('plansummary', JSON.stringify(planSummary));
      let planSummaryLife = JSON.parse(sessionStorage.getItem('plansummaryLife') || '[]');

      // if (planSummary.length > 0 || planSummaryLife.length > 0) {
      //   this.plansnexttab = false;
      // } else {
      //   this.plansnexttab = true;
      // }
      if (updatedSum > 0) {
        this.cartcheckvalue = false;
      } else {
        this.cartcheckvalue = true;
      }
    }

    setTimeout(() => {
      // this.planssummarymain = JSON.parse(
      //   sessionStorage.getItem('plansummarymain') || '[]'
      // );

      // var total = 0;
      // for (let i = 0; i < this.planssummarymain.length; i++) {
      //   total += parseFloat(this.planssummarymain[i].skuTotalPrice);
      // }

      // this.planssummarymainLife = JSON.parse(
      //   sessionStorage.getItem('planssummarymainLife') || '[]'
      // );

      this.planssummarymain = JSON.parse(
        sessionStorage.getItem('plansummarymain') || '[]'
      );
      var total = 0;
      // for (let i = 0; i < this.planssummarymainLife.length; i++) {
      //   total += parseFloat(this.planssummarymainLife[i].skuTotalPrice);
      // }
      for (let i = 0; i < this.planssummarymain.length; i++) {
        total += parseFloat(this.planssummarymain[i].skuTotalPrice);
      }
      //this.consoleMessage(total);

      this.planAmount = this._decimalPipe
        .transform(total, '1.2-2')
        ?.replace(/,/g, '');
      sessionStorage.setItem('totalAmount', this.planAmount);
    }, 100);


    for (let i = 0; i < this.planssummarymain.length; i++) {
      if (this.planssummarymain[i].disallowedPlanLevels != null) {
        let disallowed_plans = this.planssummarymain[i].disallowedPlanLevels.split(',');
        const dom1: HTMLElement = this.elementRef.nativeElement;
        for (let i = 0; i < disallowed_plans.length; i++) {
          // console.log(disallowed_plans[i]);
          // console.log(disallowed_plans[i]);
          setTimeout(() => {
            let elem: any = dom1.querySelector(`#plancheck${disallowed_plans[i]}`)

            if (elem != null) {
              if (!elem.disabled) {

                elem.disabled = true
              }
            }
          }, 100);

        }
      }
    }
  }

  public removeplansummary_v3(obj: any) {
    let planSummary = JSON.parse(sessionStorage.getItem('plansummary') || '[]');

    console.log(obj);


    this.getPlanSummaryObject()
    if (obj.planLevel == 15) {
      for (let i = 0; i < planSummary.length; i++) {

        if (planSummary[i].planLevel == 18) {
          planSummary[i].options = []
        }

      }

    }

    console.log(planSummary)


    if (planSummary) {
      ////this.consoleMessage("removeinplanid"+obj.id)
      let index: any = this.getslectedplans(obj.id);
      ////this.consoleMessage(index)

      if (index > -1) {
        // console.log(index);
        planSummary.splice(index, 1);

      } else {
        return;
      }

      // ////this.consoleMessage(planSummary)
      // ////this.consoleMessage(planSummary.length)
      ////this.consoleMessage("beforeremoveplans")
      let selectedPlans = JSON.parse(
        sessionStorage.getItem('selectedPlans') || '[]'
      );
      var newselectedplans: any = {};
      for (var i = 0; i < planSummary.length; i++) {
        newselectedplans[planSummary[i].id] = i;
      }

      ////this.consoleMessage("newselectedPlans")
      ////this.consoleMessage(newselectedplans)
      sessionStorage.setItem('selectedPlans', JSON.stringify(newselectedplans));
      // this.removeslectplans(obj.id,planSummary.length)

      let gstprice = 0;
      let hstprice = 0;
      let pstprice = 0;
      let qstprice = 0;

      if (obj.gst > 0) {
        gstprice = obj.planPrice * obj.gst;
        obj['gstPrice'] = gstprice
          ? this._decimalPipe.transform(gstprice, '1.2-2')
          : 0;
        obj['gstPrice'] = parseFloat(obj['gstPrice']);
      } else {
        obj['gstPrice'] = 0;
      }

      if (obj.hst > 0) {
        hstprice = obj.planPrice * obj.hst;

        obj['hstPrice'] = hstprice
          ? this._decimalPipe.transform(gstprice, '1.2-2')
          : 0;
        obj['hstPrice'] = parseFloat(obj['hstPrice']);
      } else {
        obj['hstPrice'] = 0;
      }

      if (obj.pst > 0) {
        pstprice = obj.planPrice * obj.pst;
        obj['pstPrice'] = pstprice
          ? this._decimalPipe.transform(pstprice, '1.2-2')
          : 0;
        obj['pstPrice'] = parseFloat(obj['pstPrice']);
      } else {
        obj['pstPrice'] = 0;
      }

      if (obj.qst > 0) {
        qstprice = obj.planPrice * obj.qst;

        obj['qstPrice'] = qstprice
          ? this._decimalPipe.transform(qstprice, '1.2-2')
          : 0;
        obj['qstPrice'] = parseFloat(obj['qstPrice']);
      } else {
        obj['qstPrice'] = 0;
      }
      obj['taxUI'] = '';
      if (obj['gstCheck']) {
        obj['taxUI'] += '<span>';
        if (obj['gstPrice'] == 0) {
          obj['taxUI'] += '-';
        } else {
          obj['taxUI'] +=
            '$' +
            this._decimalPipe.transform(obj['gstPrice'], '1.2-2') +
            '&nbsp;(GST)';
        }
        obj['taxUI'] += '</span>';
      }

      if (obj['pstCheck']) {
        obj['taxUI'] += '<span>';
        if (obj['pstPrice'] == 0) {
          obj['taxUI'] += '-';
        } else {
          obj['taxUI'] +=
            '$' +
            this._decimalPipe.transform(obj['pstPrice'], '1.2-2') +
            '&nbsp;(PST)';
        }
        obj['taxUI'] += '</span>';
      }

      if (obj['qstCheck']) {
        obj['taxUI'] += '<span>';
        if (obj['qstPrice'] == 0) {
          obj['taxUI'] += '-';
        } else {
          obj['taxUI'] +=
            '$' +
            this._decimalPipe.transform(obj['qstPrice'], '1.2-2') +
            '&nbsp;(QST)';
        }
        obj['taxUI'] += '</span>';
      }

      if (obj['hstCheck']) {
        obj['taxUI'] += '<span> ';
        if (obj['hstPrice'] == 0) {
          obj['taxUI'] += '-';
        } else {
          obj['taxUI'] +=
            '$' +
            this._decimalPipe.transform(obj['hstPrice'], '1.2-2') +
            '&nbsp;(HST)';
        }
        obj['taxUI'] += '</span>';
      }

      if (
        !obj['hstCheck'] &&
        !obj['gstCheck'] &&
        !obj['pstCheck'] &&
        !obj['qstCheck']
      ) {
        obj['taxUI'] += '<span>-';

        obj['taxUI'] += '</span>';
      }

      // ////this.consoleMessage(object["taxUI"])

      obj['tax'] = parseFloat(
        this._decimalPipe.transform(
          gstprice + hstprice + pstprice + qstprice,
          '1.2-2'
        ) ?? ''
      );

      (obj['totalPrice'] =
        obj.planPrice + gstprice + hstprice + pstprice + qstprice),
        (obj['totalUI'] =
          '$' +
          this._decimalPipe.transform(
            obj.planPrice + gstprice + hstprice + pstprice + qstprice,
            '1.2-2'
          ));

      obj['total'] = parseFloat(
        this._decimalPipe.transform(
          obj.planPrice + gstprice + hstprice + pstprice + qstprice,
          '1.2-2'
        ) ?? ''
      );

      let updatedSum = this.removetosum(obj.totalPrice);
      this.planssummarymain = [];
      this.planssummaryopt = [];

      planSummary.forEach((element: any) => {
        if (element.packagename != 'Opt-in') {
          this.planssummarymain.push(element);
        } else {
          this.planssummaryopt.push(element);
        }
      });
      console.log("setting here2");

      sessionStorage.setItem(
        'plansummarymain',
        JSON.stringify(this.planssummarymain)
      );
      sessionStorage.setItem(
        'plansummaryopt',
        JSON.stringify(this.planssummaryopt)
      );

      sessionStorage.setItem('plansummary', JSON.stringify(planSummary));
      let planSummaryLife = JSON.parse(sessionStorage.getItem('plansummaryLife') || '[]');

      // if (planSummary.length > 0 || planSummaryLife.length > 0) {
      //   this.plansnexttab = false;
      // } else {
      //   this.plansnexttab = true;
      // }
      if (updatedSum > 0) {
        this.cartcheckvalue = false;
      } else {
        this.cartcheckvalue = true;
      }
    }

    setTimeout(() => {
      // this.planssummarymain = JSON.parse(
      //   sessionStorage.getItem('plansummarymain') || '[]'
      // );

      // var total = 0;
      // for (let i = 0; i < this.planssummarymain.length; i++) {
      //   total += parseFloat(this.planssummarymain[i].skuTotalPrice);
      // }

      // this.planssummarymainLife = JSON.parse(
      //   sessionStorage.getItem('planssummarymainLife') || '[]'
      // );

      this.planssummarymain = JSON.parse(
        sessionStorage.getItem('plansummarymain') || '[]'
      );
      var total = 0;
      // for (let i = 0; i < this.planssummarymainLife.length; i++) {
      //   total += parseFloat(this.planssummarymainLife[i].skuTotalPrice);
      // }
      for (let i = 0; i < this.planssummarymain.length; i++) {
        total += parseFloat(this.planssummarymain[i].skuTotalPrice);
      }
      //this.consoleMessage(total);

      this.planAmount = this._decimalPipe
        .transform(total, '1.2-2')
        ?.replace(/,/g, '');
      sessionStorage.setItem('totalAmount', this.planAmount);
    }, 100);


    for (let i = 0; i < this.planssummarymain.length; i++) {
      if (this.planssummarymain[i].disallowedPlanLevels != null) {
        let disallowed_plans = this.planssummarymain[i].disallowedPlanLevels.split(',');
        const dom1: HTMLElement = this.elementRef.nativeElement;
        for (let i = 0; i < disallowed_plans.length; i++) {
          // console.log(disallowed_plans[i]);
          // console.log(disallowed_plans[i]);
          setTimeout(() => {
            let elem: any = dom1.querySelector(`#plancheck2${disallowed_plans[i]}`)

            if (elem != null) {
              if (!elem.disabled) {

                elem.disabled = true
              }
            }
          }, 100);

        }
      }
    }
  }

  public isGroupsNotEmpty(groups: any): boolean {
    if (Object.keys(groups).length > 0) {
      Object.keys(groups).forEach(element => {

        if (groups[element].length > 0) {
          groups[element].map(ele => {

            if (ele.plans?.length > 0) {
              this.displayPackage = true;
              return this.displayPackage
            }
          });
        }
      })
    }

    return this.displayPackage
  }




  public onCheckboxChangeCorporate(
    e: any,
    allow_multiple: any,
    disallowedPlanLevels: any,
    options: any,
    pname: any,
    groupname: any,
    plancoverage: any,
    planprice: any,
    gst: any,
    hst: any,
    pst: any,
    event: any,
    event1: any,
    packageindex: any,
    planindex: any,
    plan: any,
    product: any,
    pckage: any,
    group: any
  ) {
    console.log(plan, "plan889")
    // let multiple = allow_multiple ? Boolean(allow_multiple.data[0]) : false;
    let multiple = allow_multiple == true ? true : false;


    if (e.target.checked) {
      //unselect all checkboxes with same id(fix for single.couple and family multiple seelction)



      const dom: HTMLElement = this.elementRef.nativeElement;

      const samePlanIdElements = dom.querySelectorAll('#' + e.target.id);
      //console.log(samePlanIdElements)
      let targetClassName = 'cp_plan'
      if (e.target.className.includes('cp_plan')) {
        targetClassName = 'cp_plan'
      }
      else if (e.target.className.includes('cc_plan')) {
        targetClassName = 'cc_plan'
      }
      else if (e.target.className.includes('ep_plan')) {
        targetClassName = 'ep_plan'
      }

      for (let i = 0; i < samePlanIdElements.length; i++) {
        let elem = samePlanIdElements[i];
        let element: any = elem;
        //console.log(elem)


        if (element.checked && element.className.includes(targetClassName)) {
          element.checked = false;
          element.disabled = false;  //need to change here for flex bronze disabled
          this.unselectplanCorp(elem, options, plan, product, pckage, group, planindex, disallowedPlanLevels);

        }
      }
      e.target.checked = true

    } else {

    }



    //console.log(disallowedPlanLevels)
    if (disallowedPlanLevels != null) {
      let disallowed_plans = disallowedPlanLevels.split(",");
      //console.log(disallowed_plans)
      const dom1: HTMLElement = this.elementRef.nativeElement;
      const disallowed_elements = dom1.querySelectorAll(
        ".plansscreen input[type='checkbox']"
      );

      // disallowed_elements.forEach((elem: any) => {

      for (let i = 0; i < disallowed_elements.length; i++) {
        let elem: any = disallowed_elements[i];
        // elementcv.checked=false

        let plandetails = elem.attributes.data.value;

        let plandetailsobj = plandetails.split("##");

        //this.consoleMessage("main", plandetailsobj);
        let isBundle = plandetailsobj[21] == "true" ? true : false
        if (e.target.checked) {
          if (!elem.disabled) {

            if (plandetailsobj[12] == null || plandetailsobj[12] == '') {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                  //  elem.checked=false
                  elem.disabled = true;
                  this.disabledelement =
                    'Already included in GroupBenefitz All-In';
                }
              } else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  //  elem.checked=false
                  elem.disabled = true;
                  this.disabledelement =
                    'Already included in GroupBenefitz All-In';
                }
              }

            } else {

              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[12]) >= 0) {

                  elem.disabled = true;

                  this.disabledelement =
                    'Already included in GroupBenefitz All-In';
                }
              } else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {

                  elem.disabled = true;

                  this.disabledelement =
                    'Already included in GroupBenefitz All-In';
                }
              }

            }
          }
          if (elem.checked) {

            if (plandetailsobj[12] == null || plandetailsobj[12] == '') {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                  elem.checked = false;
                  this.unselectplanCorp(elem, options, plan, product, pckage, group, planindex, disallowedPlanLevels);
                }

              }
              else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  elem.checked = false;
                  this.unselectplanCorp(elem, options, plan, product, pckage, group, planindex, disallowedPlanLevels);
                }
              }
            } else {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[12]) >= 0) {
                  elem.checked = false;
                  this.unselectplanCorp(elem, options, plan, product, pckage, group, planindex, disallowedPlanLevels);
                  // elem.disabled =true
                }
              }
              else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  elem.checked = false;
                  this.unselectplanCorp(elem, options, plan, product, pckage, group, planindex, disallowedPlanLevels);
                  // elem.disabled =true
                }
              }

            }
          }
        }
        else {
          if (elem.disabled) {
            if (plandetailsobj[12] == null || plandetailsobj[12] == '') {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                  //  elem.checked=false
                  elem.disabled = false;
                }
              } else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  //  elem.checked=false
                  elem.disabled = false;
                }
              }
            }
            if (isBundle) {
              if (disallowed_plans.indexOf(plandetailsobj[12]) >= 0) {

                elem.disabled = false;

                this.disabledelement =
                  'Already included in GroupBenefitz All-In';
              }
            } else {
              if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {

                elem.disabled = false;

                this.disabledelement =
                  'Already included in GroupBenefitz All-In';
              }
            }

            // else {
            //   if (disallowed_plans.indexOf(plandetailsobj[12]) >= 0) {
            //     //  elem.checked=false
            //     elem.disabled = false;
            //   }
            // }
          }


          if (elem.checked) {

            if (plandetailsobj[12] == null || plandetailsobj[12] == '') {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                  elem.checked = false;
                  this.unselectplanCorp(elem, options, plan, product, pckage, group, planindex, disallowedPlanLevels);
                }

              }
              else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  elem.checked = false;
                  this.unselectplanCorp(elem, options, plan, product, pckage, group, planindex, disallowedPlanLevels);
                }
              }
            } else {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[12]) >= 0) {
                  elem.checked = false;
                  this.unselectplanCorp(elem, options, plan, product, pckage, group, planindex, disallowedPlanLevels);
                  // elem.disabled =true
                }
              }
              else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  elem.checked = false;
                  this.unselectplanCorp(elem, options, plan, product, pckage, group, planindex, disallowedPlanLevels);
                  // elem.disabled =true
                }
              }

            }
          }
        }


      }
    }





    //////this.consoleMessage(e)
    // //console.log(`newPlan${plan.id}`)

    let sameplanclassname = `newPlan${plan.id}`
    // //console.log(e.target.className)/////this.consoleMessage(e)
    let classname = e.target.className.replace(sameplanclassname, '');
    // //console.log(classname)
    classname = e.target.className.split(' ').join('.');
    // classname = classname.split(' ').join('.');

    // if (classname[0] != '.') {
    //   classname = `.${classname}`

    // }

    // if (classname[classname.length - 1] == '.') {
    //   classname = classname.substring(0, classname.length - 1);
    // }

    //console.log(classname)
    //console.log(sameplanclassname)
    // //////this.consoleMessage(classname)
    const dom: HTMLElement = this.elementRef.nativeElement;
    // const elements = dom.querySelectorAll('.' + classname);
    const elements = dom.querySelectorAll(classname);

    const samePlanElements = dom.querySelectorAll('.' + sameplanclassname);
    let element: any;
    let elementcv: any;

    if (!multiple) {
      if (e.target.checked) {
        for (let i = 0; i < elements.length; i++) {
          let elem = elements[i];
          element = elem;

          if (element.checked) {
            this.unselectplanCorp(elem, options, plan, product, pckage, group, planindex, disallowedPlanLevels);
            element.checked = false;
          }
        }

        e.checked = true;
        e.target.checked = true;
      } else {

      }
    } else {

      //console.log("elesehere")
      if (e.target.checked) {


        // for (let i = 0; i < samePlanElements.length; i++) {
        //   let elem = samePlanElements[i];
        //   element = elem;

        //   if (element.checked) {

        //     this.unselectplan(elem, options, plan, product, pckage, group,planindex);
        //     element.checked = false;
        //   }
        // }

        // e.checked = true;
        // e.target.checked = true;
      } else {
      }
      // alert("!")
      //no checking for other checkboxes you can selet multiple
    }
    setTimeout(() => {
      if (e.target.checked) {

        console.log(group)
        console.log(pckage)

        let removedisabledcompanypaidproductid: any = []
        let removedisabledcoveredpaidproductid: any = []
        let removedisabledemployedpaidproductid: any = []
        if (
          group.categorization.coveredByCompany == 1
          // ||
          // group.categorization.paidByEmployee == 1
        ) {

          pckage.groups.forEach((element: any) => {
            if (pckage.id != 5) {
              if (element.categorization.paidByCompany == 1 || element.categorization.paidByEmployee == 1) {
                element.plans.forEach((plan: any) => {
                  let pl = plan
                  Object.keys(plan.productAddonss).forEach((key) => {
                    plan.productAddonss[key].forEach((product: any) => {
                      if (pl.isBundle) {
                        removedisabledcompanypaidproductid.push(
                          pl
                        );
                      }
                      else {
                        removedisabledcompanypaidproductid.push(
                          // id: product.id,

                          product.planLevel,

                        );
                      }

                    });
                  });
                });
              }
            }
            else {
              if (group?.parentId == element?.parentId) {
                if (element.categorization.paidByCompany == 1 || element.categorization.paidByEmployee == 1) {
                  element.plans.forEach((plan: any) => {
                    let pl = plan
                    Object.keys(plan.productAddonss).forEach((key) => {
                      plan.productAddonss[key].forEach((product: any) => {
                        if (pl.isBundle) {
                          removedisabledcompanypaidproductid.push(
                            pl
                          );
                        }
                        else {
                          removedisabledcompanypaidproductid.push(
                            // id: product.id,

                            product.planLevel,

                          );
                        }

                      });
                    });
                  });
                }
              }
            }

          });
        } else {
        }

        if (
          group.categorization.paidByCompany == 1
          // ||
          // group.categorization.paidByEmployee == 1
        ) {

          pckage.groups.forEach((element: any) => {
            if (pckage.id != 5) {
              if (element.categorization.coveredByCompany == 1 || element.categorization.paidByEmployee == 1) {
                element.plans.forEach((plan: any) => {
                  let pl = plan
                  Object.keys(plan.productAddonss).forEach((key) => {
                    plan.productAddonss[key].forEach((product: any) => {
                      if (pl.isBundle) {
                        removedisabledcoveredpaidproductid.push(
                          pl,
                        );
                      }
                      else {
                        removedisabledcoveredpaidproductid.push(
                          // id: product.id,
                          product.planLevel,
                        );
                      }

                    });
                  });
                });
              }
            }
            else {
              if (group?.parentId == element?.parentId) {
                if (element.categorization.coveredByCompany == 1 || element.categorization.paidByEmployee == 1) {
                  element.plans.forEach((plan: any) => {
                    let pl = plan
                    Object.keys(plan.productAddonss).forEach((key) => {
                      plan.productAddonss[key].forEach((product: any) => {
                        if (pl.isBundle) {
                          removedisabledcoveredpaidproductid.push(
                            pl,
                          );
                        }
                        else {
                          removedisabledcoveredpaidproductid.push(
                            // id: product.id,
                            product.planLevel,
                          );
                        }

                      });
                    });
                  });
                }
              }
            }
          });
        } else {
        }

        if (
          group.categorization.paidByEmployee == 1
          // ||
          // group.categorization.paidByEmployee == 1
        ) {



          pckage.groups.forEach((element: any) => {
            //console.log(element)
            if (pckage.id != 5) {

              if (element.categorization.paidByCompany == 1 || element.categorization.coveredByCompany == 1) {
                element.plans.forEach((plan: any) => {
                  let pl = plan
                  Object.keys(plan.productAddonss).forEach((key) => {
                    plan.productAddonss[key].forEach((product: any) => {
                      if (pl.isBundle) {
                        removedisabledemployedpaidproductid.push(
                          pl,
                        );
                      }
                      else {
                        removedisabledemployedpaidproductid.push(
                          product.planLevel,
                        );
                      }

                    });
                  });
                });
              }
            }
            else {


              if (group?.parentId == element?.parentId) {
                if (element.categorization.paidByCompany == 1 || element.categorization.coveredByCompany == 1) {
                  element.plans.forEach((plan: any) => {
                    let pl = plan
                    Object.keys(plan.productAddonss).forEach((key) => {
                      plan.productAddonss[key].forEach((product: any) => {
                        if (pl.isBundle) {
                          removedisabledemployedpaidproductid.push(
                            pl,
                          );
                        }
                        else {
                          removedisabledemployedpaidproductid.push(
                            product.planLevel,
                          );
                        }

                      });
                    });
                  });
                }
              }
            }
          });
        } else {
        }

        console.log(removedisabledcompanypaidproductid)
        console.log(removedisabledcoveredpaidproductid)
        console.log(removedisabledemployedpaidproductid)

        removedisabledcompanypaidproductid = removedisabledcompanypaidproductid.filter(
          (item: any) => item !== undefined && item !== null
        );
        removedisabledcoveredpaidproductid = removedisabledcoveredpaidproductid.filter(
          (item: any) => item !== undefined && item !== null
        );
        removedisabledemployedpaidproductid = removedisabledemployedpaidproductid.filter(
          (item: any) => item !== undefined && item !== null
        );
        removedisabledcompanypaidproductid.forEach((element: any, index: any) => {
          setTimeout(() => {
            const dom: HTMLElement = this.elementRef.nativeElement;

            let planId: any;

            if (element.isBundle) {

              Object.keys(element.productAddonss).forEach((key) => {
                element.productAddonss[key].forEach((product: any) => {
                  //console.log(product)
                  plan = dom.querySelectorAll("#plancheck" + product.planId + ".coverage" + product.planCoverage)
                  //  plan.disabled = false;
                  planId = product.planId
                  plan.forEach((element: any) => {
                    //console.log(element)
                    element.disabled = false;
                    element.checked = false
                  });
                })
              })

            }
            else {
              plan = dom.querySelectorAll("#plancheck" + element.id);
              plan.disabled = false;
              planId = element.id
              plan.forEach((element: any) => {
                //console.log(element)
                element.disabled = false;
                element.checked = false
              });
            }





            //remove this plan from sum
            // plan.click()

            let selectplans =
              JSON.parse(sessionStorage.getItem("plansummarymain") || '[]') || "";

            selectplans.forEach((elem: any, index: any) => {

              setTimeout(() => {


                if (elem.id == element.id) {

                } else {
                  setTimeout(() => {
                    const dom: HTMLElement = this.elementRef.nativeElement;
                    const plan = dom.querySelectorAll(".plan-description-span.single" + ".plancheck" + planId);
                    const plan2 = dom.querySelectorAll(".plan-description-span.couple" + ".plancheck" + planId);
                    const plan3 = dom.querySelectorAll(".plan-description-span.family" + ".plancheck" + planId);
                    /* //console.log(plan) */

                    plan.forEach((elem: any) => {
                      (elem as HTMLElement).style.display = 'block';
                    });

                    plan2.forEach((elem: any) => {
                      (elem as HTMLElement).style.display = 'block';
                    });
                    plan3.forEach((elem: any) => {
                      (elem as HTMLElement).style.display = 'block';
                    });



                  }, 1000);
                }



              }, 1000);


              if (elem.isBundle) {
                // if (elem.id == element.id) {
                //   selectplans.splice(index, 1)
                // }

                Object.keys(element.productAddonss).forEach((key) => {
                  element.productAddonss[key].forEach((product: any) => {
                    if (elem.id == element.id && elem.coverage == product.planCoverage) {
                      selectplans.splice(index, 1)
                    }
                  })
                })
              } else {


                if (elem.id == elem.products[0].planLevel) {
                  selectplans.splice(index, 1)
                }
                // if(elem.id==elem.products[0].id){
                //   selectplans.splice(index,1)
                // }
              }


            })

            sessionStorage.setItem(
              "plansummarymain",
              JSON.stringify(selectplans)
            );


            sessionStorage.setItem("plansummary", JSON.stringify(selectplans));

            this.planCoverafeFunction();

          }, 1000);
        });
        removedisabledcoveredpaidproductid.forEach((element: any, index: any) => {
          setTimeout(() => {
            const dom: HTMLElement = this.elementRef.nativeElement;



            let plan: any = ''
            let planId: any;


            //console.log(element)
            if (element.isBundle) {

              Object.keys(element.productAddonss).forEach((key) => {
                element.productAddonss[key].forEach((product: any) => {
                  //console.log(product)
                  plan = dom.querySelectorAll("#plancheck" + product.planId + ".coverage" + product.planCoverage)

                  planId = product.planId
                  //console.log(plan)
                  plan.forEach((element: any) => {
                    //console.log(element)
                    element.disabled = false;
                    element.checked = false
                  });
                })
              })


            } else {
              plan = dom.querySelectorAll("#plancheck" + element.id);
              planId = element.id
              plan.forEach((element: any) => {
                //console.log(element)
                element.disabled = false;
                element.checked = false
              });
            }


            //remove this plan from sum
            // plan.click()

            let selectplans =
              JSON.parse(sessionStorage.getItem("plansummarymain") || '[]') || "";

            selectplans.forEach((elem: any, index: any) => {
              setTimeout(() => {


                if (elem.id == element.id) {

                } else {
                  setTimeout(() => {
                    const dom: HTMLElement = this.elementRef.nativeElement;
                    const plan = dom.querySelectorAll(".plan-description-span.single" + ".plancheck" + planId);
                    const plan2 = dom.querySelectorAll(".plan-description-span.couple" + ".plancheck" + planId);
                    const plan3 = dom.querySelectorAll(".plan-description-span.family" + ".plancheck" + planId);
                    // //console.log(plan)


                    plan.forEach((elem: any) => {
                      (elem as HTMLElement).style.display = 'block';
                    });

                    plan2.forEach((elem: any) => {
                      (elem as HTMLElement).style.display = 'block';
                    });
                    plan3.forEach((elem: any) => {
                      (elem as HTMLElement).style.display = 'block';
                    });



                  }, 1000);
                }



              }, 1000);
              if (elem.isBundle) {


                Object.keys(element.productAddonss).forEach((key) => {
                  element.productAddonss[key].forEach((product: any) => {
                    if (elem.id == element.id && elem.coverage == product.planCoverage) {
                      selectplans.splice(index, 1)
                    }
                  })
                })
              } else {
                if (elem.id == elem.products[0].planLevel) {
                  selectplans.splice(index, 1)
                }
              }


            })

            sessionStorage.setItem(
              "plansummarymain",
              JSON.stringify(selectplans)
            );


            sessionStorage.setItem("plansummary", JSON.stringify(selectplans));

            this.planCoverafeFunction();
          }, 100);
        });
        removedisabledemployedpaidproductid.forEach((element: any, index: any) => {
          setTimeout(() => {
            const dom: HTMLElement = this.elementRef.nativeElement;
            // const plan: any = dom.querySelectorAll("#plancheck" + element.id);
            // //console.log(plan)
            // //Rakesh changes here company to upgrade
            // plan.disabled = false;
            // plan.forEach((element: any) => {
            //   //console.log(element)
            //   element.checked = false
            // });


            let plan: any = ''

            let planId: any;
            //console.log(element)
            if (element.isBundle) {

              Object.keys(element.productAddonss).forEach((key) => {
                element.productAddonss[key].forEach((product: any) => {
                  //console.log(product)
                  plan = dom.querySelectorAll("#plancheck" + product.planId + ".coverage" + product.planCoverage)

                  planId = product.planId
                  //console.log(plan)
                  plan.forEach((element: any) => {
                    //console.log(element)
                    element.disabled = false;
                    element.checked = false
                  });
                })
              })


            } else {
              plan = dom.querySelectorAll("#plancheck" + element.id);
              planId = element.id
              plan.forEach((element: any) => {
                //console.log(element)
                element.disabled = false;
                element.checked = false
              });
            }


            //remove this plan from sum
            // plan.click()

            let selectplans =
              JSON.parse(sessionStorage.getItem("plansummarymain") || '[]') || "";

            selectplans.forEach((elem: any, index: any) => {
              setTimeout(() => {


                if (elem.id == element.id) {

                } else {
                  setTimeout(() => {
                    const dom: HTMLElement = this.elementRef.nativeElement;
                    const plan = dom.querySelectorAll(".plan-description-span.single" + ".plancheck" + planId);
                    const plan2 = dom.querySelectorAll(".plan-description-span.couple" + ".plancheck" + planId);
                    const plan3 = dom.querySelectorAll(".plan-description-span.family" + ".plancheck" + planId);
                    // //console.log(plan)


                    plan.forEach((elem: any) => {
                      (elem as HTMLElement).style.display = 'block';
                    });

                    plan2.forEach((elem: any) => {
                      (elem as HTMLElement).style.display = 'block';
                    });
                    plan3.forEach((elem: any) => {
                      (elem as HTMLElement).style.display = 'block';
                    });



                  }, 1000);
                }



              }, 1000);
              if (elem.isBundle) {


                Object.keys(element.productAddonss).forEach((key) => {
                  element.productAddonss[key].forEach((product: any) => {
                    if (elem.id == element.id && elem.coverage == product.planCoverage) {
                      selectplans.splice(index, 1)

                    }
                  })
                })
              } else {
                if (elem.id == elem.products[0].planLevel) {
                  selectplans.splice(index, 1)

                }
              }


            })

            sessionStorage.setItem(
              "plansummarymain",
              JSON.stringify(selectplans)
            );


            sessionStorage.setItem("plansummary", JSON.stringify(selectplans));

            this.planCoverafeFunction();
          }, 100);
        });

        console.log(plan, 'plannn', product)

        this.selectplanCorp(e.target, options, plan, product, pckage, group, planindex, disallowedPlanLevels);
      } else {


        this.unselectplanCorp(e.target, options, plan, product, pckage, group, planindex, disallowedPlanLevels);
      }
    }, 10);
  }


  public allowmultipleplans() { }

  public disallowedPlans() { }
  public selectplanCorp(
    elementcv: any,
    options: any,
    plan: any,
    product: any,
    pckage: any,
    group: any,
    planProductIndex: any,
    disallowedPlanLevels: any
  ) {
    // ////this.consoleMessage(elementcv)
    //this.consoleMessage(plan);
    //this.consoleMessage(product)
    //this.consoleMessage(pckage)
    //this.consoleMessage(group)

    // alert("1")
    this.planobjdata1 = {};
    this.planobjdataobj = {}

    console.log(disallowedPlanLevels)

    let details: any = elementcv.attributes.data.value;

    let detailsObj: any = details.split("##");


    let categorization = {}

    if (group.categorization.paidByCompany == 1) {

      categorization = {
        paidByCompany: detailsObj[22] == "true" ? 0 : 1,
        coveredByCompany: detailsObj[22] == "true" ? 1 : 0,
        paidByEmployee: group.categorization.paidByEmployee,
      }
    } else {
      categorization = {
        paidByCompany: group.categorization.paidByCompany,
        coveredByCompany: group.categorization.coveredByCompany,
        paidByEmployee: group.categorization.paidByEmployee,
      }
    }

    //console.log(categorization)

    // paidByCompany: group.categorization.paidByCompany,
    // coveredByCompany: group.categorization.coveredByCompany,
    // paidByEmployee: group.categorization.paidByEmployee,

    let plandetails = elementcv.attributes.data.value;

    let plandetailsobj = plandetails.split("##");
    if (options && options.length > 0) {
      sessionStorage.setItem('options', JSON.stringify(options));
    }
    // if (options && options.length > 0) {
    //   let obj = {
    //     isBundle: plan.isBundle,
    //     disallowedPlanLevels: disallowedPlanLevels,
    //     enrollmentDate: this.userForm.value.planEnrollmentDate
    //       ? this._CustomDatePipe.transform(this.userForm.value.planEnrollmentDate)
    //       : undefined,
    //     // "name":plandetailsobj[1]+"-"+plandetailsobj[2],
    //     name: plandetailsobj[14],
    //     details: plandetailsobj[0],
    //     packagename: plandetailsobj[0],
    //     groupName: plandetailsobj[1],
    //     // amount: parseFloat(plandetailsobj[3]),
    //     amount: parseFloat(product.calculatedTax.price),
    //     planCoverage: plandetailsobj[2],
    //     // planPrice: parseFloat(plandetailsobj[3]),
    //     planPrice: parseFloat(product.calculatedTax.price),
    //     // amountUI: "$" + this._decimalPipe.transform(plandetailsobj[3], "1.2-2"),
    //     amountUI: "$" + parseFloat(product.calculatedTax.price),
    //     gst:
    //       plandetailsobj[4] == null ||
    //         plandetailsobj[4] == "" ||
    //         plandetailsobj[4] == undefined ||
    //         plandetailsobj[4] == "null"
    //         ? 0
    //         : parseFloat(plandetailsobj[4]),
    //     hst:
    //       plandetailsobj[5] == null ||
    //         plandetailsobj[5] == "" ||
    //         plandetailsobj[5] == undefined ||
    //         plandetailsobj[5] == "null"
    //         ? 0
    //         : parseFloat(plandetailsobj[5]),
    //     pst:
    //       plandetailsobj[6] == null ||
    //         plandetailsobj[6] == "" ||
    //         plandetailsobj[6] == undefined ||
    //         plandetailsobj[6] == "null"
    //         ? 0
    //         : parseFloat(plandetailsobj[6]),
    //     qst:
    //       plandetailsobj[17] == null ||
    //         plandetailsobj[17] == "" ||
    //         plandetailsobj[17] == undefined ||
    //         plandetailsobj[17] == "null"
    //         ? 0
    //         : parseFloat(plandetailsobj[17]),
    //     gstCheck:
    //       plandetailsobj[4] == null ||
    //         plandetailsobj[4] == "" ||
    //         plandetailsobj[4] == undefined ||
    //         plandetailsobj[4] == "null"
    //         ? false
    //         : true,
    //     hstCheck:
    //       plandetailsobj[5] == null ||
    //         plandetailsobj[5] == "" ||
    //         plandetailsobj[5] == undefined ||
    //         plandetailsobj[5] == "null"
    //         ? false
    //         : true,
    //     pstCheck:
    //       plandetailsobj[6] == null ||
    //         plandetailsobj[6] == "" ||
    //         plandetailsobj[6] == undefined ||
    //         plandetailsobj[6] == "null"
    //         ? false
    //         : true,
    //     qstCheck:
    //       plandetailsobj[17] == null ||
    //         plandetailsobj[17] == "" ||
    //         plandetailsobj[17] == undefined ||
    //         plandetailsobj[17] == "null"
    //         ? false
    //         : true,
    //     id: parseFloat(plandetailsobj[7]),
    //     fusebillPlanID:
    //       plandetailsobj[8] == null ||
    //         plandetailsobj[8] == "" ||
    //         plandetailsobj[8] == undefined ||
    //         plandetailsobj[8] == "null"
    //         ? 0
    //         : parseFloat(plandetailsobj[8]),
    //     planFrequencyID:
    //       plandetailsobj[9] == null ||
    //         plandetailsobj[9] == "" ||
    //         plandetailsobj[9] == undefined ||
    //         plandetailsobj[9] == "null"
    //         ? 0
    //         : parseFloat(plandetailsobj[9]),
    //     optIn: plandetailsobj[10] == "true" ? true : false,
    //     planname: plandetailsobj[14],
    //     planLevel: parseInt(plandetailsobj[15]),
    //     packageId: parseInt(plandetailsobj[16]),
    //     options: [],
    //     paidByCompany1: plandetailsobj[19],
    //     coveredByCompany1: plandetailsobj[20],
    //     paidByEmployee1: plandetailsobj[21],
    //     planLevel_parentId: plandetailsobj[12],
    //     // disallowedPlanLevels: plandetailsobj[11],
    //     version: plan.version,
    //     description: plan.description,
    //     insuranceType: plan.insuranceType,
    //   };
    //   if (plandetailsobj[11] != null || plandetailsobj[11] != "null") {
    //     if (plandetailsobj[11].includes(plandetailsobj[12])) {
    //     }
    //   }
    //   let coverage = product.planCoverage;

    //   coverage = ["SINGLE", "COUPLE", "FAMILY"].includes(coverage)
    //     ? coverage
    //     : null;
    //   ////this.consoleMessage(obj)
    //   this.productobj = {
    //     id: product.id,
    //     productId: product.productId,
    //     name: product.name,

    //     planProductId: product.planProductId,
    //     price: adjustWith2DecimalsForUI(product.price1 || product.price),
    //     tax: adjustWith2DecimalsForUI(
    //       product.calculatedTax ? product.calculatedTax.tax : 0
    //     ),
    //     total: adjustWith2DecimalsForUI(
    //       product.calculatedTax ? product.calculatedTax.total : 0
    //     ),
    //     //  price: parseFloat(this._decimalPipe.transform(product.price1 || product.price, "1.2-2")) ,
    //     //  tax: parseFloat(this._decimalPipe.transform(product.calculatedTax ? product.calculatedTax.tax : 0, "1.2-2")),
    //     //  total:parseFloat(this._decimalPipe.transform(product.calculatedTax ? product.calculatedTax.total : 0, "1.2-2")),
    //     tax_details:
    //       product.bundledTaxes && product.bundledTaxes.length > 0
    //         ? product.bundledTaxes
    //         : product.taxesDataJSON,
    //     calculatedTax: product.calculatedTax,
    //     bundledProducts: product.bundledProducts,
    //     planCoverage: product.planCoverage,
    //     planLevel: product.planlevel
    //       ? product.planlevel.id
    //       : plan.planLevel
    //         ? plan.planLevel
    //         : group.id,
    //     planLevelParent: product.planlevel
    //       ? product.planlevel.parentId
    //       : group.parentId,
    //     description: product.description,
    //     coverage: coverage,
    //     version: product.version
    //   };
    //   let obj1: any = {
    //     packageId: plan.packageId,
    //     packageName: pckage.name,

    //     planproductname: this.productobj.name,

    //     groupid: plan.planLevel,
    //     groupName: group.name,
    //     id: plan.id,
    //     name: plan.name,
    //     planLevel: plan.planLevel ? plan.planLevel : group.id,
    //     planLevelParent: group.parentId,
    //     fusebillPlanID: plan.fusebillId,
    //     planFrequencyID: plan.frqMonthly,
    //     isBundle: plan.isBundle,
    //     disallowedPlanLevels: disallowedPlanLevels,
    //     coverage: coverage,
    //     planCoverage: product.planCoverage,
    //     bundledProducts: [],
    //     products: [],
    //     upgradeCalculation: plan.products && plan.products[planProductIndex] ? plan.products[planProductIndex].upgradeCalculation : plan.upgradeCalculation,

    //   };
    //   obj1.products.push(this.productobj);
    //   let finalobj1: any = { ...obj1, ...categorization };



    //   //this.consoleMessage(obj1);


    //   this.planobjdata = finalobj1;
    //   this.planobjdataobj = obj
    //   this.elementcvValues = elementcv

    //   console.log(this.planobjdata)

    //   // this.addtoplansummary(obj, obj1, elementcv);
    //   this.addtoplansummary(obj, finalobj1, elementcv);
    //   this.openplanoptions(elementcv)
    //   // this.openplanoptions(elementcv, options, plan, product);
    // }
    // else {
    let obj = {
      isBundle: plan.isBundle,
      disallowedPlanLevels: disallowedPlanLevels,
      enrollmentDate: '',
      // "name":plandetailsobj[1]+"-"+plandetailsobj[2],
      name: plandetailsobj[14],
      details: plandetailsobj[0],
      packagename: plandetailsobj[0],
      groupName: plandetailsobj[1],
      // amount: parseFloat(plandetailsobj[3]),
      amount: parseFloat(product.calculatedTax.price),
      planCoverage: plandetailsobj[2],
      // planPrice: parseFloat(plandetailsobj[3]),
      planPrice: parseFloat(product.calculatedTax.price),
      // amountUI: "$" + this._decimalPipe.transform(plandetailsobj[3], "1.2-2"),
      amountUI: "$" + parseFloat(product.calculatedTax.price),
      gst:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == "" ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == "null"
          ? 0
          : parseFloat(plandetailsobj[4]),
      hst:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == "" ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == "null"
          ? 0
          : parseFloat(plandetailsobj[5]),
      pst:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == "" ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == "null"
          ? 0
          : parseFloat(plandetailsobj[6]),
      qst:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == "" ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == "null"
          ? 0
          : parseFloat(plandetailsobj[17]),
      gstCheck:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == "" ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == "null"
          ? false
          : true,
      hstCheck:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == "" ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == "null"
          ? false
          : true,
      pstCheck:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == "" ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == "null"
          ? false
          : true,
      qstCheck:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == "" ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == "null"
          ? false
          : true,
      id: parseFloat(plandetailsobj[7]),
      fusebillPlanID:
        plandetailsobj[8] == null ||
          plandetailsobj[8] == "" ||
          plandetailsobj[8] == undefined ||
          plandetailsobj[8] == "null"
          ? 0
          : parseFloat(plandetailsobj[8]),
      planFrequencyID:
        plandetailsobj[9] == null ||
          plandetailsobj[9] == "" ||
          plandetailsobj[9] == undefined ||
          plandetailsobj[9] == "null"
          ? 0
          : parseFloat(plandetailsobj[9]),
      optIn: plandetailsobj[10] == "true" ? true : false,
      planname: plandetailsobj[14],
      planLevel: parseInt(plandetailsobj[15]),
      packageId: parseInt(plandetailsobj[16]),
      options: [],
      paidByCompany1: plandetailsobj[19],
      coveredByCompany1: plandetailsobj[20],
      paidByEmployee1: plandetailsobj[21],
      planLevel_parentId: plandetailsobj[12],
      // disallowedPlanLevels: plandetailsobj[11],
      version: plan.version,
      description: plan.description,
      insuranceType: plan.insuranceType,
    };
    if (plandetailsobj[11] != null || plandetailsobj[11] != "null") {
      if (plandetailsobj[11].includes(plandetailsobj[12])) {
      }
    }

    let coverage = product.planCoverage;

    coverage = ["SINGLE", "COUPLE", "FAMILY"].includes(coverage)
      ? coverage
      : null;
    ////this.consoleMessage(obj)
    this.productobj = {
      id: product.id,
      productId: product.productId,
      name: product.name,

      planProductId: product.planProductId,
      //  price: product.price1 || product.price,
      //  tax: product.calculatedTax ? product.calculatedTax.tax : 0,
      //  total: product.calculatedTax ? product.calculatedTax.total : 0,

      price: adjustWith2DecimalsForUI(product.price1 || product.price),
      tax: adjustWith2DecimalsForUI(
        product.calculatedTax ? product.calculatedTax.tax : 0
      ),
      total: adjustWith2DecimalsForUI(
        product.calculatedTax ? product.calculatedTax.total : 0
      ),
      //  price: parseFloat(this._decimalPipe.transform(product.price1 || product.price, "1.2-2")) ,
      //  tax: parseFloat(this._decimalPipe.transform(product.calculatedTax ? product.calculatedTax.tax : 0, "1.2-2")),
      //  total:parseFloat(this._decimalPipe.transform(product.calculatedTax ? product.calculatedTax.total : 0, "1.2-2")),

      tax_details:
        product.bundledTaxes && product.bundledTaxes.length > 0
          ? product.bundledTaxes
          : product.taxesDataJSON,
      calculatedTax: product.calculatedTax,
      bundledProducts: product.bundledProducts,
      planCoverage: product.planCoverage,
      planLevel: product.planlevel
        ? product.planlevel.id
        : plan.planLevel
          ? plan.planLevel
          : group.id,
      planLevelParent: product.planlevel
        ? product.planlevel.parentId
        : group.parentId,
      description: product.description,
      coverage: coverage,
      version: product.version
    };
    let obj1: any = {
      packageId: plan.packageId,
      packageName: pckage.name,

      planproductname: this.productobj.name,

      groupid: plan.planLevel,
      groupName: group.name,
      id: plan.id,
      name: plan.name,
      planLevel: plan.planLevel ? plan.planLevel : group.id,
      planLevelParent: group.parentId,
      fusebillPlanID: plan.fusebillId,
      planFrequencyID: plan.frqMonthly,
      isBundle: plan.isBundle,
      coverage: coverage,
      planCoverage: product.planCoverage,
      bundledProducts: [],
      products: [],
      upgradeCalculation: plan.products && plan.products[planProductIndex] ? plan.products[planProductIndex].upgradeCalculation : plan.upgradeCalculation,

    };

    obj1.products.push(this.productobj);
    let finalobj1: any = { ...obj1, ...categorization };

    //console.log(finalobj1)


    this.addtoplansummaryCorp(obj, finalobj1, elementcv);
    // }

    setTimeout(() => {


      // this.openplanoptions(elementcv, options, plan, product)
      this.openplanoptionsCorp(elementcv)



    }, 1000);
  }

  public unselectplanCorp(
    elementcv: any,
    options: any,
    plan: any,
    product: any,
    pckage: any,
    group: any,
    planProductIndex: any,
    disallowedPlanLevels: any
  ) {

    //console.log(plan)

    let plandetails = elementcv.attributes.data.value;

    let plandetailsobj = plandetails.split("##");
    let obj = {
      isBundle: plan.isBundle,
      enrollmentDate: '',
      // "name":plandetailsobj[1]+"-"+plandetailsobj[2],
      name: plandetailsobj[14],
      details: plandetailsobj[0],
      packagename: plandetailsobj[0],
      groupName: plandetailsobj[1],
      amount: parseFloat(plandetailsobj[3].replace(/\,/g, "")),
      planCoverage: plandetailsobj[2],
      planPrice: parseFloat(plandetailsobj[3].replace(/\,/g, "")),
      amountUI: "$" + parseFloat(plandetailsobj[3].replace(/\,/g, "")),
      gst:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == "" ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == "null"
          ? 0
          : parseFloat(plandetailsobj[4]),
      hst:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == "" ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == "null"
          ? 0
          : parseFloat(plandetailsobj[5]),
      pst:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == "" ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == "null"
          ? 0
          : parseFloat(plandetailsobj[6]),
      qst:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == "" ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == "null"
          ? 0
          : parseFloat(plandetailsobj[17]),
      gstCheck:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == "" ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == "null"
          ? false
          : true,
      hstCheck:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == "" ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == "null"
          ? false
          : true,
      pstCheck:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == "" ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == "null"
          ? false
          : true,
      qstCheck:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == "" ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == "null"
          ? false
          : true,
      id: parseFloat(plandetailsobj[7]),
      fusebillPlanID:
        plandetailsobj[8] == null ||
          plandetailsobj[8] == "" ||
          plandetailsobj[8] == undefined ||
          plandetailsobj[8] == "null"
          ? 0
          : parseFloat(plandetailsobj[8]),
      planFrequencyID:
        plandetailsobj[9] == null ||
          plandetailsobj[9] == "" ||
          plandetailsobj[9] == undefined ||
          plandetailsobj[9] == "null"
          ? 0
          : parseFloat(plandetailsobj[9]),
      optIn: plandetailsobj[10] == "true" ? true : false,
      planname: plandetailsobj[14],
      planLevel: parseInt(plandetailsobj[15]),
      packageId: parseInt(plandetailsobj[16]),
      options: [],
      paidByCompany1: plandetailsobj[19],
      coveredByCompany1: plandetailsobj[20],
      paidByEmployee1: plandetailsobj[21],
      planLevel_parentId: plandetailsobj[12],
      disallowedPlanLevels: plandetailsobj[11],
    };
    if (plandetailsobj[11] != null || plandetailsobj[11] != "null") {
      if (plandetailsobj[11].includes(plandetailsobj[12])) {
      }
    }

    this.removeplansummaryCorp(obj, group, pckage, elementcv);
    setTimeout(() => {


      this.openplanoptionsCorp(elementcv)


    }, 1000);
  }

  public addtoplansummaryCorp(obj: any, obj1: any, e: any) {
    let planSummary = JSON.parse(sessionStorage.getItem("plansummary") || "[]");

    console.log(obj)
    console.log(obj1)

    /* This code mainly for flex plan silver and gold */


    for (let i = 0; i < planSummary.length; i++) {
      if (obj1.planLevelParent) {
        if (planSummary[i].planLevelParent == obj1.planLevelParent && planSummary[i].coveredByCompany == obj1.coveredByCompany) {

          const dom: HTMLElement = this.elementRef.nativeElement;

          const plan: any = dom.querySelector("#plancheck" + planSummary[i].id + ".coverage" + planSummary[i].coverage);
          //console.log(plan)
          if (plan.checked) {
            plan.checked = false
          }
          planSummary.splice(i, 1)
        }
      }
    }



    //this.consoleMessage("obj1", obj1);
    //console.log("obj", obj);

    let planId;
    if (obj.isBundle == true) {
      planId = obj.id
    } else {
      planId = obj1.products[0].planLevel
    }

    console.log(planId)
    setTimeout(() => {
      console.log(planId)
      const dom: HTMLElement = this.elementRef.nativeElement;


      const plan = dom.querySelectorAll(".plan-description-span.single" + ".plancheck" + planId);
      const plan2 = dom.querySelectorAll(".plan-description-span.couple" + ".plancheck" + planId);
      const plan3 = dom.querySelectorAll(".plan-description-span.family" + ".plancheck" + planId);
      // //console.log(plan)

      if (obj.coverage === "SINGLE") {
        if (plan) {
          plan.forEach((elem: any) => {
            (elem as HTMLElement).style.display = 'block';
          });
        }
        if (plan2) {
          plan2.forEach((elem: any) => {
            (elem as HTMLElement).style.display = 'none';
          });
        }
        if (plan3) {
          plan3.forEach((elem: any) => {
            (elem as HTMLElement).style.display = 'none';
          });
        }
      } else if (obj.coverage === "COUPLE") {
        if (plan) {
          plan.forEach((elem: any) => {
            (elem as HTMLElement).style.display = 'none';
          });
        }
        if (plan2) {
          plan2.forEach((elem: any) => {
            (elem as HTMLElement).style.display = 'block';
          });
        }
        if (plan3) {
          plan3.forEach((elem: any) => {
            (elem as HTMLElement).style.display = 'none';
          });
        }
      } else if (obj.coverage === "FAMILY") {
        if (plan) {
          plan.forEach((elem: any) => {
            (elem as HTMLElement).style.display = 'none';
          });
        }
        if (plan2) {
          plan2.forEach((elem: any) => {
            (elem as HTMLElement).style.display = 'none';
          });
        }
        if (plan3) {
          plan3.forEach((elem: any) => {
            (elem as HTMLElement).style.display = 'block';
          });
        }
      } else {
        // Default case - hide all plans if coverage doesn't match expected
      }



    }, 2000);

    this.addtoslectplansCorp(obj.id, planSummary.length);
    //check if already obj.id exists in planSummary
    let getExistingObj:any = planSummary.find((item:any) => item.id == obj.id);
    if(getExistingObj){
      console.log("object already exists")
    }else{
      planSummary.push(obj);
    }

    let gstprice = 0;
    let hstprice = 0;
    let pstprice = 0;
    let qstprice = 0;

    if (obj.options && obj.options.length > 0) {
      obj["disallowedPlanLevels"] = obj1.disallowedPlanLevels

    }

    if (obj.gst > 0) {
      gstprice = obj.planPrice * obj.gst;

      obj['gstPrice'] = gstprice
        ? this._decimalPipe.transform(gstprice, '1.2-2')
        : 0;
      obj['gstPrice'] = parseFloat(obj['gstPrice']);
    } else {
      obj["gstPrice"] = 0;
    }

    if (obj.hst > 0) {
      hstprice = obj.planPrice * obj.hst;

      obj['hstPrice'] = hstprice
        ? this._decimalPipe.transform(hstprice, '1.2-2')
        : 0;
      obj['hstPrice'] = parseFloat(obj['hstPrice']);
    } else {
      obj["hstPrice"] = 0;
    }

    if (obj.pst > 0) {
      pstprice = obj.planPrice * obj.pst;


      obj['pstPrice'] = pstprice
        ? this._decimalPipe.transform(pstprice, '1.2-2')
        : 0;
      obj['pstPrice'] = parseFloat(obj['pstPrice']);
    } else {
      obj["pstPrice"] = 0;
    }

    if (obj.qst > 0) {
      qstprice = obj.planPrice * obj.qst;

      obj['qstPrice'] = qstprice
        ? this._decimalPipe.transform(qstprice, '1.2-2')
        : 0;
      obj['qstPrice'] = parseFloat(obj['qstPrice']);
    } else {
      obj["qstPrice"] = 0;
    }

    obj["taxUI"] = "";
    if (obj["gstCheck"]) {
      obj["taxUI"] += "<span>";
      if (obj["gstPrice"] == 0) {
        obj["taxUI"] += "-";
      } else {
        obj["taxUI"] +=
          "$" +
          this._decimalPipe.transform(obj["gstPrice"], "1.2-2") +
          "&nbsp;(GST)";
      }
      obj["taxUI"] += "</span>";
    }

    if (obj["pstCheck"]) {
      obj["taxUI"] += "<span>";
      if (obj["pstPrice"] == 0) {
        obj["taxUI"] += "-";
      } else {
        obj["taxUI"] +=
          "$" +
          this._decimalPipe.transform(obj["pstPrice"], "1.2-2") +
          "&nbsp;(PST)";
      }
      obj["taxUI"] += "</span>";
    }

    if (obj["qstCheck"]) {
      obj["taxUI"] += "<span>";
      if (obj["qstPrice"] == 0) {
        obj["taxUI"] += "-";
      } else {
        obj["taxUI"] +=
          "$" +
          this._decimalPipe.transform(obj["qstPrice"], "1.2-2") +
          "&nbsp;(QST)";
      }
      obj["taxUI"] += "</span>";
    }

    if (obj["hstCheck"]) {
      obj["taxUI"] += "<span> ";
      if (obj["hstPrice"] == 0) {
        obj["taxUI"] += "-";
      } else {
        obj["taxUI"] +=
          "$" +
          this._decimalPipe.transform(obj["hstPrice"], "1.2-2") +
          "&nbsp;(HST)";
      }
      obj["taxUI"] += "</span>";
    }

    if (
      !obj["hstCheck"] &&
      !obj["gstCheck"] &&
      !obj["pstCheck"] &&
      !obj["qstCheck"]
    ) {
      obj["taxUI"] += "<span>-";

      obj["taxUI"] += "</span>";
    }

    // ////this.consoleMessage(object["taxUI"])

    // obj["tax"] = parseFloat(
    //   this._decimalPipe.transform(gstprice + hstprice + pstprice + qstprice, "1.2-2")
    // );
    // obj["tax"] = parseFloat(
    //   this._decimalPipe.transform(obj1.products[0].calculatedTax.tax, "1.2-2")
    // );
    obj['tax'] = obj1.products[0]
      ? this._decimalPipe.transform(obj1.products[0].calculatedTax.tax, "1.2-2") : 0;
    obj['tax'] = parseFloat(obj['tax']);
    // obj["products"] =obj1

    obj["coverage"] = obj1.coverage;
    obj["planCoverage"] = obj1.planCoverage;
    obj["planLevelParent"] = obj1.planLevelParent;
    obj["planproductname"] = obj1.planproductname;

    obj["products"] = obj1.products;
    obj["upgradeCalculation"] = obj1.upgradeCalculation;
    obj["paidByCompany"] = obj1.paidByCompany;
    obj["coveredByCompany"] = obj1.coveredByCompany;
    obj["paidByEmployee"] = obj1.paidByEmployee;



    let pricecal = obj1.products[0].calculatedTax.total;
    obj["totalPrice"] = pricecal;

    obj["totalUI"] = "$" + pricecal;

    (obj["total"] = pricecal),
      (obj["skuTotalPrice"] = parseFloat(
        obj1.products.reduce((acc: any, calculatedTax: any) => {
          return acc + calculatedTax.total;
        }, 0)
      ));

    let updatedSum = this.addtosum(obj.skuTotalPrice);
    this.planssummarymain = [];
    this.planssummaryopt = [];

    planSummary.forEach((element: any) => {
      if (element.packagename != "Opt-in") {
        this.planssummarymain.push(element);
      } else {
        this.planssummaryopt.push(element);
      }
    });

    this.plansskumain.push(obj1);

    sessionStorage.setItem("plansskumain", JSON.stringify(this.plansskumain));

    sessionStorage.setItem(
      "plansummarymain",
      JSON.stringify(this.planssummarymain)
    );
    sessionStorage.setItem(
      "plansummaryopt",
      JSON.stringify(this.planssummaryopt)
    );

    sessionStorage.setItem("plansummary", JSON.stringify(planSummary));

    // setTimeout(() => {
    this.planCoverafeFunction();

    // }, 3000);

    if (planSummary.length > 0) {
      // this.plansnexttab = false;
    } else {
      // this.plansnexttab = true;
    }

    if (updatedSum > 0) {
      this.cartcheckvalue = false;
    } else {
      this.cartcheckvalue = true;
    }
    setTimeout(() => {
      // this.planssummarymainLife = JSON.parse(
      //   sessionStorage.getItem('planssummarymainLife') || '[]'
      // );

      this.planssummarymain = JSON.parse(
        sessionStorage.getItem('plansummarymain') || '[]'
      );
      var total = 0;
      // for (let i = 0; i < this.planssummarymainLife.length; i++) {
      //   total += parseFloat(this.planssummarymainLife[i].skuTotalPrice);
      // }
      // for (let i = 0; i < this.planssummarymain.length; i++) {
      //   total += parseFloat(this.planssummarymain[i].skuTotalPrice);
      // }

      this.companypaidproductid = this.companypaidproductid.filter(
        (item: any) => item !== undefined && item !== null
      );

      var result = this.companypaidproductid.reduce((unique: any, o: any) => {
        if (!unique.some((obj: { name: any; }) => obj.name === o.name)) {
          unique.push(o);
        }
        return unique;
      }, []);
      console.log(result);
      const filteredPlans = result.filter((result: any) => result.planLevel === 18);

      console.log(filteredPlans);


      if (filteredPlans.length > 0) {
        for (let i = 0; i < this.planssummarymain.length; i++) {
          if (obj.planproductname.includes("La Vie")) {

            if (this.planssummarymain[i].coverage == obj.coverage) {

            } else {
              const dom: HTMLElement = this.elementRef.nativeElement;
              // const plan: any = dom.querySelector(`#plancheck792`)
              const plan: any = dom.querySelector("#plancheck792" + ".coverage" + obj.coverage);
              setTimeout(() => {
                plan.click()
                // this.toastrService.success("La Vie plan selection automatically includes Complete Executive Care plan", "");
              }, 1000);
            }



          }
        }
      }

      else {
        for (let i = 0; i < this.planssummarymain.length; i++) {
          if (obj.planproductname.includes("La Vie")) {

            if (this.planssummarymain[i].planLevel == 18) {

              if (this.planssummarymain[i].coverage == obj.coverage) {

              } else {
                const dom: HTMLElement = this.elementRef.nativeElement;
                // const plan: any = dom.querySelector(`#plancheck792`)
                const plan: any = dom.querySelector("#plancheck792" + ".coverage" + obj.coverage);
                setTimeout(() => {
                  plan.click()
                  // this.toastrService.success("La Vie plan selection automatically includes Complete Executive Care plan", "");
                }, 1000);
              }
              break;
            }
            else {

              const dom: HTMLElement = this.elementRef.nativeElement;
              // const plan: any = dom.querySelector(`#plancheck792`)
              const plan: any = dom.querySelector("#plancheck792" + ".coverage" + obj.coverage);

              console.log(plan)
              setTimeout(() => {
                plan.click()
                // this.toastrService.success("La Vie plan selection automatically includes Complete Executive Care plan", "");
              }, 1000);
            }
            break;
          }
        }
      }

      for (let i = 0; i < this.planssummarymain.length; i++) {

        total += parseFloat(this.planssummarymain[i].skuTotalPrice);
      }
      //this.consoleMessage(total);

      this.planAmount = parseFloat(total.toString());
      sessionStorage.setItem("totalAmount", this.planAmount);
    }, 100);

    setTimeout(() => {
      let selectplans =
        JSON.parse(sessionStorage.getItem("plansummarymain") || '[]') || "";



      selectplans.forEach((element: any) => {
        if (element.paidByCompany == 1) {
          const dom: HTMLElement = this.elementRef.nativeElement;
          const plan: any = dom.querySelector("#plancheck" + element.id);

          const samePlanIdElements = dom.querySelectorAll('#' + e.id);
          //console.log(samePlanIdElements)
          let targetClassName = 'cp_plan'
          if (e.className.includes('cp_plan')) {
            targetClassName = 'cp_plan'
          }
          else if (e.className.includes('cc_plan')) {
            targetClassName = 'cc_plan'
          }
          else if (e.className.includes('ep_plan')) {
            targetClassName = 'ep_plan'
          }

          for (let i = 0; i < samePlanIdElements.length; i++) {
            let elem = samePlanIdElements[i];
            let element: any = elem;
            // //console.log(elem)
            // //console.log(elem.className.includes('cp_plan'))
            if (elem.className.includes('cp_plan')) {
              element.disabled = false;
              if (element.checked) {
                element.disabled = true;

              }
            }
          }
          if (plan) {
            // plan.disabled = true;
            // if(plan.isBundle){
            //   plan.disabled = false;
            // }else{
            //   plan.disabled = false;
            // }

          }
        }
      });
    }, 1000);

  }






  //   public getindexofplan(obj:any) {
  //     //console.log(obj)
  //     let plansproductarray = JSON.parse(sessionStorage.getItem("plansummary")||'[]');

  //     for (let i = 0; i < plansproductarray.length; i++) {
  //       if (obj.isBundle == false) {
  //         if (plansproductarray[i].id == obj.id) {

  // if (plansproductarray[i].paidByCompany == 1) {
  //   plansproductarray[i].products.forEach((product:any, index:any) => {
  //     const dom: HTMLElement = this.elementRef.nativeElement;
  //     const plan: any = dom.querySelector("#plancheck" + product.id);

  //     if (plan) {
  //       // plan.disabled = false;
  //     }
  //   })

  // }
  //           return i;
  //         }
  //       } else {
  //         if (plansproductarray[i].packagename == obj.packagename) {
  //           if (plansproductarray[i].paidByCompany == 1) {
  //             plansproductarray[i].products.forEach((product:any, index:any) => {
  //               const dom: HTMLElement = this.elementRef.nativeElement;
  //               const plan: any = dom.querySelector("#plancheck" + product.id);

  //               if (plan) {
  //                 plan.disabled = false;
  //               }
  //             })

  //           }
  //           return i;
  //         }
  //       }
  //     }
  //   }

  public getindexofplanCorp(obj: any) {

    //console.log(obj)
    let plansproductarray = JSON.parse(sessionStorage.getItem("plansummary") || '[]');

    for (let i = 0; i < plansproductarray.length; i++) {
      if (obj.isBundle == false) {
        if (plansproductarray[i].id == obj.id) {

          if (plansproductarray[i].paidByCompany == 1) {
            plansproductarray[i].products.forEach((product: any, index: any) => {
              const dom: HTMLElement = this.elementRef.nativeElement;
              const plan: any = dom.querySelector("#plancheck" + product.id);

              if (plan) {
                // plan.disabled = false;
              }
            })

          }
          return i;
        }
      } else {
        if (plansproductarray[i].id == obj.id) {
          if (plansproductarray[i].paidByCompany == 1) {
            plansproductarray[i].products.forEach((product: any, index: any) => {
              const dom: HTMLElement = this.elementRef.nativeElement;
              const plan: any = dom.querySelector("#plancheck" + product.id);

              if (plan) {
                plan.disabled = false;
              }
            })

          }
          return i;
        }
      }
    }
  }
  toggleItem2(item: any): void {
    item.expanded = !item.expanded;
  }


  /*  public removeplansummary12(obj: any, group: any, pckage: any) {
     //this.consoleMessage(obj)

     let planSummary = JSON.parse(sessionStorage.getItem("plansummary") || '[]');



     if (planSummary) {
       ////this.consoleMessage("removeinplanid"+obj.id)

       // let index = this.getslectedplans(obj.id);
       // ////this.consoleMessage(index)

       // if (index > -1) {
       //   planSummary.splice(index, 1);

       // } else {
       //   return;
       // }
       let index: any = this.getindexofplan(obj);

       //console.log(index)
       if (index > -1) {
         planSummary.splice(index, 1);
       } else {
         return;
       }

       let selectedPlans = JSON.parse(sessionStorage.getItem("selectedPlans") || '{}');
       var newselectedplans: any = {};
       for (var i = 0; i < planSummary.length; i++) {
         newselectedplans[planSummary[i].id] = i;
       }

       ////this.consoleMessage("newselectedPlans")
       ////this.consoleMessage(newselectedplans)
       sessionStorage.setItem("selectedPlans", JSON.stringify(newselectedplans));
       // this.removeslectplans(obj.id,planSummary.length)

       let gstprice = 0;
       let hstprice = 0;
       let pstprice = 0;
       let qstprice = 0;

       if (obj.gst > 0) {
         gstprice = obj.planPrice * obj.gst;


         obj['gstPrice'] = gstprice
           ? this._decimalPipe.transform(gstprice, '1.2-2')
           : 0;
         obj['gstPrice'] = parseFloat(obj['gstPrice']);
       } else {
         obj["gstPrice"] = 0;
       }

       if (obj.hst > 0) {
         hstprice = obj.planPrice * obj.hst;




         obj['hstPrice'] = hstprice
           ? this._decimalPipe.transform(hstprice, '1.2-2')
           : 0;
         obj['hstPrice'] = parseFloat(obj['hstPrice']);

       } else {
         obj["hstPrice"] = 0;
       }

       if (obj.pst > 0) {
         pstprice = obj.planPrice * obj.pst;


         obj['pstPrice'] = pstprice
           ? this._decimalPipe.transform(pstprice, '1.2-2')
           : 0;
         obj['pstPrice'] = parseFloat(obj['pstPrice']);




       } else {
         obj["pstPrice"] = 0;
       }
       if (obj.qst > 0) {
         qstprice = obj.planPrice * obj.qst;

         obj['qstPrice'] = qstprice
           ? this._decimalPipe.transform(qstprice, '1.2-2')
           : 0;
         obj['qstPrice'] = parseFloat(obj['qstPrice']);
       } else {
         obj["qstPrice"] = 0;
       }

       obj["taxUI"] = "";
       if (obj["gstCheck"]) {
         obj["taxUI"] += "<span>";
         if (obj["gstPrice"] == 0) {
           obj["taxUI"] += "-";
         } else {
           obj["taxUI"] +=
             "$" +
             this._decimalPipe.transform(obj["gstPrice"], "1.2-2") +
             "&nbsp;(GST)";
         }
         obj["taxUI"] += "</span>";
       }

       if (obj["pstCheck"]) {
         obj["taxUI"] += "<span>";
         if (obj["pstPrice"] == 0) {
           obj["taxUI"] += "-";
         } else {
           obj["taxUI"] +=
             "$" +
             this._decimalPipe.transform(obj["pstPrice"], "1.2-2") +
             "&nbsp;(PST)";
         }
         obj["taxUI"] += "</span>";
       }

       if (obj["qstCheck"]) {
         obj["taxUI"] += "<span>";
         if (obj["qstPrice"] == 0) {
           obj["taxUI"] += "-";
         } else {
           obj["taxUI"] +=
             "$" +
             this._decimalPipe.transform(obj["qstPrice"], "1.2-2") +
             "&nbsp;(QST)";
         }
         obj["taxUI"] += "</span>";
       }

       if (obj["hstCheck"]) {
         obj["taxUI"] += "<span> ";
         if (obj["hstPrice"] == 0) {
           obj["taxUI"] += "-";
         } else {
           obj["taxUI"] +=
             "$" +
             this._decimalPipe.transform(obj["hstPrice"], "1.2-2") +
             "&nbsp;(HST)";
         }
         obj["taxUI"] += "</span>";
       }

       if (
         !obj["hstCheck"] &&
         !obj["gstCheck"] &&
         !obj["pstCheck"] &&
         !obj["qstCheck"]
       ) {
         obj["taxUI"] += "<span>-";

         obj["taxUI"] += "</span>";
       }

       // ////this.consoleMessage(object["taxUI"])



       obj['tax'] = gstprice + hstprice + pstprice + qstprice
         ? this._decimalPipe.transform(gstprice + hstprice + pstprice + qstprice, '1.2-2')
         : 0;
       obj['tax'] = parseFloat(obj['tax']);
       (obj["totalPrice"] =
         obj.planPrice + gstprice + hstprice + pstprice + qstprice),
         (obj["totalUI"] =
           "$" +
           parseFloat(
             obj.planPrice + gstprice + hstprice + pstprice + qstprice
           ));

       obj["total"] = parseFloat(
         obj.planPrice + gstprice + hstprice + pstprice + qstprice
       );

       let updatedSum = this.removetosum(obj.totalPrice);
       this.planssummarymain = [];
       this.planssummaryopt = [];

       planSummary.forEach((element: any) => {
         if (element.packagename != "Opt-in") {
           this.planssummarymain.push(element);
         } else {
           this.planssummaryopt.push(element);
         }
       });

       sessionStorage.setItem(
         "plansummarymain",
         JSON.stringify(this.planssummarymain)
       );
       sessionStorage.setItem(
         "plansummaryopt",
         JSON.stringify(this.planssummaryopt)
       );
       //console.log(JSON.stringify(planSummary))
       sessionStorage.setItem("plansummary", JSON.stringify(planSummary));
       if (planSummary.length > 0) {
         this.plansnexttab = false;
       } else {
         this.plansnexttab = true;
       }
       this.planCoverafeFunction();


       if (updatedSum > 0) {
         this.cartcheckvalue = false;
       } else {
         this.cartcheckvalue = true;
       }

       setTimeout(() => {
         let selectplans =
           JSON.parse(sessionStorage.getItem("plansummarymain") || '[]') || "";

         //this.consoleMessage(pckage);
         //this.consoleMessage(group);

         if (
           group.categorization.coveredByCompany == 1 ||
           group.categorization.paidByEmployee == 1
         ) {
           pckage.groups.forEach((element: any) => {
             if (element.categorization.paidByCompany == 1) {
               element.plans.forEach((plan: any) => {
                 Object.keys(plan.productAddonss).forEach((key) => {
                   plan.productAddonss[key].forEach((product: any) => {
                     this.adddisabledcompanypaidproductid.push({
                       id: product.id,
                       packgeid: plan.packageId,
                     });
                     //this.consoleMessage(this.adddisabledcompanypaidproductid);
                   });
                 });
               });
             }
           });

           //this.consoleMessage(this.adddisabledcompanypaidproductid);
           //here apply logic

           this.adddisabledcompanypaidproductid.forEach((element: any, index: any) => {
             const dom: HTMLElement = this.elementRef.nativeElement;
             const plan: any = dom.querySelector("#plancheck" + element.id);

             //this.consoleMessage(selectplans);

             // //this.consoleMessage(selectplans.products)

             if (
               selectplans.some(function (el: any) {
                 return el.packageId == element.packgeid;
               })
             ) {
               selectplans.forEach((products: any) => {
                 // //this.consoleMessage(products.packageId)
                 // //this.consoleMessage(element.packgeid)
                 if (products.packageId == element.packgeid) {
                   // //this.consoleMessage("CheckHere")
                   products.products.forEach((prod: any) => {
                     // //this.consoleMessage(prod.id)
                     // //this.consoleMessage(element.id)
                     if (prod.id == element.id) {
                     } else {
                       // $("#plancheck" + element.id).click()
                     }
                   });
                 } else {
                   // //this.consoleMessage("CheckHere1")



                   // $("#plancheck" + element.id).click()
                   // $("#plancheck" + element.id).prop('disabled',true)
                   // plan.disabled=true
                 }
               });
             } else {

               // const dom: HTMLElement = this.elementRef.nativeElement;
               // const plan: any = dom.querySelector("#plancheck" + element.id);

               //  const planCheck = this.renderer.selectRootElement("#plancheck"+ element.id, true);
               //     this.renderer.setProperty(planCheck, 'click', true);
               //     this.renderer.setProperty(planCheck, 'disabled', true);
               // this.renderer.selectRootElement("#plancheck"+ element.id).click()
               // this.renderer.selectRootElement("#plancheck"+ element.id).prop("disabled", true);
               // $("#plancheck" + element.id).click(); //rakesh
               // $("#plancheck" + element.id).prop("disabled", true); //rakesh

               this.renderer.selectRootElement("#plancheck" + element.id).click()
               const dom: HTMLElement = this.elementRef.nativeElement;
               const plan: any = dom.querySelector("#plancheck" + element.id);
               //console.log(plan)

               if (plan) {
                 plan.disabled = true;
               }
             }
           });
         }

         setTimeout(() => {
           let selectplans =
             JSON.parse(sessionStorage.getItem("plansummarymain") || '[]') || "";

           selectplans.forEach((products: any) => {
             if (products.paidByCompany == 1) {
               products.products.forEach((element: any) => {
                 const dom: HTMLElement = this.elementRef.nativeElement;
                 const plan: any = dom.querySelector("#plancheck" + element.id);

                 //this.consoleMessage(plan);

                 if (plan) {
                   plan.disabled = true;
                 }
               });
             }
           });
         }, 1000);




       }, 100);
     }
   } */

  public removeplansummaryCorp(obj: any, group: any, pckage: any, e: any) {



    console.log(obj)
    let planSummary = JSON.parse(sessionStorage.getItem("plansummary") || '[]');

    if (obj.planLevel == 15) {
      for (let i = 0; i < planSummary.length; i++) {

        if (planSummary[i].planLevel == 18) {
          planSummary[i].options = []
        }

      }

    }

    if (planSummary) {

      let index: any = this.getindexofplanCorp(obj);
      if (index > -1) {
        planSummary.splice(index, 1);
      } else {

        return;
      }

      var newselectedplans: any = {};
      for (var i = 0; i < planSummary.length; i++) {
        newselectedplans[planSummary[i].id] = i;
      }

      sessionStorage.setItem("selectedPlans", JSON.stringify(newselectedplans));

      let gstprice = 0;
      let hstprice = 0;
      let pstprice = 0;
      let qstprice = 0;

      if (obj.gst > 0) {
        gstprice = obj.planPrice * obj.gst;


        obj['gstPrice'] = gstprice
          ? this._decimalPipe.transform(gstprice, '1.2-2')
          : 0;
        obj['gstPrice'] = parseFloat(obj['gstPrice']);
      } else {
        obj["gstPrice"] = 0;
      }

      if (obj.hst > 0) {
        hstprice = obj.planPrice * obj.hst;




        obj['hstPrice'] = hstprice
          ? this._decimalPipe.transform(hstprice, '1.2-2')
          : 0;
        obj['hstPrice'] = parseFloat(obj['hstPrice']);

      } else {
        obj["hstPrice"] = 0;
      }

      if (obj.pst > 0) {
        pstprice = obj.planPrice * obj.pst;


        obj['pstPrice'] = pstprice
          ? this._decimalPipe.transform(pstprice, '1.2-2')
          : 0;
        obj['pstPrice'] = parseFloat(obj['pstPrice']);




      } else {
        obj["pstPrice"] = 0;
      }
      if (obj.qst > 0) {
        qstprice = obj.planPrice * obj.qst;

        obj['qstPrice'] = qstprice
          ? this._decimalPipe.transform(qstprice, '1.2-2')
          : 0;
        obj['qstPrice'] = parseFloat(obj['qstPrice']);
      } else {
        obj["qstPrice"] = 0;
      }

      obj["taxUI"] = "";
      if (obj["gstCheck"]) {
        obj["taxUI"] += "<span>";
        if (obj["gstPrice"] == 0) {
          obj["taxUI"] += "-";
        } else {
          obj["taxUI"] +=
            "$" +
            this._decimalPipe.transform(obj["gstPrice"], "1.2-2") +
            "&nbsp;(GST)";
        }
        obj["taxUI"] += "</span>";
      }

      if (obj["pstCheck"]) {
        obj["taxUI"] += "<span>";
        if (obj["pstPrice"] == 0) {
          obj["taxUI"] += "-";
        } else {
          obj["taxUI"] +=
            "$" +
            this._decimalPipe.transform(obj["pstPrice"], "1.2-2") +
            "&nbsp;(PST)";
        }
        obj["taxUI"] += "</span>";
      }

      if (obj["qstCheck"]) {
        obj["taxUI"] += "<span>";
        if (obj["qstPrice"] == 0) {
          obj["taxUI"] += "-";
        } else {
          obj["taxUI"] +=
            "$" +
            this._decimalPipe.transform(obj["qstPrice"], "1.2-2") +
            "&nbsp;(QST)";
        }
        obj["taxUI"] += "</span>";
      }

      if (obj["hstCheck"]) {
        obj["taxUI"] += "<span> ";
        if (obj["hstPrice"] == 0) {
          obj["taxUI"] += "-";
        } else {
          obj["taxUI"] +=
            "$" +
            this._decimalPipe.transform(obj["hstPrice"], "1.2-2") +
            "&nbsp;(HST)";
        }
        obj["taxUI"] += "</span>";
      }

      if (
        !obj["hstCheck"] &&
        !obj["gstCheck"] &&
        !obj["pstCheck"] &&
        !obj["qstCheck"]
      ) {
        obj["taxUI"] += "<span>-";

        obj["taxUI"] += "</span>";
      }

      // ////this.consoleMessage(object["taxUI"])



      obj['tax'] = gstprice + hstprice + pstprice + qstprice
        ? this._decimalPipe.transform(gstprice + hstprice + pstprice + qstprice, '1.2-2')
        : 0;
      obj['tax'] = parseFloat(obj['tax']);
      (obj["totalPrice"] =
        obj.planPrice + gstprice + hstprice + pstprice + qstprice),
        (obj["totalUI"] =
          "$" +
          parseFloat(
            obj.planPrice + gstprice + hstprice + pstprice + qstprice
          ));

      obj["total"] = parseFloat(
        obj.planPrice + gstprice + hstprice + pstprice + qstprice
      );

      let updatedSum = this.removetosumCorp(obj.totalPrice);
      this.planssummarymain = [];
      this.planssummaryopt = [];
      //console.log(planSummary)

      planSummary.forEach((element: any) => {
        if (element.packagename != "Opt-in") {
          this.planssummarymain.push(element);
        } else {
          this.planssummaryopt.push(element);
        }
      });

      sessionStorage.setItem(
        "plansummarymain",
        JSON.stringify(this.planssummarymain)
      );
      sessionStorage.setItem(
        "plansummaryopt",
        JSON.stringify(this.planssummaryopt)
      );

      sessionStorage.setItem("plansummary", JSON.stringify(planSummary));
      if (planSummary.length > 0) {
        // this.plansnexttab = false;
      } else {
        // this.plansnexttab = true;
      }


      this.planCoverafeFunction();


      if (updatedSum > 0) {
        this.cartcheckvalue = false;
      } else {
        this.cartcheckvalue = true;
      }





      setTimeout(() => {
        let selectplans =
          JSON.parse(sessionStorage.getItem("plansummarymain") || '[]') || "";

        //console.log(pckage);
        //console.log(group);

        let adddisabledcompanypaidproductid: any = []

        if (
          group.categorization.coveredByCompany == 1
          ||
          group.categorization.paidByEmployee == 1
        ) {
          pckage.groups.forEach((element: any) => {
            if (element.categorization.paidByCompany == 1) {
              if (group?.parentId == element?.parentId) {
                element.plans.forEach((plan: any) => {

                  let pl = { ...plan, ...element.categorization }
                  Object.keys(plan.productAddonss).forEach((key) => {
                    plan.productAddonss[key].forEach((product: any) => {
                      //console.log(product)
                      //console.log(pl)
                      if (pl.isBundle) {
                        adddisabledcompanypaidproductid.push(
                          pl,
                        );
                      } else {
                        adddisabledcompanypaidproductid.push(product.planlevel);
                      }

                    });
                  });
                });
              }
            }
          });



          adddisabledcompanypaidproductid = adddisabledcompanypaidproductid.filter(
            (item: any) => item !== undefined && item !== null
          );
          console.log(adddisabledcompanypaidproductid);

          for (let i = 0; i < adddisabledcompanypaidproductid.length; i++) {
            // adddisabledcompanypaidproductid.forEach((element: any, index: any) => {
            const dom: HTMLElement = this.elementRef.nativeElement;
            // const plan: any = dom.querySelector("#plancheck" + adddisabledcompanypaidproductid[i].id);


            // const planCheck1 = this.renderer.selectRootElement("#plancheck" + element.id, true);

            let selectPlanCheck;
            if (obj?.isBundle == true) {
              selectPlanCheck = selectplans.some(function (el: any) {
                return el.packageId == adddisabledcompanypaidproductid[i].packageId && el.planLevelParent == adddisabledcompanypaidproductid[i].planLevel_parentId;
              })
            }
            else {
              selectPlanCheck = selectplans.some(function (el: any) {
                return el.packageId == adddisabledcompanypaidproductid[i].packageId;
              })



              let planData: any = dom.querySelectorAll("#plancheck" + adddisabledcompanypaidproductid[i].id);
              let targetClassName = 'cp_plan'
              if (e.className.includes('cp_plan')) {
                targetClassName = 'cp_plan'
              }
              else if (e.className.includes('cc_plan')) {
                targetClassName = 'cc_plan'
              }
              else if (e.className.includes('ep_plan')) {
                targetClassName = 'ep_plan'
              }

              for (let i = 0; i < planData.length; i++) {
                console.log(planData[i])
                if (planData[i].className.includes('cp_plan')) {
                  planData[i].click()
                  return false;

                }
              }


            }

            //console.log(selectPlanCheck)
            if (selectPlanCheck) {

              selectplans.forEach((products: any) => {

                if (products.packageId == adddisabledcompanypaidproductid[i].packageId) {

                  products.products.forEach((prod: any) => {
                    // if (prod.id == adddisabledcompanypaidproductid[i].id) {
                    if (prod.planLevel == adddisabledcompanypaidproductid[i].id) {
                    } else {
                      //console.log("checkHere")
                      // $("#plancheck" + element.id).click()
                    }
                  });
                } else {
                  // //this.consoleMessage("CheckHere1")

                }
              });
            } else {


              const dom: HTMLElement = this.elementRef.nativeElement;

              let coverage = adddisabledcompanypaidproductid[i].companyPaidCoverage?.replace("SELECTIVE_", "")
              //console.log(coverage)

              let planData;
              if (coverage && coverage != "DIRECT") {
                planData = dom.querySelectorAll("#plancheck" + adddisabledcompanypaidproductid[i].id + ".coverage" + coverage)
                //console.log(planData)
                let targetClassName = 'cp_plan'
                if (e.className.includes('cp_plan')) {
                  targetClassName = 'cp_plan'
                }
                else if (e.className.includes('cc_plan')) {
                  targetClassName = 'cc_plan'
                }
                else if (e.className.includes('ep_plan')) {
                  targetClassName = 'ep_plan'
                }

                planData.forEach((element: any) => {
                  if (element.className.includes('cp_plan')) {

                    //console.log(element)
                    element.click()
                  }
                });
                break;
              }
              else {
                planData = dom.querySelectorAll("#plancheck" + adddisabledcompanypaidproductid[i].id);
                let targetClassName = 'cp_plan'
                if (e.className.includes('cp_plan')) {
                  targetClassName = 'cp_plan'
                }
                else if (e.className.includes('cc_plan')) {
                  targetClassName = 'cc_plan'
                }
                else if (e.className.includes('ep_plan')) {
                  targetClassName = 'ep_plan'
                }

                planData.forEach((element: any) => {
                  if (element.className.includes('cp_plan')) {

                    //console.log(element)
                    element.click()
                  }
                });
              }


            }
          }
        }




        setTimeout(() => {
          let selectplans =
            JSON.parse(sessionStorage.getItem("plansummarymain") || '[]') || "";

          selectplans.forEach((products: any) => {
            if (products.paidByCompany == 1) {
              products.products.forEach((element: any) => {
                const dom: HTMLElement = this.elementRef.nativeElement;
                const plan: any = dom.querySelector("#plancheck" + element.id);

                //this.consoleMessage(plan);

                if (plan) {

                }


                const samePlanIdElements = dom.querySelectorAll('#' + e.id);
                //console.log(e)
                let targetClassName = 'cp_plan'
                if (e.className.includes('cp_plan')) {
                  targetClassName = 'cp_plan'
                }
                else if (e.className.includes('cc_plan')) {
                  targetClassName = 'cc_plan'
                }
                else if (e.className.includes('ep_plan')) {
                  targetClassName = 'ep_plan'
                }

                for (let i = 0; i < samePlanIdElements.length; i++) {
                  let elem = samePlanIdElements[i];
                  let element: any = elem;
                  if (elem.className.includes('cp_plan')) {
                    element.disabled = false;
                    if (element.checked) {
                      element.disabled = true;

                    }
                  }

                }
              });
            }
          });
        }, 1000);
      }, 100);



      setTimeout(() => {
        let selectplansInfo =
          JSON.parse(sessionStorage.getItem("plansummary") || '[]') || "";

        //console.log(selectplansInfo)

        console.log(obj)

        if (selectplansInfo.length > 0) {
          for (let i = 0; i < selectplansInfo.length; i++) {


            let planId;
            if (selectplansInfo[i].isBundle == true) {
              planId = selectplansInfo[i].id
            } else {
              planId = selectplansInfo[i].products[0].planLevel
            }
            if (selectplansInfo[i].id == obj.id) {

            }

            else {
              setTimeout(() => {
                const dom: HTMLElement = this.elementRef.nativeElement;
                const plan = dom.querySelectorAll(".plan-description-span.single" + ".plancheck" + planId);
                const plan2 = dom.querySelectorAll(".plan-description-span.couple" + ".plancheck" + planId);
                const plan3 = dom.querySelectorAll(".plan-description-span.family" + ".plancheck" + planId);
                /*  //console.log(plan) */


                plan.forEach((elem: any) => {
                  (elem as HTMLElement).style.display = 'block';
                });

                plan2.forEach((elem: any) => {
                  (elem as HTMLElement).style.display = 'block';
                });
                plan3.forEach((elem: any) => {
                  (elem as HTMLElement).style.display = 'block';
                });



              }, 1000);
            }
          }



        }
        else {
          setTimeout(() => {
            const dom: HTMLElement = this.elementRef.nativeElement;
            const plan = dom.querySelectorAll(".plan-description-span.single" + ".plancheck" + obj.id);
            const plan2 = dom.querySelectorAll(".plan-description-span.couple" + ".plancheck" + obj.id);
            const plan3 = dom.querySelectorAll(".plan-description-span.family" + ".plancheck" + obj.id);
            /*  //console.log(plan) */


            plan.forEach((elem: any) => {
              (elem as HTMLElement).style.display = 'block';
            });

            plan2.forEach((elem: any) => {
              (elem as HTMLElement).style.display = 'block';
            });
            plan3.forEach((elem: any) => {
              (elem as HTMLElement).style.display = 'block';
            });



          }, 1000);
        }
      }, 1000);

      setTimeout(() => {
        let selectplansInfo = JSON.parse(sessionStorage.getItem("plansummary") || '[]') || "";
        if (selectplansInfo.length === 0) {
          if (obj.groupName != "Complete Executive Care") {
            this.autoSelectCompanyPaidPlans()
          }


        }
      }, 1000);
    }
  }

  public addtoslectplansCorp(planid: number, plansumamryindex: number) {

    let selectedPlans = JSON.parse(
      sessionStorage.getItem("selectedPlans") || "{}"
    );
    ////this.consoleMessage(selectedPlans)
    selectedPlans[planid] = plansumamryindex;
    ////this.consoleMessage("afteraddtoplans")
    ////this.consoleMessage(selectedPlans)
    sessionStorage.setItem("selectedPlans", JSON.stringify(selectedPlans));
  }

  public removeslectplansCorp(planid: number, plansumamryindex: number) {
    ////this.consoleMessage("beforeremoveplans")
    let selectedPlans = JSON.parse(sessionStorage.getItem("selectedPlans") || '{}');

    ////this.consoleMessage(selectedPlans)
    delete selectedPlans[planid];

    for (const planid in selectedPlans) {
      ////this.consoleMessage(planid)
      ////this.consoleMessage(selectedPlans[planid])

      if (selectedPlans[planid] != 0) {
        selectedPlans[planid] = selectedPlans[planid] - 1;
        if (selectedPlans[planid]) {
        }
      }
    }
    ////this.consoleMessage("adjustedselectedPlans")
    ////this.consoleMessage(selectedPlans)
    sessionStorage.setItem("selectedPlans", JSON.stringify(selectedPlans));
  }

  public getslectedplansCorp(planid: number) {
    ////this.consoleMessage(planid)
    let selectedPlans = JSON.parse(
      sessionStorage.getItem("selectedPlans") || "{}"
    );
    ////this.consoleMessage(selectedPlans)
    return selectedPlans[planid];
  }

  public addtosumCorp(amount: number) {
    //this.consoleMessage("addtosum" + amount);

    // amount = Math.round((amount + Number.EPSILON) * 100) / 100;

    let selectedPlansAmount = parseFloat(
      sessionStorage.getItem("totalAmount") || "0.00"
    );

    selectedPlansAmount = selectedPlansAmount + amount;

    //this.consoleMessage("selectedPlansAmount" + selectedPlansAmount);
    let totalAmount: any = this._decimalPipe.transform(selectedPlansAmount, "1.2-2")?.replace(/,/g, "")
    sessionStorage.setItem(
      "totalAmount",
      totalAmount
    );

    sessionStorage.setItem(
      "totalAmountUI",
      "$" +
      this._decimalPipe.transform(selectedPlansAmount, "1.2-2")?.replace(/,/g, "")
    );

    // this.planAmount = selectedPlansAmount

    this.planAmount = this._decimalPipe
      .transform(selectedPlansAmount, "1.2-2")
      ?.replace(/,/g, "");

    //this.consoleMessage("palnamopunt" + this.planAmount);
    return selectedPlansAmount;
    // //////this.consoleMessage(this.planAmount )
  }

  public removetosumCorp(amount: number) {

    let selectedPlansAmount: any = parseFloat(sessionStorage.getItem("totalAmount") || '0')
    // selectedPlansAmount =selectedPlansAmount.replace(/,/g, "");
    selectedPlansAmount = selectedPlansAmount - amount;
    let finaltotalAmount: any = this._decimalPipe.transform(selectedPlansAmount, "1.2-2")?.replace(/,/g, "")
    sessionStorage.setItem(
      "totalAmount", finaltotalAmount)
    sessionStorage.setItem(
      "totalAmountUI",
      "$" +
      this._decimalPipe
        .transform(selectedPlansAmount, "1.2-2")
        ?.replace(/,/g, "")
    );

    // this.planAmount = selectedPlansAmount
    this.planAmount = this._decimalPipe
      .transform(selectedPlansAmount, "1.2-2")
      ?.replace(/,/g, "");
    return selectedPlansAmount;
  }

  public openplanoptionsCorp(elementcv: any) {
    let plandetails = elementcv.attributes.data.value;

    let plandetailsobj = plandetails.split("##");

    let modifiedOptions: any = [];
    let optionumber: any = [];
    // let optionumber = $("#optionumber").val();  //rakesh
    // jQuery("#showplanoptions-modal").modal("hide");

    // for (let i = 1; i <= optionumber; i++) {
    //   // $(".optionselectionmethod-" + i + ":checked").prop("checked", false);
    // }
    let optionsValue = JSON.parse(sessionStorage.getItem('options') || '[]');


    console.log(optionsValue)
    let planSummary = JSON.parse(sessionStorage.getItem('plansummary') || '[]');

    for (let i = 0; i < planSummary.length; i++) {

      if (planSummary[i].planproductname && planSummary[i].planproductname.includes("Medcan")) {
        // Your code here

        const filteredData = optionsValue.map((item: any) => {
          return {
            ...item, // Preserve the rest of the object
            planOptionsValues: item.planOptionsValues.filter((option: any) =>
              option.name.includes("Medcan") ||
              option.name.includes("Yes") ||
              option.name.includes("No")
            )
          };
        });

        optionsValue = filteredData


      }
      if (planSummary[i].planproductname && planSummary[i].planproductname.includes("La Vie")) {
        // Your code here

        const filteredData = optionsValue.map((item: any) => {
          return {
            ...item, // Preserve the rest of the object
            planOptionsValues: item.planOptionsValues.filter((option: any) =>
              option.name.includes("La Vie") ||
              option.name.includes("Yes") ||
              option.name.includes("No")
            )
          };
        });

        optionsValue = filteredData


      }

      if (planSummary[i].planproductname && planSummary[i].planproductname.includes("La Vie") && planSummary[i].planproductname.includes("Medcan")) {
        // Your code here

        const filteredData = optionsValue.map((item: any) => {
          return {
            ...item, // Preserve the rest of the object
            planOptionsValues: item.planOptionsValues.filter((option: any) =>
              option.name.includes("La Vie") || option.name.includes("Medcan") ||
              option.name.includes("Yes") ||
              option.name.includes("No")
            )
          };
        });

        optionsValue = filteredData


      }

    }
    // this.plandetailsobjvalue = plandetailsobj;

    this.plandetailsobjvalue = plandetails;

    optionsValue.forEach((element: any) => {
      element.planOptionsValues.forEach((options: any) => {
        options.planOptionName = element.name;
        options.json = JSON.stringify(options);
      });

      modifiedOptions.push(element);
    });

    this.optionstitle = modifiedOptions;
    //this.consoleMessage("isexeccp:" + plandetailsobj[19]);
    this.isExecutiveCP = plandetailsobj[19]
      ? parseInt(plandetailsobj[19]) == 1
        ? true
        : false
      : false;
    // this.planOptionsModel = true
    // alert("startrhetre")
    // jQuery("#showplanoptions-modal").modal("show");
  }

  public closeplanoptions() { }

  public chooseplan() {
    this.isDisabledplan = true;
  }



  public planCoverafeFunction() {
    this.paidEmployeeShare = 0;
    this.coveredEmployeeShare = 0;

    //this.consoleMessage("plancoverage");

    let planDetailsArray = JSON.parse(
      sessionStorage.getItem("planDetailsArray") || "[]"
    );
    //this.consoleMessage(planDetailsArray);
    // var package_plans = this.convertpackagesToPlans(planDetailsArray);
    // var package_plans = this.convertpackagesToPlans2(this.packagesInBlocks);
    var package_plans = this.convertpackagesToPlans2(this.basepackages);

    //this.consoleMessage(package_plans);
    let planSummaryMain = JSON.parse(sessionStorage.getItem("plansummary") || "[]");
    let planSummaryLife = JSON.parse(sessionStorage.getItem("plansummaryLife") || "[]");
    // let iafgplansCheck = JSON.parse(
    //   sessionStorage.getItem('plansummaryLife') || '[]'
    // );

    this.iafgplansCheck = JSON.parse(
      sessionStorage.getItem('plansummaryLife') || '[]'
    );
    //console.log(planSummaryMain)

    // let planSummary;
    // if(planSummaryMain.length>0){
    //  let planSummary = planSummaryMain.concat(planSummaryLife)
    // }else{
    //    planSummary = planSummaryLife
    // }
    let planSummary = planSummaryMain.concat(planSummaryLife)

    //console.log(planSummary)
    //this.consoleMessage(planSummary);
    var all_selected_plans:any = [];
    var payrollCCplans:any = [];
    var directpayCCplans:any = [];
    var employeeDealingPlans:any = [];
    var companyDealingPlans:any = [];
    var alloptinplans:any = [];
    var company_selected_plans:any = [];
    var employee_selected_plans:any = [];
    var company_paid_selected_plans:any = [];
    var company_covered_selected_plans:any = [];


    var selected_cp_plans = planSummary.filter(function (plan: any) {
      return plan.paidByCompany == 1 || plan.categorization?.paidByCompany == true;
    });

    var selected_cc_plans = planSummary.filter(function (plan: any) {
      return plan.coveredByCompany == 1 || plan.categorization?.coveredByCompany == true;
    });

    var selected_ep_plans = planSummary.filter(function (plan: any) {
      return plan.paidByEmployee == 1 || plan.categorization?.paidByEmployee == true;
    });

    // var selected_cc_plans = planSummary.forEach(element => {

    //   element.groups.forEach(group => {
    //     return group.categorization.coveredByCompany == 1;

    //   });

    // });

    // var selected_cp_plans = planSummary.forEach(element => {

    //   element.groups.forEach(group => {
    //     return group.categorization.paidByCompany == 1;

    //   });

    // });
    // var selected_ep_plans = planSummary.forEach(element => {

    //   element.groups.forEach(group => {
    //     return group.categorization.paidByEmployee == 1;

    //   });

    // });

    //this.consoleMessage(selected_cc_plans);
    //this.consoleMessage(selected_cp_plans);
    //this.consoleMessage(selected_ep_plans);

    //console.log(selected_cp_plans)

    for (var cp = 0; cp < selected_cp_plans.length; cp++) {
      var current_cp_plan: any = selected_cp_plans[cp];

      // current_cp_plan.amount = parseFloat(
      //   this._decimalPipe.transform(current_cp_plan.amount, "1.2-2")
      // );
      current_cp_plan.amount = adjustWith2DecimalsForUI(current_cp_plan.amount)

      // //this.consoleMessage("rakesh",current_cp_plan.amount)
      current_cp_plan["amounts"] = {
        company: current_cp_plan.amount,
        employee: 0,
        total: current_cp_plan.amount,
      };
      current_cp_plan["categorization"] = {
        paidByCompany: true,
        coveredByCompany: false,
        paidByEmployee: false,
      };

      console.log("you are here broo")
      current_cp_plan["type"] = "100% Company Paid";

      current_cp_plan["companyCoveredBasePlan"] = {
        planId: 0, //0
        planName: "NA", //NA
        planLevelId: 0, //0
        amount: 0, //0
        tax: 0,
        total: 0,
      };
      current_cp_plan["employeeAmount"] = current_cp_plan["amounts"].employee;
      current_cp_plan["employeeAmountUI"] =
        "$" + current_cp_plan["amounts"].employee;
      current_cp_plan["companyAmount"] = current_cp_plan["amounts"].company;
      current_cp_plan["companyAmountUI"] =
        "$" + current_cp_plan["amounts"].company;
      current_cp_plan["planLevelName"] = current_cp_plan.groupName || ""; //Here

      if (
        current_cp_plan.id == 429 ||
        current_cp_plan.packageId == 8 ||
        current_cp_plan.planLevel == 16
      ) {
        alloptinplans.push(current_cp_plan);
      } else {
        all_selected_plans.push(current_cp_plan);
        company_selected_plans.push(current_cp_plan);
        company_paid_selected_plans.push(current_cp_plan);
      }
    }

    for (var cc = 0; cc < selected_cc_plans.length; cc++) {
      var current_cc_plan: any = selected_cc_plans[cc];

      current_cc_plan["amounts"] = {
        company: current_cc_plan.upgradeCalculation.baseplanPrice,
        employee: current_cc_plan.upgradeCalculation.deltaplanPrice,
        total: current_cc_plan.upgradeCalculation.combinedplanPrice,
      };

      current_cc_plan["companyCoveredBasePlan"] =
        current_cc_plan.upgradeCalculation.basePlanDetails;

      current_cc_plan["companyCoveredBasePlan"].companyTax =
        current_cc_plan.upgradeCalculation.baseplanTax;
      current_cc_plan["companyCoveredBasePlan"].companyTaxPercentage =
        current_cc_plan.upgradeCalculation.companyTaxPercentage;

      current_cc_plan["companyCoveredBasePlan"].employeeTax = 0;
      current_cc_plan["companyCoveredBasePlan"].employeeTaxPercentage =
        current_cc_plan.upgradeCalculation.employeeTaxPercentage;
      current_cc_plan["companyCoveredBasePlan"].employeeTaxEffect = 0;
      current_cc_plan["companyCoveredBasePlan"].employeeTaxPercentageEffect =
        "0%";
      current_cc_plan["companyCoveredBasePlan"].specialTax =
        current_cc_plan["companyCoveredBasePlan"].companyTax +
        current_cc_plan["companyCoveredBasePlan"].employeeTaxEffect;
      current_cc_plan["companyCoveredBasePlan"].tax2 =
        current_cc_plan["companyCoveredBasePlan"].companyTax;

      //this.consoleMessage(current_cc_plan);
      ///
      //deleta plan things
      current_cc_plan["employeeDeductions"] = {
        amount: current_cc_plan.upgradeCalculation.deltaplanPrice, //0
        amountUI: `$${current_cc_plan.upgradeCalculation.deltaplanPrice}`, //0
        tax: `${current_cc_plan.upgradeCalculation.deltaplanTax}`,
        total: `${current_cc_plan.upgradeCalculation.deltaplanTotal}`,
        taxUI: `$${current_cc_plan.upgradeCalculation.deltaplanTax}`,
        totalUI: `$${current_cc_plan.upgradeCalculation.deltaplanTotal}`,
      };

      // current_cc_plan["employeeDeductions"].amountUI =
      //   "$" + current_cc_plan["employeeDeductions"].amount;
      // current_cc_plan["employeeDeductions"].taxUI = current_cc_plan[
      //   "companyCoveredBasePlan"
      // ].taxUI.replace(
      //   current_cc_plan["companyCoveredBasePlan"].tax,
      //   current_cc_plan["employeeDeductions"].tax
      // );
      // current_cc_plan["employeeDeductions"].totalUI =
      //   "$" + current_cc_plan["employeeDeductions"].total;

      current_cc_plan["categorization"] = {
        paidByCompany: false,
        coveredByCompany: true,
        paidByEmployee: false,
      };

      current_cc_plan["type"] = current_cc_plan.upgradeCalculation.type;

      current_cc_plan["planGrandTotal"] = {
        amount: current_cc_plan.upgradeCalculation.combinedplanPrice, //0
        amountUI: `$${current_cc_plan.upgradeCalculation.combinedplanPrice}`, //0
        tax: current_cc_plan.upgradeCalculation.combinedplanTax,
        total: current_cc_plan.upgradeCalculation.combinedplanTotal,
        taxUI: `$${current_cc_plan.upgradeCalculation.combinedplanTax}`,
        totalUI: `$${current_cc_plan.upgradeCalculation.combinedplanTotal}`,
      };
      // planid,planname,planlevelid,planlevename,amount
      current_cc_plan.amount = adjustWith2DecimalsForUI(current_cc_plan["planGrandTotal"].amount);
      current_cc_plan.amountUI = adjustWith2DecimalsForUI(current_cc_plan["planGrandTotal"].amount);
      current_cc_plan.tax = current_cc_plan["planGrandTotal"].tax;
      current_cc_plan.taxUI = current_cc_plan["planGrandTotal"].taxUI;
      current_cc_plan.total = current_cc_plan["planGrandTotal"].total;
      current_cc_plan.totalUI = current_cc_plan["planGrandTotal"].totalUI;
      current_cc_plan.skuTotalPrice = current_cc_plan["planGrandTotal"].total;
      current_cc_plan.totalPrice = current_cc_plan["planGrandTotal"].total;

      //this.consoleMessage(current_cc_plan);

      current_cc_plan["companyShareTotal"] =
        current_cc_plan["companyCoveredBasePlan"].total;
      current_cc_plan["employeeShareTotal"] =
        current_cc_plan["employeeDeductions"].total;

      current_cc_plan["companySharePlanAmountTotal"] =
        current_cc_plan["companyCoveredBasePlan"].amount;
      current_cc_plan["employeeSharePlanAmountTotal"] =
        current_cc_plan["employeeDeductions"].amount;

      current_cc_plan["companyShareTaxTotal"] =
        current_cc_plan["companyCoveredBasePlan"].tax;
      current_cc_plan["employeeShareTaxTotal"] =
        current_cc_plan["employeeDeductions"].tax;

      current_cc_plan["employeeAmount"] = current_cc_plan["amounts"].employee;
      current_cc_plan["employeeAmountUI"] =
        "$" + current_cc_plan["amounts"].employee;
      current_cc_plan["companyAmount"] = current_cc_plan["amounts"].company;
      current_cc_plan["companyAmountUI"] =
        "$" + current_cc_plan["amounts"].company;
      //this.consoleMessage(current_cc_plan["amounts"].employee);
      //this.consoleMessage(current_cc_plan["amounts"].company);
      //this.consoleMessage(current_cc_plan["amounts"].total);
      this.coveredEmployeeShare += parseFloat(
        current_cc_plan["amounts"].employee
      );

      // this.coveredEmployeeShare = parseFloat(
      //   this._decimalPipe.transform(this.coveredEmployeeShare, "1.2-2" ||)
      // );
      this.coveredEmployeeShare = parseFloat(this.coveredEmployeeShare)
      all_selected_plans.push(current_cc_plan);
      company_selected_plans.push(current_cc_plan);
      company_covered_selected_plans.push(current_cc_plan);

      if (current_cc_plan.upgradeCalculation.payroll) {
        payrollCCplans.push(current_cc_plan);
      } else {
        directpayCCplans.push(current_cc_plan);
      }
      //this.consoleMessage("payrollCCplans",payrollCCplans)
      //this.consoleMessage("directpayCCplans",directpayCCplans)
    }

    for (var ep = 0; ep < selected_ep_plans.length; ep++) {
      var current_ep_plan: any = selected_ep_plans[ep];

      //this.consoleMessage(current_ep_plan)

      current_ep_plan.amount = adjustWith2DecimalsForUI(current_ep_plan.products[0].price);

      current_ep_plan["amounts"] = {
        company: 0,
        employee: current_ep_plan.total, //current_ep_plan.amount,(+tax)
        total: current_ep_plan.total, //current_ep_plan.amount,(+tax)
      };

      current_ep_plan["categorization"] = {
        paidByCompany: false,
        coveredByCompany: false,
        paidByEmployee: true,
      };

      current_ep_plan["type"] = "Voluntary Opt In";

      current_ep_plan["companyCoveredBasePlan"] = {
        planId: 0, //0
        planName: "NA", //NA
        planLevelId: 0, //0
        amount: 0, //0
        tax: 0,
        total: 0,
      };
      current_ep_plan["employeeAmount"] = current_ep_plan["amounts"].employee;
      current_ep_plan["employeeAmountUI"] =
        "$" + current_ep_plan["amounts"].employee;
      current_ep_plan["companyAmount"] = current_ep_plan["amounts"].company;
      current_ep_plan["companyAmountUI"] =
        "$" + current_ep_plan["amounts"].company;
      //  current_cp_plan["planLevelName"] = current_ep_plan.groupName || ""

      //this.consoleMessage(current_ep_plan)

      //console.log(current_ep_plan)

      //this.consoleMessage(current_ep_plan["amounts"].employee);
      //this.consoleMessage(this.paidEmployeeShare);
      // this.paidEmployeeShare = +current_ep_plan["amounts"].employee;
      this.paidEmployeeShare += parseFloat(current_ep_plan["amounts"].total);
      //this.consoleMessage(this.paidEmployeeShare);
      // this.paidEmployeeShare = parseFloat(
      //   this._decimalPipe.transform(this.paidEmployeeShare, "1.2-2")
      // );

      //this.consoleMessage(this.paidEmployeeShare);
      all_selected_plans.push(current_ep_plan);
      employee_selected_plans.push(current_ep_plan);
    }

    employeeDealingPlans = directpayCCplans.concat(employee_selected_plans);

    //console.log(employeeDealingPlans)
    companyDealingPlans = company_paid_selected_plans.concat(payrollCCplans);
    //console.log(this.iafgplansCheck)
    // employeeDealingPlans = employeeDealingPlans.concat(this.iafgplansCheck)  //hererakesh
    //console.log(employeeDealingPlans)

    //this.consoleMessage("employeeDealingPlans",employeeDealingPlans)
    //this.consoleMessage("companyDealingPlans",companyDealingPlans)

    this.alloptinplans = alloptinplans;

    //this.consoleMessage(this.coveredEmployeeShare);
    //this.consoleMessage(this.paidEmployeeShare);

    sessionStorage.setItem("employeeshare", this.paidEmployeeShare);
    //this.consoleMessage(this._decimalPipe.transform(this.coveredEmployeeShare, "1.2-2"));
    //this.consoleMessage(this._decimalPipe.transform(this.paidEmployeeShare, "1.2-2"));

    var totalIAFG = 0;
    for (let i = 0; i < this.iafgplansCheck.length; i++) {
      totalIAFG += parseFloat(this.iafgplansCheck[i].skuTotalPrice);
    }



    this.totalEmployeeShare =
      this.coveredEmployeeShare + this.paidEmployeeShare;
    // this.cartDisplayAmount = this.paidEmployeeShare + totalIAFG;
    this.cartDisplayAmount = this.paidEmployeeShare;
    // this.totalEmployeeShare = parseFloat(
    //   this._decimalPipe.transform(this.totalEmployeeShare, "1.2-2")
    // );
    this.totalEmployeeShare = parseFloat(this.totalEmployeeShare)
    this.cartDisplayAmount = this._decimalPipe.transform(
      this.cartDisplayAmount,
      "1.2-2"
    );

    //this.cartDisplayAmount = floatWith2Decimals(this.cartDisplayAmount);

    //this.consoleMessage(this.totalEmployeeShare);

    /* if (employee_selected_plans.length > 0) {
      this.showPaymenthMethod = true;
      this.showPaymenthMethod1 = false;
      this.creditcardform = true;
      sessionStorage.setItem("paymentMethod", "CC");
      this.bankpaymentmethod = "CC";

    } else {


      this.showPaymenthMethod = false;
      this.showPaymenthMethod1 = true;
      this.creditcardform = false;
      sessionStorage.setItem("paymentMethod", "NONE");
    }*/

    //console.log(this.iafgplansCheck)
    //console.log(this.iafgplansCheck.length)
    if (employeeDealingPlans.length > 0 || this.iafgplansCheck.length > 0) {
      this.showPaymenthMethod = true;
      this.showPaymenthMethod1 = false;
      this.creditcardform = true;
      sessionStorage.setItem("paymentMethod", "CC");
      this.bankpaymentmethod = "CC";
      this.voluntryplansCheck = true
    } else {
      this.showPaymenthMethod = false;
      this.showPaymenthMethod1 = true;
      this.creditcardform = false;
      this.voluntryplansCheck = false
      // this.bankpay =false;  //rakesh
      sessionStorage.setItem("paymentMethod", "NONE");
    }

    this.directpayCCplansarr = directpayCCplans;
    this.payrollCCplansarr = payrollCCplans;
    this.companyDealingPlans = companyDealingPlans;
    this.employeeDealingPlansarr = employeeDealingPlans;

    //console.log(this.employeeDealingPlansarr)


    this.payrollCCplansarr = this.payrollCCplansarr.sort(function (a: any, b: any) {
      return a.packageId - b.packageId;
    });
    this.companyDealingPlans = this.companyDealingPlans.sort(function (a: any, b: any) {
      return a.packageId - b.packageId;
    });
    this.companyDealingPlans = this.companyDealingPlans.sort(function (a: any, b: any) {
      return a.packageId - b.packageId;
    });

    if (this.payrollCCplansarr.length > 0) {
      this.upgradeplansCheck = true
    }
    else {
      this.upgradeplansCheck = false
    }
    //this.consoleMessage(this.companyDealingPlans)
    //this.consoleMessage(this.payrollCCplansarr)
    sessionStorage.setItem(
      "allSelectedPlans",
      JSON.stringify(all_selected_plans)
    );
    sessionStorage.setItem(
      "allSelectedOptPlans",
      JSON.stringify(alloptinplans)
    );
    //this.consoleMessage(all_selected_plans);
    //this.consoleMessage(company_selected_plans);

    //this.consoleMessage(company_paid_selected_plans);
    //this.consoleMessage(company_covered_selected_plans);
    //this.consoleMessage(employee_selected_plans);

    //company paid plans

    this.companySelectedPlans = company_paid_selected_plans;
    this.companyCoveredPlans = company_covered_selected_plans;
    // this.EmployeeSelectedPlans = employee_selected_plans.concat(this.iafgplansCheck);
    this.EmployeeSelectedPlans = employee_selected_plans
    this.allSelectedPlans = all_selected_plans;

    this.allSelectedPlans = this.allSelectedPlans.sort(function (a: any, b: any) {
      return a.packageId - b.packageId;
    });

    this.allPlansAmountTotal = sumBy(this.allSelectedPlans, "amount");
    //     this.allPlansAmountTotal =  this._decimalPipe.transform(
    //   this.allPlansAmountTotal,
    //   "1.2-2"
    // );
    this.allPlansTotal = sumBy(this.allSelectedPlans, "total");
    // this.allPlansTotal =  this._decimalPipe.transform(
    //   this.allPlansTotal,
    //   "1.2-2"
    // );
    this.allPlansTotaltax = sumBy(this.allSelectedPlans, "tax");
    // this.allPlansTotaltax =  this._decimalPipe.transform(
    //   this.allPlansTotaltax,
    //   "1.2-2"
    // );

    this.allCPPlansAmountTotal = sumBy(this.companySelectedPlans, "amount");
    this.allCPTaxTotal = sumBy(this.companySelectedPlans, "tax");
    this.companyPaidTotal = sumBy(this.companySelectedPlans, "total");
    //this.consoleMessage(this.companyPaidTotal);
    // this.companyPaidTotal =  this._decimalPipe.transform(
    //   this.companyPaidTotal,
    //   "1.2-2"
    // );
    //this.consoleMessage(this.companyPaidTotal);
    // for(var i=0;i<this.companySelectedPlans.length;i++){
    //   this.companyPaidTotal += this.companySelectedPlans[i].total

    //   this.companyPaidTotal = parseFloat(this._decimalPipe.transform(this.companySelectedPlans[i].total, "1.2-2"))

    // }
    // for(var i=0;i<this.companyCoveredPlans.length;i++){
    //   this.companyCoveredTotal += this.companyCoveredPlans[i].total
    //   this.companyCoveredTotal = parseFloat(this._decimalPipe.transform(this.companyCoveredTotal, "1.2-2"))

    // }
    this.allCCPlansAmountTotal = sumBy(this.companyCoveredPlans, "amount");
    this.allCCTaxTotal = sumBy(this.companyCoveredPlans, "tax");
    this.companyCoveredTotal = sumBy(this.companyCoveredPlans, "total");
    //this.consoleMessage(this.allCCPlansAmountTotal);
    //this.consoleMessage(this.allCCTaxTotal);
    //this.consoleMessage(this.companyCoveredTotal);
    this.companyCoveredCompanyShareTotal = sumBy(
      this.companyCoveredPlans,
      "companyShareTotal"
    );
    this.companyCoveredCompanySharePlanAmountTotal = sumBy(
      this.companyCoveredPlans,
      "companySharePlanAmountTotal"
    );
    this.companyCoveredCompanyShareTaxTotal = sumBy(
      this.companyCoveredPlans,
      "companyShareTaxTotal"
    );
    this.companyCoveredEmployeeShareTotal = sumBy(
      this.companyCoveredPlans,
      "employeeShareTotal"
    );
    this.companyCoveredEmployeeSharePlanAmountTotal = sumBy(
      this.companyCoveredPlans,
      "employeeSharePlanAmountTotal"
    );
    this.companyCoveredEmployeeShareTaxTotal = sumBy(
      this.companyCoveredPlans,
      "employeeShareTaxTotal"
    );

    this.payrollCCPlansAmountTotal = sumBy(payrollCCplans, "amount");
    this.payrollCCPlantaxTotal = sumBy(payrollCCplans, "tax");
    this.payrollCCPlangrandTotal = sumBy(payrollCCplans, "total");

    this.DirectCCpayPlanamountTotal = sumBy(directpayCCplans, "amount");
    this.DirectCCpayPlantaxTotal = sumBy(directpayCCplans, "tax");
    this.DirectCCpayPlangrandTotal = sumBy(directpayCCplans, "total");

    //The below includes Employee-voluntary-plans and company-covered-split with direct-pay-plans
    this.empDirectpayPlanamountTotal = sumBy(employeeDealingPlans, "amount");
    this.empDirectpayPlantaxTotal = sumBy(employeeDealingPlans, "tax");
    this.empDirectpayPlangrandTotal = sumBy(employeeDealingPlans, "total");

    //Company paid and company covered split with payroll
    this.companydealingplansTotal = sumBy(companyDealingPlans, "amount");
    this.companydealingplanstaxTotal = sumBy(companyDealingPlans, "tax");
    this.companydealingplansgrandTotal = sumBy(companyDealingPlans, "total");

    // for(var i=0;i<this.EmployeeSelectedPlans.length;i++){
    //   this.companyCoveredTotal += this.EmployeeSelectedPlans[i].total
    //   this.companyCoveredTotal = parseFloat(this._decimalPipe.transform(this.EmployeeSelectedPlans[i].total, "1.2-2"))

    // }
    //cp+cc(company)
    this.effectiveCompanyPlansAmountTotal =
      parseFloat(this.allCPPlansAmountTotal) +
      parseFloat(this.companyCoveredCompanySharePlanAmountTotal);
    this.effectiveCompanyPlansAmountTotal = this._decimalPipe.transform(
      this.effectiveCompanyPlansAmountTotal,
      "1.2-2"
    );
    this.effectiveCompanyTaxTotal =
      parseFloat(this.allCPTaxTotal) +
      parseFloat(this.companyCoveredCompanyShareTaxTotal);
    this.effectiveCompanyTaxTotal = this._decimalPipe.transform(
      this.effectiveCompanyTaxTotal,
      "1.2-2"
    );
    this.effectiveCompanyTotalContibution =
      parseFloat(this.companyPaidTotal) +
      parseFloat(this.companyCoveredCompanyShareTotal);
    this.effectiveCompanyTotalContibution = this._decimalPipe.transform(
      this.effectiveCompanyTotalContibution,
      "1.2-2"
    );


    this.allEPPlansAmountTotal = sumBy(this.EmployeeSelectedPlans, "amount");
    this.allEPTaxTotal = sumBy(this.EmployeeSelectedPlans, "tax");
    this.paidEmployeedTotal = sumBy(this.EmployeeSelectedPlans, "total");
    //this.consoleMessage(this.paidEmployeedTotal);
    // this.paidEmployeedTotal = this._decimalPipe.transform(
    //   this.paidEmployeedTotal,
    //   "1.2-2"
    // );
    // //this.consoleMessage(this.companyPaidTotal)
    // //this.consoleMessage(this.companyCoveredTotal)
    // //this.consoleMessage(this.paidEmployeedTotal)



    this.planssummarymainLife = JSON.parse(
      sessionStorage.getItem('plansummaryLife') || '[]'
    );

    //console.log(this.planssummarymainLife)
    let total: any = 0;
    for (let i = 0; i < this.planssummarymainLife.length; i++) {
      total += parseFloat(this.planssummarymainLife[i].skuTotalPrice);
    }

    //console.log(total)
    this.effectiveEmployeeTotalContibution =
      parseFloat(this.companyCoveredEmployeeShareTotal) +
      parseFloat(this.paidEmployeedTotal);
    this.effectiveEmployeeTotalContibution = adjustWith2DecimalsForUI(
      this.effectiveEmployeeTotalContibution
    );

    //console.log(this.effectiveEmployeeTotalContibution)
    this.effectiveCompanyTotalContibution =
      parseFloat(this.companyCoveredCompanyShareTotal) +
      parseFloat(this.companyPaidTotal);

    this.effectiveCompanyTotalContibution = this._decimalPipe.transform(
      this.effectiveCompanyTotalContibution,
      "1.2-2"
    );

    //this.consoleMessage(this.companyCoveredPlans)
    //payrollDeduction setting

    let payrollDeduction = sessionStorage.getItem("payrollDeduction")
      ? sessionStorage.getItem("payrollDeduction")
      : "EMPLOYEE_CHOICE";

    if (
      this.companyCoveredPlans.length > 0 &&
      payrollDeduction == "EMPLOYEE_CHOICE"
    ) {
      // $("payrolldeduction-modal").show()
      // jQuery("#payrolldeduction-modal").modal("show");
    }
  }
  public calculateTaxforPlan(plan: any) {
    let plandetails;
    //this.consoleMessage(plan)
    //this.consoleMessage($(`#plancheck${plan.id}`))
    for (const cpPlan of plan) {
      //this.consoleMessage(plan)
      for (const product1 in cpPlan.productAddonss) {
        //this.consoleMessage(cpPlan.productAddonss[product1][0].id)
        // const dom: HTMLElement = this.elementRef.nativeElement;
        // const plan: any = dom.querySelector("#plancheck" + cpPlan.productAddonss[product1][0].id);
        // plandetails = $(
        //   "#plancheck" + cpPlan.productAddonss[product1][0].id
        // ).attr("data"); //rakesh


        plandetails = this.renderer.selectRootElement("#plancheck" + cpPlan.productAddonss[product1][0].id).attr("data");

        //this.consoleMessage(plandetails)
        let plandetailsobj = plandetails.split("##");

        let obj: any = {
          enrollmentDate: '',
          // "name":plandetailsobj[1]+"-"+plandetailsobj[2],
          name: plandetailsobj[14],
          details: plandetailsobj[0],
          packagename: plandetailsobj[0],
          groupName: plandetailsobj[1],
          amount: parseFloat(plandetailsobj[3].replace(/\,/g, "")),
          planCoverage: plandetailsobj[2],
          planPrice: parseFloat(plandetailsobj[3].replace(/\,/g, "")),
          amountUI: "$" + parseFloat(plandetailsobj[3].replace(/\,/g, "")),
          gst:
            plandetailsobj[4] == null ||
              plandetailsobj[4] == "" ||
              plandetailsobj[4] == undefined ||
              plandetailsobj[4] == "null"
              ? 0
              : parseFloat(plandetailsobj[4]),
          hst:
            plandetailsobj[5] == null ||
              plandetailsobj[5] == "" ||
              plandetailsobj[5] == undefined ||
              plandetailsobj[5] == "null"
              ? 0
              : parseFloat(plandetailsobj[5]),
          pst:
            plandetailsobj[6] == null ||
              plandetailsobj[6] == "" ||
              plandetailsobj[6] == undefined ||
              plandetailsobj[6] == "null"
              ? 0
              : parseFloat(plandetailsobj[6]),
          qst:
            plandetailsobj[17] == null ||
              plandetailsobj[17] == "" ||
              plandetailsobj[17] == undefined ||
              plandetailsobj[17] == "null"
              ? 0
              : parseFloat(plandetailsobj[17]),
          gstCheck:
            plandetailsobj[4] == null ||
              plandetailsobj[4] == "" ||
              plandetailsobj[4] == undefined ||
              plandetailsobj[4] == "null"
              ? false
              : true,
          hstCheck:
            plandetailsobj[5] == null ||
              plandetailsobj[5] == "" ||
              plandetailsobj[5] == undefined ||
              plandetailsobj[5] == "null"
              ? false
              : true,
          pstCheck:
            plandetailsobj[6] == null ||
              plandetailsobj[6] == "" ||
              plandetailsobj[6] == undefined ||
              plandetailsobj[6] == "null"
              ? false
              : true,
          qstCheck:
            plandetailsobj[17] == null ||
              plandetailsobj[17] == "" ||
              plandetailsobj[17] == undefined ||
              plandetailsobj[17] == "null"
              ? false
              : true,
          id: parseFloat(plandetailsobj[7]),
          fusebillPlanID:
            plandetailsobj[8] == null ||
              plandetailsobj[8] == "" ||
              plandetailsobj[8] == undefined ||
              plandetailsobj[8] == "null"
              ? 0
              : parseFloat(plandetailsobj[8]),
          planFrequencyID:
            plandetailsobj[9] == null ||
              plandetailsobj[9] == "" ||
              plandetailsobj[9] == undefined ||
              plandetailsobj[9] == "null"
              ? 0
              : parseFloat(plandetailsobj[9]),
          optIn: plandetailsobj[10] == "true" ? true : false,
          planname: plandetailsobj[14],
          planLevel: parseInt(plandetailsobj[15]),
          packageId: parseInt(plandetailsobj[16]),
          options: [],
          paidByCompany1: plandetailsobj[19],
          coveredByCompany1: plandetailsobj[20],
          paidByEmployee1: plandetailsobj[21],
          planLevel_parentId: plandetailsobj[12],
          disallowedPlanLevels: plandetailsobj[11],
        };

        ////this.consoleMessage(obj)
        let gstprice = 0;
        let hstprice = 0;
        let pstprice = 0;
        let qstprice = 0;

        if (obj.gst > 0) {
          gstprice = obj.planPrice * obj.gst;
          obj['gstPrice'] = gstprice
            ? this._decimalPipe.transform(gstprice, '1.2-2')
            : 0;
          obj['gstPrice'] = parseFloat(obj['gstPrice']);

        } else {
          obj["gstPrice"] = 0;
        }

        if (obj.hst > 0) {
          hstprice = obj.planPrice * obj.hst;

          obj["hstPrice"] = parseFloat(
            this._decimalPipe.transform(hstprice, "1.2-2") ?? '0'
          );
        } else {
          obj["hstPrice"] = 0;
        }

        if (obj.pst > 0) {
          pstprice = obj.planPrice * obj.pst;
          obj["pstPrice"] = parseFloat(
            this._decimalPipe.transform(pstprice, "1.2-2") ?? '0'
          );
        } else {
          obj["pstPrice"] = 0;
        }

        if (obj.qst > 0) {
          qstprice = obj.planPrice * obj.qst;
          obj["qstPrice"] = parseFloat(
            this._decimalPipe.transform(qstprice, "1.2-2") ?? '0'
          );
        } else {
          obj["qstPrice"] = 0;
        }

        obj["taxUI"] = "";
        if (obj["gstCheck"]) {
          obj["taxUI"] += "<span>";
          if (obj["gstPrice"] == 0) {
            obj["taxUI"] += "-";
          } else {
            obj["taxUI"] +=
              "$" +
              this._decimalPipe.transform(obj["gstPrice"], "1.2-2") +
              "&nbsp;(GST)";
          }
          obj["taxUI"] += "</span>";
        }

        if (obj["pstCheck"]) {
          obj["taxUI"] += "<span>";
          if (obj["pstPrice"] == 0) {
            obj["taxUI"] += "-";
          } else {
            obj["taxUI"] +=
              "$" +
              this._decimalPipe.transform(obj["pstPrice"], "1.2-2") +
              "&nbsp;(PST)";
          }
          obj["taxUI"] += "</span>";
        }

        if (obj["qstCheck"]) {
          obj["taxUI"] += "<span>";
          if (obj["qstPrice"] == 0) {
            obj["taxUI"] += "-";
          } else {
            obj["taxUI"] +=
              "$" +
              this._decimalPipe.transform(obj["qstPrice"], "1.2-2") +
              "&nbsp;(QST)";
          }
          obj["taxUI"] += "</span>";
        }

        if (obj["hstCheck"]) {
          obj["taxUI"] += "<span> ";
          if (obj["hstPrice"] == 0) {
            obj["taxUI"] += "-";
          } else {
            obj["taxUI"] +=
              "$" +
              this._decimalPipe.transform(obj["hstPrice"], "1.2-2") +
              "&nbsp;(HST)";
          }
          obj["taxUI"] += "</span>";
        }

        if (
          !obj["hstCheck"] &&
          !obj["gstCheck"] &&
          !obj["pstCheck"] &&
          !obj["qstCheck"]
        ) {
          obj["taxUI"] += "<span>-";

          obj["taxUI"] += "</span>";
        }

        // ////this.consoleMessage(object["taxUI"])

        obj["tax"] = parseFloat(
          this._decimalPipe.transform(
            gstprice + hstprice + pstprice + qstprice,
            "1.2-2"
          ) ?? '0'
        );

        //this.consoleMessage(obj.planPrice);
        //this.consoleMessage(gstprice);
        //this.consoleMessage(hstprice);
        //this.consoleMessage(pstprice);

        //this.consoleMessage(qstprice);
        let pricecal =
          obj.planPrice + gstprice + hstprice + pstprice + qstprice;
        obj["totalPrice"] = pricecal;

        obj["totalUI"] = "$" + pricecal;

        obj["total"] = pricecal;
        //this.consoleMessage(obj)
        return obj;
      }
    }
  }


  getTextForTooltip(published, restricted) {
    const pubStatus = { 0: false, 1: true }
    let data = this.getStatus(pubStatus[published], restricted)
    return this.text[data]
  }


  getTextForTooltip1(published, restricted) {
    let data: any = this.getStatus(published, restricted)
    const text = this.text[data]
    return text
  }
  public colors = { 0: "#FF3131", 1: "#37FBB3", 2: "black" }
  public text = { 0: "Unpublished", 1: "Published", 2: "Published but Restricted" }
  getStatus(published, restricted) {
    let data = -1;
    if (published) {
      if (restricted) {
        data = 2
      }
      else {
        data = 1
      }

    }
    else {
      data = 0
    }
    return data
  }

  getColorForPlans(published, restricted, name, plan) {
    // console.log(published, restricted, name, plan)
    const pubStatus = { 0: false, 1: true }
    // console.log(pubStatus[published], restricted)
    let data = this.getStatus(pubStatus[published], restricted)
    return this.colors[data]
  }

  getColorForPlans1(published, restricted) {

    let data: any = this.getStatus(published, restricted)
    const color = this.colors[data];
    return color;
  }


  public closePlans() {
    sessionStorage.removeItem("totalAmount")
    sessionStorage.removeItem("totalAmountUI")
    sessionStorage.removeItem("plansummarymain")
    sessionStorage.removeItem("plansummaryopt")
    sessionStorage.removeItem("plansummary")
    sessionStorage.removeItem("plansskumain")
    sessionStorage.removeItem("selectedPlans")

  }

  public covergages = ['SINGLE', 'COUPLE', 'FAMILY']

  public addPlansConfig() {



    let selectedPlans = JSON.parse(sessionStorage.getItem("plansummarymain") ?? "")

    if (!selectedPlans || selectedPlans?.length <= 0) {
      this.plansError = true

      return;
    }
    else {
      this.plansError = false
    }

    this.plansObj = []
    let phrPlanSelected = false;
    let isPhr = false;
    let oldPlans: any
    for (let pack of this.specialpackages) {

      let obj: any = {

      }
      let selected: any = {}
      if (pack.id == 10) isPhr = true;

      if (pack.selected) {


        if (pack.id == 10) phrPlanSelected = true;
        Object.keys(pack.groups).forEach((group: any) => {
          for (let plan of pack.groups[group]) {
            for (let plans of plan.plans) {
              if (plans.selected) {
                Object.keys(plans.productAddonss).forEach((addon: any) => {
                  for (let c of plans.productAddonss[addon]) {
                    if (c.selected) {
                      selected = { ...c }
                      for (let sc of selectedPlans) {

                        if (c.planId == sc.id && !sc?.products[0]?.selected) {
                          obj = {
                            ...(c.selected ? { oldPlan: { ...c } } : { oldPlan: {} }),
                            newPlan: { ...sc },
                            ...(c.planCoverage != sc.coverage && c.selected && this.covergages.includes(c.planCoverage) && { coverageChange: true })
                          }
                          // console.log(obj)
                        }

                        else {
                          this.unselected.forEach((ele) => {

                            if (ele.planId == c.planId) {
                              console.log(this.unselected)
                              let obj1 = {
                                ...(c.selected ? { oldPlan: { ...c } } : { oldPlan: {} }),
                                newPlan: {},

                              }
                              oldPlans.push(obj1)

                            }

                          })
                        }




                      }
                    }
                  }
                })
              }


            }

          }


        })
        if (obj && Object.keys(obj).length > 0 && ((obj.oldPlan && Object.keys(obj?.oldPlan).length > 0) || (obj.newPlan && Object.keys(obj?.newPlan).length > 0))) {

          // console.log({ obj })
          this.plansObj.push(obj)
          obj = {}


        }
      }

      // when package selected but completely different plan with in same package
      if (pack.selected && selected) {
        console.log("entered")
        Object.keys(pack.groups).forEach((group: any) => {
          for (let plan of pack.groups[group]) {
            for (let plans of plan.plans) {
              if (!plans.selected) {
                Object.keys(plans.productAddonss).forEach((addon: any) => {
                  for (let c of plans.productAddonss[addon]) {
                    for (let sc of selectedPlans) {
                      // console.log(plans.planLevel)
                      // console.log(plans.planLevel, c.name, c.planId, sc.planId, sc.planLevel, c.planCoverage)
                      if (plans.planLevel == sc.planLevel && c.planId == sc.id) {
                        obj = {
                          oldPlan: { ...selected },
                          newPlan: { ...sc },
                        }
                      }

                    }
                  }
                })

                if (Object.keys(obj).length > 0) {


                  this.unselected = this.unselected.filter((ele) => (
                    ele.planId != obj.oldPlan.planId

                  ))
                  oldPlans = oldPlans.filter(e => e.oldPlan.planId != obj.oldPlan.planId);
                  console.log(this.unselected, oldPlans, obj.oldPlan.planId, obj)
                  this.plansObj.push(obj)
                  obj = {}

                }
              }

            }
          }
        })
      }

      //when package in not selected but completely diffrenet package selected
      if (!pack.selected) {
        console.log(pack.id)
        for (let sc of selectedPlans) {
          console.log(sc.packageId == pack.id)
          if (sc.packageId == pack.id) {
            obj = {
              newPlan: { ...sc },
              oldPlan: {}
            }
          }
        }
        if (Object.keys(obj).length > 0) {
          this.plansObj.push(obj)
          obj = {}
        }
      }


    }
    //when plan selected and diselected
    if (oldPlans.length > 0) {
      const uniquePlanIds = new Set<number>();

      const filteredOldPlans = oldPlans.filter((plan) => {
        if (!uniquePlanIds.has(plan.oldPlan.planId)) {
          uniquePlanIds.add(plan.oldPlan.planId);
          return true;
        }
        return false;
      });

      if (filteredOldPlans.length > 0) {
        this.plansObj = [...this.plansObj, ...filteredOldPlans];
      }
    }

    //high cost drugs selected and all in selected
    let allinSelected = this.plansObj.some((plan) => { return plan.newPlan.planLevelParent == 6 })
    console.log(allinSelected)
    const allIndisallowed = [1, 10, 14, 24]
    if (allinSelected) {
      for (let pack of this.specialpackages) {
        if (pack.selected) {
          Object.keys(pack.groups).forEach((group: any) => {
            for (let plan of pack.groups[group]) {
              for (let plans of plan.plans) {
                if (plans.selected && allIndisallowed.includes(plans.planLevel)) {
                  Object.keys(plans.productAddonss).forEach((addon: any) => {
                    for (let c of plans.productAddonss[addon]) {
                      if (c.selected) {
                        // console.log(c.planId)
                        this.plansObj.push({
                          oldPlan: { ...c },
                          newPlan: {}
                        })

                      }
                    }
                  })
                }


              }

            }


          })

        }





      }
    }

    //phr rules
    let healthAndDentalSelected = this.plansObj.some((plan) => { return plan.newPlan.packageId == 1 })
    let phrSelected = this.plansObj.some((plan) => { return plan.newPlan.packageId == 10 });
    if (healthAndDentalSelected && isPhr) {
      if (!phrSelected && !phrPlanSelected) {
        Swal.fire({
          title: this.lang?.Error, text: this.lang?.Please_select_a_Provincial_Health_Replacement_Plan_along_with_a_Health_Dental_Insurance_Plan
        })
        return
      }

    }




    let endPoint = `/api/ap/v2/member/${this.customerid}/customerPlansConfig`;

    let url = `${api.url}${endPoint}`;
    var accessToken = sessionStorage.getItem('accessToken');

    let data = {
      "plans": this.plansObj,
      "enrollmentDate": this.addPlanEnrollmentDate
    }
    console.log({ data })

    this.http.post(url, data, {
      headers: {
        Authorization: 'Bearer ' + accessToken,
        'Content-Type': 'application/json',
      },
    }).subscribe((response: any) => {
      console.log(response, response.status)

      if (response.status == '200' || response.data) {

        console.log("entered")
        this.addPlansConfigData = response.data
        this.warningsData = response?.warnings
        console.log(this.addPlansConfigData.newPlans)
        this.closePlans()
        $("#planDetails").hide()
        $("#showAddPlanDetails").show()

        // Swal.fire({ title: this.lang?.Info, text: "Plans Added Successfully" })
        // this.getCustomerData()




      }
      // else {
      //     Swal.fire({ title: this.lang?.Error, text: Response.error || Response.data.error })
      // }

    }, (error) => {
      if (error.value) {
        Swal.fire({ title: this.lang?.Error, text: error.error })
        // this.router.navigate([this.lang?.Error]);
      } else {
        Swal.fire({ title: this.lang?.Error, text: error.error });
      }
    })

  }
  pauseVideo(videoplayer: any) {

    videoplayer.nativeElement.play();

    // this.startedPlay = true;

    // if(this.startedPlay == true)

    // {

    setTimeout(() => {

      videoplayer.nativeElement.pause();

      if (videoplayer.nativeElement.paused) {

        this.show = !this.show;

      }

    }, 5000);

    // }

  }

  // ngAfterViewInit() {
  //   // no errors
  //   let elems = document.querySelectorAll('.carousel');
  //   let instances = M.Carousel.init(elems, this.options);
  // }

  get plansVisible() {
    let selectedPlans: any = sessionStorage.getItem("plansummarymain");
    if (selectedPlans) {
      selectedPlans = JSON.parse(selectedPlans);
    } else {
      selectedPlans = []; // Set a default value if the session storage is empty or null
    }
    return selectedPlans.length > 0
  }

  get phoneForm() {
    return this.phoneform.controls;
  }

  get addressForm() {
    return this.addressform.controls;
  }

  get spouseForm() {
    return this.spouseform.controls;
  }


  get cobForm() {
    return this.cobform.controls;
  }

  get deletespouseForm() {
    return this.deletespouseform.controls;
  }

  get updatespouseForm() {
    return this.updatespouseform.controls;
  }

  get deletedependentForm() {
    return this.deletedependentform.controls;
  }

  get dependentForm() {
    return this.dependentform.controls;
  }

  get dependentPureForm() {
    return this.pureDependentform.controls;
  }

  get paymentMethodControls() {
    return this.paymentMethodForm.controls;
  }

  get valisignControls() {
    return this.valisignform.controls;
  }

  get paymentForm() {
    return this.paymentform.controls;
  }

  get ccForm() {
    return this.ccform.controls;
  }

  get padForm() {
    return this.padform.controls;
  }

  getFormConfiguration(lang: any) {
    // // let lang: any = 'en';
    // // if(this.route.snapshot.queryParamMap.get('lang') != null) {
    // //  lang = this.route.snapshot.queryParamMap.get('lang');
    // // }

    // let accessToken = sessionStorage.getItem('accessToken');
    // let customerDataEndpoint = '/formConfig';
    // this.http.get(api.url+customerDataEndpoint, {
    //   headers:{
    //     Authorization: 'Bearer ' + accessToken,
    //     'Content-Type': 'application/json',
    //     'Lang': lang,
    // }}).subscribe((response:any)=>{

    //   if(response.status==200) {
    //     this.formConfiguration = response?.data;
    //     console.log('overview',this.formConfiguration)
    //     this.logo = this.formConfiguration.customerTiles;
    //     let tokens = this.formConfiguration.language_details.languageTokens;
    //     for(let token of tokens) {
    //       this.lang1[token.key] = token.value;
    //     }
    //     // console.log(this.lang1)
    //     this.configprovinceres = response?.data.states.sort(
    //       (a: any, b: any) => (a.shortName > b.shortName ? 1 : -1)
    //     );
    //     this.beneficiaryValidations = this.formConfiguration.validations.beneficiaries
    //     console.log('beneficiaryValidations',this.beneficiaryValidations)
    //   }
    //   else {
    //     Swal.fire({allowOutsideClick: false,title: this.lang?.Info, text:response.message})
    //   }
    // },(error) => {
    //   Swal.fire({allowOutsideClick: false,title: this.lang?.Info, text: error.error.error.message})
    // });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['formConfig'] && changes['formConfig'].currentValue) {
      console.log("this.formConfig")
      this.genders = ['Male', 'Female', 'NonBinary']
      this.formConfiguration = this.formConfig;
      console.log('overview', this.formConfiguration)
      this.logo = this.formConfiguration.customerTiles;
      // let tokens = this.formConfiguration.language_details.languageTokens;
      // for (let token of tokens) {
      //   this.lang1[token.key] = token.value;
      // }
      this.provianceList = [...this.formConfiguration?.states]?.filter((list) => {
        if (list.countryId == 1)
          return list
      });
      // console.log(this.lang1)
      this.configprovinceres = [...this.formConfiguration?.states]?.sort(
        (a: any, b: any) => (a.shortName > b.shortName ? 1 : -1)
      );
      this.beneficiaryValidations = this.formConfiguration.validations.beneficiaries
      console.log('beneficiaryValidations', this.beneficiaryValidations)
    }

    if(changes['customerDataInput'] && changes['customerDataInput'].currentValue && Object.keys(this.customerDataInput)){
      console.log(this.customerDataInput.dependents, "this.customerDataInput.dependents")
      if(this.customerDataInput.dependents && Object.keys(this.customerDataInput.dependents.spouseInfo).length > 0){
        this.isSpouseExists = true;
        this.isSpouseExistsBefore = true;
        this.availableFirstNames.push(this.customerDataInput.dependents.spouseInfo)
      }
      if(this.customerDataInput.dependents && this.customerDataInput.dependents.childrens.length > 0){
        this.isChildExistsBefore = true;
        for(const child of this.customerDataInput.dependents.childrens){
        this.availableFirstNames.push(child)
        }
      }
      this.isCorporateAccount = this.customerDataInput.isCorporateAccount;
    }

    console.log(this.customerDataInput, 'customerDataInput')


  }

  navigateToQuestions(route) {
    sessionStorage.setItem('isSpouse', route)
    this.router.navigate([`questions`]);
  }

  navigateToUpgradePlans() {
    sessionStorage.setItem('isSpouse', this.pendingMedicalQuestionaireCoverage)
    this.router.navigate([`upgrade-plans`]);
  }


  get dependenttypeForm() {
    return this.dependentTypeForm.controls;
  }



  formatDate1(date) {
    const date1 = new Date(date)
    const month = String(date1.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const day = String(date1.getDate()).padStart(2, '0');
    const year = date1.getFullYear();

    const futureDate: any = new Date(date1);
    futureDate.setDate(date1.getDate() + 30);
    const today: any = new Date();
    const diffInMs: any = futureDate - today;

    const diffInDays = Math.ceil(diffInMs / (1000 * 60 * 60 * 24));

    this.iafgDays = diffInDays;
    console.log(date, this.iafgDays)
    return `${month}-${day}-${year}`;
  }

  formatDate(input) {
    const padZero = (num) => num.toString().padStart(2, '0');
    if (!input) {
      return '';
    }

    let date;
    if (input.length == 10 && input.split('-').length == 3) {
      return input;
    }
    input = input.toISOString()
    if (input.includes('T')) {
      date = new Date(input);
    } else {
      date = new Date(input);
      if (isNaN(date.getTime())) {
        const parts = input.split(/[-\/]/);
        if (parts.length === 3) {
          const [month, day, year] = parts;
          date = new Date(`${year}-${month}-${day}`);
        } else {
          return ''; // Invalid format
        }
      }
    }

    if (isNaN(date.getTime())) {
      return ''; // Invalid date
    }

    const month = padZero(date.getMonth() + 1); // Months are zero-based
    const day = padZero(date.getDate());
    const year = date.getFullYear();

    return `${month}-${day}-${year}`;
  }

  removeUnderscores(input) {
    return input.replace('_', ' ').toLowerCase()
  }

  addBeneficiary(num, customerType) {
    this.beneficiaries = [...this.beneficiariesConst];
    this.beneficiaries1 = [...this.beneficiaries];
    this.deleteBenfIds = [];
    this.deleteBenfIds1 = [];
    this.beneficiaries = this.beneficiaries.filter(ben => ben.customerType.toLowerCase() == customerType)
    this.beneficiaries1 = this.beneficiaries1.filter(ben => ben.customerType.toLowerCase() == customerType)
    this.currentBeneficiary.customerType = customerType
    this.currentBeneficiary.type = 'PRIMARY'
  }

  checkMinor(beneficiary: any, index) {
    if (!beneficiary.isMinor) {
      this.beneficiaries[index].trusteeDetails.firstName = '';
      this.beneficiaries[index].trusteeDetails.lastName = '';
    }
  }


  addDependentForm() {
    this.dependentTypeForm.get('dependentType')?.setValue('')
    // this.dependentTypeForm.get('marriageDate')?.setValue('')
    // this.dependentTypeForm.get('marriageType')?.setValue('')
    this.functionClearSettings();
    this.dependentType = '';
    sessionStorage.removeItem("plansummarymain")
    sessionStorage.removeItem("plansskumain");
    sessionStorage.removeItem("plansummaryopt");
    sessionStorage.removeItem("plansummary");
    sessionStorage.removeItem("selectedPlans");
    sessionStorage.removeItem("totalAmount");
    sessionStorage.removeItem("totalAmountUI");
    this.totalSummaryPrice = 0
    // if (this.dependentTypeForm.invalid) {
    //     this.dependentTypeForm.markAllAsTouched();
    //     return;
    // }
    this.dependentform.get('effectiveDate')?.setValue('')

    const dependentType = this.dependentTypeForm.value.dependentType
    this.addDependentWithSpouse = false;
    console.log('this.dependentCoverage', this.dependentCoverage)
    this.totalCount = 0;
    this.childCoverage = '';
    if (this.enactMode === 'delete') {
      // Assuming dependentType is set elsewhere; their 'spouse' or 'child')
      const dependentData = this.dependentType === 'spouse' ? this.spouseInfo : this.childrenInfo[0]; // Adjust based on your selection logic
      
    }
  }


  handleUpgradePlan(e) {
    console.log(e.target.value)
    this.handlePlanUpgrade = true;
    this.validateCheck = e.target.value == false ? false : true
    this.spouseform.get('upgradePlan')?.setValue(e.target.value, { emitEvent: false })
    // this.handleContinue()
  }

  handleUpgradePlan2(e) {
    console.log(e.target.value)
    this.validateCheck = e.target.value == false ? false : true
    this.dependentform.get('upgradePlan')?.setValue(e.target.value, { emitEvent: false })
  }


  changeDependent(e:any) {
    this.finalEffectiveDate = null;
    this.clearAllMessages()
    this.showCorpPlansTable = false;
    this.childrenDetails = []
    this.childrenDetailsForNormalReg = []
    // this.spouseform

    console.log(e)
    // this.functionClearSettings()
    console.log(this.spouseform.get('dependentType')?.value)
    this.dependentType = this.spouseform.get('dependentType')?.value;
    // this.mode = '';
    // this.spouseform.get('martialStatus')?.setValue('')
    // if (this.dependentType == 'spouse' || this.dependentType == 'multiple'){
    //   this.dependentTypeForm.get('marriageType')?.setValue('married')
    // }
    // if (this.dependentType == 'spouse') {
    //   this.dependentTypeForm.get('marriageDate')?.setValue('married')
    // }
    this.dependentTypeForm.get('childrenCountData')?.setValue('')
    sessionStorage.removeItem("plansummarymain")
    sessionStorage.removeItem("plansskumain");
    sessionStorage.removeItem("plansummaryopt");
    sessionStorage.removeItem("plansummary");
    sessionStorage.removeItem("selectedPlans");
    sessionStorage.removeItem("totalAmount");
    sessionStorage.removeItem("totalAmountUI");
  }

  changeCOBCoverage(e:any) {
    this.cobcoverage = e.target.value;
    this.showCorpPlansTable = false;
    this.clearAllMessages()
    this.addToPolicy = '';
    this.finalEffectiveDate = null;
    this.isExcludeSpouse = false;
    this.isExcludeAll = false;
    this.isExcludeChild = false;
    this.isExcludeChildAndSpouse = false;
    switch(this.cobcoverage){
      case 'SINGLE':
      default:
        if(this.isSpouseExistsBefore){
          this.isExcludeSpouse = true;
        }
        break;

      case 'COUPLE':
        console.log(this.isSpouseExistsBefore, this.isChildExistsBefore)
          if(this.isSpouseExistsBefore && this.isChildExistsBefore) {
            if(this.customerDataInput.dependents.childrens.length == 1){
              this.isExcludeChildAndSpouse = true;
            }
             if(this.customerDataInput.dependents.childrens.length > 1){
              this.isExcludeSpouse = true;
            }
          }else if(this.isSpouseExistsBefore && !this.isChildExistsBefore){
            this.isExcludeAll = true;
          }
          break;

      case 'FAMILY':
        this.isExcludeAll = true;
        break;
    }

    return true;
  }

  changeMode(e: any) {
    this.functionClearSettings();
    this.mode = e.target.value;
  }


  addChild_v2() {
    if (this.childrenDetails.length == this.childCount) {
      this.childCount += 1;
      this.dependentTypeForm.get('childrenCountData')?.setValue(this.childCount, { emitEvent: false })
      this.showChildForm = true;
    }
  }


  momentDateformat(date: any) {
    return moment(date).format('DD-MM-YYYY')
  }



  handleChildDetails_v2() {
    console.log(this.pureDependentform, this.dependentform, this.addDependentWithSpouse)
    if (this.addDependentWithSpouse) {
      const spouseData_ = this.dependentTypeForm.value
      console.log(spouseData_, 'effectiveDate')
      this.dependentform.get('effectiveDate')?.setValue(spouseData_.effectiveDate, { emitEvent: false })
      if (this.dependentChildCoverage == 'close') {
        this.dependentform.get('carrierName')?.setValue(false, { emitEvent: false })
        this.dependentform.get('coveredByAnotherPlan')?.setValue(false, { emitEvent: false })
      }
    }

    if (this.dependentform.valid) {
      console.log("accessed", this.dependentform.valid, this.dependentform, this.specialNeeds)
      this.showChildForm = false;
      this.addDependentWithSpouse = false;
      if (this.editChildUpdate) {
        const updatedData = this.childrenDetails.map((item, index) => {
          if (index === this.childIndex) {
            return this.dependentform.value // Replace with new value
          }
          return item; // Return the original object for all other indices
        });
        this.childrenDetails = updatedData;
      } else {
        this.childrenDetails.push(this.dependentform.value)
      }
      if (this.dependentform.value.coveredByAnotherPlan == true) {
        this.childCovered = true
      }
      console.log('this.dependentCoverage', this.dependentCoverage)
      this.totalCount = this.totalCount + 1;
      this.handleContinue('');
      let childrenName = this.dependentform.value.fullName;
      let effectiveDate = moment(this.dependentform.value.effectiveDate).format('DD-MM-YYYY')
      if (this.dependentform.value.specialNeeds) {
        Swal.fire({ title: 'Info', text: `Your child ${childrenName} has Special needs, and needs be processed before ${effectiveDate} can be covered. Please check with you advisor on the status of enrollment.` })
      } else {
        Swal.fire({ title: 'Info', text: this.editChildUpdate ? 'Child info has been updated successfully.' : 'Children has been added successfully' })
      }
      this.addDependentWithSpouse = false;
      this.dependentform.reset();
    } else {
      this.dependentform.markAllAsTouched();
      return;
    }

    this.dependentChildCoverage = 'close'
    this.postSecondaryStudent = false;
    this.dependentform.reset();
  }


  handleChildDetails_v2New() {
    if (this.dependentType == 'child' || this.dependentType == 'multiple') {
      if (this.dependentChildCoverage == 'close') {
        this.dependentform.get('carrierName')?.setValue(false, { emitEvent: false })
        this.dependentform.get('coveredByAnotherPlan')?.setValue(false, { emitEvent: false })
      }
    }
    console.log(this.pureDependentform, this.dependentform, this.addDependentWithSpouse)


    if (this.dependentform.valid) {
      const dob = moment(this.dependentform.value.dob);
      const graduationDate = moment(this.dependentform.value.graduationDate);

      this.isGradError = graduationDate.isBefore(dob);

      if(this.isGradError){
        return;
      }

      this.addToPolicy = ''
      this.clearAllMessages()
      console.log("accessed", this.dependentform.valid, this.dependentform, this.specialNeeds)
      this.showChildForm = false;
      this.addDependentWithSpouse = false;
      if (this.editChildUpdate) {
        let currentEditableChild = this.dependentform.value;
        let childExists = this.childrenDetailsForNormalReg.find(item => item.fullName == currentEditableChild.fullName);
        // if(this.normalDependentRegistration){
        //   // check current child includes in the normal
        //   // if yes then do nothing
        //   // if no then add
        //   if(childExists){
        //     // do nothing
        //   }else{
        //     this.childrenDetailsForNormalReg.push(currentEditableChild);
        //   }
        // }else{
        //   // above 30
        //   if(childExists){
        //     // check if the current exists then pop
        //     this.childrenDetailsForNormalReg = this.childrenDetailsForNormalReg.filter(
        //       item => item.fullName !== currentEditableChild.fullName
        //     );
        //   }else{
        //     // do nothing
        //   }
        // }
        const updatedData = this.childrenDetails.map((item, index) => {
          if (index === this.childIndex) {
            return this.dependentform.value // Replace with new value
          }
          return item; // Return the original object for all other indices
        });
        this.childrenDetails = updatedData;

        // here check all the children details and only include < 30 or not sn kids in normal


      } else {
        // if(this.normalDependentRegistration){
        //   this.childrenDetailsForNormalReg.push(this.dependentform.value)
        // }
        this.childrenDetails.push(this.dependentform.value)
      }
      console.log(this.dependentform.value.coveredByAnotherPlan, "this.dependentform.value.coveredByAnotherPlan")
      if (this.dependentform.value.coveredByAnotherPlan == true) {
        this.canShowPlans = true;
        this.childCovered = true
      }
      console.log('this.dependentCoverage', this.dependentCoverage)
      this.totalCount = this.totalCount + 1;
      let childrenName = this.dependentform.value.fullName;
      let effectiveDate = moment(this.dependentform.value.dob).format('DD-MM-YYYY')
      this.childEffectiveDate = moment(this.dependentform.value.dob).format('YYYY-MM-DD')
      if (this.dependentform.value.specialNeeds) {
        Swal.fire({ title: 'Info', text: `Your child ${childrenName} has Special needs, and needs be processed before ${effectiveDate} can be covered. Please check with you advisor on the status of enrollment.` })
      } else {
        Swal.fire({ title: 'Info', text: this.editChildUpdate ? 'Child info has been updated successfully.' : 'Children has been added successfully' })
      }
      this.addDependentWithSpouse = false;
      this.dependentform.reset();
      this.editChildUpdate = false;

    } else {
      this.dependentform.markAllAsTouched();
      return;
    }

    this.dependentChildCoverage = 'close'
    this.postSecondaryStudent = false;
    this.showDependentForm = false;
    this.dependentform.reset();
  }
  closeHandleChildDetails() {
    this.functionClearSettings()
    this.showChildForm = false;
  }



  closeHandleChildDetailsMultiple() {
    this.addDependentWithSpouse = false;
    this.dependentform.reset();
    this.graduationDate = true;
    this.dependentUpdate = false;
    this.showChildForm = false;
    this.dependentCoverage = 'close';
  }

  updateChildDetails_v2(child, index) {
    console.log(this.childCoverage, "childcc", this.dependentChildCoverage, child)
    this.childIndex = index;
    this.showCorpPlansTable = false;
    this.showChildForm = true;
    this.addDependentWithSpouse = true;
    this.showDependentForm = true;
    this.editChildUpdate = true;
    if (child.coveredByAnotherPlan == true) {
      this.dependentChildCoverage = 'open';
    }
    this.dependentform.patchValue(child)
  }


  clearAllMessages() {
    this.firstConfirmMessage = ''
    this.secondConfirmMessage = ''
    this.corpMessage = ''
    this.firstMessage = ''
    this.underwritingHeading = ''
    this.thirdConfirmMessage = ''
    this.underWritingMessage1 = ''
    this.underWritingMessage2 = ''
    this.secondMessage = ''
  }

  deleteChildDetails_v2(index) {
    Swal.fire({title: 'Info', text: "Are you sure you want to delete?", showCancelButton: true}).then(res => {
      if(res.isConfirmed){
        this.childrenDetails.splice(index, 1)
        console.log('this.dependentCoverage', this.dependentCoverage)
        this.totalCount = this.totalCount - 1;
        this.childCovered = false;
        this.addToPolicy = ''
        this.clearAllMessages()
        this.showCorpPlansTable = false;

        // this.handleContinue('');
      }
    })
    
  }



  getPlanSummaryObject() {
    console.log(this.oldExistingPlans);

    let selectedPlans: any = sessionStorage.getItem("plansummarymain");
    if (selectedPlans) {
      selectedPlans = JSON.parse(selectedPlans);
    } else {
      selectedPlans = []; // Set a default value if the session storage is empty or null
    }

    let object_: any = []

    console.log('selectedPlans', selectedPlans)
    // for(const i of this.selectedPlans_){
    for (const i of selectedPlans) {
      // let oldPlanObj = this.oldExistingPlans.find(item => (item.planlevel.packageId == i.planlevel.packageId && item.planlevel.parentId == i.planlevel.parentId))
      let oldPlanObj = this.oldExistingPlans.find(item => (item.planlevel.packageId == i.packageId && item.planlevel.parentId == i.planLevelParent))
      let obj = {
        packageName: oldPlanObj?.description ?? "",
        oldPlan: {
          plan: oldPlanObj?.name + ' ' + `(${oldPlanObj?.planCoverageUI})`,
          coverage: oldPlanObj?.planCoverageUI ?? "",
          tax: oldPlanObj?.calculatedTax?.tax ?? 0,
          price: oldPlanObj?.calculatedTax?.price ?? 0,
          total: oldPlanObj?.calculatedTax?.total ?? 0,
        },
        newPlan: {
          // packageName: i?.description2.replace('<br>','') ?? "",
          // plan: i.name + ' ' + `(${i.planCoverageUI})`,
          // coverage: i?.planCoverageUI ?? "",
          // tax: i?.calculatedTax?.tax ?? 0,
          // price: i?.calculatedTax?.price ?? 0,
          // total: i?.calculatedTax?.total ?? 0,
          packageName: i?.packagename ?? "",
          plan: i.name + ' ' + `(${i.coverage})`,
          coverage: i?.planCoverageUI ?? "",
          tax: i?.tax ?? 0,
          price: i?.amount ?? 0,
          total: i?.total ?? 0,
        }
      }
      object_.push(obj)
    }

    console.log(object_)
    this.plansSummaryObj = object_;
  }

  handlePrepareNotes() {
    let notes: any = [];
    if (this.newlySelectedPlans && this.newlySelectedPlans.length > 0) {
      for (const nsp of this.newlySelectedPlans) {
        let newPlanName = nsp.name + '(' + nsp?.planCoverage + ')' || '';
        let oldPlanName = this.unSelectedPlans_ && this.unSelectedPlans_.length > 0 ? this.unSelectedPlans_[0]['name'] + '(' + this.unSelectedPlans_[0]['planCoverage'] + ')' : '';
        let coverageChange = this.coverageChange
        let coverageScenario = this.coverageChange
        let newPrice = nsp.price
        let oldPrice = this.unSelectedPlans_ && this.unSelectedPlans_.length > 0 ? this.unSelectedPlans_[0]['price'] : nsp.price
        let service = this.provisioningSites
        let dependent = this.dependentType
        let approvalStatus = this.normalSpouseRegistration ? "normal" : this.spouseform.value.coveredByAnotherPlan ? "proceed" : "pending"

        if (this.dependentType == 'child') {
          for (const child of this.childrenDetails) {
            if (child.specialNeeds) {
              approvalStatus = "pending"
            } else {
              approvalStatus = this.normalDependentRegistration ? "normal" : "proceed"
            }
          }
        }


        let noteString = { planChange: oldPlanName + '-' + newPlanName, coverageChange: coverageChange, coverageScenario: coverageScenario, priceChange: oldPrice + '-' + newPrice, service: service, dependent: dependent, approvalStatus: approvalStatus }
        notes.push(noteString)
      }
    }

    return notes;
  }


  handleDeletePrepareNotes() {
    let notes: any = [];
    if (this.unSelectedPlans_ && this.unSelectedPlans_.length > 0) {
      for (const nsp of this.unSelectedPlans_) {
        let newPlanName = nsp.name + '(' + nsp?.planCoverage + ')' || '';
        let oldPlanName = this.newlySelectedPlans[0]['name'] + '(' + this.newlySelectedPlans[0]['planCoverage'] + ')';
        let coverageChange = this.coverageChange
        let coverageScenario = this.coverageChange
        let newPrice = nsp.price
        let oldPrice = this.newlySelectedPlans[0]['price']
        let service = this.provisioningSites
        let dependent = this.dependentType
        let approvalStatus = this.normalSpouseRegistration ? "normal" : this.spouseform.value.coveredByAnotherPlan ? "proceed" : "pending"

        if (this.dependentType == 'child') {
          for (const child of this.childrenDetails) {
            if (child.specialNeeds) {
              approvalStatus = "pending"
            } else {
              approvalStatus = this.normalDependentRegistration ? "normal" : "proceed"
            }
          }
        }


        let noteString = { planChange: oldPlanName + '-' + newPlanName, coverageChange: coverageChange, coverageScenario: coverageScenario, priceChange: oldPrice + '-' + newPrice, service: service, dependent: dependent, approvalStatus: approvalStatus }
        notes.push(noteString)
      }
    }

    return notes;
  }


  async addChild() {
    let selectedPlans: any = sessionStorage.getItem("plansummarymain");
    if (selectedPlans) {
      selectedPlans = JSON.parse(selectedPlans);
    } else {
      selectedPlans = []; // Set a default value if the session storage is empty or null
    }
  }


  validatePlans_v2() {
    this.validateCheck = false;
    this.showValidatePlans = true;
  }


  handleMarriageType(e) {
    this.functionClearSettings()
    console.log(e.target.value)
    this.spouseform.get('martialStatus')?.setValue('COUPLE', { emitEvent: false })
    this.dependentTypeForm.get('marriageType')?.setValue(e.target.value, { emitEvent: false })
    console.log(this.dependentTypeForm)
    this.marriageType = e.target.value;
    if (e.target.value == 'commonLaw') {
      this.isCommonLaw = true;
      this.isMarried = false;
    } else {
      this.isMarried = true;
      this.isCommonLaw = false;
    }
  }



  functionClearSettings() {
    // this.dependentTypeForm.get('marriageDate')?.setValue('')
    // this.dependentTypeForm.get('marriageType')?.setValue('')
    this.dependentform.reset();
    this.validateCheck = true;
    this.spouseform.reset();
    this.isMarried = false;
    this.childCount = 0;
    this.showValidatePlans = false;
    this.showPlanDetails = false;
    this.showAfterPlanDetails = true;
    this.showSpouseInfo = false;
    this.specialpackages = []
    this.plansSummaryObj = []
    this.childCoverage = false;
    this.isCommonLaw = false;
    this.showChildForm = false;
    this.childrenDetails = []
    this.childrenDetailsForNormalReg = []
    this.normalSpouseRegistration = true;
    this.normalDependentRegistration = true;
  }

  handleMarriageDate(e: any) {
    // const marriedDate = this.datePipe.transform(new Date(e).toLocaleString(),'MM-dd-yyyy')
    // const date1 = moment(marriedDate, "DD-MM-YYYY"); // First date
    // const date2 = moment(moment(new Date()), "DD-MM-YYYY"); // Second date
    // console.log(this.isMarried, this.isCommonLaw)
    // const differenceInDays = date2.diff(date1, 'days');
    // console.log('differenceInDays',differenceInDays)

    // If the input is coming from the calendar picker, it's already a date object.
    this.marriedDate = new Date(e);
    this.finalEffectiveDate = null;
    this.clearAllMessages();
    this.spouseMarriedDate = new Date(e);
    // If the input is a string (like "12-02-2024"), try parsing it directly.
    if (typeof e === 'string') {
      this.marriedDate = moment(e, "MM-DD-YYYY").toDate();
    }
    const marriedDateFormatted = this.datePipe.transform(this.marriedDate, 'MM-dd-yyyy');
    const date1 = moment(marriedDateFormatted, "MM-DD-YYYY"); // First date
    const date2 = moment(moment(new Date()), "MM-DD-YYYY"); // Second date
    console.log(this.maritalStatus, this.isCommonLaw);

    const differenceInDays = date2.diff(date1, 'days');
    console.log('differenceInDays', differenceInDays);

    if (this.maritalStatus == 'married') {
      if (differenceInDays <= 30) {
        this.normalSpouseRegistration = true;
        this.isInsuranceCheck = false;
      } else {
        // this.handleContinue();
        this.normalSpouseRegistration = false;
        this.isInsuranceCheck = true;
      }
    } else if (this.maritalStatus == 'commonLaw') {
      if (differenceInDays <= 365) {
        this.isInsuranceCheck = false;
        this.normalSpouseRegistration = true;
      } else {
        this.isInsuranceCheck = true;
        this.normalSpouseRegistration = false;
      }
    }
    console.log('this.normalSpouseRegistration', this.normalSpouseRegistration)
  }

   handleChildDOBDate(e: any) {
    // const marriedDate = this.datePipe.transform(new Date(e).toLocaleString(),'MM-dd-yyyy')
    // const date1 = moment(marriedDate, "DD-MM-YYYY"); // First date
    // const date2 = moment(moment(new Date()), "DD-MM-YYYY"); // Second date
    // console.log(this.isMarried, this.isCommonLaw)
    // const differenceInDays = date2.diff(date1, 'days');
    // console.log('differenceInDays',differenceInDays)

    // If the input is coming from the calendar picker, it's already a date object.
    let dateofbirthchild = new Date(e);
    this.isGradError = false;
    // If the input is a string (like "12-02-2024"), try parsing it directly.
    if (typeof e === 'string') {
      dateofbirthchild = moment(e, "MM-DD-YYYY").toDate();
    }
    const childDateFormatted = this.datePipe.transform(dateofbirthchild, 'MM-dd-yyyy');
    const date1 = moment(childDateFormatted, "MM-DD-YYYY"); // First date
    const date2 = moment(moment(new Date()), "MM-DD-YYYY"); // Second date
    console.log(this.maritalStatus, this.isCommonLaw);

    const differenceInDays = date2.diff(date1, 'days');
    console.log('differenceInDays', differenceInDays);

    if (differenceInDays <= 30) {
      this.normalDependentRegistration = true;
      this.isInsuranceCheck = false;
    } else {
      // this.handleContinue();
      this.normalDependentRegistration = false;
      this.isInsuranceCheck = true;
    }
    console.log('this.normalSpouseRegistration', this.normalDependentRegistration)
  }

  handleNormalChildRegistration() {
    this.normalDependentRegistration = !this.normalDependentRegistration;
  }


  async showTrusteeDetailsPopup(beneficiary: any) {
    const { value: formValues } = await Swal.fire({
      title: 'Trustee Details',
      html: `
        <input type="text" id="firstName" class="form-control mb-2" placeholder="First Name">
        <input type="text" id="lastName" class="form-control" placeholder="Last Name">
      `,
      confirmButtonText: 'Submit',
      focusConfirm: false,
      preConfirm: () => {
        const firstName = (document.getElementById('firstName') as HTMLInputElement).value;
        const lastName = (document.getElementById('lastName') as HTMLInputElement).value;
        if (!firstName || !lastName) {
          Swal.showValidationMessage(`Please enter both first name and last name`);
          return false;
        }
        return { firstName, lastName };
      }
    });

    if (formValues) {
      beneficiary.trusteeDetails = {
        firstName: formValues.firstName,
        lastName: formValues.lastName
      };
    }
  }

  addBenficiaryRow() {
    let obj = {
      "_id": Math.random() * 100,
      "firstName": "",
      "lastName": "",
      "type": "PRIMARY",
      "customerType": this.currentBeneficiary.customerType,
      "relationship": "",
      "dob": "",
      "isMinor": false,
      "percentage": "",
      "contactDetails": { contingentBeneficiary: { firstName: "", lastName: '' } },
      "trusteeDetails": { firstName: "", lastName: "" },
      "age": "",
      "gender": ""
    }
    this.beneficiaries.push(obj)
    this.beneficiaries1.push(obj)

    let seenIds = new Set();
    this.beneficiaries = this.beneficiaries.filter(beneficiary => {
      if (!seenIds.has(beneficiary._id)) {
        seenIds.add(beneficiary._id);
        return true;
      }
      if (!seenIds.has(beneficiary.id)) {
        seenIds.add(beneficiary.id);
        return true;
      }
      return false;
    });

    seenIds = new Set();
    this.beneficiaries1 = this.beneficiaries1.filter(beneficiary => {
      if (!seenIds.has(beneficiary._id)) {
        seenIds.add(beneficiary._id);
        return true;
      }
      if (!seenIds.has(beneficiary.id)) {
        seenIds.add(beneficiary.id);
        return true;
      }
      return false;
    });
  }

  checkValid(data, error) {
    if (data == "" || data == null || data == undefined) {
      Swal.fire({ title: this.lang?.Error, text: error })
      return true;
    } else {
      return false;
    }
  }

  onRelationshipChange(beneficiary: any) {
    if (beneficiary.relationship !== 'CHILD') {
      // If relationship is not CHILD, set isMinor to false and prevent setting it to true
      beneficiary.isMinor = false;
      beneficiary.trusteeDetails = { firstName: '', lastName: '' }
    }
  }

  addNewBeneficiary(beneficiary) {
    const obj = {
      "firstName": beneficiary.firstName,
      "lastName": beneficiary.lastName,
      "type": beneficiary.type,
      "customerType": beneficiary.customerType,
      "relationship": beneficiary.relationship != 'OTHERS' ? beneficiary.relationship : beneficiary.others,
      "dob": beneficiary.isMinor ? this.formatDate(beneficiary.dob) : '',
      "isMinor": beneficiary.isMinor,
      "percentage": beneficiary.percentage,
      "contactDetails": beneficiary.contactDetails == '' ? {} : beneficiary.contactDetails,
      "trusteeDetails": beneficiary.isMinor ? beneficiary.trusteeDetails : { firstName: '', lastName: '' }
    }
    if (this.checkValid(obj.firstName, this.lang?.Please_enter_first_name)) {
      return;
    }
    if (this.checkValid(obj.lastName, this.lang?.Please_enter_last_name)) {
      return;
    }
    if (this.checkValid(obj.type, this.lang?.Please_enter_Type)) {
      return;
    }
    if (this.checkValid(obj.customerType, this.lang?.Please_enter_Custom_Type)) {
      return;
    }
    if (this.checkValid(obj.relationship, this.lang?.Please_Enter_Relationship)) {
      return;
    }
    if (obj?.isMinor != true && obj?.isMinor != false) {
      Swal.fire({ title: this.lang?.Error, text: this.lang?.Please_Enter_Is_minor_or_not })
      return;
    }
    if (obj.isMinor == true) {
      if (this.checkValid(obj.dob, this.lang?.Please_enter_Date_of_Birth)) {
        return;
      }
      if (this.checkValid(obj.trusteeDetails.firstName, this.lang?.Please_Enter_Trustee_First_Name)) {
        return;
      }
      if (this.checkValid(obj.trusteeDetails.lastName, this.lang?.Please_Enter_Trustee_Last_Name)) {
        return;
      }
    }
    if (obj?.isMinor != true && obj?.isMinor != false) {
      Swal.fire({ title: this.lang?.Error, text: this.lang?.Please_Enter_Is_minor_or_not })
      return;
    }
    if (this.checkValid(obj.percentage, this.lang?.Please_enter_Percentage)) {
      return;
    }

    const customerId = sessionStorage.getItem('customerId')
    let endPoint = `/${customerId}/beneficiary`
    this.http.post(api.url + endPoint, obj, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      if (response.status == 200) {
        console.log('beneficiary-add in db', obj)
        this.beneficiaryReload += 1;
        if (this.beneficiaryReload == this.beneficiaries.length) {
          Swal.fire({
            title: "Info",
            text: this.lang?.Beneficiaries_updated_successfully
          }).then((result) => {
            if (result.isConfirmed) {
              window.location.reload()
            } else {
              window.location.reload()
            }
          })
        }
      }
      else {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })
      }
    }, (error) => {
      Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
    })
  }

  updateBeneficiaries() {
    console.log(this.beneficiaries, this.beneficiaries1)
    const benf = this.beneficiaries1.filter(ben => ben?.id && !this.deleteBenfIds.includes(ben?.id))
    const benf1 = this.beneficiaries1.filter(ben => ben?._id && !this.deleteBenfIds1.includes(ben?._id))
    const benfs = [...benf, ...benf1]
    const allPercentages = benfs.map(ben => Number(ben.percentage));
    let totalPercentage = 0;
    for (let i = 0; i < allPercentages.length; i++) {
      totalPercentage += allPercentages[i];
    }
    console.log(totalPercentage, allPercentages)
    if (totalPercentage != 100) {
      Swal.fire({ title: this.lang?.Error, text: this.lang?.Total_sum_percentages_are_not_equal_to_100 })
      return;
    }
    let reload = 0;
    for (let i = 0; i < benfs.length; i++) {
      let obj = benfs[i]
      if (this.checkValid(obj.firstName, this.lang?.Please_enter_first_name)) {
        reload++;
        return;
      }
      if (this.checkValid(obj.lastName, this.lang?.Please_enter_last_name)) {
        reload++;
        return;
      }
      if (this.checkValid(obj.type, this.lang?.Please_enter_Type)) {
        reload++;
        return;
      }
      if (this.checkValid(obj.customerType, this.lang?.Please_enter_Custom_Type)) {
        reload++;
        return;
      }
      if (this.checkValid(obj.relationship, this.lang?.Please_Enter_Relationship)) {
        reload++;
        return;
      }
      if (obj?.isMinor != true && obj?.isMinor != false) {
        Swal.fire({ title: this.lang?.Error, text: this.lang?.Please_Enter_Is_minor_or_not })
        reload++;
        return;
      }
      if (obj.isMinor == true) {
        if (this.checkValid(obj.dob, this.lang?.Please_enter_Date_of_Birth)) {
          reload++;
          return;
        }
        if (this.checkValid(obj.trusteeDetails.firstName, this.lang?.Please_Enter_Trustee_First_Name)) {
          reload++;
          return;
        }
        if (this.checkValid(obj.trusteeDetails.lastName, this.lang?.Please_Enter_Trustee_Last_Name)) {
          reload++;
          return;
        }
      }
      if (this.checkValid(obj.percentage, this.lang?.Please_enter_Percentage)) {
        reload++;
        return;
      }
    }
    if (reload > 0) {
      return;
    }
    for (let i = 0; i < benfs.length; i++) {
      const beneficiary = benfs[i];
      const customerId = sessionStorage.getItem('customerId')
      if (beneficiary.id) {
        let endPoint = `/${customerId}/beneficiary/${beneficiary.id}`
        const obj = {
          "firstName": beneficiary.firstName,
          "lastName": beneficiary.lastName,
          "type": beneficiary.type,
          "customerType": beneficiary.customerType,
          "relationship": beneficiary.relationship != 'OTHERS' ? beneficiary.relationship : beneficiary.others,
          "dob": beneficiary.isMinor ? this.formatDate(beneficiary.dob) : '',
          "isMinor": beneficiary.isMinor,
          "percentage": beneficiary.percentage,
          "contactDetails": beneficiary.contactDetails,
          "trusteeDetails": beneficiary.isMinor && beneficiary.trusteeDetails.firstName != null ? beneficiary.trusteeDetails : { firstName: "", lastName: "" }
        }
        if (this.checkValid(obj.firstName, this.lang?.Please_enter_first_name)) {
          return;
        }
        if (this.checkValid(obj.lastName, this.lang?.Please_enter_last_name)) {
          return;
        }
        if (this.checkValid(obj.type, this.lang?.Please_enter_Type)) {
          return;
        }
        if (this.checkValid(obj.customerType, this.lang?.Please_enter_Custom_Type)) {
          return;
        }
        if (this.checkValid(obj.relationship, this.lang?.Please_Enter_Relationship)) {
          return;
        }
        if (obj?.isMinor != true && obj?.isMinor != false) {
          Swal.fire({ title: this.lang?.Error, text: this.lang?.Please_Enter_Is_minor_or_not })
          return;
        }
        if (obj.isMinor == true) {
          if (this.checkValid(obj.dob, this.lang?.Please_enter_Date_of_Birth)) {
            return;
          }
          if (this.checkValid(obj.trusteeDetails.firstName, this.lang?.Please_Enter_Trustee_First_Name)) {
            return;
          }
          if (this.checkValid(obj.trusteeDetails.lastName, this.lang?.Please_Enter_Trustee_Last_Name)) {
            return;
          }
        }
        if (this.checkValid(obj.percentage, this.lang?.Please_enter_Percentage)) {
          return;
        }
        this.http.put(api.url + endPoint, obj, {
          headers: {
            Authorization: 'Bearer ' + this.accessToken,
            'Content-Type': 'application/json',
          }
        }).subscribe((response: any) => {
          if (response.status == 200) {
            console.log('beneficiary is updated in db', obj)
            this.beneficiaryReload += 1;
            if (this.beneficiaryReload == this.beneficiaries.length) {
              Swal.fire({
                title: "Info",
                text: this.lang?.Beneficiaries_updated_successfully
              }).then((result) => {
                if (result.isConfirmed) {
                  window.location.reload()
                } else {
                  window.location.reload()
                }
              })
            }
          }
          else {
            Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })
          }
        }, (error) => {
          Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
        })

      } else {
        this.addNewBeneficiary(beneficiary)
      }
    }
    for (let i = 0; i < this.beneficiaries1.length; i++) {
      if (this.deleteBenfIds.includes(this.beneficiaries1[i]?.id)) {
        const customerId = sessionStorage.getItem('customerId')
        let endPoint = `/${customerId}/beneficiary/${this.beneficiaries1[i].id}`
        this.http.delete(api.url + endPoint, {
          headers: {
            Authorization: 'Bearer ' + this.accessToken,
            'Content-Type': 'application/json',
          }
        }).subscribe((response: any) => {
          if (response.status == 200) {
            console.log('beneficiary deleted in db', this.beneficiaries1[i])
            this.beneficiaryReload += 1;
            if (this.beneficiaryReload == this.beneficiaries.length) {
              Swal.fire({
                title: "Info",
                text: this.lang?.Beneficiaries_updated_successfully
              }).then((result) => {
                if (result.isConfirmed) {
                  window.location.reload()
                } else {
                  window.location.reload()
                }
              })
            }
          }
          else {
            Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })
          }
        }, (error) => {
          Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
        })
      } else {
        // console.log('beneficiary-delete-local',this.beneficiaries1[i])
      }
    }
  }

  deleteBeneficiary(beneficiary) {
    Swal.fire({
      title: this.lang?.Delete_Beneficiary,
      text: this.lang?.Do_you_want_to_delete_this_beneficiary,
      showDenyButton: true,
      showConfirmButton: true,
      confirmButtonText: this.lang?.Cancel,
      denyButtonText: this.lang?.Delete,
    }).then((result) => {
      if (result.value) {
        this.deleteBenfIds = []
        this.deleteBenfIds1 = []
      } else {
        if (beneficiary.id) {
          this.deleteBenfIds = [...this.deleteBenfIds, beneficiary.id]
          this.beneficiaries = this.beneficiaries.filter(ben => ben.id != beneficiary.id)
        } else {
          this.deleteBenfIds1 = [...this.deleteBenfIds1, beneficiary._id]
          this.beneficiaries = this.beneficiaries.filter(ben => ben._id != beneficiary._id)
        }
      }
    })
  }

  getBankDetails() {
    let data = this.PADdetails;
    data['branchCode'] = this.PADdetails?.transitNumber;
    let accessToken = sessionStorage.getItem('accessToken');
    const Endpoint = '/bank/verify';
    this.http.post(api.url + Endpoint, data, {
      headers: {
        Authorization: 'Bearer ' + accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      if (response.status == 200) {
        this.bank = response?.data;
        this.address = this.bank?.address;
        this.bankinformation = response?.data?.bank?.name + "\n" + response?.data?.address?.split(",").join("\n");
      }
      else {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response?.message })
      }
    }, (error) => {
      Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error?.error?.message })
    })
  }
  viewPlansLoading(e: any) {
    this.showViewPlansLoading = false;
  }
  pdfLoaded(e: any) {
    this.loading = false;
  }

  public getLanguageTokens() {
    let body = {
      "project": "Member Portal",
      "url": "Overview"
    }
    this.http
      .post('https://languageengineapi.aitestpro.com/string/project-url-strings', body, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .subscribe(
        (response: any) => {
          // console.log(response)
          this.lang = {};
          // this.selectedLanguage = "English"
          this.selectedLanguage = sessionStorage.getItem('language') || 'English'
          for (let token of response.strings) {
            this.lang[token.key] = token[this.selectedLanguage];
          }
          console.log(this.lang)
        }
      )
  }

  updateAddressForm() {
    // this.UpdateAddressComponent = true;

    this.invalidpostalcodeprivince = false
    this.provianceList.forEach((element: any) => {
      if (element.name == this.customerData.province) {
        this.customerData.province = element.shortName
      }
    });

    this.addressform.patchValue(this.customerData);
    this.addressform.markAllAsTouched();
  }

  updateAddress() {
    // this._LoaderService.ShowLoader()

    //this._LoggerService.log(this.addressForm['postalCode'].valid)
    if (this.addressform.invalid) {
      this.addressform.markAllAsTouched();
      return;
    }
    else {
      if (this.addressform.value.secondaryPhone == this.addressform.value.primaryPhone) {
        this.secondaryphonecheck = true

      }
      else {
        this.secondaryphonecheck = false
        if (this.addressform.invalid) {
          this.addressform.markAllAsTouched();
          return;
        }
        else {
          const endPoint = '/' + this.customerid + '/address';
          let data = this.addressform.value;
          data["street_address_line1"] = this.addressform.value.line1
          data["street_address_line2"] = this.addressform.value.line2
          if (data["street_address_line2"].value == '') {
            data["street_address_line2"] = ' ';
          }
          else {
            if (data["street_address_line2"].value == null) {
              data["street_address_line2"] = ' ';
            }
          }
          data["postal_code"] = this.addressform.value.postalCode
          data["dob"] = this._CustomDatePipe.transform(this.addressform.value.dob)
          data["code"] = this.valisignform.value.code
          if (this.addressForm['secondaryPhone'].value == null) {
            data['secondaryPhone'] = '';
          }
          if (this.addressform.valid && this.invalidpostalcodeprivince == false) {
            // this._LoaderService.ShowLoader()
            let headers = {
              Authorization: 'Bearer ' + this.accessToken,
              'Content-Type': 'application/json',
            }
            this.http.put(api.url + endPoint, data, {
              headers: headers
            }).subscribe((response: any) => {
              if (response.status == 200) {
                // this._LoaderService.HideLoader()
                // this.http.get(api.adminApiUrl + '/api/ap/global/set-adminMembers').subscribe((newResponse) => {})
                this.http.post(api.reportApiUrl + '/websocket/member/notification-to-others', {
                  "message": "Members information has been updated. Please refresh screen."
                }, { headers: headers }).subscribe((res) => { })

                this.closeAddressmodal.nativeElement.click();
                Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message });
              }
              else {
                Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })
              }
            }, (error) => {

              Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })

            });
          }
        }
      }
    }


    // this.addressForm.get('secondaryPhone').valueChanges.subscribe(val => {
    //   if (condition) {
    //     this.addressForm.controls['licenseNo'].setValidators([Validators.required]);
    //   } else {
    //     this.addressForm.controls['licenseNo'].clearValidators();
    //   }
    //   this.addressForm.controls['licenseNo'].updateValueAndValidity();
    // });

  }

  updatePhoneNoForm() {
    this.phoneform.patchValue(this.customerData);
  }

  updatePhoneNo(value: any) {
    if (this.phoneform.invalid) {
      this.phoneform.markAllAsTouched();
      return;
    }
    else {
      const endPoint = '/' + this.customerid + '/address';
      let data = this.phoneform.value;
      if (this.phoneForm['secondaryPhone'].value == null) {
        data['secondaryPhone'] = '';
      }
      this.http.put(api.url + endPoint, data, {
        headers: {
          Authorization: 'Bearer ' + this.accessToken,
          'Content-Type': 'application/json',
        }
      }).subscribe((response: any) => {
        if (response.status == 200) {
          this.closePhonemodal.nativeElement.click();
          Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message });
        }
        else {
          Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })
        }
      }, (error) => {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
      });

    }

  }

  closePhoneModal() {
    this.phoneform.reset();
  }

  updateSpousePlan() {
    // this.UpdateSpousePlanComponent = true;
    this.spouseUpdate = true;
    this.spouseStatus = true;
    this.updatespouseform.patchValue(this.spouseInfo);
    this.spouseCoverage = this.spouseInfo.coveredByAnotherPlan;
    this.updatespouseForm['martialStatus'].clearValidators();
    this.updatespouseForm['martialStatus'].updateValueAndValidity();
    this.updatespouseForm['effectiveDate'].clearValidators();
    this.updatespouseForm['effectiveDate'].updateValueAndValidity();
    if (this.spouseCoverage === false) {
      this.updatespouseForm['insurer'].clearValidators();
      this.updatespouseForm['insurer'].updateValueAndValidity();
      this.updatespouseForm['healthPlan'].clearValidators();
      this.updatespouseForm['healthPlan'].updateValueAndValidity();

    }
  }



  deleteSpousePlan(children: any) {
    console.log({ children })
    // this.UpdateSpousePlanComponent = true;
    this.spouseUpdate = true;
    this.spouseStatus = true;
    this.deletespouseform.patchValue(this.spouseInfo);
    this.spouseCoverage = this.spouseInfo.coveredByAnotherPlan;
    this.deletespouseForm['martialStatus'].clearValidators();
    this.deletespouseForm['martialStatus'].updateValueAndValidity();
    this.deletespouseForm['effectiveDate'].clearValidators();
    this.deletespouseForm['effectiveDate'].updateValueAndValidity();
    if (this.spouseCoverage === false) {
      this.deletespouseForm['insurer'].clearValidators();
      this.deletespouseForm['insurer'].updateValueAndValidity();
      this.deletespouseForm['healthPlan'].clearValidators();
      this.deletespouseForm['healthPlan'].updateValueAndValidity();

    }

    this.deleteSpouseDetails_1(children)
  }


  deleteChildrenPlan(i) {
    // this.UpdateSpousePlanComponent = true;
    this.spouseUpdate = true;
    this.spouseStatus = true;
    this.deletespouseform.patchValue(this.spouseInfo);
    this.spouseCoverage = this.spouseInfo.coveredByAnotherPlan;
    this.deletespouseForm['martialStatus'].clearValidators();
    this.deletespouseForm['martialStatus'].updateValueAndValidity();
    this.deletespouseForm['effectiveDate'].clearValidators();
    this.deletespouseForm['effectiveDate'].updateValueAndValidity();
    if (this.spouseCoverage === false) {
      this.deletespouseForm['insurer'].clearValidators();
      this.deletespouseForm['insurer'].updateValueAndValidity();
      this.deletespouseForm['healthPlan'].clearValidators();
      this.deletespouseForm['healthPlan'].updateValueAndValidity();

    }
  }

  updateSpouseDetails() {


    console.log("data", this.updatespouseform)
    let data = this.updatespouseform.value;
    let spouseData = this.childrenInfo;

    // if(this.spouseForm['effectiveDate'].invalid || this.spouseForm['martialStatus'].invalid) {
    //   this.spouseform.markAllAsTouched();
    //   return;
    // }

    //this._LoggerService.log(spouseData)
    //this._LoggerService.log(data)
    if (this.updatespouseform.invalid) {
      this.updatespouseform.markAllAsTouched();
      return;
    }
    else {
      // const endPoint = '/'+this.customerid+'/lifeChange/spouse/add/true';
      const endPoint = '/' + this.customerid + '/customerRelative/' + this.spouseId + '/details';

      let data = this.updatespouseform.value;
      // //this._LoggerService.log(this.spouseForm['dob'].value)


      // for(let spouse of spouseData){
      //   //this._LoggerService.log(spouse)
      //   if(spouse["relationType"]=="spouse"){
      //    data["firstName"]=spouse.firstName;
      //    data["lastName"]=spouse.lastName;
      //    data["dob"]=spouse.dob;
      //    data["gender"]=spouse.gender;
      //    data["email"]=spouse.email;
      //    data["coverage"]=spouse.healthPlan;
      //    data["carrierName"]=spouse.insurer;
      //    data["healthPlan"]=spouse.healthPlan;
      //    data["insurer"]=spouse.insurer;
      //   }

      // }
      data["coverage"] = this.updatespouseform.value.healthPlan || "";
      data["carrierName"] = this.updatespouseform.value.insurer || "";
      data["relationType"] = "SPOUSE"
      if (this.updatespouseform.value.coveredByAnotherPlan === true) {
        data["coveredByAnotherPlan"] = true
      }
      else {
        data["coveredByAnotherPlan"] = false
      }

      data["dob"] = this._CustomDatePipe.transform(this.updatespouseform.value.dob)
      //this._LoggerService.log(data)
      this.http.put(api.url + endPoint, data, {
        headers: {
          Authorization: 'Bearer ' + this.accessToken,
          'Content-Type': 'application/json',
        }
      }).subscribe((response: any) => {
        if (response.status == 200) {
          this.closeSpousemodal.nativeElement.click();
          Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message });
        }
        else {
          Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })
        }
      }, (error) => {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
      });
    }
  }



  deleteSpouseDetails_1(children) {
    this.dependentTypeForm.reset()
    this.dependentType == "spouse"
    this.spouseCovered = children?.coveredByAnotherPlan;
    this.dependentTypeForm.get('effectiveDate')?.setValue('')
    // this.handleContinue('remove');
    // $('#deleteSpousePlan').hide()
    // $('#showPlanDetails-modal').show()
  }

  deleteChildrenDetails_1(children) {
    this.dependentTypeForm.reset()
    this.dependentType == "dependent"
    this.childCovered = children?.coveredByAnotherPlan;
    this.dependentTypeForm.get('effectiveDate')?.setValue('')
    // this.handleContinue('remove');
    // $('#deleteSpousePlan').hide()
    // $('#showPlanDetails-modal').show()
  }


  // this.dependentTypeForm1.get('effectiveDate')?.value
  async handleDeleteDependent(depDetails: any) {
    // Hide the modal initially, if it is visible
    // $('#deleteSpousePlan').modal('close');

    // Show SweetAlert confirmation dialog

    sessionStorage.removeItem("plansummarymain")
    sessionStorage.removeItem("plansskumain");
    sessionStorage.removeItem("plansummaryopt");
    sessionStorage.removeItem("plansummary");
    sessionStorage.removeItem("selectedPlans");
    sessionStorage.removeItem("totalAmount");
    sessionStorage.removeItem("totalAmountUI");
    console.log("called333");
    this.dependentUpdate = true;
    this.dependentStatus = true;
    this.childrenId = depDetails.id;

    console.log(depDetails)
    this.selectedDependentDetails = depDetails;
    this.dependentType = depDetails.relationType == "child" ? "dependent" : "spouse"
    this.spouseCovered = depDetails.relationType == "child" ? false : depDetails?.coveredByAnotherPlan
    this.childCovered = depDetails.relationType == "spouse" ? false : depDetails?.coveredByAnotherPlan
    this.currentDeleteMember = depDetails.relationType == "child" ? "child" : "spouse"
    this.dependentTypeForm.reset()
    this.dependentTypeForm.get('effectiveDate')?.setValue('')
    Swal.fire({
      allowOutsideClick: false,
      title: 'Info',
      text: 'Are you sure you want to Delete?',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
    }).then((res) => {
      if (res.isConfirmed) {
        // After SweetAlert confirmation, show the modal

      } else {
        $("#cancelButton22").click()
        // $(".modal-backdrop").remove();
        // $('#deleteSpousePlan').hide();
      }
    })
  }

  async handleConfirmDelete() {

    console.log("0hgggg")


    let selectedPlans: any = sessionStorage.getItem("plansummarymain");
    if (selectedPlans) {
      selectedPlans = JSON.parse(selectedPlans);
    } else {
      selectedPlans = []; // Set a default value if the session storage is empty or null
    }
    // console.log('selectedPlans', selectedPlans)

    // if (!selectedPlans || selectedPlans?.length <= 0) {
    //   this.plansError = true

    //   return;
    // }
    // else {
    //   this.plansError = false
    // }

    console.log('this.specialpackages', this.specialpackages)

    // 1st
    this.plansObj = []
    let phrPlanSelected = false;
    let isPhr = false;
    let oldPlans: any = []
    for (let pack of this.specialpackages) {
      let obj: any = {};
      let selected: any = {};

      if (pack.id == 10) isPhr = true;

      if (pack.selected) {
        if (pack.id == 10) phrPlanSelected = true;
        console.log("Package selected, checking groups...");  // Debugging package selection

        Object.keys(pack.groups).forEach((group: any) => {
          for (let plan of pack.groups[group]) {
            for (let plans of plan.plans) {
              if (plans.selected) {
                Object.keys(plans.productAddonss).forEach((addon: any) => {
                  for (let c of plans.productAddonss[addon]) {
                    if (c.selected) {
                      selected = { ...c };
                      console.log("Selected addon:", selected);  // Debugging selected addon

                      for (let sc of selectedPlans) {
                        console.log("Comparing with selected plan:", sc);  // Debugging comparison with selected plans
                        if (c.planId == sc?.id && !sc?.products[0]?.selected) {
                          obj = {
                            ...(c.selected ? { oldPlan: { ...c } } : { oldPlan: {} }),
                            newPlan: { ...sc },
                            ...(c.planCoverage != sc.coverage && c.selected && this.covergages.includes(c.planCoverage) && { coverageChange: true })
                          };
                          console.log("Plan comparison result obj:", obj);  // Debugging obj creation
                        } else {
                          this.unselected.forEach((ele) => {
                            if (ele.planId == c.planId) {
                              console.log("Unselected plans:", this.unselected);  // Debugging unselected plans
                              let obj1: any = {
                                ...(c.selected ? { oldPlan: { ...c } } : { oldPlan: {} }),
                                newPlan: {},
                              };
                              oldPlans.push(obj1);
                              console.log("Added to oldPlans:", obj1);  // Debugging addition to oldPlans
                            }
                          });
                        }
                      }
                    }
                  }
                });
              }
            }
          }
        });

        if (obj && Object.keys(obj).length > 0 && ((obj.oldPlan && Object.keys(obj?.oldPlan).length > 0) || (obj.newPlan && Object.keys(obj?.newPlan).length > 0))) {
          console.log("Pushing obj to plansObj:", obj);  // Debugging push to plansObj
          this.plansObj.push(obj);
          obj = {};
        }
      }

      // when package selected but completely different plan with in same package
      if (pack.selected && selected) {
        console.log("Entered package with different plan selection");  // Debugging package with different plan selection
        Object.keys(pack.groups).forEach((group: any) => {
          for (let plan of pack.groups[group]) {
            for (let plans of plan.plans) {
              if (!plans.selected) {
                Object.keys(plans.productAddonss).forEach((addon: any) => {
                  for (let c of plans.productAddonss[addon]) {
                    for (let sc of selectedPlans) {
                      console.log("=====")
                      console.log(plans, sc)
                      console.log("----")
                      console.log(c)
                      console.log("=====0")
                      if (plans.planLevel == sc.planLevel && c.planId == sc.id) {
                        obj = {
                          oldPlan: { ...selected },
                          newPlan: { ...sc },
                        };
                        console.log("Created obj for different plan selection:", obj);  // Debugging obj creation
                      }
                    }
                  }
                });

                if (Object.keys(obj).length > 0) {
                  this.unselected = this.unselected.filter((ele) => (
                    ele.planId != obj.oldPlan.planId
                  ));
                  oldPlans = oldPlans.filter(e => e.oldPlan.planId != obj.oldPlan.planId);
                  console.log("Updated unselected and oldPlans:", this.unselected, oldPlans);  // Debugging unselected and oldPlans after filtering
                  console.log("Pushing obj to plansObj:", obj);  // Debugging push to plansObj
                  this.plansObj.push(obj);
                  obj = {};
                }
              }
            }
          }
        });
      }

      //when package in not selected but completely diffrenet package selected
      if (!pack.selected) {
        console.log("Package not selected, checking for selected plans...");  // Debugging package not selected
        for (let sc of selectedPlans) {
          console.log("Checking if package matches:", sc.packageId == pack.id);  // Debugging package match check
          if (sc.packageId == pack.id) {
            obj = {
              newPlan: { ...sc },
              oldPlan: {}
            };
            console.log("Created obj for unselected package:", obj);  // Debugging obj creation for unselected package
          }
        }
        if (Object.keys(obj).length > 0) {
          console.log("Pushing obj to plansObj:", obj);  // Debugging push to plansObj
          this.plansObj.push(obj);
          obj = {};
        }
      }
    }

    //when plan selected and diselected
    if (oldPlans.length > 0) {
      const uniquePlanIds = new Set<number>();
      const filteredOldPlans = oldPlans.filter((plan) => {
        if (!uniquePlanIds.has(plan.oldPlan.planId)) {
          uniquePlanIds.add(plan.oldPlan.planId);
          return true;
        }
        return false;
      });

      if (filteredOldPlans.length > 0) {
        console.log("Pushing filteredOldPlans to plansObj:", filteredOldPlans);  // Debugging push of filtered old plans
        this.plansObj = [...this.plansObj, ...filteredOldPlans];
      }
    }

    //high cost drugs selected and all in selected
    let allinSelected = this.plansObj.some((plan) => { return plan.newPlan.planLevelParent == 6 });
    console.log("All-in selected:", allinSelected);  // Debugging all-in selected flag
    const allIndisallowed = [1, 10, 14, 24];
    if (allinSelected) {
      for (let pack of this.specialpackages) {
        if (pack.selected) {
          Object.keys(pack.groups).forEach((group: any) => {
            for (let plan of pack.groups[group]) {
              for (let plans of plan.plans) {
                if (plans.selected && allIndisallowed.includes(plans.planLevel)) {
                  Object.keys(plans.productAddonss).forEach((addon: any) => {
                    for (let c of plans.productAddonss[addon]) {
                      if (c.selected) {
                        console.log("High cost drug selected:", c.planId);  // Debugging high cost drug selection
                        this.plansObj.push({
                          oldPlan: { ...c },
                          newPlan: {}
                        });
                      }
                    }
                  });
                }
              }
            }
          });
        }
      }
    }

    //phr rules
    let healthAndDentalSelected = this.plansObj.some((plan) => { return plan.newPlan.packageId == 1 });
    let phrSelected = this.plansObj.some((plan) => { return plan.newPlan.packageId == 10 });
    console.log("Health and Dental selected:", healthAndDentalSelected);  // Debugging health and dental selection
    console.log("Phr selected:", phrSelected);  // Debugging phr selection

    if (healthAndDentalSelected && isPhr) {
      if (!phrSelected && !phrPlanSelected) {
        console.log("Error: PHR plan not selected with Health/Dental plan");  // Debugging PHR selection error
        Swal.fire({
          title: this.lang?.Error, text: this.lang?.Please_select_a_Provincial_Health_Replacement_Plan_along_with_a_Health_Dental_Insurance_Plan
        });
        return;
      }
    }

    const notes = await this.handlePrepareNotes();



    let filteredPlans = this.plansObj.filter(plan =>
      Object.keys(plan.newPlan).length > 0 && Object.keys(plan.oldPlan).length > 0
    );


    console.log(this.dependentTypeForm1)
    let data: any = {}
    let slug = 'remove'

    let effDate = moment(this.dependentTypeForm1.value.effectiveDate).format('DD-MM-YYYY');
    if (this.dependentType == "spouse") {
      data = {
        "spouse": this.selectedDependentDetails,
        "dependent": [],
        "notes": this.handleGenerateNotes(filteredPlans, 'proceed', this.dependentType, slug, ''),
        "approvalStatus": "proceed",
        "coverageScenario": this.coverageChange,
        // "isPlanChanges": this.newlySelectedPlans.length > 0 ? true : false,
        "isPlanChanges": filteredPlans.length > 0 ? true : false,
        "effectiveDate": effDate,
        "changedCoveragePlans": this.newlySelectedPlans,
        "removalDependents": [],
        "plans": filteredPlans,
        "reason": this.noReason
      }
    } else {
      data = {
        "spouse": {},
        "dependent": [this.selectedDependentDetails],
        "notes": this.handleGenerateNotes(filteredPlans, 'proceed', this.dependentType, slug, ''),
        "approvalStatus": "proceed",
        "coverageScenario": this.coverageChange,
        // "isPlanChanges": this.newlySelectedPlans.length > 0 ? true : false,
        "isPlanChanges": filteredPlans.length > 0 ? true : false,
        "effectiveDate": effDate,
        "changedCoveragePlans": this.newlySelectedPlans,
        "removalDependents": [],
        "plans": filteredPlans,
        "reason": this.noReason
      }
    }


    console.log(data);




    // using for delete
    let endPoint = `/v2/${this.customerid}/lifeChange/${this.dependentType}/${slug}/false`



    this.http.post(api.url + endPoint, data, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      if (response.status == 200) {

        if (this.selectedDependentDetails.relationType == 'spouse') {

          Swal.fire({ title: 'Info', text: 'Spouse deleted successfully. enrollment process is begin in the background.please check after some time.' }).then((result) => {
            if (result.isConfirmed) {
              // $("#addDependent").hide();
              window.location.reload()
            } else {
              window.location.reload()
            }
          })

        } else {
          Swal.fire({ title: 'Info', text: 'Dependent deleted successfully. enrollment process is begin in the background.please check after some time.' }).then((result) => {
            if (result.isConfirmed) {
              // $("#addDependent").hide();
              window.location.reload()
            } else {
              window.location.reload()
            }
          })
        }

      }
      else {
        Swal.fire({ title: 'Info', text: 'Something went wrong' }).then((result) => {
          if (result.isConfirmed) {
            $("#addDependent").hide();

            window.location.reload()
          } else {
            window.location.reload()
          }
        })
      }
    }, (error) => {
      Swal.fire({ title: 'Info', text: 'Something went wrong' }).then((result) => {
        if (result.isConfirmed) {
          $("#addDependent").hide();

          window.location.reload()
        } else {
          window.location.reload()
        }
      })
    });




  }


  async deleteSpouseDetails_2() {

    let data = this.deletespouseform.value;
    let spouseData = this.childrenInfo;

    // if(this.spouseForm['effectiveDate'].invalid || this.spouseForm['martialStatus'].invalid) {
    //   this.spouseform.markAllAsTouched();
    //   return;
    // }

    //this._LoggerService.log(spouseData)
    console.log(this.deletespouseform)
    //this._LoggerService.log(data)
    if (this.deletespouseform.invalid) {
      this.deletespouseform.markAllAsTouched();
      return;
    }
    else {
      // const endPoint = '/'+this.customerid+'/lifeChange/spouse/add/true';

      let spouseData = this.childrenInfo;
      let spouseData_: any = {}


      const notes = await this.handlePrepareNotes();
      let data = this.deletespouseform.value;
      //this._LoggerService.log(data)

      let approvalStatus: any;

      for (let spouse of spouseData) {
        //this._LoggerService.log(spouse)
        if (spouse["relationType"] == "spouse") {
          spouseData_["firstName"] = spouse.firstName;
          spouseData_["lastName"] = spouse.lastName;
          spouseData_["dob"] = spouse.dob;
          spouseData_["gender"] = spouse.gender;
          spouseData_["email"] = spouse.email || "";
          spouseData_["coverage"] = spouse.healthPlan;
          spouseData_["carrierName"] = spouse.insurer;
          spouseData_["healthPlan"] = spouse.healthPlan;
          spouseData_["insurer"] = spouse.insurer;
          spouseData_["id"] = spouse.id

          approvalStatus = "proceed"

        }

      }




      let finalData: any = {
        "spouse": spouseData_,
        "dependent": [],
        "notes": notes,
        "approvalStatus": approvalStatus,
        "isPlanChanges": this.unSelectedPlans_.length > 0 ? true : false,
        "effectiveDate": this.dependentForm['effectiveDate'].value,
        "changedCoveragePlans": this.unSelectedPlans_,
        "removalDependents": [],
      }

      // this.spouseData["dob"]= this.datePipe.transform(new Date(this.spouseform.value.dob).toLocaleString(),'MM-dd-yyyy')

      const endPoint = `/${this.customerid}/lifeChanges/spouse/remove/false`;

      // data["dob"]= this.datePipe.transform(new Date(this.spouseform.value.dob).toLocaleString(),'MM-dd-yyyy')
      this.http.post(api.url + endPoint, finalData, {
        headers: {
          Authorization: 'Bearer ' + this.accessToken,
          'Content-Type': 'application/json',
        }
      }).subscribe((response: any) => {
        if (response.status == 200) {
          this.closeSpousemodal.nativeElement.click();
          Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message });
        }
        else {
          Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })
        }
      }, (error) => {
        //this._LoggerService.log(error)
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
      });



      // //this._LoggerService.log(this.spouseForm['dob'].value)


      // for(let spouse of spouseData){
      //   //this._LoggerService.log(spouse)
      //   if(spouse["relationType"]=="spouse"){
      //    data["firstName"]=spouse.firstName;
      //    data["lastName"]=spouse.lastName;
      //    data["dob"]=spouse.dob;
      //    data["gender"]=spouse.gender;
      //    data["email"]=spouse.email;
      //    data["coverage"]=spouse.healthPlan;
      //    data["carrierName"]=spouse.insurer;
      //    data["healthPlan"]=spouse.healthPlan;
      //    data["insurer"]=spouse.insurer;
      //   }

      // }
    }
  }

  async deleteDependentDetails_2() {

    let data = this.deletespouseform.value;
    let spouseData = this.childrenInfo;

    // if(this.spouseForm['effectiveDate'].invalid || this.spouseForm['martialStatus'].invalid) {
    //   this.spouseform.markAllAsTouched();
    //   return;
    // }

    //this._LoggerService.log(spouseData)
    console.log(this.deletespouseform)
    //this._LoggerService.log(data)
    if (this.deletespouseform.invalid) {
      this.deletespouseform.markAllAsTouched();
      return;
    }
    else {
      // const endPoint = '/'+this.customerid+'/lifeChange/spouse/add/true';

      let spouseData = this.childrenInfo;
      let spouseData_: any = {}


      const notes = await this.handlePrepareNotes();
      let data = this.deletespouseform.value;
      //this._LoggerService.log(data)

      let approvalStatus: any;

      for (let spouse of spouseData) {
        //this._LoggerService.log(spouse)
        if (spouse["relationType"] == "spouse") {
          spouseData_["firstName"] = spouse.firstName;
          spouseData_["lastName"] = spouse.lastName;
          spouseData_["dob"] = spouse.dob;
          spouseData_["gender"] = spouse.gender;
          spouseData_["email"] = spouse.email || "";
          spouseData_["coverage"] = spouse.healthPlan;
          spouseData_["carrierName"] = spouse.insurer;
          spouseData_["healthPlan"] = spouse.healthPlan;
          spouseData_["insurer"] = spouse.insurer;
          spouseData_["id"] = spouse.id

          approvalStatus = "proceed"

        }

      }




      let finalData: any = {
        "spouse": {},
        "dependent": [],
        "notes": notes,
        "approvalStatus": approvalStatus,
        "isPlanChanges": this.unSelectedPlans_.length > 0 ? true : false,
        "effectiveDate": this.dependentForm['effectiveDate'].value,
        "changedCoveragePlans": this.unSelectedPlans_,
        "removalDependents": [],
      }

      // this.spouseData["dob"]= this.datePipe.transform(new Date(this.spouseform.value.dob).toLocaleString(),'MM-dd-yyyy')

      const endPoint = `/${this.customerid}/lifeChanges/dependent/remove/false`;

      // data["dob"]= this.datePipe.transform(new Date(this.spouseform.value.dob).toLocaleString(),'MM-dd-yyyy')
      this.http.post(api.url + endPoint, finalData, {
        headers: {
          Authorization: 'Bearer ' + this.accessToken,
          'Content-Type': 'application/json',
        }
      }).subscribe((response: any) => {
        if (response.status == 200) {
          this.closeSpousemodal.nativeElement.click();
          Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message });
        }
        else {
          Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })
        }
      }, (error) => {
        //this._LoggerService.log(error)
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
      });



      // //this._LoggerService.log(this.spouseForm['dob'].value)


      // for(let spouse of spouseData){
      //   //this._LoggerService.log(spouse)
      //   if(spouse["relationType"]=="spouse"){
      //    data["firstName"]=spouse.firstName;
      //    data["lastName"]=spouse.lastName;
      //    data["dob"]=spouse.dob;
      //    data["gender"]=spouse.gender;
      //    data["email"]=spouse.email;
      //    data["coverage"]=spouse.healthPlan;
      //    data["carrierName"]=spouse.insurer;
      //    data["healthPlan"]=spouse.healthPlan;
      //    data["insurer"]=spouse.insurer;
      //   }

      // }
    }
  }

  openCoverage(value: any) {
    this.coverage = value;
    if (this.coverage === 'open') {
      this.spouseCoverage = true;
      this.spouseForm['insurer'].setValidators([Validators.required]);
      this.spouseForm['insurer'].updateValueAndValidity();
      this.spouseForm['healthPlan'].setValidators([Validators.required]);
      this.spouseForm['healthPlan'].updateValueAndValidity();
    }
    else {
      this.spouseForm['insurer'].reset();
      this.spouseForm['healthPlan'].reset();
      this.spouseForm['insurer'].clearValidators();
      this.spouseForm['insurer'].updateValueAndValidity();
      this.spouseForm['healthPlan'].clearValidators();
      this.spouseForm['healthPlan'].updateValueAndValidity();
    }
  }


  handleChangeCurrentCoverage(value: any) {
    this.coveredByAnotherPlan = value;
    this.finalEffectiveDate = null;
  }



  openDependentCoverage(value: any) {

    sessionStorage.removeItem("plansummarymain")
    sessionStorage.removeItem("plansskumain");
    sessionStorage.removeItem("plansummaryopt");
    sessionStorage.removeItem("plansummary");
    sessionStorage.removeItem("selectedPlans");
    sessionStorage.removeItem("totalAmount");
    sessionStorage.removeItem("totalAmountUI");

    if (this.totalCount == 0) {
      this.totalCount = this.totalCount + 1;
    }


    this.showSpouseInfo = true;
    this.showPlanDetails = true;
    this.showAfterPlanDetails = false;
    this.dependentCoverage = value;
    console.log(this.dependentCoverage, 'depovver', this.dependentType)
    console.log('this.normalSpouseRegistration', this.normalSpouseRegistration)
    if (this.dependentCoverage == 'open') {

      this.noReason = ''
      if (this.dependentType == 'spouse') {
        this.childCovered = false;
        this.spouseCovered = true;
        this.handleContinue('')

      }
      if (this.dependentType == 'multiple') {
        //check childForm has true
        console.log(this.spouseform.value, this.dependentform.value)

        this.childCovered = false;
        this.spouseCovered = true;
        console.log('this.dependentCoverage', this.dependentCoverage)
        this.handleContinue('')

      }
      if (this.dependentType == 'child') {
        this.childCovered = true;
        this.handleContinue('')
      }
      if (this.dependentType == 'spouse' || this.dependentType == 'multiple') {
        this.spouseForm['insurer'].setValidators([Validators.required]);
        this.spouseForm['insurer'].updateValueAndValidity();
      }
      else {
        this.dependentForm['carrierName'].setValidators([Validators.required]);
        this.dependentForm['carrierName'].updateValueAndValidity();
      }


    }
    else {
      if (this.normalSpouseRegistration == false) {
        // this.spouseCovered = false;
        // show popup for approval for admin beacuase > 30 days and niot coverede
        let reason;
        if (this.isCommonLaw) {
          reason = 'The date of marriage is more than 365 days and the spouse has not been covered by any other insurance carrier. The request is currently pending approval from our insurance carrier.'
        } else {
          reason = 'The date of marriage is more than 30 days and the spouse has not been covered by any other insurance carrier. The request is currently pending approval from our insurance carrier.'
        }
        this.noReason = reason
        Swal.fire('Info', reason).then(res => {
          if (res.isConfirmed) {
            this.spouseCovered = false;
            this.handleContinue('')
            // this.showPlanDetails = false
            this.dependentForm['carrierName'].reset();
            this.dependentForm['carrierName'].clearValidators();
            this.dependentForm['carrierName'].updateValueAndValidity();
            this.spouseForm['healthPlan'].reset();
            this.spouseForm['healthPlan'].clearValidators();
            this.spouseForm['healthPlan'].updateValueAndValidity();
          }
        })
      } else {
        this.spouseCovered = false;
        this.handleContinue('');
        this.dependentForm['carrierName'].reset();
        this.dependentForm['carrierName'].clearValidators();
        this.dependentForm['carrierName'].updateValueAndValidity();
        this.spouseForm['healthPlan'].reset();
        this.spouseForm['healthPlan'].clearValidators();
        this.spouseForm['healthPlan'].updateValueAndValidity();
      }



    }



    if (value == 'open') {
      Swal.fire({
        title: 'Info',
        text: 'Do you wish to change your coverage if applicable?',
        showCancelButton: true,
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel'
      }).then(res => {
        if (res.isConfirmed) {
          this.isUpgradeOrDowngrade = 'upgrade';
          this.handleUpgradeOrDowngrade('upgrade')
        } else {
          // remains same and make plan changes as false
          this.isUpgradeOrDowngrade = 'downgrade';
          this.handleUpgradeOrDowngrade('downgrade')
        }
      })
    }


    console.log('this.normalSpouseRegistration', this.normalSpouseRegistration)
  }



  handleUpgradeOrDowngrade(value: any) {

    console.log(this.upgradeorDowngradeplans, value)
    // this.handleContinue();
    if (value == 'upgrade') {
      const selectedPlans = this.upgradeorDowngradeplans.map(plan => {
        const selectedOption = document.querySelector(`input[name="plan_${plan.name}"]:checked`) as HTMLInputElement;
        return {
          planName: plan.name,
          addOn: plan.addon,
          action: selectedOption ? selectedOption.value : null,
          isBundle: plan.isBundle
        };
      });

      // Handle the selected plans and actions (Upgrade/Downgrade)
      selectedPlans.forEach((plan) => {
        console.log(plan, "....plan...")
        // we gonna click that element
        let element: any = plan.addOn
        if (plan.isBundle) {
          // if(element.name.includes('Life Insurance' || 'Critical')){

          // }else{

          // }
          $("#plancheck" + element.planId + ".coverage" + element.planCoverage.toUpperCase()).click()
          console.log($("#plancheck" + element.planId + ".coverage" + element.planCoverage.toUpperCase()), "called3322")

        }
        else {
          console.log(element, "elem677")
          if (element?.planCoverage && element?.planCoverage != '-') {
            // $("#plancheck" + element.planSelectionId2 + ".coverage"+element.coverage).click()
            console.log("#plancheck" + element.planlevel.id + ".coverage" + element.planCoverage.toUpperCase())
            $("#plancheck" + element.planlevel.id + ".coverage" + element.planCoverage.toUpperCase()).click()
          }
          else {
            console.log($("#plancheck" + element.planlevel.id))
            $("#plancheck" + element.planlevel.id).click()

          }
        }
        console.log(`Upgrading ${plan.planName}`);

      });
    } if (value == 'downgrade') {
      const selectedPlans = this.upgradeorDowngradeplansSelected.map(plan => {
        const selectedOption = document.querySelector(`input[name="plan_${plan.name}"]:checked`) as HTMLInputElement;
        return {
          planName: plan.name,
          addOn: plan.addon,
          action: selectedOption ? selectedOption.value : null,
          isBundle: plan.isBundle
        };
      });

      // Handle the selected plans and actions (Upgrade/Downgrade)
      selectedPlans.forEach((plan) => {
        console.log(plan, "....plan...")
        // we gonna click that element
        let element: any = plan.addOn
        if (plan.isBundle) {
          // if(element.name.includes('Life Insurance' || 'Critical')){

          // }else{

          // }
          $("#plancheck" + element.planId + ".coverage" + element.planCoverage.toUpperCase()).click()
          console.log($("#plancheck" + element.planId + ".coverage" + element.planCoverage.toUpperCase()), "called3322")

        }
        else {
          console.log(element, "elem677")
          if (element?.planCoverage && element?.planCoverage != '-') {
            // $("#plancheck" + element.planSelectionId2 + ".coverage"+element.coverage).click()
            console.log("#plancheck" + element.planlevel.id + ".coverage" + element.planCoverage.toUpperCase())
            $("#plancheck" + element.planlevel.id + ".coverage" + element.planCoverage.toUpperCase()).click()
          }
          else {
            console.log($("#plancheck" + element.planlevel.id))
            $("#plancheck" + element.planlevel.id).click()

          }
        }
        console.log(`Upgrading ${plan.planName}`);

      });
    }
  }

  openChildCoverage(value: any) {
    console.log(value, "valiiii", this.dependentTypeForm)
    // if(this.dependentTypeForm.invalid){
    //   this.dependentTypeForm.markAllAsTouched()
    //   return;
    // }
    this.showPlanDetails = true
    this.showAfterPlanDetails = false
    this.showSpouseInfo = true
    this.dependentChildCoverage = value;
    if (this.dependentChildCoverage === 'open') {
      this.childCoverage = true;
      this.dependentForm['carrierName'].setValidators([Validators.required]);
      this.dependentForm['carrierName'].updateValueAndValidity();

    }
  }

  updateDependentForm(i: any, msg: any) {
    console.log("iii", i, "data99", this.childrenInfo)
    // i.carrierName = i.insurer;
    // delete i.insurer;
    // let i=this.currentIndexOfSwipperDependents-1;
    let childId = i.id;
    this.dependentUpdate = true;
    this.dependentStatus = true;
    this.childrenId = childId;
    this.dependentform.patchValue(i);
    this.childCoverage = i.coveredByAnotherPlan;
    this.specialNeeds = i.specialNeeds;
    this.postSecondaryStudent = i.postSecondaryStudent;
    // this.dependentForm['martialStatus'].clearValidators();
    // this.dependentForm['martialStatus'].updateValueAndValidity();
    this.dependentForm['effectiveDate'].clearValidators();
    this.dependentForm['effectiveDate'].updateValueAndValidity();
    if (this.childCoverage === false) {
      this.dependentForm['carrierName'].clearValidators();
      this.dependentForm['carrierName'].updateValueAndValidity();
      this.dependentForm['graduationDate'].clearValidators();
      this.dependentForm['graduationDate'].updateValueAndValidity();
    }
    if (this.postSecondaryStudent === false) {
      this.dependentForm['graduationDate'].clearValidators();
      this.dependentForm['graduationDate'].updateValueAndValidity();
    }
  }


  deleteDependentForm(i: any, children: any) {
    // let i=this.currentIndexOfSwipperDependents-1;
    let childId = this.childrenInfo[i].id;
    this.dependentType = "dependent"
    console.log("called", this.dependentType)
    this.dependentUpdate = true;
    this.dependentStatus = true;
    this.childrenId = childId;
    this.currentDeleteMember = "child";
    this.deleteChildrenDetails_1(children)
    // this.deletedependentform.patchValue(this.customerData.dependents.childrens[i]);
    // this.childCoverage = this.customerData.dependents.childrens[i].coveredByAnotherPlan;
    // this.specialNeeds = this.customerData.dependents.childrens[i].specialNeeds;
    // this.postSecondaryStudent = this.customerData.dependents.childrens[i].postSecondaryStudent;
    // // this.dependentForm['martialStatus'].clearValidators();
    // // this.dependentForm['martialStatus'].updateValueAndValidity();
    // this.deletedependentform['effectiveDate'].clearValidators();
    // this.deletedependentform['effectiveDate'].updateValueAndValidity();
    // if(this.childCoverage===false) {
    //   this.deletedependentform['carrierName'].clearValidators();
    //   this.deletedependentform['carrierName'].updateValueAndValidity();
    //   this.deletedependentform['graduationDate'].clearValidators();
    //   this.deletedependentform['graduationDate'].updateValueAndValidity();
    // }
    // if(this.postSecondaryStudent===false) {
    //   this.deletedependentform['graduationDate'].clearValidators();
    //   this.deletedependentform['graduationDate'].updateValueAndValidity();
    // }

  }
  updateDependent() {

    if (this.dependentform.invalid) {
      this.dependentform.markAllAsTouched();
      return;
    }
    else {
      console.log(this.dependentform)
      // let depData = {
      //   "carrierName": this.dependentform.get('postalCode')?.value
      // }

      let depData: any = {
        firstName: this.dependentform.get('firstName')?.value,
        lastName: this.dependentform.get('lastName')?.value,
        gender: this.dependentform.get('gender')?.value,
        dob: this.dependentform.get('dob')?.value,
        age: this.dependentform.get('age')?.value,
        phoneNum: this.dependentform.get('phoneNum')?.value,
        coveredByAnotherPlan: this.dependentform.get('coveredByAnotherPlan')?.value,
        carrierName: this.dependentform.get('carrierName')?.value,
        specialNeeds: this.dependentform.get('specialNeeds')?.value,
        postSecondaryStudent: this.dependentform.get('postSecondaryStudent')?.value,
        effectiveDate: this.dependentform.get('effectiveDate')?.value,
      };



      let depType = depData.relationType == "CHILDREN" ? "dependent" : "spouse"

      if (depType == "dependent") {
        depData['insurer'] = depData.carrierName;
        delete depData['carrierName']
      }
      let childId = this.childrenId;
      let finalData: any = {};
      const endPoint = `/v2/${this.customerid}/lifeChange/${depType}/update/false`
      // const endPoint = '/'+this.customerid+`/lifeChange/${depType}/update/false`;
      // const endPoint = '/'+this.customerid+'/customerRelative/'+childId+'/details';

      console.log('this.normalSpouseRegistration', this.normalSpouseRegistration)
      console.log('this.spouseform.value.coveredByAnotherPlan', this.spouseform.value.coveredByAnotherPlan)
      let approvalStatus = this.normalSpouseRegistration ? "normal" : this.dependentform.get('coveredByAnotherPlan')?.value ? "proceed" : "pending"


      if (depType == "dependent") {
        finalData = {
          "spouse": {},
          "dependent": [depData],
          "notes": {
            "planChange": "classic bronze(single)-classic bronze(couple)",
            "coverageChange": "single-couple",
            "coverageScenario": "STC",
            "priceChange": "153.12-306.26",
            "service": [
              "greenshield"
            ],
            "dependent": "spouse",
            "approvalStatus": approvalStatus
          },
          "approvalStatus": approvalStatus,
          "coverageScenario": this.coverageChange ?? "STC",
          // "isPlanChanges": this.newlySelectedPlans.length > 0 ? true : false,
          "isPlanChanges": true,
          "effectiveDate": this.dependentform.get('effectiveDate')?.value,
          "changedCoveragePlans": [],
          "removalDependents": [],
          "plans": [],
          "reason": this.noReason ?? ""
        }
      }
      if (depType == "spouse") {

        finalData = {
          "spouse": depData,
          "dependent": [],
          "notes": {
            "planChange": "classic bronze(single)-classic bronze(couple)",
            "coverageChange": "single-couple",
            "coverageScenario": "STC",
            "priceChange": "153.12-306.26",
            "service": [
              "greenshield"
            ],
            "dependent": "spouse",
            "approvalStatus": approvalStatus
          },
          "approvalStatus": approvalStatus,
          "coverageScenario": this.coverageChange ?? "STC",
          // "isPlanChanges": this.newlySelectedPlans.length > 0 ? true : false,
          "isPlanChanges": true,
          "effectiveDate": this.dependentform.get('effectiveDate')?.value,
          "changedCoveragePlans": [],
          "removalDependents": [],
          "plans": [],
          "reason": this.noReason ?? ""
        }
      }



      let accessToken = sessionStorage.getItem('accessToken');
      this.http.post(api.url + endPoint, finalData, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        }
      }).subscribe((response: any) => {
        if (response.status == 200) {
          this.closeDependentmodal.nativeElement.click();
          Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message });
        }
        else {
          Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })
        }
      }, (error) => {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
      });
    }
  }


  async updateCobInfo() {
    if(this.addToPolicy == '') {
      this.showAddToPolicyError = true
    }
    console.log(this.cobform)
    if (this.cobform.invalid) {
      this.cobform.markAllAsTouched()
      return;
    }


    this.showAddToPolicyError = false;
    // direct submit if there is no policy change
    if(!this.isNeedToUpdate) {
      await this.updateCobData()
    }else{
      document.getElementById('addDependent')?.classList.add('d-none');
      
      // Show the second modal by removing d-none
      document.getElementById('showPlanSummaryBrief')?.classList.remove('d-none');
      document.getElementById('showPlanSummaryBrief')?.classList.add('d-block');
      document.getElementById('showPlanSummaryBrief')?.classList.add('show');
    }

  }

  async updateCobData() {
    let endPoint = `/customer/update-customer-details/${this.customerid}/cob`


    let existingSpouse = this.availableFirstNames.find(item => item.relationType == 'spouse');
   
    let validationInputData:any = {
    maritalStatus: "",
    dependentId: existingSpouse.id,
    coverage: this.cobform.get('cobCoverage')?.value,
    insurer: this.cobform.get('insurer')?.value,
    deleteDependent: this.isDependentSelected
    }
    // commented
    // return;  
    this.http.post(api.url + endPoint, validationInputData, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      if(response.status == 200){
        Swal.fire({title: "Info", text: "Cob information for spouse updated successfully."}).then(res => {
          if(res.isConfirmed){
            window.location.reload()
          }
        })
      }else {
          Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })
        }
    })
  }


  async handlemaritalstatustype(e:any) {
  console.log(e)
  this.showSpouseDropDownForDelete = false;
  console.log(e.target.value)
  if(e.target.value == "DIVORCED" || e.target.value == "SEPERATED"){
    this.showSpouseDropDownForDelete = true;
  }
  }


  async updateMaritalStatus() {
    if(this.maritalStatusform.invalid){
      this.maritalStatusform.markAllAsTouched()
      return;
    }

    let endPoint = `/customer/update-customer-details/${this.customerid}/maritalStatus`


    let existingSpouse = this.availableFirstNames.find(item => item.relationType == 'spouse');
   
    let validationInputData:any = {
    maritalStatus: this.maritalStatusform.get('maritalStatus')?.value == "other" ?  this.maritalStatusform.get('reason')?.value : this.maritalStatusform.get('maritalStatus')?.value,
    dependentId: existingSpouse.id,
    coverage: "",
    insurer: "",
    deleteDependent: this.isDependentSelected
    }
    // commented
    // return;
    this.http.post(api.url + endPoint, validationInputData, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      if(response.status == 200){
        Swal.fire({title: "Info", text: "Marital Status updated successfully."}).then(res => {
          if(res.isConfirmed){
            window.location.reload()
          }
        })
      }else {
          Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })
        }
    })
  }


  handleDependentPlanChange(value: any) {
    this.isDependentPlanChange = value.currentTarget.checked;
  }

  openGraduationDate(value: any) {
    this.graduationDate = value.currentTarget.checked;
    //this.consoleMessage("enrolledUnv: " + event.target.checked)

    this.postSecondaryStudent = value.currentTarget.checked;
    if (this.postSecondaryStudent) {
      this.dependentForm['graduationDate']?.setValidators(Validators.compose([Validators.required, this.validateDateforGraduation]));
      this.dependentForm['graduationDate'].updateValueAndValidity();
    }
    else {
      this.dependentForm['graduationDate'].reset();
      this.dependentForm['graduationDate'].clearValidators();
      this.dependentForm['graduationDate'].updateValueAndValidity();
    }
  }


  closeDependentForm() {
    this.spouseform.reset();
     this.isExcludeSpouse = false;
    this.isExcludeAll = false;
    this.isExcludeChild = false;
    this.isExcludeChildAndSpouse = false;
    this.functionClearSettings()
    this.dependentTypeForm.reset();
    this.dependentType = ""
    this.dependentform.reset();
    this.finalEffectiveDate = null;
    this.clearAllMessages()
    this.graduationDate = true;
    this.dependentUpdate = false;
    this.showCorpPlansTable = false;
    this.dependentCoverage = 'close';


    this.cobform.reset();
    sessionStorage.removeItem("plansummarymain")
    sessionStorage.removeItem("plansskumain");
    sessionStorage.removeItem("plansummaryopt");
    sessionStorage.removeItem("plansummary");
    sessionStorage.removeItem("selectedPlans");
    sessionStorage.removeItem("totalAmount");
    sessionStorage.removeItem("totalAmountUI");

     this.needToUpdate = ''
    this.cobevent = ''
    this.cobeventType = ''
    this.dependentType = ''
    this.maritalStatus = ''
    this.needToUpdate = false;
    this.firstConfirmMessage = ''
    this.secondConfirmMessage = ''
    this.corpMessage = ''
    this.firstMessage = ''
    this.thirdConfirmMessage = ''
    this.underWritingMessage1 = ''
    this.underWritingMessage2 = ''
    this.secondMessage = ''
    this.deleteForm.reset()
    this.spouseform.reset()
    this.childrenDetails = []
    this.childrenDetailsForNormalReg = []
    this.addToPolicy = ''
    this.dependentform.reset()
    this.cobform.reset()

    // this.childCoverage = '';
  }

  showAddDependentForm() {
    console.log("called")
    this.showCorpPlansTable = false;
    this.showDependentForm = true;
  }

  closeAddDependentForm() {
    this.showDependentForm = false;
    this.editChildUpdate = false;
  }


  closeSpouseForm() {
    console.log("called")
    this.spouseCoverage = '';
    this.coverage = 'open'
    this.dependentUpdate = false;
    this.dependentTypeForm1.reset()
    this.specialpackages = []
  }

  selectTab(tabName: string): void {
    this.selectedTab = tabName;
  }

  tabData() {
    this.selectedTab = 'tab1';
  }

  hicDetails() {
    this.hicList = this.customerData.healthCards_v2.cards;
  }

  viewHealthCard(link: any) {
    this.src = link.link;
    this.healthCard = true;
    if (this.src == '') {
      this.card = true;
    }
  }

  closeHealthCard() {
    this.healthCard = false;
    this.displayStyle = "none";
    this.card = false;
  }

  closeDownloadBooklet() {
    this.hidebooklet = false;
  }

  download() {
    // Swal.fire({allowOutsideClick: false,
    //   icon: this.lang?.Info,
    //   title: 'Are you sure you want to download helathcard?',
    //   showCancelButton: true,
    //   confirmButtonColor: '#3085d6',
    //   cancelButtonColor: '#d33',
    //   confirmButtonText: 'Yes',
    //   cancelButtonText: 'No',
    // })
  }

  downloadAllHic() {
    Swal.fire({
      allowOutsideClick: false,
      title: 'Alert',
      text: 'Download all healthcards?',
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: 'Download',
    }).then((result) => {
      if (result.isConfirmed) {
        this.hicList = this.customerData.healthCards_v2.cards;
        if (this.hicList.length > 0) {
          for (let i = 0; i < this.hicList.length; i++) {
            this.http.get(this.hicList[i].link, { responseType: "arraybuffer" }).subscribe(
              pdf => {
                const blob = new Blob([pdf], { type: "application/pdf" });
                const fileName = this.hicList[i].name + ".pdf";
                saveAs(blob, fileName);
              },
              (error) => {
                Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
              }
            );
          }
        }
        else {
          Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: this.lang?.No_Health_Cards_Found })
        }
      }
      else {
        // document.getElementById("viewHicDetails").click();
        // $("#hicDetails").modal('show');

        // this.hicList = this.customerData.healthCards;
        // this.displayStyle = "block";
        // this.viewHicDetails();
        // this.display='block';
        // this.content.open();
        // this.content.nativeElement.style.display = 'block';
      }
    });
  }

  downloadHic(value: any) {
    this.http.get(value.link, { responseType: "arraybuffer" }).subscribe(
      pdf => {
        const blob = new Blob([pdf], { type: "application/pdf" });
        const fileName = value.name + ".pdf";
        saveAs(blob, fileName);
      },
      (error) => {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
      }
    );
  }

  checkAllCheckBox(value: any) {
    this.hicList.forEach(hic => hic.checked = value.target.checked)
  }

  isAllCheckBoxChecked() {
    return this.hicList.every(hic => hic.checked);
  }

  checkAllBooklets(value: any) {
    this.bookletList.forEach(booklet => booklet.checked = value.target.checked)
  }

  isAllBookletsChecked() {
    return this.bookletList.every(booklet => booklet.checked);
  }

  // disabledDownload() {
  //   this.bookletList = this.bookletList.filter((selected:any)=>selected.checked).map((selected: any)=>selected);
  //   if(this.bookletList.length>0) {
  //     return false;
  //   }
  //   else {
  //     return true;
  //   }
  // }

  downloadSelected() {
    this.bookletList1 = this.bookletList.filter((selected: any) => selected.checked).map((selected: any) => selected);
    if (this.bookletList1.length > 0) {
      for (let i = 0; i < this.bookletList1.length; i++) {
        this.http.get(this.bookletList1[i].link, { responseType: "arraybuffer" }).subscribe(
          pdf => {
            const blob = new Blob([pdf], { type: "application/pdf" });
            const fileName = this.bookletList1[i].name + ".pdf";
            saveAs(blob, fileName);
          },
          (error) => {
            Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
          }
        );
      }
    }
    else {
      Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: this.lang?.No_booklets_Selected })
    }
  }

  downloadAllHpBooklets() {
    Swal.fire({
      allowOutsideClick: false,
      title: 'Alert',
      text: 'Download all booklets?',
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: 'Download',
      cancelButtonText: 'Cancel',
    }).then((result) => {
      if (result.isConfirmed) {
        if (this.bookletList.length > 0) {
          for (let i = 0; i < this.bookletList.length; i++) {
            this.http.get(this.bookletList[i].link, { responseType: "arraybuffer" }).subscribe(
              pdf => {
                const blob = new Blob([pdf], { type: "application/pdf" });
                const fileName = this.bookletList[i].name + ".pdf";
                saveAs(blob, fileName);
              },
              (error) => {
                Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
              }
            );
          }
        }
        else {
          Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: this.lang?.No_Booklets_Found })
        }
        this.hicList = this.customerData.healthCards_v2.cards;
        if (this.hicList.length > 0) {
          for (let i = 0; i < this.hicList.length; i++) {
            this.http.get(this.hicList[i].link, { responseType: "arraybuffer" }).subscribe(
              pdf => {
                const blob = new Blob([pdf], { type: "application/pdf" });
                const fileName = this.hicList[i].name + ".pdf";
                saveAs(blob, fileName);
              },
              (error) => {
                Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
              }
            );
          }
        }
        else {
          Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: this.lang?.No_Health_Cards_Found })
        }
        // this.downloadRoe();
      }
      else {

        // this.displayBooklet = "block";
      }
    });
  }

  downloadHpbooklet(value: any) {
    this.http.get(value.link, { responseType: "arraybuffer" }).subscribe(
      pdf => {
        const blob = new Blob([pdf], { type: "application/pdf" });
        const fileName = value.name + ".pdf";
        saveAs(blob, fileName);
      },
      (error) => {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
      }
    );
  }


  getRoe(roe: any) {
    setTimeout(() => {
      if (roe.link != "") {
        if (!hasWhiteSpace(roe.link)) {
          this.roe = roe.link;

          //this._LoggerService.log(this.roe)
          this.viewRoe = true;
        }
        else {
          this.viewRoe = false;
        }
      }
      // else {
      //   let customerDataEndpoint = '/'+this.customerid+'/ROE';
      //   this.http.get(api.url+customerDataEndpoint, {
      //     headers:{
      //       Authorization: 'Bearer ' + this.accessToken,
      //       'Content-Type': 'application/json',
      //   }}).subscribe((response:any)=>{
      //     if(response.status==200) {
      //       this.roe = response?.data.roe;
      //     }
      //     else {
      //       Swal.fire({allowOutsideClick: false,title: this.lang?.Info, text:response.message})
      //     }
      //   },(error) => {
      //     Swal.fire({allowOutsideClick: false,title: this.lang?.Info, text: error.error.error.message})
      //   });
      // }
    }, 1000);
  }

  closeRoe() {
    this.viewRoe = true;
  }

  downloadRoe(roe: any) {
    this.getRoe(roe);
    this.http.get(this.roe, { responseType: "arraybuffer" }).subscribe(
      pdf => {
        const blob = new Blob([pdf], { type: "application/pdf" });
        const fileName = this.roe + ".pdf";
        saveAs(blob, fileName);
      },
      (error) => {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
      });
    this.openRoe.nativeElement.click();
  }

  openPaymentDetails(value: any) {
    this.openUpdatePaymentForm = value;
    if (value == 'close') {
      Object.keys(this.paymentMethodControls).forEach(controlName => {
        if (controlName !== 'paymentmethod') {
          const control = this.paymentMethodControls[controlName];
          control.reset();
        }
      });
      this.bankDetails = false;
      this.resetButton = false;
      this.uploadCheque = false;
      setTimeout(() => {
        this.closePaymenttoPAD.nativeElement.click();
      }, 1000);
    }
  }

  public provincelist(event: any) {
    this.configprovinceres.forEach((element: any) => {
      if (element.shortName == event.target.value) {
        this.provincialZipcodes = element.zipcodes.split(',');
        this.provincelistid = element.id;
        this.state_id = parseInt(element.fusebillId);
        this.statename = element.name;
      }
    });
    if (this.addressform.value.postalCode) {
      if (
        this.provincialZipcodes.indexOf(
          this.addressform.value.postalCode[0]
        ) == -1
      ) {
        this.invalidpostalcodeprivince = true;
        this.addressForm['postalCode'].markAsTouched();
        // this.addressForm['postalCode'].updateValueAndValidity();
      } else {
        this.invalidpostalcodeprivince = false;
      }
      if (this.addressform.value.postalCode.length == 0) {
        this.invalidpostalcodeprivince = false;
      }
    }
  }

  changeTextToUppercase(event: any) {
    const inputValue = this.addressform.get('postalCode')?.value;
    this.addressform.get('postalCode')?.setValue(inputValue.toUpperCase(), { emitEvent: false });
    this.postalvalue = event.target.value;
    if (this.provincialZipcodes.indexOf(this.postalvalue[0]) == -1) {
      this.invalidpostalcodeprivince = true;
      this.addressForm['postalCode'].markAsTouched();
    } else {
      this.invalidpostalcodeprivince = false;
    }
    if (this.postalvalue.length == 0) {
      this.invalidpostalcodeprivince = false;
    }
  }

  upperCase(event: any) {
    //this._LoggerService.log(event?.data)
    const inputValue = event?.data;
    //this._LoggerService.log(this.paymentform.get('postalcode')?.value)
    if (inputValue != null) {
      this.paymentform.get('postalcode')?.setValue(inputValue.toUpperCase(), { emitEvent: false });
    }
  }

  phoneFormat(event: any) {
    // alert(event.target.id)
    this.secondaryphonecheck = false
    if (event.target.id == 'primaryPhone') {
      const inputValue = this.addressform.get('primaryPhone')?.value;
      this.addressform.get('primaryPhone')?.setValue(this.phoneNoFormat.transform(inputValue), { emitEvent: false });
    }
    else if (event.target.id == 'secondaryPhone') {
      const inputValue = this.addressform.get('secondaryPhone')?.value;
      this.addressform.get('secondaryPhone')?.setValue(this.phoneNoFormat.transform(inputValue), { emitEvent: false });
    }

  }

  getBankInfo() {
    if (this.paymentMethodForm.invalid) {
      this.paymentMethodForm.markAllAsTouched();
      return
    }
    else {
      let data = this.paymentMethodForm.value;
      let accessToken = sessionStorage.getItem('accessToken');
      // const bankInfoUrl = 'https://testcustomersapi.groupbenefitz.aitestpro.com/api/ep/bank/verify';
      // this.http.post(bankInfoUrl, data,{
      const Endpoint = '/bank/verify';
      this.http.post(api.url + Endpoint, data, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        }
      }).subscribe((response: any) => {
        if (response.status == 200) {
          this.bankDetails = true;
          Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: this.lang?.Bank_Details_verified_successfully })

        }
        else {
          Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })
        }
        this.bankInfo = response?.data;
        this.address = this.bankInfo.address;
        this.bankAddress = this.bankInfo.address.split(', ');
        this.resetButton = true;
        this.uploadCheque = true;
      }, (error) => {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
      });
    }
  }

  openpad() {
    this.openUpdatePaymentForm = 'close';
  }

  closeChangeToPad() {
    this.paymentMethodForm.reset();
    this.paymentMethodForm.get('paymentmethod')?.setValue('');
    this.resetButton = false;
    this.uploadCheque = false;
    this.bankDetails = false;
    this.previewbutton = false;
    this.paymentMethodForm.get('files')?.setValue('');
  }

  closepadinfo() {
    this.bankinfo = true;
    this.resetbutton = true;
    this.cheque = false;
    this.paymentMethodForm.reset();
    this.paymentMethodForm.get('paymentmethod')?.setValue('');
    this.resetButton = false;
    this.uploadCheque = false;
    this.bankDetails = false;
    this.updatepreviewbutton = false;
    this.existVoid = true;
    this.padform.get('file')?.setValue('');
    this.paymentMethodForm.get('files')?.setValue('');
    this.voidCheckFileType = this.PADdetails.voidCheckFileType;
  }

  updateBankInfo() {
    if (this.padform.invalid) {
      this.padform.markAllAsTouched();
      return
    }
    else {
      let data = this.padform.value;
      data['branchCode'] = this.padform.value.transitNumber
      data['accountNumber'] = this.padform.value.accountNo
      data['bankCode'] = this.padform.value.bankcode
      let accessToken = sessionStorage.getItem('accessToken');
      // const bankInfoUrl = 'https://testcustomersapi.groupbenefitz.aitestpro.com/api/ep/bank/verify';

      const Endpoint = '/bank/verify';
      this.http.post(api.url + Endpoint, data, {
        // this.http.post(bankInfoUrl, data,{
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        }
      }).subscribe((response: any) => {
        if (response.status == 200) {
          this.banknameres = response?.data.bank.name + "\n" + response?.data.address.split(",").join("\n");
          // this.banknameres = response?.data.bank.name
          this.bankinfo = true;
        }
        else {
          Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })
        }
        this.bank = response?.data;
        this.address = this.bank.address;
        this.bankAddress = this.bank.address.split(', ');
        this.resetbutton = true;
        this.cheque = true;
      }, (error) => {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
      });
    }
  }

  updateBankDetails(event) {
    this.banknameres = event.target.value;
  }

  valisignModal() {
    this.showTimer = true;
    this.timer(1);
    const endPoint = '/' + this.customerid + '/address/initialize';
    this.http.get(api.url + endPoint, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      // if(response.status==200) {
      //     Swal.fire({allowOutsideClick: false, title: this.lang?.Info, text: response.message });
      //   }
      // else {
      //   Swal.fire({allowOutsideClick: false,title: this.lang?.Info, text:response.message})
      // }
    }, (error) => {
      Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
    });
  }

  closeValisign() {
    clearInterval(this.startTimer);
  }

  timer(minute: any) {
    let seconds: number = minute * 60;
    let textSec: any = "0";
    let statSec: number = 60;
    const prefix = minute < 10 ? "0" : "";
    this.startTimer = setInterval(() => {
      seconds--;
      if (statSec != 0) {
        statSec--;
      }
      else {
        statSec = 59;
      }
      if (statSec < 10) {
        textSec = "0" + statSec;
      }
      else {
        textSec = statSec;
      }
      this.displayTimer = `${prefix}${Math.floor(seconds / 60)}:${textSec}`;
      if (seconds == 0) {
        clearInterval(this.startTimer);
        this.showTimer = false;
      }
    }, 1000);
  }

  viewinvoices(value: any) {
    //this._LoggerService.log('bookletlink', value)
    setTimeout(() => {
      this.invoiceslink = value;
    }, 1000);
    // this.hidebooklet = true;
  }
  closeInvoice() {
    // this.hidebooklet = false;
    // this.displayBooklet = "none";
  }
  getCustomerDraftData() {
    let customerDataEndpoint = '/' + this.customerid + '/invoices';
    this.http.post(api.url + customerDataEndpoint, {}, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      if (response.status == 200) {
        this.getCustomerDraftDetails = response?.data?.invoice
      }
      else {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: response.message })
      }
    }, (error) => {
      Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: error.error.error.message })
    });
  }


  downloadinvoices(value: any) {
    this.http.get(value.file, { responseType: "arraybuffer" }).subscribe(
      pdf => {
        const blob = new Blob([pdf], { type: "application/pdf" });
        const fileName = "Invoice" + ".pdf";
        saveAs(blob, fileName);
      },
      (error) => {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: error.error.error.message })
      }
    );
  }
  getInvoices() {
    // let Endpoint = '/'+this.customerid+'/invoices';
    let Endpoint = '/' + this.fusebillId + '/invoices/list';
    this.http.get(api.url + Endpoint, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      if (response.status == 200) {
        // this.invoiceResponse = response?.data?.invoices;
        // this.upcomingInvoice = response?.data?.upcomingInvoice;
        // this.customerInvoices = response?.invoicesData

        this.customerInvoices = response?.data
        this.customerFinalInvoices = response?.data.filter(invoice => invoice.status.toLowerCase() != 'draft')
        this.customerFinalInvoicesIGBMS = response?.data.filter(invoice => invoice.status.toLowerCase() != 'draft')

        this.customerFinalInvoices.reverse()
        this.customerFinalInvoicesIGBMS.reverse()

        this.allCustomerFinalInvoices = this.customerFinalInvoices
        this.allCustomerFinalInvoicesIGBMS = this.customerFinalInvoicesIGBMS
        const draftInvoiceData = response?.data.filter(invoice => invoice.status.toLowerCase() == 'draft')[0]
        this.getCustomerDraftDate = draftInvoiceData?.month
        this.getCustomerDraftDate1 = draftInvoiceData?.month
        this.invoicedraftData = draftInvoiceData?.invoice

        setTimeout(() => {
          // this.getCustomerInvoices()
        }, 1000);

      }
      else {
        // Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })
      }
    }, (error) => {
      Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
    });
  }
  getCustomerInvoices() {
    let customerDataEndpoint = '/' + this.customerid + '/get-invoices';

    this.http.get(api.url + customerDataEndpoint, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      if (response.status == 200) {

        let invoices = response?.data

        // const filteredInvoices = invoiceFilter(this.customerInvoices)
        // this.customerFinalInvoices = [...invoiceFilter(this.customerInvoices,invoices)]
        this.customerFinalInvoices = invoiceFilter(this.customerInvoices, invoices)
        this.customerFinalInvoicesIGBMS = this.customerFinalInvoices.filter((inv: any) => inv.status != 'DRAFT')
        this.customerFinalInvoices = this.customerFinalInvoices.filter((inv: any) => inv.status.toLowerCase() == 'draft')

        this.allCustomerFinalInvoices = this.customerFinalInvoices
        this.allCustomerFinalInvoicesIGBMS = this.customerFinalInvoicesIGBMS

        console.log('customerFinalInvoices', this.customerFinalInvoices)
        console.log('customerFinalInvoicesIGBMS', this.customerFinalInvoicesIGBMS)
      }
      else {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: response.message })
      }
    }, (error) => {
      Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: error.error.error.message })
    });
  }
  getDraftInvoice() {
    let Endpoint = '/v4/' + this.customerid + '/invoices';
    this.http.post(api.url + Endpoint, {}, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      if (response.status == 200) {
        this.invoicedraftData = response?.data?.invoice;
        this.getCustomerDraftDate = response?.date;
        this.getCustomerDraftDate1 = response?.date;
        console.log('getCustomerDraftDate', this.getCustomerDraftDate)
      }
      else {
        if (response?.message)
          Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response?.message })
      }
    }, (error) => {
      if (error.error?.error?.message)
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error?.error?.message })
    });
  }

  getCreditcard() {
    let Endpoint = '/' + this.customerid + '/creditCards';
    this.http.get(api.url + Endpoint, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      if (response.status == 200) {
        sessionStorage.setItem('defaultCreditCard', JSON.stringify([]))
        sessionStorage.setItem('existingCreditCards', JSON.stringify({}))
        if (response?.data[0]) {
          const data = response.data;
          let defaultCard = data?.filter((card) => card.defaultCard == true)?.[0] ?? {}
          let nonDefaultCards = data?.filter((card) => card.defaultCard != true)
          sessionStorage.setItem('defaultCreditCard', JSON.stringify(defaultCard || []))
          sessionStorage.setItem('existingCreditCards', JSON.stringify(nonDefaultCards || {}))
          this.ccDetails = response?.data[0];
          this.publicapikey = response?.data[0].publicKey;
          // this.paymentMethodId = response?.data[0].paymentMethodId;
          this.creditCardNo = response?.data[0].maskedCardNumber;
          this.fullName = this.customerData.firstName + ' ' + this.customerData.lastName;

          // if(response?.data[0].firstName=="Rakesh"){
          //   response?.data[0].firstName =  this.customerData.firstName
          // }else{
          //   response?.data[0].firstName =  response?.data[0].firstName

          // }

          // if(response?.data[0].lastName=="Test"){

          //   response?.data[0].firstName =  this.customerData.firstName
          // }else{
          //   response?.data[0].firstName =  response?.data[0].firstName

          // }

          // this.customerData
          // this.fullName = response?.data[0].firstName + ' ' + response?.data[0].lastName;
          this.expire = response?.data[0].expirationMonth + '/' + response?.data[0].expirationYear;
        }
      }
      else {
        // Swal.fire({allowOutsideClick: false,title: this.lang?.Info, text:response.message})
      }
    }, (error) => {
      Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
    });
  }

  viewBooklet(value: any) {
    //this._LoggerService.log('bookletlink',value)
    setTimeout(() => {
      this.bookletLink = value;
    }, 1000);
    this.hidebooklet = true;
  }

  closeBooklet() {
    this.hidebooklet = false;
    this.displayBooklet = "none";
  }

  // lifeEventChanges() {
  //   Swal.fire({allowOutsideClick: false,title:this.lang?.Info,text:"Work in progress!"});
  // }


  handleCalculateBackdatedPrice() {
    this.backdatedamount = 0
    this.backdatedamountUI = 0
    let backdatedMonths:any = 0
    const currentDate = moment();

    let finalEffectDate = moment(this.finalEffectiveDate).format('YYYY-MM-DD')

    const effectiveDate = moment(finalEffectDate, 'YYYY-MM-DD').format('YYYY-MM-DD');
    const daysDiff = currentDate.diff(effectiveDate,'days');
    if (daysDiff < 0) {
      backdatedMonths = 0
    }

    if (daysDiff < 31) {
      backdatedMonths = 1
    }
    let enrollmentDate = moment(finalEffectDate,'YYYY-MM-DD');
    const monthsAgo = Math.floor(currentDate.diff(enrollmentDate,'months',false));
    if (monthsAgo > 0) {
      backdatedMonths = monthsAgo + 1;
    }


    console.log('Effective date:', finalEffectDate, 'Parsed:', enrollmentDate.format(), 'daysdiff: ', daysDiff);

    console.log(this.currentamount, this.upcomingamount)
    console.log(monthsAgo, "monthsAgo889")
    // now calculate the price
    this.backdatedamount = Math.abs((this.upcomingamount - this.currentamount)* backdatedMonths ).toFixed(2);
    this.backdatedamountUI = this.handleAmountonUI(this.backdatedamount);
    return Math.abs((this.upcomingamount - this.currentamount)* backdatedMonths ).toFixed(2);
  }

  resetPaymentForm() {
    this.paymentMethodControls['bankCode'].reset();
    this.paymentMethodControls['branchCode'].reset();
    this.paymentMethodControls['accountNumber'].reset();
    this.paymentMethodControls['files'].reset();
    this.bankDetails = false;
    this.uploadCheque = false;
    this.resetButton = false;
    // document.getElementById('bankDetails')?.remove();
  }

  resetPadForm() {
    this.bankinfo = false;
    this.cheque = false;
    this.resetbutton = false;
    this.padForm['bankcode'].reset();
    this.padForm['transitNumber'].reset();
    this.padForm['accountNo'].reset();
    this.padForm['file'].reset();
    this.existVoid = false;
    // document.getElementById('bankinfo')?.remove();
  }

  onFileSelect(event: any) {

    // if (event.target.files.length > 0) {
    //   const file = event.target.files[0];
    //   this.paymentMethodForm.get('files')?.setValue(file);
    // }
    this.fileExtension = "." + event.target.files[0].name.split(".").pop();
    this.paymentVoidCheque = event.target.files[0];
    this.selectedBase64 = this.convertFile(this.paymentVoidCheque);
    // if(this.paymentVoidCheque) {
    //   const reader = new FileReader();
    //   reader.readAsBinaryString(this.paymentVoidCheque);
    //   reader.onload = (e) => {
    //     this.selectedBase64 = e.target?.result as string;
    //   };
    // }
    this.fileExtension = "." + event.target.files[0].name.split(".").pop();

    // alert(this.fileExtension)
    if (this.fileExtension == '.pdf') {
      this.voidCheckFileType = 'application/pdf';

    }
    else {
      // alert("!")
      this.voidCheckFileType = 'image/jpeg';
    }

    var allowedMimes = [
      "image/jpeg",
      "image/pjpeg",
      "image/png",
      "application/pdf",
    ];
    let error = false;
    let message = "";
    if (allowedMimes.includes(this.paymentVoidCheque.type)) {
      if (this.paymentVoidCheque.size <= 1024 * (Number(api.fileSize) ?? 5) * 1024) {
        error = false;
      } else {
        error = true;
        // message = this.lang?.File_size_is_too_large_maximum_file_size_is_600kb;
        message = 'File size is too large, maximum file size is 5MB';
      }
    } else {
      error = true;
      message = this.lang?.Invalid_file_type_Only_jpg_png_image_pdf_files_are_allowed;
    }
    if (error) {
      Swal.fire({
        allowOutsideClick: false,
        title: this.lang?.Error,
        html: message,
        width: "50%",
        showCancelButton: false,
        confirmButtonText: "Ok",
      }).then((result) => {
        if (result.value) {
          this.paymentMethodForm.get('files')?.reset();
        } else {
        }
      });
    }
    else {
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = (_event) => {
        this.imagedisplay = reader.result;
        this.previewbutton = true;
      };
    }
  }

  fileSelect(event: any) {
    // this.imagedisplay =""
    // alert("11")
    // if (event.target.files.length > 0) {
    //   const file = event.target.files[0];
    //   this.paymentMethodForm.get('files')?.setValue(file);
    // }
    this.fileExtension = "." + event.target.files[0].name.split(".").pop();

    // alert(this.fileExtension)
    if (this.fileExtension == '.pdf') {
      this.voidCheckFileType = 'application/pdf';
    }
    else {
      // alert("!")
      this.voidCheckFileType = 'image/jpeg';
    }
    this.paymentVoidCheque = event.target.files[0];
    this.selectedBase64 = this.convertFile(this.paymentVoidCheque);
    // if(this.paymentVoidCheque) {
    //   const reader = new FileReader();
    //   reader.readAsBinaryString(this.paymentVoidCheque);
    //   reader.onload = (e) => {
    //     this.selectedBase64 = e.target?.result as string;
    //   };
    // }

    var allowedMimes = [
      "image/jpeg",
      "image/pjpeg",
      "image/png",
      "application/pdf",
    ];
    let error = false;
    let message = "";
    if (allowedMimes.includes(this.paymentVoidCheque.type)) {
      if (this.paymentVoidCheque.size <= 1024 * (Number(api.fileSize) ?? 5) * 1024) {
        error = false;
      } else {
        error = true;
        // message = this.lang?.File_size_is_too_large_maximum_file_size_is_600kb;
        message = 'File size is too large, maximum file size is 5MB';
      }
    } else {
      error = true;
      message = this.lang?.Invalid_file_type_Only_jpg_png_image_pdf_files_are_allowed;
    }
    if (error) {
      Swal.fire({
        allowOutsideClick: false,
        title: this.lang?.Error,
        html: message,
        width: "30%",
        showCancelButton: false,
        confirmButtonText: "Ok",
      }).then((result) => {
        if (result.value) {
          this.paymentMethodForm.get('files')?.reset();
        } else {
        }
      });
    }
    else {
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = (_event) => {

        this.imagedisplay = reader.result;
        this.updatepreviewbutton = true;
        if (this.padform.get('file')?.value != '') {
          this.review = false;
        }
      };
    }
  }

  convertFile(file: File): Observable<string> {
    const result = new ReplaySubject<string>(1);
    const reader = new FileReader();
    reader.readAsBinaryString(file);
    reader.onload = (event) => {
      if (event.target?.result) {
        result.next(btoa(event.target.result.toString()));
      }
    }
    return result;
  }

  // DataURIToBlob(dataURI: string) {
  //   const byteCharacters = atob(dataURI);
  //   const byteArrays = [];
  //   for (let offset = 0; offset < byteCharacters.length; offset += 512) {
  //     const slice = byteCharacters.slice(offset, offset + 512);
  //     const byteNumbers = new Array(slice.length);
  //     for (let i = 0; i < slice.length; i++) {
  //       byteNumbers[i] = slice.charCodeAt(i);
  //     }
  //     const byteArray = new Uint8Array(byteNumbers);
  //     byteArrays.push(byteArray);
  //   }
  //   return new Blob(byteArrays, { type: 'application/octet-stream' });
  // }

  generateCorporatePAD() {

    let inputData1 = {
      bankCode: this.paymentMethodForm.get("bankCode")?.value,
      branchCode: this.paymentMethodForm.get("branchCode")?.value,
      accountNumber: this.paymentMethodForm.get("accountNumber")?.value,
    };
    let bankAddress = this.address;
    let bankAdressArr = bankAddress.split(",")
    let provincePostal = bankAdressArr[bankAdressArr.length - 1];
    let provincePostalArr = provincePostal.split(" ");
    let bankobject = {
      name: this.bankInfo.bank.name,
      address: this.bankInfo.bank.address.split(",")[0],
      city: bankAdressArr[bankAdressArr.length - 2].replace(" ", ''),
      province: provincePostalArr[provincePostalArr.length - 3],
      postalCode: provincePostalArr[provincePostalArr.length - 2] + " " + provincePostalArr[provincePostalArr.length - 1],
    }
    //  var fileExtension = '.' +this.bankfile.name.split('.').pop();
    // event.target.files[0].name ="void_cheque_"+Date.now()+fileExtension
    var fileExtension = "." + this.paymentVoidCheque.name.split(".").pop();
    this.encBank = btoa(JSON.stringify(inputData1));
    var formData: any = new FormData();
    formData.append("bank", JSON.stringify(bankobject));
    // formData.append("files", this.paymentVoidCheque, this.paymentVoidCheque.name);
    formData.append(

      "files",

      this.paymentVoidCheque,

      "void_cheque_" + Date.now() + fileExtension.toLowerCase()

    );
    // formData.append("files", this.paymentVoidCheque,"void_cheque_"+Date.now()+this.fileExtension.toLowerCase());
    // if(this.selectedBase64) {
    //   let file = this?.dataURIToBlob(this.selectedBase64);
    //   let file = this.selectedBase64._buffer[0];
    // formData.append("files", file, this.paymentVoidCheque.name);
    // }
    // formData.append("files", this.bankfile.name,"void.pdf");
    formData.append("session", this.encBank) || "";
    formData.append("timestamp", new Date().getTime());
    let Endpoint = '/' + this.customerid + '/generatePAD';
    // let data = this.paymentMethodForm.value.files;
    this.http.post(api.url + Endpoint, formData, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
      }
    }).subscribe((response: any) => {
      if (response.status == 200) {
        this.pad = response?.data.url;
        this.filename = response?.data.filename;
        this.padfilename = response?.data.padfilename;
        this.ext = response?.data.ext;
        this.mimetype = response?.data.mimetype;
      }
      else {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })
      }
    }, (error) => {
      Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
    });
  }

  updateCorporatePAD() {

    let inputData1 = {
      bankCode: this.padform.get("bankcode")?.value,
      branchCode: this.padform.get("transitNumber")?.value,
      accountNumber: this.padform.get("accountNo")?.value,
      amount: this.PADdetails.nextBillingPrice,
      customerId: this.customerid
    };


    //this._LoggerService.log(inputData1)
    let bankAddress;
    if (this.address == null) {
      bankAddress = this.bankinformation;
    }
    else {
      bankAddress = this.address;
    }
    let bankAdressArr = bankAddress.split(",")
    let provincePostal = bankAdressArr[bankAdressArr.length - 1];
    let provincePostalArr = provincePostal.split(" ");
    let bankobject = {
      name: this.bank.bank.name,
      address: this.bank.bank.address.split(",")[0],
      city: bankAdressArr[bankAdressArr.length - 2].replace(" ", ''),
      province: provincePostalArr[provincePostalArr.length - 3],
      postalCode: provincePostalArr[provincePostalArr.length - 2] + " " + provincePostalArr[provincePostalArr.length - 1],
    }
    //  var fileExtension = '.' +this.bankfile.name.split('.').pop();
    // event.target.files[0].name ="void_cheque_"+Date.now()+fileExtension
    if (!this.paymentVoidCheque) {
      this.paymentVoidCheque = this.voidCheckPdf;
      //this._LoggerService.log(this.paymentVoidCheque)
    }
    //this._LoggerService.log(this.paymentVoidCheque)
    var fileExtension = "." + this.paymentVoidCheque.name.split(".").pop();
    this.encBank = btoa(JSON.stringify(inputData1));
    var formData: any = new FormData();
    formData.append("bank", JSON.stringify(bankobject));
    // formData.append("files", this.paymentVoidCheque, this.paymentVoidCheque.name);
    formData.append(

      "files",

      this.paymentVoidCheque,

      "void_cheque_" + Date.now() + fileExtension.toLowerCase()

    );
    // formData.append("files", this.paymentVoidCheque,"void_cheque_"+Date.now()+this.fileExtension.toLowerCase());
    // if(this.selectedBase64) {
    //   let file = this?.dataURIToBlob(this.selectedBase64);
    //   let file = this.selectedBase64._buffer[0];
    // formData.append("files", file, this.paymentVoidCheque.name);
    // }
    // formData.append("files", this.bankfile.name,"void.pdf");
    formData.append("session", this.encBank) || "";
    formData.append("timestamp", new Date().getTime());
    let Endpoint = '/' + this.customerid + '/generatePAD';
    // let data = this.paymentMethodForm.value.files;
    this.http.post(api.url + Endpoint, formData, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
      }
    }).subscribe((response: any) => {
      if (response.status == 200) {
        this.pad = response?.data.url;
        this.filename = response?.data.filename;
        this.padfilename = response?.data.padfilename;
        this.ext = response?.data.ext;
        this.mimetype = response?.data.mimetype;
      }
      else {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })
      }
    }, (error) => {
      Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
    });
  }

  closeAgreement() {

  }

  drawComplete() {
    //this._LoggerService.log("complete")
    this.showconfirm = false
  }

  drawStart() {
    //this._LoggerService.log("draw")

  }

  @HostListener('document:mouseup', ['$event'])
  onMouseUp(e: any) {
    this.isDrawing = false;
  }

  onMouseDown(e: any) {
    this.isDrawing = true;
    const coords = this.relativeCoords(e);
    this.context.moveTo(coords.x, coords.y);
  }

  onMouseMove(e: any) {
    if (this.isDrawing) {
      const coords = this.relativeCoords(e);
      this.context.lineTo(coords.x, coords.y);
      this.signaturecheckvalue1cc = true;
      this.context.stroke();
      this.showupdatesignatue = false;
    }
  }


  clearCreditCardSignature() {
    this.context.clearRect(
      0,
      0,
      this.sigPadElement.width,
      this.sigPadElement.height
    );
    this.context.beginPath();
    this.signaturecheckvalue1cc = false;
    sessionStorage.removeItem("signature");
    this.signaturemessagecc = true;
    this.signaturecheckcc = true;
  }

  private relativeCoords(event: any) {
    const bounds = event.target.getBoundingClientRect();
    const x = event.clientX - bounds.left;
    const y = event.clientY - bounds.top;
    return { x: x, y: y };
  }

  clearSignature() {
    this.context.clearRect(0, 0, this.sigPadElement.width, this.sigPadElement.height);
    this.context.beginPath();
    this.showupdatesignatue = true;
  }
  // clearSignature() {
  //   this.showconfirm =true

  //   this.signaturePad.clear();
  // }

  savePad() {
    const base64Data = this.sigPadElement.toDataURL();
    this.signatureImg = base64Data;
    let Endpoint = '/' + this.customerid + '/updatePAD';
    let data = {
      url: this.pad,
      signature: this.signatureImg,
      session: this.encBank,
      filename: this.filename,
      padfilename: this.padfilename,
      ext: this.ext,
      mimetype: this.mimetype,
      adminName: 'sai',
    }
    this.http.post(api.url + Endpoint, data, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
      }
    }).subscribe((response: any) => {
      if (response.status == 200) {
        this.signedPad = response?.data.url;
      }
      else {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })
      }
    }, (error) => {
      Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
    });
  }

  closeSignaturePad() {
    this.closePaymentmodal.nativeElement.click();
  }


  addSpouse() {
    this.spouseUpdate = false;
    if (JSON.stringify(this.spouseInfo) === '{}') {
      this.spouseStatus = true;
      this.spouseForm['martialStatus'].clearValidators();
      this.spouseForm['martialStatus'].updateValueAndValidity();
      this.spouseForm['effectiveDate'].clearValidators();
      this.spouseForm['effectiveDate'].updateValueAndValidity();
    }
    else {
      this.spouseStatus = false;
      // this.spouseForm['firstName'].clearValidators();
      // this.spouseForm['firstName'].updateValueAndValidity();
      // this.spouseForm['lastName'].clearValidators();
      // this.spouseForm['lastName'].updateValueAndValidity();
      // this.spouseForm['dob'].clearValidators();
      // this.spouseForm['dob'].updateValueAndValidity();
      // this.spouseForm['phoneNum'].clearValidators();
      // this.spouseForm['phoneNum'].updateValueAndValidity();
      // this.spouseForm['coveredByAnotherPlan'].clearValidators();
      // this.spouseForm['coveredByAnotherPlan'].updateValueAndValidity();
      // this.spouseForm['healthPlan'].clearValidators();
      // this.spouseForm['healthPlan'].updateValueAndValidity();
      // this.spouseForm['insurer'].clearValidators();
      // this.spouseForm['insurer'].updateValueAndValidity();
    }
    this.spouseform.reset();
  }

  addSpouseData() {

    // Object.keys(this.spouseForm).forEach(controlName => {
    //   if (controlName !== 'martialStatus' && controlName !== 'effectiveDate') {
    //     const control = this.spouseForm[controlName];
    //     control.reset();
    //   }
    //   if(controlName == 'email') {
    //     const control = this.spouseForm[controlName];
    //     control.setErrors(null);
    //     const updatedErrors = { ...control.errors };
    //     delete updatedErrors['pattern'];
    //     control.setErrors(updatedErrors);
    //   }
    // });

    if (this.spouseStatus) {

      if (this.spouseform.invalid) {
        this.spouseform.markAllAsTouched();
        return;
      }
      else {
        const endPoint = '/' + this.customerid + '/lifeChanges/spouse/add/true';
        this.spouseData = this.spouseform.value;
        if (this.spouseform.value.coveredByAnotherPlan != true) {
          this.spouseData["coverage"] = ""
          this.spouseData["carrierName"] = ""
        }
        else {
          this.spouseData["coverage"] = this.spouseform.value.healthPlan
          this.spouseData["carrierName"] = this.spouseform.value.insurer
        }
        if (this.spouseform.value.email == null) {
          this.spouseData["email"] = ""
        }
        this.spouseData["dob"] = this._CustomDatePipe.transform(this.spouseform.value.dob)
        this.spouseData["relationType"] = "SPOUSE"

        let data: any;
        data = {
          'spouse': this.spouseData,
          'dependent': []
        }

        this.http.post(api.url + endPoint, data, {
          headers: {
            Authorization: 'Bearer ' + this.accessToken,
            'Content-Type': 'application/json',
          }
        }).subscribe((response: any) => {
          if (response.status == 200) {

            this.closeSpousemodal.nativeElement.click();
            Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message });
          }
          else {
            Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })
          }
        }, (error) => {
          Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
        });
      }
    }
    else {
      if (this.spouseForm['effectiveDate'].invalid || this.spouseForm['martialStatus'].invalid) {

        this.spouseform.markAllAsTouched();
        return;
      }
      else {

        console.log(this.spouseform.value, 'asdsad')
        let spouseData = this.childrenInfo;
        let spouseData_: any = {}

        let data = this.spouseform.value;
        //this._LoggerService.log(data)

        for (let spouse of spouseData) {
          //this._LoggerService.log(spouse)
          if (spouse["relationType"] == "spouse") {
            spouseData_["firstName"] = spouse.firstName;
            spouseData_["lastName"] = spouse.lastName;
            spouseData_["dob"] = spouse.dob;
            spouseData_["gender"] = spouse.gender;
            spouseData_["email"] = spouse.email || "";
            spouseData_["coverage"] = spouse.healthPlan;
            spouseData_["carrierName"] = spouse.insurer;
            spouseData_["healthPlan"] = spouse.healthPlan;
            spouseData_["insurer"] = spouse.insurer;
            spouseData_["id"] = spouse.id
          }

        }

        console.log('this.normalSpouseRegistration', this.normalSpouseRegistration)
        console.log('this.spouseform.value.coveredByAnotherPlan', this.spouseform.value.coveredByAnotherPlan)
        let approvalStatus = this.normalSpouseRegistration ? "normal" : this.spouseform.value.coveredByAnotherPlan ? "proceed" : "pending"



        let finalData: any = {
          "spouse": spouseData_,
          "dependent": [],
          "notes": {
            "planChange": "classic bronze(single)-classic bronze(couple)",
            "coverageChange": "single-couple",
            "coverageScenario": "STC",
            "priceChange": "153.12-306.26",
            "service": [
              "greenshield"
            ],
            "dependent": "spouse",
            "approvalStatus": approvalStatus
          },
          "approvalStatus": approvalStatus,
          "isPlanChanges": this.newlySelectedPlans.length > 0 ? true : false,
          "effectiveDate": this.spouseForm['effectiveDate'].value,
          "changedCoveragePlans": this.newlySelectedPlans,
          "removalDependents": [],
        }

        // this.spouseData["dob"]= this.datePipe.transform(new Date(this.spouseform.value.dob).toLocaleString(),'MM-dd-yyyy')

        if (this.spouseform.value.coveredByAnotherPlan === true) {
          data["coveredByAnotherPlan"] = true
        }
        else {
          data["coveredByAnotherPlan"] = false
        }

        data = {
          'spouse': data,
          'dependent': []
        }
        const endPoint = `/'+this.customerid+'/lifeChanges/${this.dependentType}/remove/false`;






        for (const key in spouseData) {
          if (spouseData[key] === null) {
            spouseData[key] = "";
          }
        }

        // data["dob"]= this.datePipe.transform(new Date(this.spouseform.value.dob).toLocaleString(),'MM-dd-yyyy')
        this.http.post(api.url + endPoint, finalData, {
          headers: {
            Authorization: 'Bearer ' + this.accessToken,
            'Content-Type': 'application/json',
          }
        }).subscribe((response: any) => {
          if (response.status == 200) {
            this.closeSpousemodal.nativeElement.click();
            Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message });
          }
          else {
            Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })
          }
        }, (error) => {
          //this._LoggerService.log(error)
          Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
        });
      }
    }


    // this.closeSpousemodal.nativeElement.click();
  }

  addDependent() {
    this.dependentform.reset();
    this.dependentUpdate = false;
    this.postSecondaryStudent = false;
    // if(this.childrenInfo.length!==0) {
    this.dependentStatus = true;
    //   this.dependentForm['effectiveDate'].clearValidators();
    //   this.dependentForm['effectiveDate'].updateValueAndValidity();
    // }
    // else {
    //   this.dependentStatus = false;
    // }
    this.dependentForm['graduationDate'].clearValidators();
    this.dependentForm['graduationDate'].updateValueAndValidity();
    this.dependentData = [];
  }

  addAnotherDependent() {
    if (this.dependentform.valid) {
      if (this.dependentform.value.coveredByAnotherPlan === false) {
        this.dependentForm["carrierName"].setValue("");
      }
      if (this.dependentform.value.postSecondaryStudent != true) {
        this.dependentForm["graduationDate"].setValue("");
      }
      this.dependentData.push(this.dependentform.value);
      this.dependentform.reset();
    }
    else {
      this.dependentform.markAllAsTouched();
    }

  }




  addDependentData() {
    if (this.dependentform.valid) {
      let data: any;
      if (this.dependentform.value.coveredByAnotherPlan === false) {
        this.dependentForm["carrierName"].setValue("");
      }
      if (this.dependentform.value.postSecondaryStudent != true) {
        this.dependentForm["graduationDate"].setValue("");
      }

      this.dependentData.push(this.dependentform.value);
      if (this.dependentData['graduationDate']) {
        this.dependentData['graduationDate'] = this._CustomDatePipe.transform(this.dependentform.value.graduationDate)

      }
      else {
        this.dependentData['graduationDate'] = ""

      }
      this.dependentData['dob'] = this._CustomDatePipe.transform(this.dependentform.value.dob)
      data = {
        'spouse': {},
        'dependent': this.dependentData
      }
      const endPoint = '/' + this.customerid + '/lifeChanges/dependent/add/true';
      this.http.post(api.url + endPoint, data, {
        headers: {
          Authorization: 'Bearer ' + this.accessToken,
          'Content-Type': 'application/json',
        }
      }).subscribe((response: any) => {
        if (response.status == 200) {

          this.closeSpousemodal.nativeElement.click();
          Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message });
        }
        else {
          Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })
        }
      }, (error) => {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
      });
      this.closeDependentmodal.nativeElement.click();
    }
    else {
      this.dependentform.markAllAsTouched();
    }
  }

  getMonth(event: any) {
    this.expireMonth = event.target.value;
    this.validateExpire(this.expireYear, this.expireMonth);
  }

  getYear(event: any) {
    this.expireYear = event.target.value;
    this.validateExpire(this.expireYear, this.expireMonth);
  }

  validateExpire(year: any, month: any) {
    let date = 31
    if (month == 4 || month == 6 || month == 9 || month == 11) {
      date = 30
    }
    else if (month == 2) {
      if ((year % 4 == 0 && year % 100 !== 0) || (year % 400 == 0)) {
        date = 29;
      }
      else {
        date = 28;
      }
    }
    if (year != null && month != null) {
      const expiry = new Date(parseInt("20" + year), month - 1, date);
      const current = new Date();
      if (expiry.getTime() < current.getTime()) {
        this.invalidExpiration = true;
      }
      else {
        this.invalidExpiration = false;
      }
    }
  }

  closePaymentInfo() {
    this.paymentform.reset();
    this.paymentform.get('expireMonth')?.setValue('');
    this.paymentform.get('expireYear')?.setValue('');
  }

  closeCcInfo() {
    this.ccform.reset();
    this.ccform.get('expireMonth')?.setValue('');
    this.ccform.get('expireYear')?.setValue('');
  }

  // closeButton() {
  //   this.closebutton.nativeElement.click();
  // }

  changeToCC() {
    this.getCreditcard();
    // this.paymentform.get('FirstName')?.setValue(this.customerData.firstName);
    // this.paymentform.get('LastName')?.setValue(this.customerData.lastName);
    // this.paymentform.get('address1')?.setValue(this.customerData.line1);
    // this.paymentform.get('streetaddressline2')?.setValue(this.customerData.line2);
    // this.paymentform.get('countryId')?.setValue(this.customerData.country);
    // this.paymentform.get('email')?.setValue(this.customerData.email);
    // this.paymentform.get('city')?.setValue(this.customerData.city);
    // this.paymentform.get('province')?.setValue(this.customerData.province);
    // this.paymentform.get('postalcode')?.setValue(this.customerData.postalCode);
  }


  getGroups(data): any[] {
    return Array.isArray(data?.value) ? data.value : Object.values(data?.value ?? {});
  }

  saveCcPayment(value: any, value1: any) {
    if (this.paymentform.invalid) {
      this.paymentform.markAllAsTouched();
      return;
    }
    else {
      // value1.CutomerID.value=parseInt(value1.CustomerID.value)
      var accessToken = sessionStorage.getItem('accessToken');
      var headers = {
        Authorization: 'Bearer ' + accessToken,
        'Content-Type': 'application/json',
      };
      this.http.get(api.adminApiUrl + '/api/ap/global/set-adminCorporates').subscribe((newResponse) => {
        this.http.post(api.reportApiUrl + '/websocket/corporate/notification-to-others', {
          "message": "Corporates information has been updated. Please refresh screen."
        }, { headers: headers }).subscribe((res) => { })
      })
      this.http.get(api.adminApiUrl + '/api/ap/global/set-adminAdvisors').subscribe((newResponse) => {
        this.http.post(api.reportApiUrl + '/websocket/advisor/notification-to-others', {
          "message": "Advisors information has been updated. Please refresh screen."
        }, { headers: headers }).subscribe((res) => { })
      })
      // this.http.get(api.adminApiUrl + '/api/ap/global/set-adminMembers').subscribe((newResponse) => {})
      this.http.post(api.reportApiUrl + '/websocket/member/notification-to-others', {
        "message": "Members information has been updated. Please refresh screen."
      }, { headers: headers }).subscribe((res) => { })
      setTimeout(() => {
        const cardNumber = this.paymentform.get('CardNumber')?.value;
        const expirationMonth = this.paymentform.get('ExpirationMonth')?.value;
        const expirationYear = this.paymentform.get('ExpirationYear')?.value;

        let newCardDetails = {
          expiry: expirationMonth + '/' + expirationYear,
          endingNumber: "************" + cardNumber.slice(-4)
        }
        localStorage.setItem("newCardDetails", JSON.stringify(newCardDetails))

        value1.submit();
        this.router.navigate(["home"]);
      }, 100)


      // value.submit();
    }
  }

  updateCcInfo(value: any, value1: any) {
    if (this.ccform.invalid) {
      this.ccform.markAllAsTouched();
      return;
    }
    else {
      const cardNumber = this.ccform.get('CardNumber')?.value;
      const expirationMonth = this.ccform.get('ExpirationMonth')?.value;
      const expirationYear = this.ccform.get('ExpirationYear')?.value;

      let newCardDetails = {
        expiry: expirationMonth + '/' + expirationYear,
        endingNumber: "************" + cardNumber.slice(-4)
      }


      localStorage.setItem("newCardDetails", JSON.stringify(newCardDetails))


      console.log(this.ccform)
      value1.submit();
      this.router.navigate(["home"]);
    }
  }

  padUpdate() {
    // this.padform.patchValue(this.PADdetails);
    // this.padForm['branchCode'] = this.PADdetails.transitNumber;
    // this.padform.get('accountNo')?.setValue(this.PADdetails.accountNumber)
    // this.padform.get('bankcode')?.setValue(this.PADdetails.bankCode)
    // this.padform.get('bankdetails')?.setValue(this.bankinformation)
    // this.banknameres = this.bankinformation;
    this.padform.patchValue({});
    this.padform.get('branchCode')?.setValue('')
    this.padform.get('accountNo')?.setValue('')
    this.padform.get('bankcode')?.setValue('')
    this.padform.get('bankdetails')?.setValue('')
    this.banknameres = '';
    this.bankinfo = true;
    this.resetbutton = true;
    this.resetPadForm();
  }

  checkFirstCharacter(event: any, form: any) {
    //this._LoggerService.log(event)
    if (event.target.value.startsWith(' ')) {
      event.target.value = event.target.value.trimStart();
    }
    //this._LoggerService.log(form)
    //this._LoggerService.log(event.target.id)
    //this._LoggerService.log(this.addressform.get('line1')?.value)
    //this._LoggerService.log(form.get(event.target.id));
    // Removing the special characters
    // form.get(event.target.id).setValue(event.target.value.replace(/[^a-zA-Z0-9\s]/g, ''));
  }


  public formatCreditCardNumber(event: any): void {
    let inputVal = event.target.value.replace(/\s+/g, ''); // Remove existing spaces

    if (inputVal.length > 0) {
      // Format the input with spaces every 4 digits
      inputVal = inputVal.match(/.{1,4}/g).join(' ');


    }
    // this.paymentForm.patchValue({ CardNumber: inputVal });
    this.ccform.get('CardNumber')?.setValue(inputVal);
    this.paymentform.get('CardNumber')?.setValue(inputVal);

    // this.creditCardForm.patchValue({ CardNumber: inputVal });
  }
  public formatAmericaCreditCardNumber(event: any): void {
    let inputVal = event.target.value.replace(/\s+/g, ''); // Remove existing spaces

    if (inputVal.length > 0) {
      // Format the input with spaces every 4 digits
      // inputVal = inputVal.match(/.{1,4}/g).join(' ');

      inputVal = inputVal.replace(/(\d{4})(\d{1,6})?(\d{1,5})?/, function (match, p1, p2, p3) {
        return p1 + (p2 ? ' ' + p2 : '') + (p3 ? ' ' + p3 : '');
      });
    }
    this.ccform.get('CardNumber')?.setValue(inputVal);
    this.paymentform.get('CardNumber')?.setValue(inputVal);
    // if (this.isValidAmexCard(inputVal.replaceAll(' ',''))) {
    //   console.log("This is a valid American Express card number.");
    // } else {
    //   console.log("This is not a valid American Express card number.");
    // }
    // this.creditCardForm.patchValue({ CardNumber: inputVal });
  }
  public isValidAmexCard(cardNumber) {
    // Remove any non-digit characters
    const cleanedCardNumber = cardNumber.replace(/\D/g, '');

    // Check if the card number has 15 digits and starts with 34 or 37
    const isAmex = /^3[47]\d{13}$/.test(cleanedCardNumber);

    return isAmex;
  }
  public isValidAmexCardNumber(val) {
    // Define the regex pattern for formatted Amex card number
    const amexPattern = /^3[47][0-9]{2} [0-9]{6} [0-9]{5}$/;
    console.log(amexPattern)
    return amexPattern.test(val.replaceAll(' ', ''));


  }
  public creditcardlblurmethod(event) {
    // this.postalvalue = event.target.value
    this.validateCreditCardNumber(event)


    let val = event.target.value;


    console.log(val.slice(0, 2))


    if (val.slice(0, 2) == 34 || val.slice(0, 2) == 37) {
      this.creditcardvalidationAmerica(val)
      this.formatAmericaCreditCardNumber(event)
      // this.isValidAmexCardNumber(val)
    }
    else {
      this.creditcardvalidation(val)
      this.formatCreditCardNumber(event)

      // this.dependentForm['cardNumber'].setValidators([Validators.required]);

    }

    val = val.replaceAll(' ', '')
    let checksum = 0; // running checksum total
    let j = 1; // takes value of 1 or 2
    // Process each digit one by one starting from the last
    for (let i = val.length - 1; i >= 0; i--) {
      let calc = 0;
      // Extract the next digit and multiply by 1 or 2 on alternative digits.
      calc = Number(val.charAt(i)) * j;

      // If the result is in two digits add 1 to the checksum total
      if (calc > 9) {
        checksum = checksum + 1;
        calc = calc - 10;
      }
      // Add the units element to the checksum total
      checksum = checksum + calc;
      // Switch the value of j
      if (j == 1) {
        j = 2;
      } else {
        j = 1;
      }
    }
    //Check if it is divisible by 10 or not.
    // return (checksum % 10) == 0;
    if (checksum % 10 == 0) {
      this.invalidcreditcard = false;
    } else {
      this.invalidcreditcard = true;
    }

    if (event.target.value.length < 13) {
      this.invalidcreditcard = true;
    }

    if (event.target.value.length == 0) {
      this.invalidcreditcard = false;
    }
  }
  validateCreditCardNumber(val) {
    const cardImage = document.getElementById('card-image');

    console.log(val.target.value)
    const visaPattern = /^(?:4[0-9]{12}(?:[0-9]{3})?)$/;
    const mastPattern = /^(?:5[1-5][0-9]{14})$/;
    const amexPattern = /^(?:3[47][0-9]{13})$/;
    const discPattern = /^(?:6(?:011|5[0-9][0-9])[0-9]{12})$/;

    const ccNum: string = val.target.value.replaceAll(' ', '')

    const isVisa = visaPattern.test(ccNum) === true;
    const isMast = mastPattern.test(ccNum) === true;
    const isAmex = amexPattern.test(ccNum) === true;
    const isDisc = discPattern.test(ccNum) === true;

    if (isVisa || isMast || isAmex || isDisc) {
      // at least one regex matches, so the card number is valid.
      if (isVisa) {
        this.cardType = 'Visa card'
        // Visa-specific logic goes here
      }
      else if (isMast) {
        this.cardType = 'Master card'
        // Mastercard-specific logic goes here
      }
      else if (isAmex) {
        this.cardType = 'Amex card';
        // cardImage['src']= 'path/to/amex.png';
        // cardImage.style.display = 'inline';
        // AMEX-specific logic goes here
      }
      else if (isDisc) {
        this.cardType = 'Discover card'
        // Discover-specific logic goes here
      }
      // return of (null);
    }
    else {
      this.cardType = '';
      // cardImage.style.display = 'none';
      // return of({
      //   invalid: true
      // });
      // alert("Please enter a valid card number.");
    }
  }

  creditcardvalidation(value: any) {
    console.log(value)
    var creditcardRegexp = /^[0-9_ ]{19,19}$/;
    if (value && !creditcardRegexp.test(value)) {
      this.invalidcreditcarddetails = true

      console.log("test")

    } else {
      this.invalidcreditcarddetails = false

    }
  }
  creditcardvalidationAmerica(value: any) {
    console.log(value)
    var creditcardRegexp = /^[0-9_ ]{17,17}$/;
    if (value && !creditcardRegexp.test(value)) {
      this.invalidcreditcarddetails = true
    } else {
      this.invalidcreditcarddetails = false

    }
  }



  changepad() {
    this.changetopad = true;
    setTimeout(() => {
      this.voidCheque1 = this.imagedisplay;
    }, 1000);
  }

  updatePadpreview() {
    this.changetopad = false;
    setTimeout(() => {
      // console.log(this.imagedisplay)
      this.voidCheque2 = this.imagedisplay;
      this.voidCheckImage = this.imagedisplay;
    }, 1000);
  }

  uploadNewVoid() {
    this.bankinfo = true;
    this.cheque = true;
    this.resetbutton = true;
    this.existVoid = false;
    if (this.padform.get('file')?.value == null) {
      this.review = false;
    }
  }

  existingVoidCheque() {
    setTimeout(() => {
      if (this.voidCheckFileType == 'application/pdf') {
        this.voidCheque2 = this.voidCheckImage;
      }
    }, 1000);
    // setTimeout(() => {
    //   this.pad = this.padAgreement;
    // }, 1000);
  }

  viewPadAgreement() {
    this.padView = this.padAgreement
  }

  downloadPAD(data) {
    this.http.get(data, { responseType: "arraybuffer" }).subscribe(
      pdf => {
        const blob = new Blob([pdf], { type: "application/pdf" });
        const fileName = "PAD"
        // -${this.roe.time.toISOString()}
        //       const fileName = this.roe+".pdf";
        // const fileName = this.roe
        saveAs(blob, fileName);
      },
      (error) => {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: error.error.error.message })
      });
  }

  padformValid() {
    if (this.padform.invalid) {
      this.resetbutton = false;
      this.bankinfo = false;
      this.cheque = false;
      return
    }
  }

  paymentMethodFormValid() {
    if (this.paymentMethodForm.invalid) {
      this.resetButton = false;
      this.bankDetails = false;
      this.uploadCheque = false;
      return
    }
  }

  ccUpdate() {

    // this.ccform.get('FirstName')?.setValue(this.ccDetails.firstName);
    // this.ccform.get('LastName')?.setValue(this.ccDetails.lastName);

    if (this.ccDetails.firstName == "Rakesh") {
      this.ccform.get('FirstName')?.setValue(this.customerData.firstName);
    }
    else {
      this.ccform.get('FirstName')?.setValue(this.ccDetails.firstName);
    }
    if (this.ccDetails.lastName == "Test") {
      this.ccform.get('LastName')?.setValue(this.customerData.lastName);
    }
    else {
      this.ccform.get('LastName')?.setValue(this.ccDetails.lastName);
    }

    let oldCardDetails = {
      expiry: this.expire,
      endingNumber: this.creditCardNo
    }

    // store the existing card details in the local storage
    localStorage.setItem("oldCardDetails", JSON.stringify(oldCardDetails))


    // this.fullName = this.customerData.firstName + ' ' + this.customerData.lastName;

    // this.ccform.get('ExpirationMonth')?.setValue(this.ccDetails.expirationMonth);
    // this.ccform.get('ExpirationYear')?.setValue(this.ccDetails.expirationYear);
  }

  changeToPAD() {
    let Endpoint = '/' + this.customerid + '/paymentType/ACH/change';
    this.http.post(api.url + Endpoint, { "paymentId": 0 }, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
      }
    }).subscribe((response: any) => {
      if (response.status == 200) {
        if (response.message == "Payment method updated successfully. Any changes related to plans and member-cards if applicable, will be reflected soon.") {
          setTimeout(() => {
            // window.location.reload()
          }, 40000);
        }
        let existingCreditCards = JSON.parse(sessionStorage.getItem('existingCreditCards') || '')
        if (existingCreditCards && existingCreditCards?.length > 0) {
          for (let i = 0; i < existingCreditCards.length; i++) {
            this.http.delete(api.url + `/payment/cc/${existingCreditCards[i]?.paymentMethodId0 ?? existingCreditCards[i]?.paymentMethodId}/remove`, {
              headers: {
                Authorization: 'Bearer ' + this.accessToken,
                'Content-Type': 'application/json',
              }
            })
              .subscribe((response: any) => {
                if (response.status != 200) {
                  Swal.fire({ title: 'Error', text: 'Error deleting old credit card' + existingCreditCards[i]?.maskedCardNumber })
                }
              })
          }
          sessionStorage.removeItem('existingCreditCards')
        }
        let defaultCreditCard = JSON.parse(sessionStorage.getItem('defaultCreditCard') || '')
        if (defaultCreditCard) {
          this.http.delete(api.url + `/payment/cc/${defaultCreditCard?.paymentMethodId0 ?? defaultCreditCard?.paymentMethodId}/remove`, {
            headers: {
              Authorization: 'Bearer ' + this.accessToken,
              'Content-Type': 'application/json',
            }
          })
            .subscribe((response: any) => {
              if (response.status != 200) {
                Swal.fire({ title: 'Error', text: 'Error deleting old credit card' + defaultCreditCard?.maskedCardNumber })
              }
            })
          sessionStorage.removeItem('defaultCreditCard')
        }

        var accessToken = sessionStorage.getItem('accessToken');
        var headers = {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        };
        this.http.get(api.adminApiUrl + '/api/ap/global/set-adminCorporates').subscribe((newResponse) => {
          this.http.post(api.reportApiUrl + '/websocket/corporate/notification-to-others', {
            "message": "Corporates information has been updated. Please refresh screen."
          }, { headers: headers }).subscribe((res) => { })
        })
        this.http.get(api.adminApiUrl + '/api/ap/global/set-adminAdvisors').subscribe((newResponse) => {
          this.http.post(api.reportApiUrl + '/websocket/advisor/notification-to-others', {
            "message": "Advisors information has been updated. Please refresh screen."
          }, { headers: headers }).subscribe((res) => { })
        })
        // this.http.get(api.adminApiUrl + '/api/ap/global/set-adminMembers').subscribe((newResponse) => {})
        this.http.post(api.reportApiUrl + '/websocket/member/notification-to-others', {
          "message": "Members information has been updated. Please refresh screen."
        }, { headers: headers }).subscribe((res) => { })

        Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })
      }
      else {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })
      }
    }, (error) => {
      Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
    });
    this.bankinfo = true;
    this.resetbutton = true;
    this.cheque = false;
    this.paymentMethodForm.reset();
    this.paymentMethodForm.get('paymentmethod')?.setValue('');
    this.resetButton = false;
    this.uploadCheque = false;
    this.bankDetails = false;
    this.updatepreviewbutton = false;
    this.existVoid = true;
    this.padform.get('file')?.setValue('');
    this.voidCheckFileType = this.PADdetails.voidCheckFileType;
  }

  resolved(captchaResponse: any) {
    this.recaptchaResponse = captchaResponse;
  }

  dependentnextcard() {
    // this.index = i+1;
    this.currentIndex = (this.currentIndex + 1) % this.childrenInfo.length;
  }

  dependentpreviouscard() {
    // this.index = i;
    this.currentIndex = (this.currentIndex - 1 + this.childrenInfo.length) % this.childrenInfo.length;
  }

  getindex(i: any) {
  }


  upgradeIafgPlans() {
    // Swal.fire({allowOutsideClick: false,title: this.lang?.Info, text:'Please contact your Admin/Advisor.'})
    this.router.navigate(['upgrade-plans'])
  }

  hasMemberData(member: any): boolean {
    return member && Object.keys(member).length > 0;
  }

  hasSpouseData(spouse: any): boolean {
    return spouse && Object.keys(spouse).length > 0;
  }

  formatNumber(number) {
    // let num = number.toString();
    // return num.slice(0,2)+','+num.slice(2)
    return number.toLocaleString();
  }

  filterEmptyListItems(content: string): string {
    // Create a temporary div to manipulate the HTML content
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = content;

    // Select all li elements and filter out empty ones
    const listItems = tempDiv.querySelectorAll('li');
    listItems.forEach((li) => {
      if (!li.textContent?.trim()) {
        li.remove(); // Remove empty <li> tags
      }
    });

    // Return the modified HTML content
    return tempDiv.innerHTML;
  }

  openVideoPopup() {
    let el: HTMLElement = this.openPopup.nativeElement;
    el.click();
  }

  // closeVideo() {
  //   var video = document.getElementsByTagName('video')[0];
  //   video.pause()
  // }

  openiframePopup() {
    let el: HTMLElement = this.openiframe.nativeElement;
    el.click();
  }

  openequitablePopup() {
    let el: HTMLElement = this.openequitable.nativeElement;
    el.click();
  }

  openSupportPopup() {
    let el: HTMLElement = this.opensupport.nativeElement;
    el.click();
  }

  downloadCard() {
    this.http.get(this.health_card, { responseType: "arraybuffer" }).subscribe(
      pdf => {
        const blob = new Blob([pdf], { type: "application/pdf" });
        const fileName = this.health_card + ".pdf";
        saveAs(blob, fileName);
      },
      (error) => {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
      });
  }

  onSlideChangeDependents(event: any) {
    //this._LoggerService.log(event)

    this.currentIndexOfSwipperDependents = event[0].realIndex + 1;
    if (this.childrenInfo[event[0].realIndex].relationType == "spouse") {

      this.editSpouse = true;

      this.editChild = false;

    }

    else if (this.childrenInfo[event[0].realIndex].relationType == "child") {

      this.editSpouse = false;

      this.editChild = true;

    }

  }

  onSlideChangeDownload(event: any) {

    this.currentIndexOfSwipperDownload = event[0].realIndex + 1;

  }

  onSlideChangePlan(event: any) {

    this.currentIndexOfSwipperPlan = event[0].realIndex + 1;

  }

  onSlideChangeBenifuts(event: any) {

    this.currentIndexOfSwipperBenifits = event[0].realIndex + 1;

  }

  setlanguage(event: any) {
    this.getFormConfiguration(event);
    //this._LoggerService.log("123")
  }

  filterInvoices() {
    console.log('Selected filter:', this.filterInvoice);
    console.log('customerFinalInvoices:', this.customerFinalInvoices);
    console.log('customerFinalInvoicesIGBMS:', this.customerFinalInvoicesIGBMS);

    if (this.filterInvoice === 'All') {
      this.customerFinalInvoicesIGBMS = this.allCustomerFinalInvoicesIGBMS;
      this.customerFinalInvoices = this.allCustomerFinalInvoices
      this.getCustomerDraftDate = this.getCustomerDraftDate1;
    } else {
      const selectedYear = this.filterInvoice;
      this.customerFinalInvoicesIGBMS = this.allCustomerFinalInvoicesIGBMS.filter(invoice => {
        const dueDate = new Date(invoice.dueDate);
        return dueDate.getFullYear().toString() == selectedYear;
      });
      this.customerFinalInvoices = this.allCustomerFinalInvoices.filter(invoice => {
        const dueDate = new Date(invoice.dueDate);
        return dueDate.getFullYear().toString() == selectedYear;
      });
      // this.getCustomerDraftDate = this.getCustomerDraftDate1.slice(0,3) == selectedYear;
      const draftYear = new Date(this.getCustomerDraftDate1).getFullYear().toString();
      console.log(draftYear, selectedYear)
      if (draftYear == selectedYear) {
        this.getCustomerDraftDate = this.getCustomerDraftDate1; // If it matches the selected year, keep the date
      } else {
        this.getCustomerDraftDate = ''; // Otherwise, set it to null (or any other default behavior)
      }
    }

    console.log('Filtered invoices:', this.filteredInvoices);
  }

  CustomInvoiceFilter() {
    console.log('this.filterDateSelection', this.filterDateSelection);
    if (this.filterDateSelection) {
      this.updateCustomRange();
      // if (this.dropdown) {
      //   this.dropdown.hide();
      // }
    } else {
      console.log('No date selected');
    }
  }

  updateCustomRange() {
    const [startDate, endDate] = this.filterDateSelection.map(date => new Date(date));

    startDate.setHours(0, 0, 0, 0);
    endDate.setHours(23, 59, 59, 999);

    if (isNaN(startDate) || isNaN(endDate)) {
      console.log('Invalid start or end date');
      return;
    }

    console.log('Custom date range:', startDate, 'to', endDate);

    // Filter invoices within the date range
    this.customerFinalInvoices = this.allCustomerFinalInvoices.filter(invoice => {
      const invoiceDate = new Date(invoice.dueDate);
      invoiceDate.setHours(0, 0, 0, 0);
      return invoiceDate >= startDate && invoiceDate <= endDate;
    });

    this.customerFinalInvoicesIGBMS = this.allCustomerFinalInvoicesIGBMS.filter(invoice => {
      const invoiceDate = new Date(invoice.dueDate);
      invoiceDate.setHours(0, 0, 0, 0);
      return invoiceDate >= startDate && invoiceDate <= endDate;
    });

    const draftDate = new Date(this.getCustomerDraftDate1);
    draftDate.setHours(0, 0, 0, 0);
    console.log(draftDate, startDate, endDate)
    if (draftDate >= startDate && draftDate <= endDate) {
      this.getCustomerDraftDate = this.getCustomerDraftDate1;
    } else {
      this.getCustomerDraftDate = '';
    }

    $('#dropdownMenuButton').click()
  }

  onCustomClick(event: MouseEvent) {
    event.stopPropagation();
    this.filterInvoice = 'Custom';
  }

  
  public capitalize(str: String) {
    if (str) {
      // return str.charAt(0).toUpperCase() + str.slice(1);
      const words = str.split(' ');

      let finalres: any = words.filter((v) => v != '');
      return finalres
        .map((word: any) => {
          return word[0].toUpperCase() + word.substring(1);
        })
        .join(' ');
    }
  }

  public checkDateOfBirth(event: any) {
    const validDatePattern = /^\d{2}-\d{2}-\d{4}/;

    // Extract the first valid date part
    const match = event.target.value.match(validDatePattern);
    console.log(match)
    if (match[0] != event.target.value) {
      this.addressform.get('dob')?.reset();
      this.addressform.get('dob')?.markAsTouched();
    }
    if (event.target.value == 'Invalid date') {
      this.addressform.get('dob')?.reset();
      this.addressform.get('dob')?.markAsTouched();
    }
  }


  handleAmountonUI(amount:any){
    amount = parseFloat(amount);
    const formatted = amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return formatted;
  }

  handleKeepDependentsToCurrent(value:any) {
    this.addToPolicy = value == 'open' ? 'close' : 'open';
    this.clearAllMessages();
    this.finalEffectiveDate = null;
    this.showCorpPlansTable = false;
    this.showAddToPolicyError = false;
    if(value == 'close' && this.isExcludeAll) {
      this.isExcludeChild = true;
    }


    let endPoint:any = `/customer/get-coverage-information/${this.customerid}/${this.addToPolicy == 'open' ? true : false}/${this.cobcoverage}`
    


    this.http.get(api.url + endPoint, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      if (response.status == 200) {
        console.log(response)
        this.cobeventType = response.data.eventType == 'upgrade' ? "add" : "remove"
        // this.cobevent = this.isExcludeSpouse ? "spouse" : this.isExcludeAll ? "multiple" : "dependent";
        this.cobevent = "spouse";


        if(response.data.needtoupdate){
          this.isNeedToUpdate = true;
          this.needToUpdate = ''
          // this.handleAddToPolicyV2(value, event, eventType)
        }else{
          this.isNeedToUpdate = false;
          this.needToUpdate = `Coverage remains unchanged.`
          // this.isNeedToUpdate = true; 
        }
      }
      else {
        // Swal.fire({allowOutsideClick: false,title: this.lang?.Info, text:response.message})
      }
    }, (error) => {
      // Swal.fire({allowOutsideClick: false,title: this.lang?.Info, text: error.error.error.message})
    });
  }

  handleAddToPolicyV2(effectiveDate:any, value:any, event:any, eventType:any){
    this.currentamount = 0;
    this.upcomingamount = 0;
    this.addToPolicy = value;
    this.showAddToPolicyError = false;
    this.underWritingMessage1 = '';
    this.underWritingMessage2 = '';
    this.corpMessage = '';
    this.secondMessage = '';
    this.firstMessage = '';
    this.firstConfirmMessage = '';
    this.secondConfirmMessage = '';
    this.clearAllMessages();
    // call the api

    sessionStorage.removeItem("plansummarymain")
    sessionStorage.removeItem("plansskumain");
    sessionStorage.removeItem("plansummaryopt");
    sessionStorage.removeItem("plansummary");
    sessionStorage.removeItem("selectedPlans");
    sessionStorage.removeItem("totalAmount");
    sessionStorage.removeItem("totalAmountUI");

    if (this.totalCount == 0) {
      this.totalCount = this.totalCount + 1;
    }
    let childCovered = 'none'
    let childCoveredCount = 0;
    let existingSpouseBefore:any = {};
    let existingChildrenBefore:any = [];
    if (this.availableFirstNames && this.availableFirstNames.length > 0) {
      existingSpouseBefore = this.availableFirstNames.find(item => item.relationType == 'spouse');
      existingChildrenBefore = this.availableFirstNames.filter(item => item.relationType != 'spouse');
    }
    if (existingChildrenBefore && existingChildrenBefore.length > 0) {
      for (const cd of existingChildrenBefore) {
        if (cd.coveredByAnotherPlan == true) {
          childCoveredCount++;
        }
      }

      if (existingChildrenBefore.length == childCoveredCount) {
        childCovered = 'full'
      } else {
        childCovered = 'partial'
      }


      if (childCoveredCount == 0) {
        childCovered = 'none'
      }
    }

    let endPoint:any 
    if(!this.isCorporateAccount){
      endPoint = `/customer/${this.customerid}/customerPlans/${event}/${eventType}`
    }else{
      endPoint = `/customer/v2/${this.customerid}/customerPlans/${event}/${eventType}`
    }
    let payload = {
      enrollmentDate: moment(effectiveDate).format('YYYY-MM-DD'),
      spouseCovered: true,
      removeRoleBasedPlans: false,
      childCovered: childCovered,
      totalCount: existingChildrenBefore.length,
      isIncluded: true
    }

    console.log({ payload })

    let dataaaa:any;
    // commented
    // return;
    this.http.post(api.url + endPoint, payload, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      if (response.status == 200) {
        this.handleContinue(response)
        console.log(response?.data, 'asda')
        this.coverageChange = response?.data?.coverageChange;
        let prs = response?.data?.gsOrEqMemberStatus ?? {}
        let prsStatus: any = []
        const prsKeys = Object.keys(prs);
        if (prsKeys.length > 0) {
          for (const prk of prsKeys) {
            if (prs[prk] == true) {
              if (prk == 'greenShildCustomer') {
                prsStatus.push('GreenShield')
              }
              if (prk == 'hcdSecuremePlans') {
                prsStatus.push('HCD Secureme')
              }
              if (prk == 'equitableCustomer') {
                prsStatus.push('Equitable')
              }
              if (prk == 'phrCustomer') {
                prsStatus.push('PHR')
              }
              if (prk == 'waddelCustomer') {
                prsStatus.push('Waddel')
              }
            }
          }
        }
        this.provisioningSites = prsStatus.toString() ?? ""

        console.log("calledoooo")
        this.isSpecialCondition = response?.data?.isSpecialCondition ?? false;
        console.log(this.normalDependentRegistration, this.normalSpouseRegistration)
        let data__ = response?.data?.packages
        dataaaa = response

        const startOfCurrentMonth = moment(effectiveDate).startOf('month');
        const formattedDate = startOfCurrentMonth.format('MMMM Do'); // Format for "April 1st"

        // this.firstConfirmMessage = `Your marital status was changed ${this.coveragetext(this.coverageChange)}`
        // if(this.normalSpouseRegistration){
        //   this.secondConfirmMessage = `Your policies have been ${eventType == 'add' ? "upgraded" : "downgraded"} ${this.coveragetext(this.coverageChange)} effective ${formattedDate} ${moment().year()}`
        // }else{
        //   this.secondConfirmMessage = `Your reporting of life event change is outside the 30 day window. Coverage for your dependents has to be approved by the carrier(s) pending underwriting, which may take up to 6 weeks.`
        //   // this.secondConfirmMessage = `Your policies ${eventType == 'add' ? "upgrade" : "downgrade"} from ${this.coveragetext(this.coverageChange)} is pending approval from underwriting`
        //   // this.underWritingMessage1 = 'This can take upto 6 weeks to complete'
        //   this.underWritingMessage2 = "Once approved you'll be advised of the premium change"
        // }


        if(!this.isCorporateAccount){
          this.processPackages(dataaaa, formattedDate)
        }else{
          this.processPackagesForCorp(dataaaa, formattedDate)
        }

      }
      else {
        Swal.fire({allowOutsideClick: false,title: this.lang?.Info, text:response.message})
      }
    }, (error) => {
      // Swal.fire({allowOutsideClick: false,title: this.lang?.Info, text: error.error.error.message})
    });


  }

  handleEffectiveDateChange() {
    this.childrenDetailsForNormalReg = [] 
    this.childrenApprovalNeed = []
    if (this.addToPolicy === null || this.addToPolicy == '' || this.addToPolicy == undefined) {
      this.showAddToPolicyError = true;
      this.finalEffectiveDate = null;
      this.clearAllMessages();
      return;
    }

    this.currentamount = 0;
    this.upcomingamount = 0;
    this.showAddToPolicyError = false;
    this.underWritingMessage1 = '';
    this.underWritingMessage2 = '';
    this.corpMessage = '';
    this.secondMessage = '';
    this.firstMessage = '';
    this.firstConfirmMessage = '';
    this.secondConfirmMessage = '';
    // call the api

    sessionStorage.removeItem("plansummarymain")
    sessionStorage.removeItem("plansskumain");
    sessionStorage.removeItem("plansummaryopt");
    sessionStorage.removeItem("plansummary");
    sessionStorage.removeItem("selectedPlans");
    sessionStorage.removeItem("totalAmount");
    sessionStorage.removeItem("totalAmountUI");

    if (this.totalCount == 0) {
      this.totalCount = this.totalCount + 1;
    }
    let childCovered = 'none'
    let childCoveredCount = 0;
    if (this.childrenDetails && this.childrenDetails.length > 0) {
      for (const cd of this.childrenDetails) {
        if (cd.coveredByAnotherPlan == true) {
          childCoveredCount++;
        }
      }

      if (this.childrenDetails.length == childCoveredCount) {
        childCovered = 'full'
      } else {
        childCovered = 'partial'
      }


      if (childCoveredCount == 0) {
        childCovered = 'none'
      }
    }

    let endPoint:any 
    if(!this.isCorporateAccount){
      endPoint = `/customer/${this.customerid}/customerPlans/${this.dependentType == 'child' ? 'dependent' : this.dependentType}/add`
    }else{
      endPoint = `/customer/v2/${this.customerid}/customerPlans/${this.dependentType == 'child' ? 'dependent' : this.dependentType}/add`
    }
    let enrollmentDate:any;
    if(this.childrenDetails && this.childrenDetails.length > 0) {
      enrollmentDate = this.childrenDetails[0]
    }
    let payload = {
      enrollmentDate: moment(this.finalEffectiveDate).format('YYYY-MM-DD'),
      spouseCovered: this.coveredByAnotherPlan == 'open' ? true : false,
      removeRoleBasedPlans: false,
      childCovered: childCovered,
      totalCount: this.childrenDetails.length - 1,
      totalCountIncluded: this.childrenDetails.length,
      isIncluded: this.addToPolicy == 'open' ? true : false
    }


    if (this.childrenDetails && this.childrenDetails.length > 0) {
     
      this.childrenDetails.map((child: any) => {
        const dob = moment(child.dob);
        const today = moment();
        const daysDiff = today.diff(dob, 'days');

        let approvalNeeded = false;

        // Check backdated DOB (> 30 days ago)
        if (daysDiff > 30) {
          approvalNeeded = true;
        }

        // Additional special needs check
        if (child.specialNeeds) {
          approvalNeeded = true;
        }

        if(this.addToPolicy == 'close'){
          approvalNeeded = false;
        }


        // Format and assign DOB

        // Final backdated flag per child
        if(!approvalNeeded) {
          this.childrenDetailsForNormalReg.push(child)
        }else{
          this.childrenApprovalNeed.push(child)
        }
        // child.isBackdated = approvalNeeded;
      });

    }


    console.log(this.childrenApprovalNeed)

    if(this.childrenApprovalNeed.length == this.childrenDetails.length){
      payload.totalCount = this.childrenDetails.length
    }else{
      if(this.childrenApprovalNeed.length > 0){
      payload.totalCount = Math.abs(this.childrenDetails.length - this.childrenApprovalNeed.length);
      }
    }
    
    if(this.isCorporateAccount && this.dependentType == 'child'){
      if(this.childrenDetailsForNormalReg.length != this.childrenDetails.length && this.childrenDetailsForNormalReg.length > 0){
        payload.totalCount = this.childrenDetailsForNormalReg.length;
        payload.totalCountIncluded =  this.childrenDetails.length;
      }else{
        payload.totalCount = this.childrenDetails.length;
        payload.totalCountIncluded =  this.childrenDetails.length;
      }
    }
    console.log(this.childrenDetailsForNormalReg)
    console.log(this.dependentType)
    if(this.dependentType == 'multiple'){
      if(this.childrenDetails.length > 0) {
      if(!this.normalSpouseRegistration){
        if(this.childrenDetailsForNormalReg.length <= 1) {
          payload.totalCount = this.childrenDetailsForNormalReg.length - 1;
          payload.totalCountIncluded = this.childrenDetails.length;
        }
        if(this.childrenDetailsForNormalReg.length > 1) {
          payload.totalCount = this.childrenDetailsForNormalReg.length;
          payload.totalCountIncluded = this.childrenDetails.length;
        }else{
          payload.totalCount = this.childrenDetails.length;
          payload.totalCountIncluded = this.childrenDetails.length;
        }
      }else{
         payload.totalCount = this.childrenDetailsForNormalReg.length;
          payload.totalCountIncluded = this.childrenDetails.length;
      }
      }
    }

    console.log({ payload })

    let dataaaa:any;
    // commented
    // return;

    if(this.addToPolicy == 'open' || this.enactMode == 'cob'){
    this.http.post(api.url + endPoint, payload, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      if (response.status == 200) {
        this.handleContinue(response)
        console.log(response?.data, 'asda')
        this.coverageChange = response?.data?.coverageChange;
        this.coverageChange2 = response?.data?.coverageChange2;
        this.isSpecialCondition = response?.data?.isSpecialCondition ?? false;
        this.maxEnrollmentDate = response?.data?.maxEnrollmentDate;
        this.customerOldPlans = response?.data?.customerPlans;

        let prs = response?.data?.gsOrEqMemberStatus ?? {}
        let prsStatus: any = []
        const prsKeys = Object.keys(prs);
        if (prsKeys.length > 0) {
          for (const prk of prsKeys) {
            if (prs[prk] == true) {
              if (prk == 'greenShildCustomer') {
                prsStatus.push('GreenShield')
              }
              if (prk == 'hcdSecuremePlans') {
                prsStatus.push('HCD Secureme')
              }
              if (prk == 'equitableCustomer') {
                prsStatus.push('Equitable')
              }
              if (prk == 'phrCustomer') {
                prsStatus.push('PHR')
              }
              if (prk == 'waddelCustomer') {
                prsStatus.push('Waddel')
              }
            }
          }
        }
        this.provisioningSites = prsStatus.toString() ?? ""

        console.log("calledoooo")
        console.log(this.normalDependentRegistration, this.normalSpouseRegistration)
        let data__ = response?.data?.packages
        dataaaa = response


        let ecDate = this.finalEffectiveDate
        const startOfCurrentMonth = moment(ecDate).startOf('month');
        const formattedDate = startOfCurrentMonth.format('MMMM Do'); // Format for "April 1st"

        // this.firstConfirmMessage = `Your marital status was changed to ${this.maritalStatusText(this.coverageChange)}`
       
        // if(this.normalDependentRegistration && this.normalSpouseRegistration){
        //    this.secondConfirmMessage = `Your policies have been ${this.enactMode == 'add' ? "upgraded" : "downgraded"} ${this.coveragetext(this.coverageChange)} effective ${formattedDate} ${moment().year()}`
        // }else{
        //   this.secondConfirmMessage = `Your reporting of life event change is outside the 30 day window. Coverage for your dependents has to be approved by the carrier(s) pending underwriting, which may take up to 6 weeks.`
        //   // this.secondConfirmMessage = `Your policies ${eventType == 'add' ? "upgrade" : "downgrade"} from ${this.coveragetext(this.coverageChange)} is pending approval from underwriting`
        //   // this.underWritingMessage1 = 'This can take upto 6 weeks to complete'
        //   this.underWritingMessage2 = "Once approved you'll be advised of the premium change"
        // }


        if(!this.isCorporateAccount){
          this.processPackages(dataaaa, formattedDate)
        }else{
          this.processPackagesForCorp(dataaaa, formattedDate)
        }

      }
      else {
        this.finalEffectiveDate = null;
        Swal.fire({allowOutsideClick: false,title: this.lang?.Info, text:response.message})
      }
    }, (error) => {
      // Swal.fire({allowOutsideClick: false,title: this.lang?.Info, text: error.error.error.message})
    });
  }
  }

  handleAddToPolicy(value:any){
    console.log("called")
    this.finalEffectiveDate = null;
    this.clearAllMessages()
    this.showCorpPlansTable= false;
    this.addToPolicy = value;
    if(value == 'close'){
      this.showPlanDetails= false;
    }
  }


  onDependentChange(e:any){
    this.normalDependentDeletion= false;
    console.log(this.selectedDepId, "selectedDepId")
    this.isSpouseSelected = this.availableFirstNames.find(item => item.id == e.target.value && item.relationType == 'spouse')
    this.isChildSelected = this.availableFirstNames.find(item => item.id == e.target.value && item.relationType != 'spouse')
    console.log(this.isSpouseSelected, this.isChildSelected)
    if(!!this.isSpouseSelected) {
      this.dependentType = 'spouse'
      if(this.isSpouseSelected.addedToPolicy == "false"){
        this.normalDependentDeletion = true;
      }
    }if(!!this.isChildSelected) {
      this.dependentType = 'child'
      if(this.isChildSelected.addedToPolicy == "false"){
        this.normalDependentDeletion = true;
      }
    }
  }


  onDependentSelectForms(e:any){
    this.isDependentSelected = true;
  }
  onEffectiveDateChange(){
    if(this.finalEffectiveDate != null) {

    console.log(this.finalEffectiveDate, "avalue")
    if(this.enactMode == 'cob') {
      // call the cob related changes
      const date1 = moment(this.finalEffectiveDate).format('MM-DD-YYYY'); // First date
      const date2 = moment(moment(new Date()), "MM-DD-YYYY"); // Second date
      const differenceInDays = date2.diff(date1, 'days');
      console.log(differenceInDays, "differenceInDays8899")
      if (differenceInDays <= 30) {
        this.normalSpouseRegistration= true;
      }else{
        this.normalSpouseRegistration= false;
      }

      if(this.isNeedToUpdate){
 
        this.handleAddToPolicyV2(this.finalEffectiveDate, this.addToPolicy, this.cobevent, this.cobeventType)
      }
      return;
    }

    this.currentamount = 0;
    this.upcomingamount = 0;
    // this.addToPolicy = value;
    this.showAddToPolicyError = false;
    console.log(this.finalEffectiveDate)


    const childDateFormatted = this.datePipe.transform(this.finalEffectiveDate, 'MM-dd-yyyy');
    const date1 = moment(childDateFormatted, "MM-DD-YYYY"); // First date
    const date2 = moment(moment(new Date()), "MM-DD-YYYY"); // Second date
    console.log(this.maritalStatus, this.isCommonLaw);

    const differenceInDays = date2.diff(date1, 'days');
    console.log('differenceInDays', differenceInDays);

   

    
    // call the api

    sessionStorage.removeItem("plansummarymain")
    sessionStorage.removeItem("plansskumain");
    sessionStorage.removeItem("plansummaryopt");
    sessionStorage.removeItem("plansummary");
    sessionStorage.removeItem("selectedPlans");
    sessionStorage.removeItem("totalAmount");
    sessionStorage.removeItem("totalAmountUI");

    if (this.totalCount == 0) {
      this.totalCount = this.totalCount + 1;
    }
    let childCovered = 'none'
    let childCoveredCount = 0;
    if (this.childrenDetails && this.childrenDetails.length > 0) {
      for (const cd of this.childrenDetails) {
        if (cd.coveredByAnotherPlan == true) {
          childCoveredCount++;
        }
      }

      if (this.childrenDetails.length == childCoveredCount) {
        childCovered = 'full'
      } else {
        childCovered = 'partial'
      }


      if (childCoveredCount == 0) {
        childCovered = 'none'
      }
    }

    let endPoint:any 
    if(!this.isCorporateAccount){
      endPoint = `/customer/${this.customerid}/customerPlans/${this.isSpouseSelected ? 'spouse' : 'child'}/remove`
    }else{
      endPoint = `/customer/v2/${this.customerid}/customerPlans/${this.isSpouseSelected ? 'spouse' : 'child'}/remove`
    }
    let payload = {
      enrollmentDate: moment(this.finalEffectiveDate).format('YYYY-MM-DD'),
      spouseCovered: this.coveredByAnotherPlan == 'open' ? true : false,
      removeRoleBasedPlans: false,
      childCovered: childCovered,
      totalCount: this.childrenDetails.length,
      isIncluded: true
    }

    console.log({ payload })

    let dataaaa:any;
    // commented
    // return;

    if(!!this.isSpouseSelected){
      if (differenceInDays <= 30) {
        this.isSpouseSelected.isBackdated= false;
      }else{
        this.isSpouseSelected.isBackdated= true;
      }
      this.isSpouseSelected.dateOfMarriage= moment(this.finalEffectiveDate).format('YYYY-MM-DD')
    }if(!!this.isChildSelected) {
      if (differenceInDays <= 30) {
        this.isChildSelected.isBackdated= false;
      }else{
        this.isChildSelected.isBackdated= true;
      }
      this.isChildSelected.dob= moment(this.finalEffectiveDate).format('YYYY-MM-DD')
    }

    if(this.finalEffectiveDate){
    this.http.post(api.url + endPoint, payload, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      if (response.status == 200) {
        this.handleContinue(response)
        console.log(response?.data, 'asda')
        this.coverageChange = response?.data?.coverageChange;
        let prs = response?.data?.gsOrEqMemberStatus ?? {}
        let prsStatus: any = []
        const prsKeys = Object.keys(prs);
        if (prsKeys.length > 0) {
          for (const prk of prsKeys) {
            if (prs[prk] == true) {
              if (prk == 'greenShildCustomer') {
                prsStatus.push('GreenShield')
              }
              if (prk == 'hcdSecuremePlans') {
                prsStatus.push('HCD Secureme')
              }
              if (prk == 'equitableCustomer') {
                prsStatus.push('Equitable')
              }
              if (prk == 'phrCustomer') {
                prsStatus.push('PHR')
              }
              if (prk == 'waddelCustomer') {
                prsStatus.push('Waddel')
              }
            }
          }
        }
        this.provisioningSites = prsStatus.toString() ?? ""

        console.log("calledoooo")
        let data__ = response?.data?.packages
        dataaaa = response

        const startOfCurrentMonth = moment().startOf('month');
        const formattedDate = moment(this.finalEffectiveDate).format('MMMM Do'); // Format for "April 1st"

        // this.firstConfirmMessage = `Your marital status was changed ${this.coveragetext(this.coverageChange)}`
        // if(this.effectedPackageNames.length > 0){
        //   this.secondConfirmMessage = `Your policies (${this.effectedPackageNames.join(',')}) need to be change ${this.coveragetext(this.coverageChange)}`
        // }


        if(!this.isCorporateAccount){
          this.processPackages(dataaaa, formattedDate)
        }else{
          this.processPackagesForCorp(dataaaa, formattedDate)
        }

      }
      else {
        this.finalEffectiveDate = null
        // this.deleteForm.get('effectiveDate')?.setValue('', {emitEvent: false})
        Swal.fire({allowOutsideClick: false,title: "Info", text:response.message})
      }
    }, (error) => {
      // Swal.fire({allowOutsideClick: false,title: this.lang?.Info, text: error.error.error.message})
    });
  }

}
  }



  coveragetext(coverage) {
    let text=''
    switch(coverage){
      case 'STC':
      default:
        text = 'from Single to Couple';
        break;
      case 'STF':
          text = 'from Single to Family';
          break;
      case 'CTF':
        text = 'from Couple to Family';
        break;
      case 'CTS':
        text = 'from Couple to Single';
        break;
      case 'FTS':
        text = 'from Family to Single';
        break;
      case 'FTC':
        text = 'from Family to Couple';
        break;
      case 'F':
        text='to Family';
        break;
    }

    return text;
  }

  maritalStatusText(coverage) {
    let text=''
    switch(coverage){
      case 'STC':
      default:
        text = 'Couple';
        break;
      case 'STF':
          text = 'Family';
          break;
      case 'CTF':
        text = 'Family';
        break;
      case 'CTS':
        text = 'Single';
        break;
      case 'FTS':
        text = 'Single';
        break;
      case 'FTC':
        text = 'Couple';
        break;
      case 'F':
        text='Family';
        break;
    }

    return text;
  }

    maritalStatusTextNext(coverage) {
    let text=''
    switch(coverage){
      case 'STC':
      default:
        text = 'FAMILY';
        break;
      case 'STF':
          text = 'FAMILY';
          break;
      case 'CTF':
        text = 'FAMILY';
        break;
      case 'FTS':
        text = 'SINGLE';
        break;
      case 'CTS':
        text = 'SINGLE';
        break;
      case 'FTC':
        text = 'FAMILY';
        break;
      case 'F':
        text='FAMILY';
        break;
    }

    return text;
  }

  currentCoverage(coverage) {
    let text=''
    switch(coverage){
      case 'STC':
      default:
        text = 'Single';
        break;
      case 'STF':
          text = 'Single';
          break;
      case 'CTF':
        text = 'Couple';
        break;
      case 'CTS':
        text = 'Couple';
        break;
      case 'FTS':
        text = 'Family';
        break;
      case 'FTC':
        text = 'Family';
        break;
      case 'F':
        text='Family';
        break;
    }

    return text;
  }
  

  // Process packages and create plan details objects
processPackages(dataaaa: any, formattedDate: string) {
  this.proceedDeleteButtonDisabled = true;
  this.clearAllMessages();
  this.isDirectUpdate = false;
  this.currentamount = 0;
  this.currentamountUI = 0;
  this.backdatedamount = 0;
  this.backdatedamountUI = 0;
  this.specialConditionMessage = ''
  this.upcomingamount = 0;
  this.upcomingamountUI = 0;
  this.effectedPackages = [];
  let epa:any = []
  this.effectedPackageNames = [];
  this.obj1 = [];
  let prevVersionPackage:any = []

  const COUPLE_SAMEAS_FAMILY_PLANLEVELS = [10,31,40,58,59];
  
  let getUpdatingCoverage = this.maritalStatusText(this.coverageChange)?.toUpperCase() ?? "COUPLE";
  
  // first check the existing coverage for customer
  setTimeout(() => {
      this._LoaderService.ShowLoader();
  let coverages = ['SINGLE', 'COUPLE', 'FAMILY']

    const dom: HTMLElement = this.elementRef.nativeElement;

    let planSummMain: any = JSON.parse(sessionStorage.getItem('plansummarymain') ?? '[]');
    console.log(planSummMain, "planSummMain")
    if ( planSummMain?.length > 0) {
      for (const psm of planSummMain) {
        if(COUPLE_SAMEAS_FAMILY_PLANLEVELS.includes(psm.planLevel)){
          getUpdatingCoverage = this.maritalStatusTextNext(this.coverageChange)?.toUpperCase() ?? "COUPLE";
          console.log(getUpdatingCoverage)
          if (psm.isBundle) {
            const selector = `#plancheck${psm.id}.coverage${getUpdatingCoverage}`;
            console.log(`Selector: '${selector}'`);
            const selectedElement = dom.querySelectorAll(selector);
            console.log("accessed",  selectedElement)
            setTimeout(function() {
                $(selectedElement).click();
            }, 1000);
            // if ($el.length) $el.click();
          } else {
            if (psm.coverage && psm.coverage !== '-') {
              $(`#plancheck${psm.planLevel}.coverage${psm.coverage}`).click();
            } else {
              $(`#plancheck${psm.planLevel}`).click();
            }
          }
        }
      }
    }
  
    // Wait for click handlers to update sessionStorage
    setTimeout(() => {
       for(const package_ of dataaaa.data.customerPlans) {
    this.currentamount += package_.total;
  }

  console.log(this.isSpecialCondition, "this.isSpecialCondition12778")
  if(this.isSpecialCondition){
    this.currentamount = 0;
    this.specialConditionMessage = 'There are upcoming coverage changes due to recent life events. Please ensure that the appropriate coverage level is updated based on the effective dates of these changes. \n Kindly contact your administrator to handle the updates manually through the underwriting queue in the admin portal.'
  }

  for(const package_ of dataaaa.data.activeButCancelledInFuturePlans) {
    if(this.isSpecialCondition){
      this.currentamount += package_.total; 
    }
  }

  for (const package_ of dataaaa.data.packages) {
    console.log(package_, 'Current Package');

    // Process each group in the package
    Object.keys(package_.groups).forEach(groupKey => {
      const groups = package_.groups[groupKey];

      groups.forEach(group => {
        group.plans.forEach(plan => {
          console.log(plan.isBundle, "Is Bundled Plan");

          // Process each product in the plan
          plan.productAddonssNames.forEach(product => {
            if (!plan.productAddonss[product]) return;
            const coverages = ['SINGLE', 'COUPLE', 'FAMILY']
            const msCurrent = this.currentCoverage(this.coverageChange)
            const msNext = this.maritalStatusText(this.coverageChange)
            const productAddons = plan.productAddonss[product];
            let selectedAddons:any = [];
            let unselectedAddons:any = [];
            for(const paon of productAddons) {
              if(paon){
                if(paon.selected900 && paon.planCoverage == msCurrent.toUpperCase()){
                  selectedAddons.push(paon);
                }else if(!paon.selected900){
                   if(!paon.selected900 && coverages.includes(paon.planCoverage) && paon.planCoverage == msNext.toUpperCase()){
                  unselectedAddons.push(paon);
                }else if(!paon.selected900 && coverages.includes(paon.planCoverage) && paon.planCoverage != msNext.toUpperCase()){
                  continue
                }else{
                  unselectedAddons.push(paon);
                }
                  // unselectedAddons.push(paon)
                }else{
                  if(paon.selected900 && coverages.includes(paon.planCoverage) && paon.planCoverage == msNext.toUpperCase()){
                  unselectedAddons.push(paon);
                }else if(paon.selected900 && !coverages.includes(paon.planCoverage) && paon.planCoverage != msCurrent.toUpperCase()){
                  selectedAddons.push(paon);
                }else if(!paon.selected900 && coverages.includes(paon.planCoverage) && paon.planCoverage != msNext.toUpperCase()){
                  continue;
                }else if(paon.selected900 && coverages.includes(paon.planCoverage) && paon.planCoverage != msNext.toUpperCase()){
                  continue;
                }else{
                  unselectedAddons.push(paon);
                }
                }
              }
            }

            // const productAddons = plan.productAddonss[product];
            const selectedAddons_ = productAddons.filter((item: any) => item.selected900);
            const unselectedAddons_ = productAddons.filter((item: any) => !item.selected900);
            console.log(selectedAddons, "selectedAddons")
            console.log(unselectedAddons, "unselectedaddonns")
            // Process selected addons
            // Process unselected addons
            if (unselectedAddons.length > 0) {
              if(coverages.includes(unselectedAddons[0].planCoverageUI.toUpperCase())){
                this.effectedPackages.push(unselectedAddons[0]);
                epa.push(unselectedAddons[0])
                this.effectedPackageNames.push(product);
                console.log('Selected Addon:', selectedAddons[0]);
                console.log('Unselected Addon Price:', unselectedAddons[0].price);
                this.upcomingamount += unselectedAddons[0].calculatedTax.total;
              }
            } else if (selectedAddons.length > 0) {
              if(coverages.includes(selectedAddons[0].planCoverageUI.toUpperCase())){
                console.log("nothing already covered");
                this.upcomingamount += selectedAddons[0].calculatedTax.total;
              }else{
                this.effectedPackages.push(selectedAddons[0]);
                epa.push(selectedAddons[0])
                this.upcomingamount += selectedAddons[0].calculatedTax.total;
              }
            }

          });

        });
      });
    });
   
    console.log(this.effectedPackages, 'Effected Packages');
  }

  //Effective July 1st, your premium will be adjusted from $543.13 to $711.43. It will be reflected in your July invoice.
  console.log(this.upcomingamount, this.currentamount)
  this.upcomingamountUI = this.handleAmountonUI(Math.abs(this.upcomingamount).toFixed(2))
  if(this.enactMode == 'add' && this.coverageChange == 'F'){
    this.currentamount = this.upcomingamount
  }
  this.currentamountUI = this.handleAmountonUI(Math.abs(this.currentamount).toFixed(2))
  if(this.upcomingamount != this.currentamount || this.isSpecialCondition){
    this.firstConfirmMessage = `Your marital status has been changed ${this.coveragetext(this.coverageChange)}.`;

    // check child
    this.backdatedDependentsChild = []
    this.backdatedDependentsSpouse = []
    let spouseDetails= this.spouseform.value;
    let childrenDetails = this.childrenDetails;

    console.log(spouseDetails, childrenDetails)

    if (this.childrenDetails && this.childrenDetails.length > 0) {
      this.childrenDetails.forEach((child: any) => {
        const dob = moment(child.dob);
        const today = moment();
        const daysDiff = today.diff(dob, 'days');

        let approvalNeeded = false;

        // Check backdated DOB (> 30 days ago)
        if (daysDiff > 30) {
          approvalNeeded = true;
        }

        // Additional special needs check
        if (child.specialNeeds) {
          approvalNeeded = true;
        }

        if(approvalNeeded){
            this.backdatedDependentsChild.push(child)
        }
      });

    }

    if(!this.normalSpouseRegistration){
      this.backdatedDependentsSpouse.push(spouseDetails)
    }
    const inputDate = moment(this.finalEffectiveDate);
    const today = moment().startOf('day');
    const isBackdated = inputDate.isBefore(today);
    if(isBackdated){
      this.handleCalculateBackdatedPrice();
    }
    console.log(this.upcomingamount, this.backdatedamount)
    console.log(parseFloat(this.upcomingamount) + parseFloat(this.backdatedamount))
    let sumAmount:any = this.handleAmountonUI(Math.abs(parseFloat(this.upcomingamount) + parseFloat(this.backdatedamount)).toFixed(2))
    console.log(this.backdatedDependentsChild)
    console.log(this.childrenDetailsForNormalReg, "8899childrendetails")

    // stf -> when there is existing child and adding spouse and child at once
    // stf -> when there is existing spouse and adding one or children
    // stf -> adding spouse with children with one spouse and one child and child/spouse is in underwriting
    // stf -> adding multiple children and no spouse existed and one child is noraml and another req uw


    let splitPackages:any = [];
    if(this.childrenDetailsForNormalReg.length != this.childrenDetails.length && this.coverageChange != this.coverageChange2) {
      splitPackages = this.splitPackages();
    }
    if(!this.normalSpouseRegistration && this.coverageChange != this.coverageChange2){
      splitPackages = this.splitPackages();
    }

    if(this.normalDependentRegistration && this.normalSpouseRegistration){


      if(this.childrenDetailsForNormalReg.length != this.childrenDetails.length) {
            // means one or more dependent is not covered
            this.underwritingHeading =  `Your reporting of a life event change includes dependents both within and outside the ${(this.maritalStatus == 'married' || this.dependentType == 'child') ? "30" : "360"}-day eligibility window. As a result, coverage for one or more dependents requires approval from the insurance carrier(s), which may take up to 6 weeks pending underwriting.`
            if(this.coverageChange != this.coverageChange2){
              this.underWritingMessage1 = `A further upgrade ${this.coveragetext(splitPackages[1])} coverage is pending underwriting approval for additional dependents reported outside the eligibility window.`
            }

          }
      
        this.secondMessage = `Your policies (${this.effectedPackageNames.join(',')}) will be ${this.enactMode == 'add' ? "upgraded" : "downgraded"} ${this.coveragetext(this.coverageChange)} effective ${formattedDate} ${moment().year()}.`
        this.secondConfirmMessage = `Your premium for plans will be adjusted from $${this.currentamountUI} to $${this.upcomingamountUI} (Including Taxes).`;
        if(this.backdatedamount > 0){
        this.secondConfirmMessage = `Your premium for plans will be adjusted from $${this.currentamountUI} to $${sumAmount}($${this.upcomingamountUI} and $${this.backdatedamountUI}) (Including Taxes).`;
  }
      if(this.backdatedDependentsChild && this.backdatedDependentsChild.length > 0) {
        let fullNames = this.backdatedDependentsChild.map(item => item.fullName);
    this.firstConfirmMessage = `Your marital status will update ${this.coveragetext(this.coverageChange)}.`;
        if(this.maritalStatus == 'married'){
        this.secondConfirmMessage = `Your reporting of life event change for(${fullNames.join(',')})  is outside the 30 day window. Coverage for your dependents has to be approved by the carrier(s) pending underwriting, which may take up to 6 weeks.`
      }else{
        this.secondConfirmMessage = `Your reporting of life event change for(${fullNames.join(',')})  is outside the 360 day window. Coverage for your dependents has to be approved by the carrier(s) pending underwriting, which may take up to 6 weeks.`
      }
      this.underWritingMessage2 = "Once approved you'll be advised of the premium change."
        // this.secondConfirmMessage = `Your reporting of life event change is outside the 360 day window. Coverage for your dependents has to be approved by the carrier(s) pending underwriting, which may take up to 6 weeks.`
      }
    }else{
      console.log(this.marriageType, 'this.marriageType8888')
      if(this.maritalStatus == 'married'){
        this.secondConfirmMessage = `Your reporting of life event change is outside the 30 day window. Coverage for your dependents has to be approved by the carrier(s) pending underwriting, which may take up to 6 weeks.`
      }else{
        this.secondConfirmMessage = `Your reporting of life event change is outside the 360 day window. Coverage for your dependents has to be approved by the carrier(s) pending underwriting, which may take up to 6 weeks.`
      }


       let fullNames:any = [];
        if(this.backdatedDependentsChild.length > 0){
          fullNames = this.backdatedDependentsChild.map(item => item.fullName);
        }
        if(this.backdatedDependentsSpouse.length > 0) {
          fullNames.push(this.backdatedDependentsSpouse[0].fullName)
        }

        if(fullNames && fullNames.length > 0) {
          if(this.maritalStatus == 'married' || this.dependentType == 'child'){
        this.secondConfirmMessage = `Your reporting of life event change for(${fullNames.join(',')})  is outside the 30 day window. Coverage for your dependents has to be approved by the carrier(s) pending underwriting, which may take up to 6 weeks.`
      }else{
        this.secondConfirmMessage = `Your reporting of life event change for(${fullNames.join(',')})  is outside the 360 day window. Coverage for your dependents has to be approved by the carrier(s) pending underwriting, which may take up to 6 weeks.`
      }
        }




        if(splitPackages.length > 0) {
        this.secondMessage = `Your policies (${this.effectedPackageNames.join(',')}) will be ${this.enactMode == 'add' ? "upgraded" : "downgraded"} ${this.coveragetext(splitPackages[0])}.`
        this.firstConfirmMessage = `Your marital status will update ${this.coveragetext(splitPackages[0])}.`;
        this.underWritingMessage1 = `A further upgrade ${this.coveragetext(splitPackages[1])} coverage is pending underwriting approval for additional dependents reported outside the eligibility window.`
          
      }else{
        this.secondMessage = `Your policies (${this.effectedPackageNames.join(',')}) will be ${this.enactMode == 'add' ? "upgraded" : "downgraded"} ${this.coveragetext(this.coverageChange)}.`
        this.firstConfirmMessage = `Your marital status will update ${this.coveragetext(this.coverageChange)}.`;
      }


      // if(this.backdatedDependentsSpouse && this.backdatedDependentsSpouse.length > 0) {
      //   let fullNames = this.backdatedDependentsSpouse.map(item => item.fullName);
      //   this.secondMessage = `Your policies (${this.effectedPackageNames.join(',')}) have been ${this.enactMode == 'add' ? "upgraded" : "downgraded"} ${this.coveragetext(this.coverageChange)} effective ${formattedDate} ${moment().year()}.`
      //   this.firstConfirmMessage = `Your marital status will update ${this.coveragetext(this.coverageChange)}.`;
      //   if(this.maritalStatus == 'married'){
      //   this.secondConfirmMessage = `Your reporting of life event change for(${fullNames.join(',')})  is outside the 30 day window. Coverage for your dependents has to be approved by the carrier(s) pending underwriting, which may take up to 6 weeks.`
      // }else{
      //   this.secondConfirmMessage = `Your reporting of life event change for(${fullNames.join(',')})  is outside the 360 day window. Coverage for your dependents has to be approved by the carrier(s) pending underwriting, which may take up to 6 weeks.`
      // }
      // // this.underWritingMessage2 = "Once approved you'll be advised of the premium change."
      //   // this.secondConfirmMessage = `Your reporting of life event change is outside the 360 day window. Coverage for your dependents has to be approved by the carrier(s) pending underwriting, which may take up to 6 weeks.`
      // }

      // if(this.backdatedDependentsChild && this.backdatedDependentsChild.length > 0 && this.childrenDetails.length != this.backdatedDependentsChild.length) {
      //   let fullNames = this.backdatedDependentsChild.map(item => item.fullName);
      //   this.secondMessage = `Your policies (${this.effectedPackageNames.join(',')}) have been ${this.enactMode == 'add' ? "upgraded" : "downgraded"} ${this.coveragetext(this.coverageChange)} effective ${formattedDate} ${moment().year()}.`
      //   this.firstConfirmMessage = `Your marital status will update ${this.coveragetext(this.coverageChange)}.`;
      //   if(this.maritalStatus == 'married'){
      //   this.secondConfirmMessage = `Your reporting of life event change for(${fullNames.join(',')})  is outside the 30 day window. Coverage for your dependents has to be approved by the carrier(s) pending underwriting, which may take up to 6 weeks.`
      // }else{
      //   this.secondConfirmMessage = `Your reporting of life event change for(${fullNames.join(',')})  is outside the 360 day window. Coverage for your dependents has to be approved by the carrier(s) pending underwriting, which may take up to 6 weeks.`
      // }
      // // this.underWritingMessage2 = "Once approved you'll be advised of the premium change."
      //   // this.secondConfirmMessage = `Your reporting of life event change is outside the 360 day window. Coverage for your dependents has to be approved by the carrier(s) pending underwriting, which may take up to 6 weeks.`
      // }
      // this.secondConfirmMessage = `Your policies ${eventType == 'add' ? "upgrade" : "downgrade"} from ${this.coveragetext(this.coverageChange)} is pending approval from underwriting`
      // this.underWritingMessage1 = 'This can take upto 6 weeks to complete'
      this.underWritingMessage2 = "Once approved you'll be advised of the premium change."
    }
    this.firstMessage = `Effective ${formattedDate}, your premium for plans will be adjusted from $${this.currentamountUI} to $${this.upcomingamountUI}(Including Taxes). It will be reflected in your ${formattedDate.split(' ')[0]} invoice.`
    if(this.backdatedamount > 0){
    this.firstMessage = `Effective ${formattedDate}, your premium for plans will be adjusted from $${this.currentamountUI} to $${sumAmount}($${this.upcomingamountUI} and $${this.backdatedamountUI})(Including Taxes). It will be reflected in your ${formattedDate.split(' ')[0]} invoice.`
    }
    if(this.underWritingMessage2){
          this.firstMessage = `Effective ${formattedDate}, your premium for plans will be adjusted from $${this.currentamountUI} to $${this.upcomingamountUI}(Including Taxes). It will be reflected in your ${formattedDate.split(' ')[0]} invoice once admin approves.`
    }
    // this.firstMessage = `Updating your plans (${this.effectedPackageNames.join(',')}) as of ${formattedDate}, ${moment().year()} ${this.coveragetext(this.coverageChange)}`;
    this.upcomingamount = Math.abs(this.upcomingamount).toFixed(2)
    // this.secondMessage = `Updating your plans (${this.effectedPackageNames.join(',')}) as of ${formattedDate}, ${moment().year()} ${this.coveragetext(this.coverageChange)}`;
    // this.secondMessage = `Your premium will change from $${this.currentamount} to $${this.upcomingamount}`;
  }else{
    this.addToPolicy = 'close';
     this.showPlanDetails= false;
     this.isDirectUpdate = true;
    this.firstMessage = `No need to update the coverage, as it is already included under the current plan.`
  }

  // this.showPlanDetails = false;
      this._LoaderService.hide();
      this.proceedDeleteButtonDisabled = false;
    }, 2000); // wait 800ms for session update — adjust if needed
  
  }, 6000); // initial delay

  
 

  console.log(this.selectedPlans_, 'Selected Plans');
  console.log(this.unSelectedPlans_, 'Unselected Plans');
}


processPackagesForCorp(dataaaa:any, formattedDate:any) {
  this.showCorpPlansTable = true;
   console.log(this.childrenDetailsForNormalReg, "8899childrendetails")
  this._LoaderService.ShowLoader();
  // get all the upgraded plans
  this.effectedPackageNames = []
  this.upcomingamount = 0
  this.backdatedamount = 0;
  this.currentamount = 0
   this.upcomingamountUI = 0
  this.backdatedamountUI = 0;
  this.currentamountUI = 0
  this.clearAllMessages()
  let coverages = ['SINGLE', 'COUPLE', 'FAMILY']
  let currentCoverage =  this.currentCoverage(this.coverageChange)?.toUpperCase() ?? "SINGLE";
  let getUpdatingCoverage = this.maritalStatusText(this.coverageChange)?.toUpperCase() ?? "COUPLE";
  this._LoaderService.hide()

  setTimeout(() => {
    
    let planSummMain: any = JSON.parse(sessionStorage.getItem('plansummarymain') ?? '[]');
    console.log(planSummMain, "planSummMain")
    // if ( planSummMain?.length > 0) {
    //   for (const psm of planSummMain) {
    //     console.log(psm, "psm23333", coverages)
    //     if (coverages.includes(psm.coverage)) {
    //       if (psm.isBundle) {
    //         const selector = `#plancheck${psm.id}.coverage${getUpdatingCoverage}`;
    //         const $el = $(selector);
    //         console.log("accessed", $el.length)
    //         setTimeout(function() {
    //             $(selector).click();
    //         }, 1000);
    //         // if ($el.length) $el.click();
    //       } else {
    //         if (psm.coverage && psm.coverage !== '-') {
    //           $(`#plancheck${psm.planLevel}.coverage${psm.coverage}`).click();
    //         } else {
    //           $(`#plancheck${psm.planLevel}`).click();
    //         }
    //       }
    //     }
    //   }
    // }
  
    // Wait for click handlers to update sessionStorage
      this.payrollDeduction = false;
      this.upcomingamount = 0;
      this.currentamount = 0;
      this.upcomingamountWithoutTax = 0;
      this.currentamountWithoutTax = 0;
      this.upcomingamountTax = 0;
      this.currentamountTax = 0;
      this.effectedPackageNames = [];
      let isCoveredByCompany:any = false;
  
      const updatedPlans: any[] = JSON.parse(sessionStorage.getItem('plansummarymain') ?? '[]');
      console.log(updatedPlans)
      console.log(this.customerSelectedPlans)
      if (updatedPlans.length > 0) {
        for (const psm of updatedPlans) {
          // check if the same plan exists in the customer plans

          if (psm.paidByCompany && coverages.includes(psm.coverage)) {
              isCoveredByCompany = false;
              this.payrollDeduction = true;
              if(!this.effectedPackageNames.includes(psm.planproductname))
              this.effectedPackageNames.push(psm.planproductname);
            }
            if (psm.coveredByCompany && coverages.includes(psm.coverage)) {
              isCoveredByCompany = true;
              this.payrollDeduction = true;
               if(!this.effectedPackageNames.includes(psm.planproductname))
              this.effectedPackageNames.push(psm.planproductname);
            }
            this.upcomingamount += psm.total;
            this.upcomingamountWithoutTax += psm.planPrice;
            this.upcomingamountTax += psm.tax;
          
        }
      }
  
     for(const package_ of dataaaa.data.customerPlans) {
    this.currentamount += package_.total;
    this.currentamountWithoutTax += package_.totalPrice;
    this.currentamountTax += package_.totalTax;

  }
  

      console.log(this.upcomingamount, this.currentamount)
      this.upcomingamount = Math.abs(this.upcomingamount).toFixed(2)


      console.log(this.upcomingamount, this.currentamount)
      

      if(this.isSpecialCondition){
      this.currentamount = 0;
    }

    for(const package_ of dataaaa.data.activeButCancelledInFuturePlans) {
      if(this.isSpecialCondition){
        this.currentamount += package_.total;
      }
    }

    this.currentamount = Math.abs(this.currentamount).toFixed(2)
    this.upcomingamountUI = this.handleAmountonUI(Math.abs(this.upcomingamount).toFixed(2));
    this.currentamountUI = this.handleAmountonUI(Math.abs(this.currentamount).toFixed(2))
      console.log(this.normalDependentRegistration, this.normalSpouseRegistration)
      
      // this.firstMessage = `Updating your plans (${this.effectedPackageNames.join(',')}) as of ${formattedDate}, ${moment().year()} to ${getUpdatingCoverage}`;
      this.firstConfirmMessage = `Your marital status will change ${this.coveragetext(this.coverageChange)}`;




      this.backdatedDependentsChild = []
      this.backdatedDependentsSpouse = []
      let spouseDetails= this.spouseform.value;
      let childrenDetails = this.childrenDetails;

      console.log(spouseDetails, childrenDetails)

      if (this.childrenDetails && this.childrenDetails.length > 0) {
        this.childrenDetails.forEach((child: any) => {
          const dob = moment(child.dob);
          const today = moment();
          const daysDiff = today.diff(dob, 'days');

          let approvalNeeded = false;

          // Check backdated DOB (> 30 days ago)
          if (daysDiff > 30) {
            approvalNeeded = true;
          }

          // Additional special needs check
          if (child.specialNeeds) {
            approvalNeeded = true;
          }

          if(approvalNeeded){
              this.backdatedDependentsChild.push(child)
          }
        });

      }

      if(!this.normalSpouseRegistration){
        this.backdatedDependentsSpouse.push(spouseDetails)
      }

      const inputDate = moment(this.finalEffectiveDate);
      const today = moment().startOf('day');
      const isBackdated = inputDate.isBefore(today);
      if(isBackdated){
        this.handleCalculateBackdatedPrice();
      }


      let sumAmount = Math.abs(parseFloat(this.upcomingamount) + parseFloat(this.backdatedamount)).toFixed(2)

      let splitPackages:any = [];
        if(this.childrenDetailsForNormalReg.length != this.childrenDetails.length && this.coverageChange != this.coverageChange2) {
          splitPackages = this.splitPackages();
        }
        if(!this.normalSpouseRegistration && this.coverageChange != this.coverageChange2){
          splitPackages = this.splitPackages();
        }

      if(this.normalDependentRegistration && this.normalSpouseRegistration){
        if (this.upcomingamount !== this.currentamount && this.upcomingamount > 0 || this.isSpecialCondition) {
          // check if any other dependent is not covered
          if(this.childrenDetailsForNormalReg.length != this.childrenDetails.length) {
            // means one or more dependent is not covered
            this.underwritingHeading =  `Your reporting of a life event change includes dependents both within and outside the ${(this.maritalStatus == 'married' || this.dependentType == 'child') ? "30" : "360"}-day eligibility window. As a result, coverage for one or more dependents requires approval from the insurance carrier(s), which may take up to 6 weeks pending underwriting.`
            if(this.coverageChange != this.coverageChange2){
              this.underWritingMessage1 = `A further upgrade ${this.coveragetext(splitPackages[1])} coverage is pending underwriting approval for additional dependents reported outside the eligibility window.`
            }

          }
          this.secondMessage = `Your policies (${this.effectedPackageNames.join(',')}) will be ${this.enactMode == 'add' ? "upgraded" : "downgraded"} ${this.coveragetext(this.coverageChange)} effective ${formattedDate} ${moment().year()}.`
          // if(this.addToPolicy == 'open' && this.coveredByAnotherPlan != "open") {
          // }else{
          //   this.secondMessage = `Your policies (${this.effectedPackageNames.join(',')}) have been ${this.enactMode == 'add' ? "upgraded" : "downgraded"} ${this.coveragetext(this.coverageChange)} effective ${formattedDate} ${moment().year()}.`
          // }
          // check if there is any covered by company
          console.log(isCoveredByCompany, "isCoveredByCompany9900")
          if(isCoveredByCompany) {
            this.firstMessage = `Effective ${formattedDate}, your premium will be adjusted from $${this.currentamountUI} to $${this.upcomingamountUI}. It will be reflected in your ${formattedDate.split(' ')[0]} invoice.`
            this.corpMessage = `Your ${this.dependentType}'s premium of amount $${this.handleAmountonUI(Math.abs(this.upcomingamount - this.currentamount).toFixed(2))} will be paid through payroll deduction`;
          }else{
            this.firstMessage = `Effective ${formattedDate}, your premium will be adjusted from $${this.currentamountUI} to $${this.upcomingamountUI}.`
            // if backdated add the upcoming amount
            this.corpMessage = `Your ${this.dependentType}'s premium of amount $${this.handleAmountonUI(Math.abs(this.upcomingamount - this.currentamount).toFixed(2))} will be 100% paid by company`;
          }
          if(this.backdatedamount > 0){
            if(isCoveredByCompany) {
              this.firstMessage = `Effective ${formattedDate}, your premium will be adjusted from $${this.currentamountUI} to $${sumAmount}($${this.upcomingamountUI} and $${this.backdatedamountUI}). It will be reflected in your ${formattedDate.split(' ')[0]} invoice.`
              this.corpMessage = `Your ${this.dependentType}'s premium of amount $${this.handleAmountonUI(Math.abs(this.upcomingamount - this.currentamount).toFixed(2))} will be paid through payroll deduction`;
            }else{
              this.firstMessage = `Effective ${formattedDate}, your premium will be adjusted from $${this.currentamountUI} to $${sumAmount}($${this.upcomingamountUI} and $${this.backdatedamountUI}).`
              // if backdated add the upcoming amount
              this.corpMessage = `Your ${this.dependentType}'s premium of amount $${this.handleAmountonUI(Math.abs(this.upcomingamount - this.currentamount).toFixed(2))} will be 100% paid by the company`;
            }
          }
          
        }
        if (this.upcomingamount !== this.currentamount && this.upcomingamount == 0) {
          this.showCorpPlansTable = false;
          this.secondMessage = `No Need to pay the premium as the coverage is already covered`;
          this._LoaderService.hide()
          this.addToPolicy = 'close';
          this.showPlanDetails= false;
        }

        if(this.upcomingamount == 0 ){
          this.addToPolicy = 'close';
          this.showPlanDetails= false;
           this.firstMessage = `Your marital status was changed ${this.coveragetext(this.coverageChange)}`;
          this.secondMessage = `your insurer doesn't provide the coverage to ${this.enactMode == 'add' ? "upgrade" : "downgrade"}.`;
        }
        // this.secondConfirmMessage = `Your policies have been ${this.enactMode == 'add' ? "upgraded" : "downgraded"} ${this.coveragetext(this.coverageChange)}`
      }else{
        // check if normal dependent exists
        
        let fullNames:any = [];
        if(this.backdatedDependentsChild.length > 0){
          fullNames = this.backdatedDependentsChild.map(item => item.fullName);
        }
        if(this.backdatedDependentsSpouse.length > 0) {
          fullNames.push(this.backdatedDependentsSpouse[0].fullName)
        }

       this.underwritingHeading =  `Your reporting of 'life event change' for ${fullNames.join(',')} is outside the ${this.maritalStatus == 'married' ? "30" : "360"} day window. Request for Coverage for your dependents has to be approved by the insurance carrier(s) pending underwriting, which may take up to 6 weeks.`
       if (this.upcomingamount == this.currentamount && this.upcomingamount != 0) {
          this.showCorpPlansTable = false;
          this.firstMessage = `Your marital status was changed ${this.coveragetext(this.coverageChange)}`;
          this.secondMessage = `your insurer doesn't provide the coverage to ${this.enactMode == 'add' ? "upgrade" : "downgrade"}.`;
           this.addToPolicy = 'close';
          this.showPlanDetails= false;
        }else{
          this.secondConfirmMessage = `Your policies ${this.enactMode == 'add' ? "upgrade" : "downgrade"} ${this.coveragetext(this.coverageChange)} is pending approval from underwriting`
          this.underWritingMessage1 = 'This can take upto 6 weeks to complete.'
          this.underWritingMessage2 = "Once approved your future invoice will reflect the new amount."
          if(splitPackages.length > 0) {
          this.underwritingHeading =  `Your reporting of a life event change includes dependents both within and outside the ${this.maritalStatus == 'married' ? "30" : "360"}-day eligibility window. As a result, coverage for one or more dependents requires approval from the insurance carrier(s), which may take up to 6 weeks pending underwriting.`
          this.secondConfirmMessage = `Your policies (${this.effectedPackageNames.join(',')}) will be ${this.enactMode == 'add' ? "upgrade" : "downgrade"} ${this.coveragetext(splitPackages[0])}.`
          this.underWritingMessage1 = `A further upgrade ${this.coveragetext(splitPackages[1])} coverage is pending underwriting approval for additional dependents reported outside the eligibility window.`
          this.underWritingMessage2 = "This can take upto 6 weeks to complete. \n Once approved your future invoice will reflect the new amount."
          }else{
          // this.underwritingHeading =  `Your reporting of a life event change includes dependents both within and outside the ${this.maritalStatus == 'married' ? "30" : "360"}-day eligibility window. As a result, coverage for one or more dependents requires approval from the insurance carrier(s), which may take up to 6 weeks pending underwriting.`
          this.secondConfirmMessage = `Your policies (${this.effectedPackageNames.join(',')}) will be ${this.enactMode == 'add' ? "upgrade" : "downgrade"} ${this.coveragetext(this.coverageChange)}.`
          if(this.coverageChange == this.coverageChange2){
            // nothing
          }else{
            this.underWritingMessage1 = `The ${fullNames.join(',')} addition requires approval from the insurance carrier(s), pending underwriting, which may take up to 6 weeks.`
            this.underWritingMessage2 = ""
          }
          }
        }

        
      }


  
      
      
      this.showPlanDetails = false;
      this.showAfterPlanDetails = true;
      this._LoaderService.hide();
  
  }, 8000); // initial delay
  
  
  
  //payrollDeduction

}


private resetState() {
  this.currentamount = 0;
  this.upcomingamount = 0;
  this.effectedPackages = [];
  this.effectedPackageNames = [];
  this.obj1 = [];
}

private processPackageGroups(package_: any, formattedDate: string) {
  Object.keys(package_.groups).forEach(groupKey => {
    package_.groups[groupKey].forEach(group => {
      group.plans.forEach(plan => {
        this.processPlanProducts(package_, group, plan, formattedDate);
      });
    });
  });
}

private processPlanProducts(package_: any, group: any, plan: any, formattedDate: string) {
  plan.productAddonssNames.forEach(product => {
    if (!plan.productAddonss[product]) return;

    const productAddons = plan.productAddonss[product];
    const [selectedAddons, unselectedAddons] = this.splitAddonsBySelection(productAddons);

    this.processSelectedAddons(selectedAddons);
    this.processUnselectedAddons(unselectedAddons, product, formattedDate);

    productAddons.forEach((addon: any, k: number) => {
      const planDetails = this.createPlanDetailsString(package_, group, plan, product, k);
      const plandetailsobj = planDetails.split('##');
      const planObj = this.createPlanObject(plandetailsobj, plan, addon.calculatedTax);
      
      if (this.effectedPackages.length > 0) {
        const productObj = this.createProductObject(package_, group, plan);
        this.addtoplansummary(planObj, productObj);
      }
    });
  });
}

private splitAddonsBySelection(addons: any[]): [any[], any[]] {
  const selected = addons.filter(item => item.selected);
  const unselected = addons.filter(item => !item.selected);
  return [selected, unselected];
}

private processSelectedAddons(selectedAddons: any[]) {
  if (selectedAddons.length > 0) {
    this.currentamount += selectedAddons[0].price;
  }
}

private processUnselectedAddons(unselectedAddons: any[], product: string, formattedDate: string) {
  const coverages = ['SINGLE', 'COUPLE', 'FAMILY']
  if (unselectedAddons.length > 0) {
    if(coverages.includes(unselectedAddons[0].planCoverageUI.toUpperCase())){
      this.effectedPackages.push(unselectedAddons[0]);
      this.effectedPackageNames.push(product);
      this.firstMessage = `Updating your plans (${product}) as of ${formattedDate} to ${unselectedAddons[0].planCoverageUI}`;
    }
    this.upcomingamount += unselectedAddons[0].price;
  }
}

private finalizeProcessing() {
  this.secondMessage = `Your premium will change from $${this.currentamount} to $${this.upcomingamount}`;
  this.getPlanSummaryObject();
}



private generateTaxUI(obj: any) {
  obj['taxUI'] = '';
  const taxTypes = [
    { key: 'gst', name: 'GST' },
    { key: 'pst', name: 'PST' },
    { key: 'qst', name: 'QST' },
    { key: 'hst', name: 'HST' }
  ];

  taxTypes.forEach(tax => {
    const checkKey = `${tax.key}Check`;
    const priceKey = `${tax.key}Price`;
    
    if (obj[checkKey]) {
      obj['taxUI'] += '<span>';
      obj['taxUI'] += obj[priceKey] == 0 ? '-' : 
        `$${this._decimalPipe.transform(obj[priceKey], '1.2-2')}&nbsp;(${tax.name})`;
      obj['taxUI'] += '</span>';
    }
  });

  if (!obj['hstCheck'] && !obj['gstCheck'] && !obj['pstCheck'] && !obj['qstCheck']) {
    obj['taxUI'] += '<span>-</span>';
  }
}


private updateSessionStorage(planSummary: any[]) {
  this.planssummarymain = planSummary.filter(plan => plan.packagename !== 'Opt-in');
  this.planssummaryopt = planSummary.filter(plan => plan.packagename === 'Opt-in');
  
  sessionStorage.setItem('plansskumain', JSON.stringify(this.plansskumain));
  sessionStorage.setItem('plansummarymain', JSON.stringify(this.planssummarymain));
  sessionStorage.setItem('plansummaryopt', JSON.stringify(this.planssummaryopt));
  sessionStorage.setItem('plansummary', JSON.stringify(planSummary));
}

private checkCartValue(totalPrice: number) {
  const updatedSum = this.addtosum(totalPrice);
  this.cartcheckvalue = updatedSum <= 0;
}


// Helper method to create plan details string
private createPlanDetailsString(
  package_: any, 
  group: any, 
  plan: any, 
  product: string, 
  index: number
): string {
  return `${package_.name}##${group.name}##${
    plan.planCoverage
  }##${plan.productAddonss[product][index].calculatedTax?.price}##0##0##0##${
    plan.id
  }##${plan.fusebillId}##${
    plan.frqMonthly
  }##${package_.optIn}##${
    group.disallowedPlanLevels
  }##${group.parentId}##${group.id}##${
    plan.name
  }##${plan.planLevel}##${plan.packageId}##0##${
    plan.planOptions
  }##${plan.productAddonss[product][index].id}##${
    plan.productAddonss[product][index].plan_level.id
  }##${plan.isBundle}##${group.disallowedPlanLevels}`;
}

// Helper method to create plan object
private createPlanObject(plandetailsobj: string[], plan: any, calculatedTax: any): any {
  return {
    isBundle: plan.isBundle,
    disallowedPlanLevels: plan.disallowedPlanLevels,
    enrollmentDate: undefined,
    name: plandetailsobj[14],
    details: plandetailsobj[0],
    packagename: plandetailsobj[0],
    groupName: plandetailsobj[1],
    amount: parseFloat(calculatedTax.price),
    planCoverage: plandetailsobj[2],
    planPrice: parseFloat(calculatedTax.price),
    amountUI: '$' + this._decimalPipe.transform(calculatedTax.price, '1.2-2'),
    gst: this.parseTaxValue(plandetailsobj[4]),
    hst: this.parseTaxValue(plandetailsobj[5]),
    pst: this.parseTaxValue(plandetailsobj[6]),
    qst: this.parseTaxValue(plandetailsobj[17]),
    gstCheck: this.checkTaxValue(plandetailsobj[4]),
    hstCheck: this.checkTaxValue(plandetailsobj[5]),
    pstCheck: this.checkTaxValue(plandetailsobj[6]),
    qstCheck: this.checkTaxValue(plandetailsobj[17]),
    id: parseFloat(plandetailsobj[7]),
    fusebillPlanID: this.parseOptionalNumber(plandetailsobj[8]),
    planFrequencyID: this.parseOptionalNumber(plandetailsobj[9]),
    optIn: plandetailsobj[10] === 'true',
    planname: plandetailsobj[14],
    planLevel: parseInt(plandetailsobj[15]),
    packageId: parseInt(plandetailsobj[16]),
    options: [],
    version: plan.version,
    description: plan.description,
    insuranceType: plan.insuranceType
  };
}

// Helper method to create product object
private createProductObject(package_: any, group: any, plan: any): any {
  const productObjects = this.effectedPackages.map(product => ({
    id: product.id,
    productId: product.productId,
    name: product.name,
    planProductId: product.planProductId,
    price: this._decimalPipe.transform(product.price1 || product.price, '1.2-2')?.replace(/,/g, ''),
    tax: this._decimalPipe.transform(
      product.calculatedTax ? product.calculatedTax.tax : 0,
      '1.2-2'
    )?.replace(/,/g, ''),
    total: this._decimalPipe.transform(
      product.calculatedTax ? product.calculatedTax.total : 0,
      '1.2-2'
    )?.replace(/,/g, ''),
    tax_details: product.bundledTaxes && product.bundledTaxes.length > 0
      ? product.bundledTaxes
      : product.taxesDataJSON,
    calculatedTax: product.calculatedTax,
    bundledProducts: product.bundledProducts,
    planCoverage: product.planCoverage,
    planLevel: product.planlevel ? product.planlevel.id : '',
    planLevelParent: product.planlevel ? product.planlevel.parentId : '',
    description: product.description,
    coverage: this.coverage,
  }));

  return {
    packageId: plan.packageId,
    packageName: package_.name,
    planproductname: productObjects[0]?.name || '',
    groupid: plan.planLevel,
    groupName: group.name,
    id: plan.id,
    name: plan.name,
    planLevel: plan.planLevel ? plan.planLevel : group.id,
    planLevelParent: group.parentId,
    fusebillPlanID: plan.fusebillId,
    planFrequencyID: plan.frqMonthly,
    isBundle: plan.isBundle,
    coverage: this.coverage,
    planCoverage: this.effectedPackages[0]?.planCoverage || '',
    bundledProducts: [],
    products: productObjects,
  };
}

// Helper functions
private parseTaxValue(value: any): number {
  return value == null || value === '' || value === undefined || value === 'null' 
    ? 0 
    : parseFloat(value);
}

private checkTaxValue(value: any): boolean {
  return !(value == null || value === '' || value === undefined || value === 'null');
}

private parseOptionalNumber(value: any): number {
  return value == null || value === '' || value === undefined || value === 'null' 
    ? 0 
    : parseFloat(value);
}
  
  async addDependent_v2Configuration() {
    console.log(this.childrenDetails)
    console.log(this.spouseform)
    if (this.dependentType == 'spouse' || this.dependentType == 'multiple') {
      if (this.spouseform.invalid) {
        this.spouseform.markAllAsTouched()
        return;
      }
    }
    

    if(this.finalEffectiveDate == null && this.addToPolicy == 'open'){
      Swal.fire({title: "Info", text: "Please select effective date"}).then(res => {
        if(res.isConfirmed){
          return;
        }
      })
    }else{
 this.showAddToPolicyError = false;
    // direct submit if there is no policy change
    if(this.addToPolicy == 'close') {
      await this.addDependent_v2Confirmation()
    }else{
      document.getElementById('addDependent')?.classList.add('d-none');
      
      // Show the second modal by removing d-none
      document.getElementById('showPlanSummaryBrief')?.classList.remove('d-none');
      document.getElementById('showPlanSummaryBrief')?.classList.add('d-block');
      document.getElementById('showPlanSummaryBrief')?.classList.add('show');
    }
    }

   
  }



  async deleteDependent_v2Configuration() {


    if(this.enactMode == 'delete') {
        if (this.deleteForm.invalid) {
          this.deleteForm.markAllAsTouched()
          return;
        }
    }


     if(this.finalEffectiveDate == null){
      Swal.fire({title: "Info", text: "Please select effective date"}).then(res => {
        if(res.isConfirmed){
          return;
        }
      })
    }else{
  document.getElementById('addDependent')?.classList.add('d-none');
      
    // Show the second modal by removing d-none
    document.getElementById('showPlanSummaryBrief')?.classList.remove('d-none');
    document.getElementById('showPlanSummaryBrief')?.classList.add('d-block');
    document.getElementById('showPlanSummaryBrief')?.classList.add('show');
    }
    
  
  }
  async closeaddDependent_v2Confirmation() {
    console.log(this.obj1, "this.obj1plas")

    document.getElementById('addDependent')?.classList.add('d-block');
    document.getElementById('addDependent')?.classList.remove('d-none');

    // Show the second modal by removing d-none
    document.getElementById('showPlanSummaryBrief')?.classList.remove('d-block');
    document.getElementById('showPlanSummaryBrief')?.classList.add('d-none');
    document.getElementById('showPlanSummaryBrief')?.classList.remove('show');
  }
  async addDependent_v2Confirmation() { 
    let validationInputData:any ={};
    console.log(this.spouseform.value)
    let spouseDetails:any = {}
    if(this.spouseform.value.fullName != null && this.spouseform.value.fullName != undefined && this.spouseform.value.fullName != '') {
      const fullName = this.spouseform.value.fullName.trim().split(/\s+/);
      console.log(fullName, "ajjjj")
      spouseDetails = {
        ...this.spouseform.value,
        firstName: fullName[0],
        lastName: fullName.slice(1).join(' '),
        dob: moment(this.spouseform.value.dob).format('YYYY-MM-DD'),
        gender: "Female",
        isBackdated: this.normalSpouseRegistration == true ? false : this.addToPolicy == 'open' ? true : false,
        maritalStatus: this.maritalStatus,
        dateOfMarriage: moment(this.spouseform.value.dateOfMarriage).format('YYYY-MM-DD')
    };
    if(this.enactMode == "delete"){
      spouseDetails.isBackdated = false;
    }
    }
    if (this.childrenDetails && this.childrenDetails.length > 0) {
     
      this.childrenDetails.forEach((child: any) => {
        const dob = moment(child.dob);
        const today = moment();
        const daysDiff = today.diff(dob, 'days');

        let approvalNeeded = false;

        // Check backdated DOB (> 30 days ago)
        if (daysDiff > 30) {
          approvalNeeded = true;
        }

        // Additional special needs check
        if (child.specialNeeds) {
          approvalNeeded = true;
        }

        if(this.addToPolicy == 'close'){
          approvalNeeded = false;
        }

        // Graduation date logic
        if (child.graduationDate) {
          const graduationDate = moment(child.graduationDate, 'MM-DD-YYYY');
          child.graduationDate = graduationDate.format('YYYY-MM-DD');
          this.isGradError = graduationDate.isBefore(dob);
        }

        // Split full name
        if (child.fullName) {
          child.firstName = child.fullName.split(' ')[0];
          child.lastName = child.fullName.trim().split(/\s+/).slice(1).join(' ');
        }

        // Format and assign DOB
        child.dob = dob.format('YYYY-MM-DD');

        // Final backdated flag per child
        child.isBackdated = approvalNeeded;
      });

    }
    let plansMain = sessionStorage.getItem("plansummarymain") ? JSON.parse(sessionStorage.getItem("plansummarymain") || '') : []
    let plans:any = []
    if(this.isCorporateAccount){
      
      let plansummaryLIFEFinal:any = []
      let plansummary:any;
      let provisioning:any = false;
      let iafgPlansAvailability:any = false;
      let plansummaryMain:any = JSON.parse(sessionStorage.getItem("allSelectedPlans") || '')
      // this.plansummaryMain = JSON.parse(sessionStorage.getItem("plansummarymain")||'')

      let plansummaryLIFE:any = JSON.parse(sessionStorage.getItem("planssummarymainLife") || '')
      let planDetailsArrayBlock = JSON.parse(sessionStorage.getItem("planssummarymainLife") || '[]')



      plansummaryLIFE.forEach((element: any, index: number) => {

        element.member.maximumCoverageWithoutEvidence = element.member.defaultRange

        if (element.spouse && element.spouse.maximumCoverageWithoutEvidence) {
          element.spouse.maximumCoverageWithoutEvidence = element.spouse.defaultRange

        }
        element['amount'] = element.guaranteedAcceptanceDetails.amount
        element['amountUI'] = "$" + element.guaranteedAcceptanceDetails.amount
        element['planPrice'] = element.guaranteedAcceptanceDetails.amount
        element['total'] = element.guaranteedAcceptanceDetails.total
        element['totalPrice'] = element.guaranteedAcceptanceDetails.total
        element['skuTotalPrice'] = element.guaranteedAcceptanceDetails.total
        element['totalUI'] = "$" + element.guaranteedAcceptanceDetails.total
        element['tax'] = element.guaranteedAcceptanceDetails.tax
        element['taxUI'] = "$" + element.guaranteedAcceptanceDetails.tax
        plansummaryLIFEFinal.push(element)

      });
      planDetailsArrayBlock.forEach((element: any, index: number) => {
        if (element.id == 13) {
          iafgPlansAvailability = true
        }
        else {
          iafgPlansAvailability = false
        }

      });

      plansummary = plansummaryMain.concat(plansummaryLIFEFinal)

      // this.plansummary =this.plansummaryMain.concat(this.plansummaryLIFE)
      // this.optplansummary = JSON.parse(sessionStorage.getItem("allSelectedOptPlans"))
      plansummary = plansummary.sort(function (a: any, b: any) {
        return (a.packageId - b.packageId);
      })
      console.log(plansummary)
      let taxesInfo = {}
      plansummary.forEach((element: any) => {

        if (element.packageId == 1) {
          provisioning = true
        }

        element.totalPrice = this._decimalPipe.transform(element.totalPrice, "1.2-2")?.replace(/,/g, "")
        element.total = this._decimalPipe.transform(element.totalPrice, "1.2-2")?.replace(/,/g, "")
        element.tax = this._decimalPipe.transform(element.tax, "1.2-2")?.replace(/,/g, "")
        element.amount = this._decimalPipe.transform(element.amount, "1.2-2")?.replace(/,/g, "")
        element.planLevelName = element.groupName
        taxesInfo = this.determineTaxes(element?.products?.[0]?.calculatedTax?.planProductInfos ?? [])
        element.taxApplicable = element.tax > 0
        Object.assign(element, taxesInfo);
        plans.push(element)
      });
    }
    validationInputData['plans'] = this.isCorporateAccount ? plans : plansMain
    validationInputData['spouseDetails'] = spouseDetails.fullName != '' ? spouseDetails : {};
    validationInputData['childrenDetails'] = this.childrenDetails
    validationInputData['isPolicyChange'] = this.addToPolicy == 'open' ? true : this.enactMode == 'delete' ? true : false
    if(this.enactMode == 'delete') {
      validationInputData['isPolicyChange'] = this.normalDependentDeletion ? false : true;
    }
    validationInputData['coverageScenario'] = this.coverageChange
    validationInputData['isCorporateCustomer'] = this.isCorporateAccount ?true : false
    validationInputData['payrollDeduction'] = this.payrollDeduction
    validationInputData['differenceAmount'] = parseFloat(Math.abs(this.upcomingamountWithoutTax - this.currentamountWithoutTax).toFixed(2)) ?? 0;
    // validationInputData['differenceAmountTax'] = parseFloat(Math.abs(this.upcomingamountTax - this.currentamountTax).toFixed(2)) ?? 0;
    validationInputData['eventType'] = this.cobeventType == 'add' ? 'upgrade' : 'downgrade'
    validationInputData['effectiveDate'] = moment(this.finalEffectiveDate).format('YYYY-MM-DD')
    validationInputData['maxEnrollmentDate'] = this.maxEnrollmentDate
    validationInputData['coverageChange2'] = this.coverageChange2
    validationInputData['isSpecialCondition'] = this.isSpecialCondition
    validationInputData['customerPlans'] = this.customerOldPlans


    
    if(this.enactMode == 'delete'){
      if(this.dependentType == 'spouse') {
    validationInputData['spouseDetails'] = this.isSpouseSelected ?  this.isSpouseSelected : {};
      }else{
    validationInputData['childrenDetails'] = this.isChildSelected ? [this.isChildSelected] : [];
      }
    }
    if(this.enactMode == 'cob') {
    validationInputData['isPolicyChange'] = true;
      console.log(this.availableFirstNames, "this.availableFirstNames")
      console.log(this.cobevent, this.cobeventType)
      if(this.cobevent == 'spouse'){
        console.log(this.cobform.value)
        spouseDetails = this.availableFirstNames.find(item => item.relationType == 'spouse');
        validationInputData['spouseDetails'] = spouseDetails
      }
    }
    let event:any;
    if(this.enactMode == 'add') {
      event = 'add';
    }else if(this.enactMode == 'delete') {
      event = 'remove';
    }else{
      if(this.enactMode == "cob") {
        event = this.cobeventType
      }
    }
    validationInputData['isCancelAll'] = false;
    // if(this.isExcludeAll){
    //   validationInputData['isCancelAll'] = true;
    // }
    if(this.dependentType == 'child') {
      validationInputData['spouseDetails'] = {}
    }
    if(this.dependentType == 'spouse') {
      validationInputData['childrenDetails'] = []
    }
    let endPoint:any;
    if(this.enactMode == 'cob') {
    endPoint = `/customer/v2new/${this.customerid}/lifeChange/${this.cobevent}/${event}/false`
    }else{
      endPoint = `/customer/v2new/${this.customerid}/lifeChange/${this.dependentType}/${event}/false`
    }
    console.log(validationInputData, endPoint)
   

    let dataaaa:any;
    // commented
    // return;
    this.http.post(api.url + endPoint, validationInputData, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      if(this.backdatedDependentsChild.length > 0 || this.backdatedDependentsSpouse.length > 0){
      Swal.fire({title: "Info", text: 'Changes will be reflected soon once the admin approved.'}).then(res => {
        if(res.isConfirmed) {
          window.location.reload()
        }
       })
      }else{
        Swal.fire({title: "Info", text: this.enactMode == 'cob' ? 'COB details updated successfully' : `Dependent has been ${this.enactMode == 'delete' ? "removed" : "added"} successfully`}).then(res => {
          if(res.isConfirmed) {
            window.location.reload()
          }
        })
      }
      })
  

  }
  

  public determineTaxes(taxArray:any) {
    let taxObj: any = {
      pst: null,
      pstTaxRate: null,
      hst: null,
      hstTaxRate: null,
      gst: null,
      gstTaxRate: null,
      taxName: null,
      taxPrice: null
    };
    for (let tax of taxArray) {
      if (!taxObj.taxName || taxObj.taxName == null) {
        taxObj.taxName = "";
      }
 
      if (tax.name.includes("PST") || tax.name.includes("Prov")) {
        taxObj.pst = tax.price + (taxObj.pst ?? 0);
        taxObj.pstTaxRate = (tax.taxRate) * 100
           if(!taxObj.taxName.includes(tax.name))
        taxObj.taxName += tax.name + " | "
      }
      if (tax.name.includes("HST")) {
        taxObj.hst = tax.price + (taxObj.hst ?? 0);
        taxObj.hstTaxRate = (tax.taxRate) * 100
           if(!taxObj.taxName.includes(tax.name))
        taxObj.taxName += tax.name + " | "
      }
      if (tax.name.includes("GST")) {
        taxObj.gst = tax.price + (taxObj.gst ?? 0);
        taxObj.gstTaxRate = (tax.taxRate) * 100;
          if(!taxObj.taxName.includes(tax.name))
        taxObj.taxName += tax.name + " | "
      }
    }
    taxObj.taxName = taxObj.taxName?.trim();
    if (taxObj.taxName && taxObj.taxName[taxObj.taxName.length - 1] == "|") {
      taxObj.taxName = taxObj.taxName.slice(0,-1);
      taxObj.taxName = taxObj.taxName?.trim();
    }
 
    if (taxObj.pst || taxObj.hst || taxObj.gst) {
      taxObj.taxPrice = 0;
      taxObj.taxPrice = (taxObj.pst ?? 0) + (taxObj.hst ?? 0) + (taxObj.gst ?? 0)
    }
 
    return taxObj;
  }


}



export function postalcodeValidator(control: FormControl): { [key: string]: any } | null {
  var postalRegexp = /^(?!.*[DFIOQU])[A-VXY][0-9][A-Z] ?[0-9][A-Z][0-9]$/gm;
  if (control.value && !postalRegexp.test(control.value)) {
    return { invalidPostalCode: true };
  }
  return null
}

export function notSameAsPrimaryValidator(primaryControlName: string): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const primaryControl = control.root.get(primaryControlName);
    if (!primaryControl || !primaryControl.value || control.value === primaryControl.value) {
      return { 'notSameAsPrimary': true };
    }
    return null;
  };
}
function phoneNumbersMustBeDifferent(control: AbstractControl): { [key: string]: boolean } | null {
  const primaryPhoneNumber = control.get('primaryPhone')?.value;
  const secondaryPhoneNumber = control.get('secondaryPhone')?.value;

  if (secondaryPhoneNumber == "") {
    return { phoneNumbersMatch: false };
  }
  else if (primaryPhoneNumber === secondaryPhoneNumber) {
    return { phoneNumbersMatch: true };
  }
  return null;
}


export function childrenminimumAgeValidator(control: AbstractControl): any {
  const birthDate = new Date(control.value);
  const today = new Date();
  const age = today.getFullYear() - birthDate.getFullYear();

  console.log(age)
  if (age > 21) {
    return { childrenminimumAge: true };
  }
}

function hasWhiteSpace(s: any) {
  return /\s/g.test(s);
}